/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ autocomplete; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=5e569f3e&
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js&

/* harmony default export */ var autocompletevue_type_script_lang_js_ = ((function (x) { return x.default || x })(__webpack_require__(8795)));

;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1001);
;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/autocomplete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_autocompletevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var autocomplete = (component.exports);

/***/ }),

/***/ 6388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ infoWindow; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=25e3f758&
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js&

/* harmony default export */ var infoWindowvue_type_script_lang_js_ = ((function (x) { return x.default || x })(__webpack_require__(6401)));

;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_infoWindowvue_type_script_lang_js_ = (infoWindowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1001);
;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/infoWindow.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_infoWindowvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var infoWindow = (component.exports);

/***/ }),

/***/ 391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ map; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=6839df3e&
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._t("visible")],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js&

/* harmony default export */ var mapvue_type_script_lang_js_ = ((function (x) { return x.default || x })(__webpack_require__(7626)));

;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_mapvue_type_script_lang_js_ = (mapvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=6839df3e&prod&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=6839df3e&prod&lang=css&

// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1001);
;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/map.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_mapvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var map = (component.exports);

/***/ }),

/***/ 6891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__esModule": function() { return /* reexport */ placeInputImplvue_type_script_lang_js_/* __esModule */.X; },
  "default": function() { return /* binding */ placeInput; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=13bfbbee&
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js&
var placeInputImplvue_type_script_lang_js_ = __webpack_require__(2587);
;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js&
 /* harmony default export */ var components_placeInputImplvue_type_script_lang_js_ = (placeInputImplvue_type_script_lang_js_/* default */.Z); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1001);
;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/placeInput.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_placeInputImplvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var placeInput = (component.exports);

/***/ }),

/***/ 7483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ streetViewPanorama; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=50f7f8d6&
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._t("default")],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js&

/* harmony default export */ var streetViewPanoramavue_type_script_lang_js_ = ((function (x) { return x.default || x })(__webpack_require__(19)));

;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_streetViewPanoramavue_type_script_lang_js_ = (streetViewPanoramavue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=50f7f8d6&prod&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=50f7f8d6&prod&lang=css&

// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1001);
;// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_streetViewPanoramavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var streetViewPanorama = (component.exports);

/***/ }),

/***/ 1001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1609);

/***/ }),

/***/ 5448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var settle = __webpack_require__(6026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(5327);
var buildFullPath = __webpack_require__(4097);
var parseHeaders = __webpack_require__(4109);
var isURLSameOrigin = __webpack_require__(7985);
var transitionalDefaults = __webpack_require__(7874);
var AxiosError = __webpack_require__(2648);
var CanceledError = __webpack_require__(644);
var parseProtocol = __webpack_require__(205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var bind = __webpack_require__(1849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(7185);
var defaults = __webpack_require__(5546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(644);
axios.CancelToken = __webpack_require__(4972);
axios.isCancel = __webpack_require__(6502);
axios.VERSION = (__webpack_require__(7288).version);
axios.toFormData = __webpack_require__(7675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(2648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(6268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 4972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(2648);
var utils = __webpack_require__(4867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 6502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var buildURL = __webpack_require__(5327);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(3572);
var mergeConfig = __webpack_require__(7185);
var buildFullPath = __webpack_require__(4097);
var validator = __webpack_require__(4875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 2648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 4097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 3572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var transformData = __webpack_require__(8527);
var isCancel = __webpack_require__(6502);
var defaults = __webpack_require__(5546);
var CanceledError = __webpack_require__(644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 7185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(2648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var defaults = __webpack_require__(5546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 5546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var normalizeHeaderName = __webpack_require__(6016);
var AxiosError = __webpack_require__(2648);
var transitionalDefaults = __webpack_require__(7874);
var toFormData = __webpack_require__(7675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(5448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(5448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(1623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 7874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 7288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 1849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 5327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 1793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 6268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 7985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 6016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 1623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 4109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 7675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 4875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(7288).version);
var AxiosError = __webpack_require__(2648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 4867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(1849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 9996:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 6808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 2433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

 /*! 
  * portal-vue © Thorsten Lünborg, 2019 
  * 
  * Version: 2.1.7
  * 
  * LICENCE: MIT 
  * 
  * https://github.com/linusborg/portal-vue
  * 
 */



__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(144));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var inBrowser = typeof window !== 'undefined';
function freeze(item) {
  if (Array.isArray(item) || _typeof(item) === 'object') {
    return Object.freeze(item);
  }

  return item;
}
function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return transports.reduce(function (passengers, transport) {
    var temp = transport.passengers[0];
    var newPassengers = typeof temp === 'function' ? temp(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}
function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return compareFn(a[1], b[1]) || a[0] - b[0];
  }).map(function (c) {
    return c[1];
  });
}
function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var transports = {};
var targets = {};
var sources = {};
var Wormhole = Vue.extend({
  data: function data() {
    return {
      transports: transports,
      targets: targets,
      sources: sources,
      trackInstances: inBrowser
    };
  },
  methods: {
    open: function open(transport) {
      if (!inBrowser) return;
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers,
          _transport$order = transport.order,
          order = _transport$order === void 0 ? Infinity : _transport$order;
      if (!to || !from || !passengers) return;
      var newTransport = {
        to: to,
        from: from,
        passengers: freeze(passengers),
        order: order
      };
      var keys = Object.keys(this.transports);

      if (keys.indexOf(to) === -1) {
        Vue.set(this.transports, to, []);
      }

      var currentIndex = this.$_getTransportIndex(newTransport); // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays

      var newTransports = this.transports[to].slice(0);

      if (currentIndex === -1) {
        newTransports.push(newTransport);
      } else {
        newTransports[currentIndex] = newTransport;
      }

      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;
      if (!to || !from && force === false) return;

      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.$_getTransportIndex(transport);

        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    registerTarget: function registerTarget(target, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.targets[target]) {
        console.warn("[portal-vue]: Target ".concat(target, " already exists"));
      }

      this.$set(this.targets, target, Object.freeze([vm]));
    },
    unregisterTarget: function unregisterTarget(target) {
      this.$delete(this.targets, target);
    },
    registerSource: function registerSource(source, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.sources[source]) {
        console.warn("[portal-vue]: source ".concat(source, " already exists"));
      }

      this.$set(this.sources, source, Object.freeze([vm]));
    },
    unregisterSource: function unregisterSource(source) {
      this.$delete(this.sources, source);
    },
    hasTarget: function hasTarget(to) {
      return !!(this.targets[to] && this.targets[to][0]);
    },
    hasSource: function hasSource(to) {
      return !!(this.sources[to] && this.sources[to][0]);
    },
    hasContentFor: function hasContentFor(to) {
      return !!this.transports[to] && !!this.transports[to].length;
    },
    // Internal
    $_getTransportIndex: function $_getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return +i;
        }
      }

      return -1;
    }
  }
});
var wormhole = new Wormhole(transports);

var _id = 1;
var Portal = Vue.extend({
  name: 'portal',
  props: {
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: function _default() {
        return String(_id++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerSource(_this.name, _this);
    });
  },
  mounted: function mounted() {
    if (!this.disabled) {
      this.sendUpdate();
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterSource(this.name);
    this.clear();
  },
  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    }
  },
  methods: {
    clear: function clear(target) {
      var closer = {
        from: this.name,
        to: target || this.to
      };
      wormhole.close(closer);
    },
    normalizeSlots: function normalizeSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    normalizeOwnChildren: function normalizeOwnChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizeSlots();

      if (slotContent) {
        var transport = {
          from: this.name,
          to: this.to,
          passengers: _toConsumableArray(slotContent),
          order: this.order
        };
        wormhole.open(transport);
      } else {
        this.clear();
      }
    }
  },
  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;

    if (children && this.disabled) {
      return children.length <= 1 && this.slim ? this.normalizeOwnChildren(children)[0] : h(Tag, [this.normalizeOwnChildren(children)]);
    } else {
      return this.slim ? h() : h(Tag, {
        class: {
          'v-portal': true
        },
        style: {
          display: 'none'
        },
        key: 'v-portal-placeholder'
      });
    }
  }
});

var PortalTarget = Vue.extend({
  name: 'portalTarget',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    slim: {
      type: Boolean,
      default: false
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerTarget(_this.name, _this);
    });
  },
  watch: {
    ownTransports: function ownTransports() {
      this.$emit('change', this.children().length > 0);
    },
    name: function name(newVal, oldVal) {
      /**
       * TODO
       * This should warn as well ...
       */
      wormhole.unregisterTarget(oldVal);
      wormhole.registerTarget(newVal, this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.transition) {
      this.$nextTick(function () {
        // only when we have a transition, because it causes a re-render
        _this2.firstRender = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterTarget(this.name);
  },
  computed: {
    ownTransports: function ownTransports() {
      var transports = this.transports[this.name] || [];

      if (this.multiple) {
        return transports;
      }

      return transports.length === 0 ? [] : [transports[transports.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    }
  },
  methods: {
    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$scopedSlots.default ? this.$scopedSlots.default(this.slotProps) : this.$slots.default || [];
    },
    // can't be a computed prop because it has to "react" to this.children().
    noWrapper: function noWrapper() {
      var noWrapper = this.slim && !this.transition;

      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }

      return noWrapper;
    }
  },
  render: function render(h) {
    var noWrapper = this.noWrapper();
    var children = this.children();
    var Tag = this.transition || this.tag;
    return noWrapper ? children[0] : this.slim && !Tag ? h() : h(Tag, {
      props: {
        // if we have a transition component, pass the tag if it exists
        tag: this.transition && this.tag ? this.tag : undefined
      },
      class: {
        'vue-portal-target': true
      }
    }, children);
  }
});

var _id$1 = 0;
var portalProps = ['disabled', 'name', 'order', 'slim', 'slotProps', 'tag', 'to'];
var targetProps = ['multiple', 'transition'];
var MountingPortal = Vue.extend({
  name: 'MountingPortal',
  inheritAttrs: false,
  props: {
    append: {
      type: [Boolean, String]
    },
    bail: {
      type: Boolean
    },
    mountTo: {
      type: String,
      required: true
    },
    // Portal
    disabled: {
      type: Boolean
    },
    // name for the portal
    name: {
      type: String,
      default: function _default() {
        return 'mounted_' + String(_id$1++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    // name for the target
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    },
    // Target
    multiple: {
      type: Boolean,
      default: false
    },
    targetSlim: {
      type: Boolean
    },
    targetSlotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    targetTag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  created: function created() {
    if (typeof document === 'undefined') return;
    var el = document.querySelector(this.mountTo);

    if (!el) {
      console.error("[portal-vue]: Mount Point '".concat(this.mountTo, "' not found in document"));
      return;
    }

    var props = this.$props; // Target already exists

    if (wormhole.targets[props.name]) {
      if (props.bail) {
        console.warn("[portal-vue]: Target ".concat(props.name, " is already mounted.\n        Aborting because 'bail: true' is set"));
      } else {
        this.portalTarget = wormhole.targets[props.name];
      }

      return;
    }

    var append = props.append;

    if (append) {
      var type = typeof append === 'string' ? append : 'DIV';
      var mountEl = document.createElement(type);
      el.appendChild(mountEl);
      el = mountEl;
    } // get props for target from $props
    // we have to rename a few of them


    var _props = pick(this.$props, targetProps);

    _props.slim = this.targetSlim;
    _props.tag = this.targetTag;
    _props.slotProps = this.targetSlotProps;
    _props.name = this.to;
    this.portalTarget = new PortalTarget({
      el: el,
      parent: this.$parent || this,
      propsData: _props
    });
  },
  beforeDestroy: function beforeDestroy() {
    var target = this.portalTarget;

    if (this.append) {
      var el = target.$el;
      el.parentNode.removeChild(el);
    }

    target.$destroy();
  },
  render: function render(h) {
    if (!this.portalTarget) {
      console.warn("[portal-vue] Target wasn't mounted");
      return h();
    } // if there's no "manual" scoped slot, so we create a <Portal> ourselves


    if (!this.$scopedSlots.manual) {
      var props = pick(this.$props, portalProps);
      return h(Portal, {
        props: props,
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    } // else, we render the scoped slot


    var content = this.$scopedSlots.manual({
      to: this.to
    }); // if user used <template> for the scoped slot
    // content will be an array

    if (Array.isArray(content)) {
      content = content[0];
    }

    if (!content) return h();
    return content;
  }
});

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue$$1.component(options.portalName || 'Portal', Portal);
  Vue$$1.component(options.portalTargetName || 'PortalTarget', PortalTarget);
  Vue$$1.component(options.MountingPortalName || 'MountingPortal', MountingPortal);
}

var index = {
  install: install
};

exports.ZP = index;
__webpack_unused_export__ = Portal;
__webpack_unused_export__ = PortalTarget;
__webpack_unused_export__ = MountingPortal;
__webpack_unused_export__ = wormhole;
//# sourceMappingURL=portal-vue.common.js.map


/***/ }),

/***/ 5463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var Vue = __webpack_require__(144);
Vue = 'default' in Vue ? Vue['default'] : Vue;

var version = '2.2.2';

var compatible = (/^2\./).test(Vue.version);
if (!compatible) {
  Vue.util.warn('VueClickaway ' + version + ' only supports Vue 2.x, and does not support Vue ' + Vue.version);
}



// @SECTION: implementation

var HANDLER = '_vue_clickaway_handler';

function bind(el, binding, vnode) {
  unbind(el);

  var vm = vnode.context;

  var callback = binding.value;
  if (typeof callback !== 'function') {
    if (false) {}
    return;
  }

  // @NOTE: Vue binds directives in microtasks, while UI events are dispatched
  //        in macrotasks. This causes the listener to be set up before
  //        the "origin" click event (the event that lead to the binding of
  //        the directive) arrives at the document root. To work around that,
  //        we ignore events until the end of the "initial" macrotask.
  // @REFERENCE: https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/
  // @REFERENCE: https://github.com/simplesmiler/vue-clickaway/issues/8
  var initialMacrotaskEnded = false;
  setTimeout(function() {
    initialMacrotaskEnded = true;
  }, 0);

  el[HANDLER] = function(ev) {
    // @NOTE: this test used to be just `el.containts`, but working with path is better,
    //        because it tests whether the element was there at the time of
    //        the click, not whether it is there now, that the event has arrived
    //        to the top.
    // @NOTE: `.path` is non-standard, the standard way is `.composedPath()`
    var path = ev.path || (ev.composedPath ? ev.composedPath() : undefined);
    if (initialMacrotaskEnded && (path ? path.indexOf(el) < 0 : !el.contains(ev.target))) {
      return callback.call(vm, ev);
    }
  };

  document.documentElement.addEventListener('click', el[HANDLER], false);
}

function unbind(el) {
  document.documentElement.removeEventListener('click', el[HANDLER], false);
  delete el[HANDLER];
}

var directive = {
  bind: bind,
  update: function(el, binding) {
    if (binding.value === binding.oldValue) return;
    bind(el, binding);
  },
  unbind: unbind,
};

var mixin = {
  directives: { onClickaway: directive },
};

__webpack_unused_export__ = version;
__webpack_unused_export__ = directive;
exports.jB = mixin;

/***/ }),

/***/ 144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EffectScope": function() { return /* binding */ EffectScope; },
/* harmony export */   "computed": function() { return /* binding */ computed; },
/* harmony export */   "customRef": function() { return /* binding */ customRef; },
/* harmony export */   "default": function() { return /* binding */ Vue; },
/* harmony export */   "defineAsyncComponent": function() { return /* binding */ defineAsyncComponent; },
/* harmony export */   "defineComponent": function() { return /* binding */ defineComponent; },
/* harmony export */   "del": function() { return /* binding */ del; },
/* harmony export */   "effectScope": function() { return /* binding */ effectScope; },
/* harmony export */   "getCurrentInstance": function() { return /* binding */ getCurrentInstance; },
/* harmony export */   "getCurrentScope": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "h": function() { return /* binding */ h; },
/* harmony export */   "inject": function() { return /* binding */ inject; },
/* harmony export */   "isProxy": function() { return /* binding */ isProxy; },
/* harmony export */   "isReactive": function() { return /* binding */ isReactive; },
/* harmony export */   "isReadonly": function() { return /* binding */ isReadonly; },
/* harmony export */   "isRef": function() { return /* binding */ isRef; },
/* harmony export */   "isShallow": function() { return /* binding */ isShallow; },
/* harmony export */   "markRaw": function() { return /* binding */ markRaw; },
/* harmony export */   "mergeDefaults": function() { return /* binding */ mergeDefaults; },
/* harmony export */   "nextTick": function() { return /* binding */ nextTick; },
/* harmony export */   "onActivated": function() { return /* binding */ onActivated; },
/* harmony export */   "onBeforeMount": function() { return /* binding */ onBeforeMount; },
/* harmony export */   "onBeforeUnmount": function() { return /* binding */ onBeforeUnmount; },
/* harmony export */   "onBeforeUpdate": function() { return /* binding */ onBeforeUpdate; },
/* harmony export */   "onDeactivated": function() { return /* binding */ onDeactivated; },
/* harmony export */   "onErrorCaptured": function() { return /* binding */ onErrorCaptured; },
/* harmony export */   "onMounted": function() { return /* binding */ onMounted; },
/* harmony export */   "onRenderTracked": function() { return /* binding */ onRenderTracked; },
/* harmony export */   "onRenderTriggered": function() { return /* binding */ onRenderTriggered; },
/* harmony export */   "onScopeDispose": function() { return /* binding */ onScopeDispose; },
/* harmony export */   "onServerPrefetch": function() { return /* binding */ onServerPrefetch; },
/* harmony export */   "onUnmounted": function() { return /* binding */ onUnmounted; },
/* harmony export */   "onUpdated": function() { return /* binding */ onUpdated; },
/* harmony export */   "provide": function() { return /* binding */ provide; },
/* harmony export */   "proxyRefs": function() { return /* binding */ proxyRefs; },
/* harmony export */   "reactive": function() { return /* binding */ reactive; },
/* harmony export */   "readonly": function() { return /* binding */ readonly; },
/* harmony export */   "ref": function() { return /* binding */ ref$1; },
/* harmony export */   "set": function() { return /* binding */ set; },
/* harmony export */   "shallowReactive": function() { return /* binding */ shallowReactive; },
/* harmony export */   "shallowReadonly": function() { return /* binding */ shallowReadonly; },
/* harmony export */   "shallowRef": function() { return /* binding */ shallowRef; },
/* harmony export */   "toRaw": function() { return /* binding */ toRaw; },
/* harmony export */   "toRef": function() { return /* binding */ toRef; },
/* harmony export */   "toRefs": function() { return /* binding */ toRefs; },
/* harmony export */   "triggerRef": function() { return /* binding */ triggerRef; },
/* harmony export */   "unref": function() { return /* binding */ unref; },
/* harmony export */   "useAttrs": function() { return /* binding */ useAttrs; },
/* harmony export */   "useCssModule": function() { return /* binding */ useCssModule; },
/* harmony export */   "useCssVars": function() { return /* binding */ useCssVars; },
/* harmony export */   "useListeners": function() { return /* binding */ useListeners; },
/* harmony export */   "useSlots": function() { return /* binding */ useSlots; },
/* harmony export */   "version": function() { return /* binding */ version; },
/* harmony export */   "watch": function() { return /* binding */ watch; },
/* harmony export */   "watchEffect": function() { return /* binding */ watchEffect; },
/* harmony export */   "watchPostEffect": function() { return /* binding */ watchPostEffect; },
/* harmony export */   "watchSyncEffect": function() { return /* binding */ watchSyncEffect; }
/* harmony export */ });
/*!
 * Vue.js v2.7.10
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return (isDef(val) &&
        typeof val.then === 'function' &&
        typeof val.catch === 'function');
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null
        ? ''
        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
            ? JSON.stringify(val, null, 2)
            : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    if (arr.length) {
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l
            ? l > 1
                ? fn.apply(ctx, arguments)
                : fn.call(ctx, a)
            : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) { }
/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function (_) { return _; };
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b)
        return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (a.length === b.length &&
                    a.every(function (e, i) {
                        return looseEqual(e, b[i]);
                    }));
            }
            else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            }
            else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return (keysA.length === keysB.length &&
                    keysA.every(function (key) {
                        return looseEqual(a[key], b[key]);
                    }));
            }
            else {
                /* istanbul ignore next */
                return false;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            return false;
        }
    }
    else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    }
    else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val))
            return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    }
    else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj)
                return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof __webpack_require__.g !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer =
                __webpack_require__.g['process'] && __webpack_require__.g['process'].env.VUE_ENV === 'server';
        }
        else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
}
else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */ (function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }());
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) { vm = null; }
    if (!vm)
        currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */ (function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function () {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}());
var createEmptyVNode = function (text) {
    if (text === void 0) { text = ''; }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var uid$2 = 0;
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */ (function () {
    function Dep() {
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        remove$2(this.subs, sub);
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {}
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.slice();
        if (false) {}
        for (var i = 0, l = subs.length; i < l; i++) {
            if (false) { var sub; }
            subs[i].update();
        }
    };
    return Dep;
}());
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted)
            ob.observeArray(inserted);
        // notify change
        if (false) {}
        else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */ (function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                }
                else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        }
        else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}());
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (!isObject(value) || isRef(value) || value instanceof VNode) {
        return;
    }
    var ob;
    if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        ob = value.__ob__;
    }
    else if (shouldObserve &&
        (ssrMockReactivity || !isServerRendering()) &&
        (isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value.__v_skip /* ReactiveFlags.SKIP */) {
        ob = new Observer(value, shallow, ssrMockReactivity);
    }
    return ob;
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) &&
        (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = !shallow && observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {}
                else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {}
            if (setter) {
                setter.call(obj, newVal);
            }
            else if (getter) {
                // #7981: for accessor properties without setter
                return;
            }
            else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            }
            else {
                val = newVal;
            }
            childOb = !shallow && observe(newVal, false, mock);
            if (false) {}
            else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {}
    if (isReadonly(target)) {
         false && 0;
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
         false &&
            0;
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {}
    else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {}
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
         false &&
            0;
        return;
    }
    if (isReadonly(target)) {
         false &&
            0;
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {}
    else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) { var existingOb; }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {}
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {}
    if (false) {}
    else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            }
            else {
                var ob = val && val.__ob__;
                if (ob)
                    ob.dep.depend();
                return val;
            }
        },
        set: function (value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            }
            else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {}
        else {
            dep.depend();
        }
    }, function () {
        if (false) {}
        else {
            dep.notify();
        }
    }), get = _a.get, set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {}
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {}
        return target;
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function () {
             false &&
                0;
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false
            ? 0
            : noop;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering()
        ? null
        : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {}
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {}
                    watcher.depend();
                }
                return watcher.value;
            }
            else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? 0 : { flush: 'post' }));
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? 0 : { flush: 'sync' }));
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {}
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? 'pre' : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
    if (false) {}
    var warnInvalidSource = function (s) {
        warn("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") +
            "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function (fn, type, args) {
        if (args === void 0) { args = null; }
        return invokeWithErrorHandling(fn, null, args, instance, type);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function () { return source.value; };
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = function () {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                }
                else {
                     false && 0;
                }
            });
        };
    }
    else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function () { return call(source, WATCHER_GETTER); };
        }
        else {
            // no cb -> simple effect
            getter = function () {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    }
    else {
        getter = noop;
         false && 0;
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onCleanup = function (fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            call(cb, WATCHER_CB, [
                getter(),
                isMultiSource ? [] : undefined,
                onCleanup
            ]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep ||
                forceTrigger ||
                (isMultiSource
                    ? newValue.some(function (v, i) {
                        return hasChanged(v, oldValue[i]);
                    })
                    : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    }
    else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () { return queueWatcher(watcher); };
    }
    else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0)
                    buffer.push(watcher);
            }
            else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {}
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        }
        else {
            oldValue = watcher.get();
        }
    }
    else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () { return watcher.get(); });
    }
    else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

var activeEffectScope;
var EffectScope = /** @class */ (function () {
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        if (!detached && activeEffectScope) {
            this.parent = activeEffectScope;
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = currentEffectScope;
            }
        }
        else if (false) {}
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    };
    return EffectScope;
}());
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) { scope = activeEffectScope; }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if (false) {}
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {}
    }
    else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return (vm._provided = Object.create(parentProvides));
    }
    else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue)
                ? defaultValue.call(instance)
                : defaultValue;
        }
        else if (false) {}
    }
    else if (false) {}
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        }
        else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
             false &&
                0;
        }
        else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        }
        else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    }
    else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        }
        else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs, props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) { var keyInLowerCase; }
            checkProp(res, props, key, altKey, true) ||
                checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        }
        else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children)
        ? [createTextVNode(children)]
        : isArray(children)
            ? normalizeArrayChildren(children)
            : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean')
            continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        }
        else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            }
            else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        }
        else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            }
            else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null, i, l, keys, key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    }
    else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    }
    else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        }
        else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {}
            props = extend(extend({}, bindObject), props);
        }
        nodes =
            scopedSlotFn(props) ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    else {
        nodes =
            this.$slots[name] ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    }
    else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    }
    else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    }
    else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    }
    else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
             false &&
                0;
        }
        else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function (key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                }
                else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                        asProp || config.mustUseProp(tag, type, key)
                            ? data.domProps || (data.domProps = {})
                            : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    }
    else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
             false && 0;
        }
        else {
            var on = (data.on = data.on ? extend({}, data.on) : {});
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res, 
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        }
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        }
        else if (false) {}
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) &&
            data &&
            data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    }
    else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    }
    else if (isStable &&
        prevScopedSlots &&
        prevScopedSlots !== emptyObject &&
        key === prevScopedSlots.$key &&
        !hasNormalSlots &&
        !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    }
    else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function () {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
            res && typeof res === 'object' && !isArray(res)
                ? [res] // single vnode
                : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res &&
            (!vnode ||
                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
            ? undefined
            : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = (vm._setupContext = createSetupContext(vm));
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        }
        else if (isObject(setupResult)) {
            // bindings
            if (false) {}
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    }
                    else if (false) {}
                }
            }
            else {
                // exposed for compiled render fn
                var proxy = (vm._setupProxy = {});
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        }
        else if (false) {}
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = (vm._attrsProxy = {});
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = (vm._listenersProxy = {});
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind(vm.$emit, vm),
        expose: function (exposed) {
            if (false) {}
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        }
        else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {}
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw)
        ? raw.reduce(function (normalized, p) { return ((normalized[p] = {}), normalized); }, {})
        : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            props[key] = { default: defaults[key] };
        }
        else if (false) {}
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode
        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
        : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {}
    else {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        }
        catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {}
            else {
                vnode = vm._vnode;
            }
        }
        finally {
            currentRenderingInstance = null;
            setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {}
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = (factory.owners = [owner]);
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
        var forceRender_1 = function (renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            }
            else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
             false &&
                0;
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            }
            else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    }
                    else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? 0 : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
         false &&
            0;
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {}
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    }
    else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {}
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        }
        else if ((!data || !data.pre) &&
            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        }
        else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    }
    else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    }
    else if (isDef(vnode)) {
        if (isDef(ns))
            applyNS(vnode, ns);
        if (isDef(data))
            registerDeepBindings(data);
        return vnode;
    }
    else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) &&
                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
         false &&
            0;
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while ((cur = cur.$parent)) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture)
                                return;
                        }
                        catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    }
    finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
            res._handled = true;
        }
    }
    catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        }
        catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {}
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS)
            setTimeout(noop);
    };
    isUsingMicroTask = true;
}
else if (!isIE &&
    typeof MutationObserver !== 'undefined' &&
    (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
}
else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
        setImmediate(flushCallbacks);
    };
}
else {
    // Fallback to setTimeout.
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            }
            catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        }
        else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) { name = '$style'; }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
             false && 0;
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
             false &&
                0;
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false)
        return;
    var instance = currentInstance;
    if (!instance) {
         false &&
            0;
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {}
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {}
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {}
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) { target = currentInstance; }
        if (!target) {
             false &&
                0;
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    }
    else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) { target = currentInstance; }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.10';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if ((!isA && !isObject(val)) ||
        Object.isFrozen(val) ||
        val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--)
            _traverse(val[i], seen);
    }
    else if (isRef(val)) {
        _traverse(val.value, seen);
    }
    else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--)
            _traverse(val[keys[i]], seen);
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */ (function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this, 
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm
            ? activeEffectScope
            : vm
                ? vm._scope
                : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {}
        }
        else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? 0 : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        }
        else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                 false &&
                    0;
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        }
        catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            }
            else {
                throw e;
            }
        }
        finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        }
        else if (this.sync) {
            this.run();
        }
        else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
                // Deep watchers and watchers on Object/Arrays should fire even
                // when the value is the same, because the value may
                // have mutated.
                isObject(value) ||
                this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                }
                else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}());

var mark;
var measure;
if (false) { var perf_1; }

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        }
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) { var lowerCaseEvent; }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        }
        else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper &&
            wrapper.$vnode &&
            wrapper.$parent &&
            wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {}
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {}
    else {
        updateComponent = function () {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function () {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {}
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {}
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key));
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {}
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive)
            return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) { setContext = true; }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prev = currentInstance;
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    setContext && setCurrentInstance(prev);
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {}
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 &&
        typeof performance_1.now === 'function' &&
        getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () { return performance_1.now(); };
    }
}
var sortCompareFn = function (a, b) {
    if (a.post) {
        if (!b.post)
            return 1;
    }
    else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index = 0; index < queue.length; index++) {
        watcher = queue[index];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {}
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    }
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {}
        nextTick(flushSchedulerQueue);
    }
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption)
            ? provideOption.call(vm)
            : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {}
            else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__')
                continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            }
            else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
            }
            else if (false) {}
        }
        return result;
    }
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    }
    else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function () {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    }
    else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    }
    else {
        if (isDef(data.attrs))
            mergeProps(props, data.attrs);
        if (isDef(data.props))
            mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    }
    else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {}
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function (vnode, hydrating) {
        if (vnode.componentInstance &&
            !vnode.componentInstance._isDestroyed &&
            vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        }
        else {
            var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function (oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function (vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            }
            else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function (vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            }
            else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {}
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode, 
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    }
    else {
        on[event] = callback;
    }
}

var warn = noop;
var tip = (/* unused pure expression or super */ null && (noop));
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) { var repeat_1, classify_1, classifyRE_1, hasConsole_1; }

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from) {
    if (!from)
        return to;
    var key, toVal, fromVal;
    var keys = hasSymbol
        ? Reflect.ownKeys(from)
        : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            set(to, key, fromVal);
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    }
    else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal)
                ? childVal.call(vm, vm)
                : childVal;
            var defaultData = isFunction(parentVal)
                ? parentVal.call(vm, vm)
                : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            }
            else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
             false &&
                0;
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal
        ? parentVal
            ? parentVal.concat(childVal)
            : isArray(childVal)
                ? childVal
                : [childVal]
        : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
         false && 0;
        return extend(res, childVal);
    }
    else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch)
        parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch)
        childVal = undefined;
    /* istanbul ignore if */
    if (!childVal)
        return Object.create(parentVal || null);
    if (false) {}
    if (!parentVal)
        return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props =
    strats.methods =
        strats.inject =
            strats.computed =
                function (parentVal, childVal, vm, key) {
                    if (childVal && "production" !== 'production') {}
                    if (!parentVal)
                        return childVal;
                    var ret = Object.create(null);
                    extend(ret, parentVal);
                    if (childVal)
                        extend(ret, childVal);
                    return ret;
                };
strats.provide = mergeDataOrFn;
/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn('Invalid component name: "' +
            name +
            '". Component names ' +
            'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn('Do not use built-in or reserved HTML elements as component ' +
            'id: ' +
            name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props)
        return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            }
            else if (false) {}
        }
    }
    else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    }
    else if (false) {}
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject)
        return;
    var normalized = (options.inject = {});
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    }
    else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val)
                ? extend({ from: key }, val)
                : { from: val };
        }
    }
    else if (false) {}
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn("Invalid value for option \"".concat(name, "\": expected an Object, ") +
            "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {}
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id))
        return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId))
        return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId))
        return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {}
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        }
        else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {}
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {}
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function'
        ? def.call(vm)
        : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
    if (!valid && haveExpectedTypes) {
        warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        try {
            valid = value instanceof type;
        }
        catch (e) {
            warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
        " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    }
    else if (type === 'Number') {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = (/* unused pure expression or super */ null && (['string', 'number', 'boolean']));
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) { var getHandler_1, hasHandler_1, isBuiltInModifier_1, hasProxy_1, warnReservedPrefix_1, warnNonPresent_1, allowedGlobals_1; }

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props)
        initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods)
        initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    }
    else {
        var ob = observe((vm._data = {}));
        ob && ob.vmCount++;
    }
    if (opts.computed)
        initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = (vm._props = shallowReactive({}));
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = (vm.$options._propKeys = []);
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) { var hyphenatedKey; }
        else {
            defineReactive(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
         false &&
            0;
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {}
        if (props && hasOwn(props, key)) {
             false &&
                0;
        }
        else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    }
    catch (e) {
        handleError(e, vm, "data()");
        return {};
    }
    finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = (vm._computedWatchers = Object.create(null));
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {}
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        }
        else if (false) {}
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache
            ? createComputedGetter(key)
            : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    }
    else {
        sharedPropertyDefinition.get = userDef.get
            ? shouldCache && userDef.cache !== false
                ? createComputedGetter(key)
                : createGetterInvoker(userDef.get)
            : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {}
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {}
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {}
        vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        }
        else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {}
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {}
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        }
        else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {}
        else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {}
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = (vm.$options = Object.create(vm.constructor.options));
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified)
                modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function Vue(options) {
    if (false) {}
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        }
        else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {}
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            }
            else {
                /* istanbul ignore if */
                if (false) {}
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    }
    else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function () {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function () {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function () {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) { return matches(val, name); });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) { return !matches(val, name); });
        });
    },
    updated: function () {
        this.cacheVNode();
    },
    render: function () {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (
            // not included
            (include && (!name_2 || !matches(include, name_2))) ||
                // excluded
                (exclude && name_2 && matches(exclude, name_2))) {
                return vnode;
            }
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null
                ? // same constructor may get registered as different local components
                    // so cid alone is not enough (#3269)
                    componentOptions.Ctor.cid +
                        (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            }
            else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config; };
    if (false) {}
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function () {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
        (attr === 'selected' && tag === 'option') ||
        (attr === 'checked' && tag === 'input') ||
        (attr === 'muted' && tag === 'video'));
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
        ? 'false'
        : // allow arbitrary string value for contenteditable
            key === 'contenteditable' && isValidContentEditableValue(value)
                ? value
                : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,' +
    'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function (val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? (b ? a + ' ' + b : a) : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
            el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
    }
    else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
             false && 0;
            return document.createElement('div');
        }
        return selected;
    }
    else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createElement: createElement,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

var ref = {
    create: function (_, vnode) {
        registerRef(vnode);
    },
    update: function (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function (vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref))
        return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            }
            else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    }
                    else {
                        ref.value = [refValue];
                    }
                }
                else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        }
        else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        }
        else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        }
        else if (false) {}
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        }
        else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return (a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
            a.isComment === b.isComment &&
            isDef(a.data) === isDef(b.data) &&
            sameInputType(a, b)) ||
            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
}
function sameInputType(a, b) {
    if (a.tag !== 'input')
        return true;
    var i;
    var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
    var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key))
            map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return (!inVPre &&
            !vnode.ns &&
            !(config.ignoredElements.length &&
                config.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                        ? ignore.test(vnode.tag)
                        : ignore === vnode.tag;
                })) &&
            config.isUnknownElement(vnode.tag));
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {}
            vnode.elm = vnode.ns
                ? nodeOps.createElementNS(vnode.ns, tag)
                : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {}
        }
        else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
        else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef((i = i.hook)) && isDef((i = i.init))) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        }
        else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            }
            else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {}
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        }
        else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create))
                i.create(emptyNode, vnode);
            if (isDef(i.insert))
                insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
        else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef((i = activeInstance)) &&
            i !== vnode.context &&
            i !== vnode.fnContext &&
            isDef((i = i.$options._scopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
        }
        if (isDef((i = vnode.children))) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                }
                else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            }
            else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef((i_3 = vnode.componentInstance)) &&
                isDef((i_3 = i_3._vnode)) &&
                isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                i_3(vnode, rm);
            }
            else {
                rm();
            }
        }
        else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {}
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            }
            else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove &&
                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    }
                    else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                }
                else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c))
                return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = (vnode.elm = oldVnode.elm);
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            }
            else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) &&
            isTrue(oldVnode.isStatic) &&
            vnode.key === oldVnode.key &&
            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            if (isDef((i = data.hook)) && isDef((i = i.update)))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
            else if (isDef(ch)) {
                if (false) {}
                if (isDef(oldVnode.text))
                    nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        }
        else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {}
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.init)))
                i(vnode, true /* hydrating */);
            if (isDef((i = vnode.componentInstance))) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                }
                else {
                    // v-html and domProps: innerHTML
                    if (isDef((i = data)) &&
                        isDef((i = i.domProps)) &&
                        isDef((i = i.innerHTML))) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {}
                            return false;
                        }
                    }
                    else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode ||
                                !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {}
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        }
        else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return (vnode.tag.indexOf('vue-component') === 0 ||
                (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                        (node.tagName && node.tagName.toLowerCase())));
        }
        else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode))
                invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        }
        else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            }
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                        else if (false) {}
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, 
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                for (var i_10 = 1; i_10 < insert_1.fns.length; i_10++) {
                                    insert_1.fns[i_10]();
                                }
                            }
                        }
                        else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                }
                else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        }
        else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function () {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        }
        else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef,
                };
            }
            else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        }
        catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            }
            else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    }
    else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        }
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    }
    else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    }
    else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    }
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE &&
            !isIE9 &&
            el.tagName === 'TEXTAREA' &&
            key === 'placeholder' &&
            value !== '' &&
            !el.__ieph) {
            var blocker_1 = function (e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass = {
    create: updateClass,
    update: updateClass
};

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
                // event is fired after handler attachment
                e.timeStamp >= attachedTimestamp_1 ||
                // bail for environments that have buggy event.timeStamp implementations
                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                // #9681 QtWebEngine event.timeStamp is negative value
                e.timeStamp <= 0 ||
                // #9448 bail if event is fired in another document in a multi-page
                // electron/nw.js app, since event.timeStamp will be using a different
                // starting reference
                e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name, 
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children)
                vnode.children.length = 0;
            if (cur === oldProps[key])
                continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        }
        else if (key === 'innerHTML' &&
            isSVG(elm.tagName) &&
            isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        }
        else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            }
            catch (e) { }
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
    //@ts-expect-error
    !elm.composing &&
        (elm.tagName === 'OPTION' ||
            isNotInFocusAndDirty(elm, checkVal) ||
            isDirtyWithModifiers(elm, checkVal)));
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    }
    catch (e) { }
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode &&
                childNode.data &&
                (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while ((parentNode = parentNode.parent)) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    }
    else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    }
    else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        }
        else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
        }
    }
}
var style = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
        }
        else {
            el.classList.add(cls);
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
        }
        else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        }
        else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if (typeof def === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    }
    else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
    ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
    : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type)
        return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function (e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {}
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        }
        else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    }));
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode &&
                pendingNode.tag === vnode.tag &&
                pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    }
                    else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {}
    var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        }
        else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    }));
    if (delayLeave) {
        delayLeave(performLeave);
    }
    else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        }
                        else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn("<transition> explicit ".concat(name, " duration is not a valid number - ") +
            "got ".concat(JSON.stringify(val), "."), vnode.context);
    }
    else if (isNaN(val)) {
        warn("<transition> explicit ".concat(name, " duration is NaN - ") +
            'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    }
    else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser
    ? {
        create: _enter,
        activate: _enter,
        remove: function (vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
                // @ts-expect-error
                leave(vnode, rm);
            }
            else {
                rm();
            }
        }
    }
    : {};

var platformModules = [attrs, klass, events, domProps, style, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            }
            else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        }
        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function (el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
            if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple
                    ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                    : binding.value !== binding.oldValue &&
                        hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
         false &&
            0;
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        }
        else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) { return !looseEqual(o, value); });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing)
        return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
}
var show = {
    bind: function (el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
            el.style.display === 'none' ? '' : el.style.display);
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        }
        else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue)
            return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            }
            else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        }
        else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    }
    else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
var isVShowDirective = function (d) { return d.name === 'show'; };
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function (h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {}
        var mode = this.mode;
        // warn invalid mode
        if (false) {}
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key =
            child.key == null
                ? child.isComment
                    ? id + 'comment'
                    : id + child.tag
                : isPrimitive(child.key)
                    ? String(child.key).indexOf(id) === 0
                        ? child.key
                        : id + child.key
                    : child.key;
        var data = ((child.data || (child.data = {})).transition =
            extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild &&
            oldChild.data &&
            !isSameChild(child, oldChild) &&
            !isAsyncPlaceholder(oldChild) &&
            // #6687 component root is a comment node
            !(oldChild.componentInstance &&
                oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = (oldChild.data.transition = extend({}, data));
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            }
            else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function () {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function () {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function (h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                }
                else if (false) { var name_1, opts; }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                }
                else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function () {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                }));
            }
        });
    },
    methods: {
        hasMove: function (el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return (this._hasMove = info.hasTransform);
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            }
            else if (false) {}
        }
        if (false) {}
    }, 0);
}




/***/ }),

/***/ 8795:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindProps = __webpack_require__(8179);

var _simulateArrowDown = __webpack_require__(3166);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _mapElementFactory = __webpack_require__(8336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mappedProps = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object,
    // Do not bind -- must check for undefined
    // in the property
    noBind: true
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

var props = {
  selectFirstOnEnter: {
    required: false,
    type: Boolean,
    default: false
  },
  options: {
    type: Object
  }
};

exports["default"] = {
  mounted: function mounted() {
    var _this = this;

    this.$gmapApiPromiseLazy().then(function () {
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = _extends({}, (0, _bindProps.getPropsValues)(_this, mappedProps), _this.options);

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      // Not using `bindEvents` because we also want
      // to return the result of `getPlace()`
      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: _extends({}, (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps), props)
};

/***/ }),

/***/ 4001:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports["default"] = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'circle',
  ctr: function ctr() {
    return google.maps.Circle;
  },
  events: events
});

/***/ }),

/***/ 6401:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports["default"] = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'infoWindow',
  ctr: function ctr() {
    return google.maps.InfoWindow;
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },

  inject: {
    '$markerPromise': {
      default: null
    }
  },

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  beforeCreate: function beforeCreate(options) {
    var _this = this;

    options.content = this.$refs.flyaway;

    if (this.$markerPromise) {
      delete options.position;
      return this.$markerPromise.then(function (mo) {
        _this.$markerObject = mo;
        return mo;
      });
    }
  },


  methods: {
    _openInfoWindow: function _openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindowObject.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindowObject.open(this.$map);
        }
      } else {
        this.$infoWindowObject.close();
      }
    }
  },

  afterCreate: function afterCreate() {
    var _this2 = this;

    this._openInfoWindow();
    this.$watch('opened', function () {
      _this2._openInfoWindow();
    });
  }
});

/***/ }),

/***/ 8336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = function (options) {
  var mappedProps = options.mappedProps,
      name = options.name,
      ctr = options.ctr,
      ctrArgs = options.ctrArgs,
      events = options.events,
      beforeCreate = options.beforeCreate,
      afterCreate = options.afterCreate,
      props = options.props,
      rest = _objectWithoutProperties(options, ['mappedProps', 'name', 'ctr', 'ctrArgs', 'events', 'beforeCreate', 'afterCreate', 'props']);

  var promiseName = '$' + name + 'Promise';
  var instanceName = '$' + name + 'Object';

  assert(!(rest.props instanceof Array), '`props` should be an object, not Array');

  return _extends({}, typeof GENERATE_DOC !== 'undefined' ? { $vgmOptions: options } : {}, {
    mixins: [_mapElementMixin2.default],
    props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
    render: function render() {
      return '';
    },
    provide: function provide() {
      var _this = this;

      var promise = this.$mapPromise.then(function (map) {
        // Infowindow needs this to be immediately available
        _this.$map = map;

        // Initialize the maps with the given options
        var options = _extends({}, _this.options, {
          map: map
        }, (0, _bindProps.getPropsValues)(_this, mappedProps));
        delete options.options; // delete the extra options

        if (beforeCreate) {
          var result = beforeCreate.bind(_this)(options);

          if (result instanceof Promise) {
            return result.then(function () {
              return { options: options };
            });
          }
        }
        return { options: options };
      }).then(function (_ref) {
        var _Function$prototype$b;

        var options = _ref.options;

        var ConstructorObject = ctr();
        // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
        _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [ConstructorObject, null].concat(_toConsumableArray(ctrArgs(options, (0, _bindProps.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);

        (0, _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
        (0, _bindEvents2.default)(_this, _this[instanceName], events);

        if (afterCreate) {
          afterCreate.bind(_this)(_this[instanceName]);
        }
        return _this[instanceName];
      });
      this[promiseName] = promise;
      return _defineProperty({}, promiseName, promise);
    },
    destroyed: function destroyed() {
      // Note: not all Google Maps components support maps
      if (this[instanceName] && this[instanceName].setMap) {
        this[instanceName].setMap(null);
      }
    }
  }, rest);
};

exports.mappedPropsToVueProps = mappedPropsToVueProps;

var _bindEvents = __webpack_require__(8636);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(8179);

var _mapElementMixin = __webpack_require__(9859);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */


function assert(v, message) {
  if (!v) throw new Error(message);
}

/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */
function mappedPropsToVueProps(mappedProps) {
  return Object.entries(mappedProps).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        prop = _ref4[1];

    var value = {};

    if ('type' in prop) value.type = prop.type;
    if ('default' in prop) value.default = prop.default;
    if ('required' in prop) value.required = prop.required;

    return [key, value];
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    acc[key] = val;
    return acc;
  }, {});
}

/***/ }),

/***/ 9859:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports["default"] = {
  inject: {
    '$mapPromise': { default: 'abcdef' }
  },

  provide: function provide() {
    var _this = this;

    // Note: although this mixin is not "providing" anything,
    // components' expect the `$map` property to be present on the component.
    // In order for that to happen, this mixin must intercept the $mapPromise
    // .then(() =>) first before its component does so.
    //
    // Since a provide() on a mixin is executed before a provide() on the
    // component, putting this code in provide() ensures that the $map is
    // already set by the time the
    // component's provide() is called.
    this.$mapPromise.then(function (map) {
      _this.$map = map;
    });

    return {};
  }
};

/***/ }),

/***/ 7626:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(8636);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(8179);

var _mountableMixin = __webpack_require__(4062);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(7777);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(7382);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(8336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object,
    noBind: true
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number,
    noBind: true
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['bounds_changed', 'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

exports["default"] = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

  provide: function provide() {
    var _this = this;

    this.$mapPromise = new Promise(function (resolve, reject) {
      _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$mapPromise': this.$mapPromise
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        });
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

      return _this2.$mapObject;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: _extends({}, customMethods, linkedMethods)
};

/***/ }),

/***/ 3576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports["default"] = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'marker',
  ctr: function ctr() {
    return google.maps.Marker;
  },

  inject: {
    '$clusterPromise': {
      default: null
    }
  },

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      // Repaint will be performed in `updated()` of cluster
      this.$clusterObject.removeMarker(this.$markerObject, true);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    if (this.$clusterPromise) {
      this.$clusterPromise.then(function (co) {
        co.addMarker(inst);
        _this.$clusterObject = co;
      });
    }
  }
});

/***/ }),

/***/ 2587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "X", ({
  value: true
}));

var _bindProps = __webpack_require__(8179);

var _simulateArrowDown = __webpack_require__(3166);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.Z = {
  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    this.$gmapApiPromiseLazy().then(function () {
      var options = (0, _bindProps.getPropsValues)(_this, props);
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);

      var placeholder = props.placeholder,
          place = props.place,
          defaultPlace = props.defaultPlace,
          className = props.className,
          label = props.label,
          selectFirstOnEnter = props.selectFirstOnEnter,
          rest = _objectWithoutProperties(props, ['placeholder', 'place', 'defaultPlace', 'className', 'label', 'selectFirstOnEnter']); // eslint-disable-line


      (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};

/***/ }),

/***/ 890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true,
    noBind: true
  },
  paths: {
    type: Array,
    twoWay: true,
    noBind: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports["default"] = (0, _mapElementFactory2.default)({
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,
  mappedProps: props,
  name: 'polygon',
  ctr: function ctr() {
    return google.maps.Polygon;
  },

  beforeCreate: function beforeCreate(options) {
    if (!options.path) delete options.path;
    if (!options.paths) delete options.paths;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    var clearEvents = function () {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        inst.setPaths(paths);

        var updatePaths = function () {
          _this.$emit('paths_changed', inst.getPaths());
        };
        var eventListeners = [];

        var mvcArray = inst.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        inst.setPaths(path);

        var mvcPath = inst.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', inst.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),

/***/ 9562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports["default"] = (0, _mapElementFactory2.default)({
  mappedProps: props,
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,

  name: 'polyline',
  ctr: function ctr() {
    return google.maps.Polyline;
  },

  afterCreate: function afterCreate() {
    var _this = this;

    var clearEvents = function () {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),

/***/ 9605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports["default"] = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'rectangle',
  ctr: function ctr() {
    return google.maps.Rectangle;
  },
  events: events
});

/***/ }),

/***/ 19:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(8636);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(8179);

var _mountableMixin = __webpack_require__(4062);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(7777);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(7382);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(8336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

exports["default"] = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
  replace: false, // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },

  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),

/***/ 6292:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreetViewPanorama = exports.MountableMixin = exports.Autocomplete = exports.MapElementFactory = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Cluster = exports.Circle = exports.Polygon = exports.Polyline = exports.Marker = exports.loadGmapApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Vue component imports


exports.install = install;
exports.gmapApi = gmapApi;

var _lazyValue = __webpack_require__(7009);

var _lazyValue2 = _interopRequireDefault(_lazyValue);

var _manager = __webpack_require__(6922);

var _marker = __webpack_require__(3576);

var _marker2 = _interopRequireDefault(_marker);

var _polyline = __webpack_require__(9562);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(890);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(4001);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(9605);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = __webpack_require__(6388);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(391);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(7483);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(6891);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(9972);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(9859);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mapElementFactory = __webpack_require__(8336);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

var _mountableMixin = __webpack_require__(4062);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var Cluster = undefined;

var GmapApi = null;

// export everything
exports.loadGmapApi = _manager.loadGmapApi;
exports.Marker = _marker2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Cluster = Cluster;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.MapElementFactory = _mapElementFactory2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
exports.StreetViewPanorama = _streetViewPanorama2.default;
function install(Vue, options) {
  // Set defaults
  options = _extends({
    installComponents: true,
    autobindAllEvents: false
  }, options);

  // Update the global `GmapApi`. This will allow
  // components to use the `google` global reactively
  // via:
  //   import {gmapApi} from 'vue2-google-maps'
  //   export default {  computed: { google: gmapApi }  }
  GmapApi = new Vue({ data: { gmapApi: null } });

  var defaultResizeBus = new Vue();

  // Use a lazy to only load the API when
  // a VGM component is loaded
  var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
      this.$gmapOptions = options;
      this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  });
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

function makeGmapApiPromiseLazy(options) {
  // Things to do once the API is loaded
  function onApiLoaded() {
    GmapApi.gmapApi = {};
    return window.google;
  }

  if (options.load) {
    // If library should load the API
    return (0, _lazyValue2.default)(function () {
      // Load the
      // This will only be evaluated once
      if (typeof window === 'undefined') {
        // server side -- never resolve this promise
        return new Promise(function () {}).then(onApiLoaded);
      } else {
        return new Promise(function (resolve, reject) {
          try {
            window['vueGoogleMapsInit'] = resolve;
            (0, _manager.loadGmapApi)(options.load, options.loadCn);
          } catch (err) {
            reject(err);
          }
        }).then(onApiLoaded);
      }
    });
  } else {
    // If library should not handle API, provide
    // end-users with the global `vueGoogleMapsInit: () => undefined`
    // when the Google Maps API has been loaded
    var promise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
      }
      window['vueGoogleMapsInit'] = resolve;
    }).then(onApiLoaded);

    return (0, _lazyValue2.default)(function () {
      return promise;
    });
  }
}

function gmapApi() {
  return GmapApi.gmapApi && window.google;
}

/***/ }),

/***/ 6922:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isApiSetUp = false;

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var loadGmapApi = exports.loadGmapApi = function (options, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!isApiSetUp) {
    isApiSetUp = true;

    var googleMapScript = document.createElement('SCRIPT');

    // Allow options to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      throw new Error('options should  be an object');
    }

    // libraries
    if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'https://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.head.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),

/***/ 7777:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

/***/ }),

/***/ 7382:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */
function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
  var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isHandled = false;

  function requestHandle() {
    if (!isHandled) {
      isHandled = true;
      vueInst.$nextTick(function () {
        isHandled = false;
        handler();
      });
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      vueInst.$watch(prop, requestHandle, { immediate: immediate });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),

/***/ 8636:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

exports["default"] = function (vueInst, googleMapsInst, events) {
  var _loop = function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/***/ }),

/***/ 8179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getPropsValues = getPropsValues;
exports.bindProps = bindProps;

var _WatchPrimitiveProperties = __webpack_require__(7382);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPropsValues(vueInst, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (vueInst[prop] !== undefined) {
      acc[prop] = vueInst[prop];
    }
    return acc;
  }, {});
}

/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */
function bindProps(vueInst, googleMapsInst, props) {
  var _loop = function (attribute) {
    var _props$attribute = props[attribute],
        twoWay = _props$attribute.twoWay,
        type = _props$attribute.type,
        trackProperties = _props$attribute.trackProperties,
        noBind = _props$attribute.noBind;


    if (noBind) return 'continue';

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueInst[attribute];

    if (typeof googleMapsInst[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueInst.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueInst.$watch(attribute, function () {
        var attributeValue = vueInst[attribute];

        googleMapsInst[setMethodName](attributeValue);
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      (0, _WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function (prop) {
        return attribute + '.' + prop;
      }), function () {
        googleMapsInst[setMethodName](vueInst[attribute]);
      }, vueInst[attribute] !== undefined);
    }

    if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) {
      googleMapsInst.addListener(eventName, function () {
        // eslint-disable-line no-unused-vars
        vueInst.$emit(eventName, googleMapsInst[getMethodName]());
      });
    }
  };

  for (var attribute in props) {
    var _ret = _loop(attribute);

    if (_ret === 'continue') continue;
  }
}

/***/ }),

/***/ 7009:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports["default"] = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};

/***/ }),

/***/ 4062:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports["default"] = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),

/***/ 3166:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports["default"] = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function (event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),

/***/ 939:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/*! (c) 2020 Andrea Giammarchi */

const {parse: $parse, stringify: $stringify} = JSON;
const {keys} = Object;

const Primitive = String;   // it could be Number
const primitive = 'string'; // it could be 'number'

const ignore = {};
const object = 'object';

const noop = (_, value) => value;

const primitives = value => (
  value instanceof Primitive ? Primitive(value) : value
);

const Primitives = (_, value) => (
  typeof value === primitive ? new Primitive(value) : value
);

const revive = (input, parsed, output, $) => {
  const lazy = [];
  for (let ke = keys(output), {length} = ke, y = 0; y < length; y++) {
    const k = ke[y];
    const value = output[k];
    if (value instanceof Primitive) {
      const tmp = input[value];
      if (typeof tmp === object && !parsed.has(tmp)) {
        parsed.add(tmp);
        output[k] = ignore;
        lazy.push({k, a: [input, parsed, tmp, $]});
      }
      else
        output[k] = $.call(output, k, tmp);
    }
    else if (output[k] !== ignore)
      output[k] = $.call(output, k, value);
  }
  for (let {length} = lazy, i = 0; i < length; i++) {
    const {k, a} = lazy[i];
    output[k] = $.call(output, k, revive.apply(null, a));
  }
  return output;
};

const set = (known, input, value) => {
  const index = Primitive(input.push(value) - 1);
  known.set(value, index);
  return index;
};

const parse = (text, reviver) => {
  const input = $parse(text, Primitives).map(primitives);
  const value = input[0];
  const $ = reviver || noop;
  const tmp = typeof value === object && value ?
              revive(input, new Set, value, $) :
              value;
  return $.call({'': tmp}, '', tmp);
};
exports.parse = parse;

const stringify = (value, replacer, space) => {
  const $ = replacer && typeof replacer === object ?
            (k, v) => (k === '' || -1 < replacer.indexOf(k) ? v : void 0) :
            (replacer || noop);
  const known = new Map;
  const input = [];
  const output = [];
  let i = +set(known, input, $.call({'': value}, '', value));
  let firstRun = !i;
  while (i < input.length) {
    firstRun = true;
    output[i] = $stringify(input[i++], replace, space);
  }
  return '[' + output.join(',') + ']';
  function replace(key, value) {
    if (firstRun) {
      firstRun = !firstRun;
      return value;
    }
    const after = $.call(this, key, value);
    switch (typeof after) {
      case object:
        if (after === null) return after;
      case primitive:
        return known.get(after) || set(known, input, after);
    }
    return after;
  }
};
exports.stringify = stringify;

const toJSON = any => $parse(stringify(any));
exports.toJSON = toJSON;
const fromJSON = any => parse($stringify(any));
exports.fromJSON = fromJSON;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./src/plugin/Signup.js
class Signup {
    constructor(Vue, store, solutionTypes, upsellSolutionTypes, googleMapsKey, pageRequestedFrom, testSignup, decoInStock, fibreFreeze, vendorScope, fibreTypeScope, signalUuid) {
		this.$store = store;

        store.commit('signupCoverage/updateSolutionTypes', solutionTypes);
		store.commit('signupCoverage/updateUpsellSolutionTypes', upsellSolutionTypes);
		store.commit('signupGeneral/updateGoogleMapsKey', googleMapsKey);
		store.commit('signupGeneral/updatePageRequestedFrom', pageRequestedFrom);
		store.commit('signupGeneral/updateTestSignup', testSignup);
		if (decoInStock !== undefined) {
			store.commit('signupGeneral/updateDecoInStock', decoInStock);
		}
		if (fibreFreeze !== undefined) {
			store.commit('signupGeneral/updateFibreFreeze', fibreFreeze);
		}
		if (vendorScope !== undefined) {
			store.commit('signupCoverage/updateVendorScope', vendorScope);
		}
		if (fibreTypeScope !== undefined) {
			store.commit('signupGeneral/setFibreTypeScope', fibreTypeScope);
		}
		if (signalUuid !== undefined) {
			store.commit('signupSignal/setUuid', signalUuid);
		}

		if(window) {
			window.___ = function(token) {
				if(false) {}
			}
		}
    }
}

/* harmony default export */ var plugin_Signup = (Signup);

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchBar.vue?vue&type=template&id=2deab18e&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.inputBlur),expression:"inputBlur"}],staticClass:"search-bar"},[_c('div',{staticClass:"search-bar-inner",class:{'has-predictions': _vm.hasPredictions, 'wobble': _vm.wobble}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchAddress),expression:"searchAddress"}],attrs:{"autocomplete":"off","id":"search","type":"text","placeholder":"What's your street address?"},domProps:{"value":(_vm.searchAddress)},on:{"keyup":_vm.navigatePredictions,"focus":function($event){return _vm.inputFocus()},"input":function($event){if($event.target.composing)return;_vm.searchAddress=$event.target.value}}}),_c('loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('current-location',{directives:[{name:"show",rawName:"v-show",value:(_vm.geoLocationSupported && _vm.showGeoLocation && !_vm.loading && _vm.showCurrentLocation),expression:"geoLocationSupported && showGeoLocation && !loading && showCurrentLocation"}],on:{"error":function($event){return _vm.wobbleBar()},"toggleLoader":_vm.toggleLoading,"location":_vm.getPlaceFromPosition}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showCurrentLocation && !_vm.loading),expression:"!showCurrentLocation && !loading"}],staticClass:"clear-icon",on:{"click":function($event){$event.preventDefault();return _vm.clearAddress()}}},[_c('svg',{staticClass:"signup-icon"},[_c('use',{attrs:{"href":"#cross"}})])])],1),_c('search-predictions',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPredictions),expression:"showPredictions"}],attrs:{"predictions":_vm.predictions,"index":_vm.predictionIndex},on:{"select":_vm.selectPrediction}}),_c('GmapMap',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGeoLocation),expression:"showGeoLocation"}],staticStyle:{"width":"0","height":"0","max-height":"0"},attrs:{"center":{lat:10, lng:10}}}),(_vm.ctas && _vm.ctas.length)?_c('div',{staticClass:"search-bar-ctas"},_vm._l((_vm.ctas),function(cta,i){return _c('button',{key:i,staticClass:"button",class:cta.cssClass,attrs:{"id":cta.id},on:{"click":function($event){$event.preventDefault();return _vm.handleCtaEvent(cta.event)}}},[_c('span',[_vm._v(_vm._s(cta.label))])])}),0):_vm._e(),_c('icons')],1)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/IconSymbols.vue?vue&type=template&id=8af2b0e6&
var IconSymbolsvue_type_template_id_8af2b0e6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"display":"none"}},[_c('symbol',{attrs:{"viewBox":"0 0 99 28","id":"provider-mtn-lte"}},[_c('path',{attrs:{"d":"M10.5133339,6.34158971 C15.9150772,6.34158971 18.1719168,8.86113748 17.2835074,13.89937 C16.3025805,19.4630189 13.2980064,22.2445844 8.2696125,22.2445844 C7.19910244,22.2445844 6.16328644,21.9922327 5.16199189,21.4873565 L4.71045137,24.0472944 C4.30741348,26.3333046 2.32122206,28 0,28 L3.7041512,6.99300941 C5.89091223,6.55907483 8.16069733,6.34158971 10.5133339,6.34158971 Z M53.9252093,6.34164149 C58.7511349,6.34164149 60.7299042,8.80526452 59.8609994,13.732338 C59.7453526,14.3885907 59.5841374,15.0448434 59.3776991,15.7010961 L48.8219039,15.7010961 C48.4266333,17.942401 49.874808,19.0631397 53.1660827,19.0631397 C54.7715025,19.0631397 56.4035039,18.9117632 58.062432,18.6088375 L57.5014585,21.7892984 C56.0444809,22.092224 54.3115043,22.2436006 52.3025287,22.2436006 C46.5374471,22.2436006 44.1328558,19.532804 45.0889272,14.1110382 C46.0021921,8.93161301 48.9475619,6.34164149 53.9252093,6.34164149 Z M24.425356,6.34162423 L22.6576853,16.3675153 C22.3478554,18.1243117 22.9602658,19.0025373 24.4950893,19.0025373 C25.5003538,19.0025373 26.6243721,18.4158453 27.7915422,17.6696643 C28.4500388,17.2486752 28.9062398,16.5744714 29.041909,15.8048157 L30.7105032,6.34162423 L34.7237939,6.34162423 L32.6231639,18.2549754 C32.2165013,20.5616985 30.2121861,22.2435833 27.8699059,22.2435833 L28.1740399,20.518374 C26.1079313,21.8716147 24.5342712,22.2435833 22.4847329,22.2435833 C19.2336757,22.2435833 17.9474066,20.3202209 18.6255804,16.4733236 L20.4120652,6.34162423 L24.425356,6.34162423 Z M40.8996979,6.34179684 L40.4971779,8.37096746 C42.1526538,7.01824458 43.7577285,6.34179684 45.3125744,6.34179684 L44.6846293,9.58267023 C43.1903685,9.58267023 41.7321826,10.2035384 40.3105895,11.4452749 L38.2184172,22.2434107 L34.2049538,22.2434107 L37.2859929,6.34179684 L40.8996979,6.34179684 Z M69.8588936,0 C71.9997411,0 73.6217313,1.93302839 73.2499353,4.04142574 L70.0579097,22.1449901 L65.9540002,22.1449901 L69.8588936,0 Z M92.7755588,6.2597221 C97.5963062,6.2597221 99.5731768,8.72075602 98.7053077,13.6426512 C98.5898334,14.2982135 98.4284457,14.9537758 98.22218,15.6093381 L87.6774316,15.6093381 C87.2826789,17.8483991 88.7293001,18.967757 92.0174679,18.967757 C93.620989,18.967757 95.251437,18.8167256 96.9082938,18.5139726 L96.3481833,21.6911539 C94.8925865,21.9937344 93.1616812,22.1449383 91.1546043,22.1449383 C85.395564,22.1449383 82.9935618,19.437076 83.9485976,14.0208337 C84.8608268,8.84693191 87.8030897,6.2597221 92.7755588,6.2597221 Z M80.2614482,3.69657375 L79.7674463,6.24839907 L85.1086045,6.24839907 L85.0328299,6.46329507 C84.4209157,8.20034737 82.7925228,9.36932298 80.9559553,9.39827595 L80.8861137,9.39882627 L79.1540002,9.39882627 L77.7180806,16.7950462 C77.5775783,17.5194787 77.5056011,18.0645724 77.6196945,18.4318806 C77.7381971,18.7865518 78.0384812,18.9695046 78.6343368,18.980267 L78.6910676,18.9807716 L80.8144817,18.9807716 L80.2,22.1444895 L77.0238543,22.1444895 C76.8911194,22.1455252 76.786692,22.1444895 76.6655217,22.1444895 C74.848658,22.1444895 73.7866057,21.4806421 73.4795374,20.1406922 C73.3407878,19.5529977 73.3480585,18.8358799 73.502577,17.9879574 L73.5218262,17.8855787 L76.2799171,3.69657375 L80.2614482,3.69657375 Z M10.1083973,9.58280832 C8.96729093,9.58280832 8.00586865,9.65357728 7.22361267,9.79494261 L5.76007595,18.0947614 C6.66367481,18.639855 7.69103305,18.9125744 8.84197808,18.9125744 C11.2350047,18.9125744 12.7280573,17.23138 13.3207905,13.8691637 C13.8246311,11.0118236 12.7537758,9.58280832 10.1083973,9.58280832 Z M53.3697592,9.49172348 C51.249452,9.49172348 49.8972469,10.6328299 49.3133166,12.9143523 L56.0979891,12.9143523 L56.1193924,12.7933546 C56.5074135,10.5924398 55.5908691,9.49172348 53.3697592,9.49172348 Z M92.2207992,9.40652455 C90.1027358,9.40652455 88.7520842,10.5464227 88.1683266,12.8255286 L94.9462674,12.8255286 L94.9674981,12.7045309 C95.3551739,10.5060326 94.4393199,9.40652455 92.2207992,9.40652455 Z","fill-rule":"nonzero"}})]),_c('symbol',{attrs:{"viewBox":"0 0 190 42","id":"provider-mtn-lte-black-friday-2021"}},[_c('path',{attrs:{"d":"M158.131,31.629 C159.286955,31.629 160.13676,32.4390186 160.211627,33.4502372 L160.217,33.596 L160.217,33.61 C160.217,34.688 159.335,35.591 158.117,35.591 C156.967727,35.591 156.118225,34.7809814 156.043372,33.7697628 L156.038,33.624 L156.038,33.61 C156.038,32.532 156.92,31.629 158.131,31.629 Z M169.52,31.629 C170.675955,31.629 171.52576,32.4390186 171.600627,33.4502372 L171.606,33.596 L171.606,33.61 C171.606,34.688 170.724,35.591 169.506,35.591 C168.356727,35.591 167.507225,34.7809814 167.432372,33.7697628 L167.427,33.624 L167.427,33.61 C167.427,32.532 168.309,31.629 169.52,31.629 Z M10.5133339,13.8415897 C15.9150772,13.8415897 18.1719168,16.3611375 17.2835074,21.39937 C16.3025805,26.9630189 13.2980064,29.7445844 8.2696125,29.7445844 C7.19910244,29.7445844 6.16328644,29.4922327 5.16199189,28.9873565 L4.71045137,31.5472944 C4.30741348,33.8333046 2.32122206,35.5 0,35.5 L3.7041512,14.4930094 C5.89091223,14.0590748 8.16069733,13.8415897 10.5133339,13.8415897 Z M150.732,30.6 C151.905333,30.6 152.685016,31.1777778 152.756611,32.1640212 L152.762,32.315 L152.762,32.329 C152.762,33.4356667 151.955651,34.040746 150.832748,34.0958632 L150.662,34.1 L149.983,34.1 L149.983,35.5 L148.625,35.5 L148.625,30.6 L150.732,30.6 Z M155.786,31.65 L155.786,33.05 L155.674,33.05 C155.024313,33.05 154.639176,33.4006836 154.593572,34.159729 L154.589,34.317 L154.589,35.5 L153.259,35.5 L153.259,31.713 L154.589,31.713 L154.589,32.476 C154.806,31.958 155.156,31.622 155.786,31.65 Z M165.593,31.629 C166.350647,31.629 166.829263,32.0754498 166.882949,32.8633025 L166.888,33.015 L166.888,35.5 L165.558,35.5 L165.558,33.442 C165.558,33.029 165.355,32.805 165.04,32.805 C164.7565,32.805 164.54104,32.98644 164.500783,33.323805 L164.494,33.442 L164.494,35.5 L163.171,35.5 L163.171,33.442 C163.171,33.029 162.961,32.805 162.646,32.805 C162.3625,32.805 162.15271,32.98644 162.113587,33.323805 L162.107,33.442 L162.107,35.5 L160.777,35.5 L160.777,31.713 L162.107,31.713 L162.107,32.231 C162.352,31.916 162.702,31.629 163.234,31.629 C163.738,31.629 164.123,31.853 164.326,32.245 C164.655,31.867 165.04,31.629 165.593,31.629 Z M158.117,32.749 C157.671154,32.749 157.37442,33.0770473 157.331407,33.4908917 L157.326,33.596 L157.326,33.61 C157.326,34.072 157.662,34.464 158.131,34.464 C158.576846,34.464 158.879544,34.1359527 158.923475,33.727614 L158.929,33.624 L158.929,33.61 C158.929,33.141 158.586,32.749 158.117,32.749 Z M169.506,32.749 C169.060154,32.749 168.76342,33.0770473 168.720407,33.4908917 L168.715,33.596 L168.715,33.61 C168.715,34.072 169.051,34.464 169.52,34.464 C169.965846,34.464 170.268544,34.1359527 170.312475,33.727614 L170.318,33.624 L170.318,33.61 C170.318,33.141 169.975,32.749 169.506,32.749 Z M150.627,31.741 L149.983,31.741 L149.983,33.036 L150.634,33.036 C151.070333,33.036 151.359618,32.8183681 151.404802,32.485548 L151.411,32.392 L151.411,32.378 C151.411,31.958 151.11,31.741 150.627,31.741 Z M53.9252093,13.8416415 C58.7511349,13.8416415 60.7299042,16.3052645 59.8609994,21.232338 C59.7453526,21.8885907 59.5841374,22.5448434 59.3776991,23.2010961 L48.8219039,23.2010961 C48.4266333,25.442401 49.874808,26.5631397 53.1660827,26.5631397 C54.7715025,26.5631397 56.4035039,26.4117632 58.062432,26.1088375 L57.5014585,29.2892984 C56.0444809,29.592224 54.3115043,29.7436006 52.3025287,29.7436006 C46.5374471,29.7436006 44.1328558,27.032804 45.0889272,21.6110382 C46.0021921,16.431613 48.9475619,13.8416415 53.9252093,13.8416415 Z M24.425356,13.8416242 L22.6576853,23.8675153 C22.3478554,25.6243117 22.9602658,26.5025373 24.4950893,26.5025373 C25.5003538,26.5025373 26.6243721,25.9158453 27.7915422,25.1696643 C28.4500388,24.7486752 28.9062398,24.0744714 29.041909,23.3048157 L30.7105032,13.8416242 L34.7237939,13.8416242 L32.6231639,25.7549754 C32.2165013,28.0616985 30.2121861,29.7435833 27.8699059,29.7435833 L28.1740399,28.018374 C26.1079313,29.3716147 24.5342712,29.7435833 22.4847329,29.7435833 C19.2336757,29.7435833 17.9474066,27.8202209 18.6255804,23.9733236 L20.4120652,13.8416242 L24.425356,13.8416242 Z M40.8996979,13.8417968 L40.4971779,15.8709675 C42.1526538,14.5182446 43.7577285,13.8417968 45.3125744,13.8417968 L44.6846293,17.0826702 C43.1903685,17.0826702 41.7321826,17.7035384 40.3105895,18.9452749 L38.2184172,29.7434107 L34.2049538,29.7434107 L37.2859929,13.8417968 L40.8996979,13.8417968 Z M69.8588936,7.5 C71.9997411,7.5 73.6217313,9.43302839 73.2499353,11.5414257 L70.0579097,29.6449901 L65.9540002,29.6449901 L69.8588936,7.5 Z M92.7755588,13.7597221 C97.5963062,13.7597221 99.5731768,16.220756 98.7053077,21.1426512 C98.5898334,21.7982135 98.4284457,22.4537758 98.22218,23.1093381 L87.6774316,23.1093381 C87.2826789,25.3483991 88.7293001,26.467757 92.0174679,26.467757 C93.620989,26.467757 95.251437,26.3167256 96.9082938,26.0139726 L96.3481833,29.1911539 C94.8925865,29.4937344 93.1616812,29.6449383 91.1546043,29.6449383 C85.395564,29.6449383 82.9935618,26.937076 83.9485976,21.5208337 C84.8608268,16.3469319 87.8030897,13.7597221 92.7755588,13.7597221 Z M80.2614482,11.1965737 L79.7674463,13.7483991 L85.1086045,13.7483991 L85.0328299,13.9632951 C84.4209157,15.7003474 82.7925228,16.869323 80.9559553,16.8982759 L79.1540002,16.8988263 L77.7180806,24.2950462 C77.5775783,25.0194787 77.5056011,25.5645724 77.6196945,25.9318806 C77.7381971,26.2865518 78.0384812,26.4695046 78.6343368,26.480267 L80.8144817,26.4807716 L80.2,29.6444895 L76.6655217,29.6444895 L76.6655217,29.6444895 C74.848658,29.6444895 73.7866057,28.9806421 73.4795374,27.6406922 C73.3407878,27.0529977 73.3480585,26.3358799 73.502577,25.4879574 L73.5218262,25.3855787 L76.2799171,11.1965737 L80.2614482,11.1965737 Z M10.1083973,17.0828083 C8.96729093,17.0828083 8.00586865,17.1535773 7.22361267,17.2949426 L5.76007595,25.5947614 C6.66367481,26.139855 7.69103305,26.4125744 8.84197808,26.4125744 C11.2350047,26.4125744 12.7280573,24.73138 13.3207905,21.3691637 C13.8246311,18.5118236 12.7537758,17.0828083 10.1083973,17.0828083 Z M53.3697592,16.9917235 C51.249452,16.9917235 49.8972469,18.1328299 49.3133166,20.4143523 L56.0979891,20.4143523 L56.1193924,20.2933546 C56.5074135,18.0924398 55.5908691,16.9917235 53.3697592,16.9917235 Z M92.2207992,16.9065246 C90.1027358,16.9065246 88.7520842,18.0464227 88.1683266,20.3255286 L94.9462674,20.3255286 L94.9674981,20.2045309 C95.3551739,18.0060326 94.4393199,16.9065246 92.2207992,16.9065246 Z"}}),_c('image',{attrs:{"id":"Summer-01","x":"105.38","y":"0","width":"84.24","height":"41.76","xlink:href":"data:image/png;base64,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"}})]),_c('symbol',{attrs:{"viewBox":"0 0 88 22","id":"provider-telkom-lte"}},[_c('path',{attrs:{"d":"M9.82678004,4.18110958 L9.82678004,21.6462304 C9.47338297,21.6863387 9.11831331,21.7197223 8.76157104,21.7492631 C8.40841292,21.7792843 8.06194521,21.7939346 7.72646888,21.7939346 C7.39075362,21.7939346 7.03138297,21.7814458 6.64620646,21.7639135 C6.26174677,21.7463811 5.87250822,21.7057924 5.47490665,21.6462304 L5.47490665,4.18110958 L0.177534834,4.18110958 C0.0604526419,3.59605685 -2.84217094e-14,2.97954193 -2.84217094e-14,2.3363682 C-2.84217094e-14,1.72657802 0.0604526419,1.12999716 0.177534834,0.540381214 L15.1272581,0.540381214 C15.2472076,1.12999716 15.3069434,1.72657802 15.3069434,2.3363682 C15.3069434,2.97954193 15.2472076,3.59605685 15.1272581,4.18110958 L9.82678004,4.18110958 Z M36.9224665,21.8234755 C37.6323669,21.8234755 38.3319928,21.7639135 39.0239724,21.6462304 L39.0239724,0.191415035 C38.3319928,0.0715704897 37.6323669,0.0141699963 36.9224665,0.0141699963 C36.2118493,0.0141699963 35.5201086,0.0715704897 34.8515454,0.191415035 L34.8515454,21.6462304 C35.5201086,21.7639135 36.2118493,21.8234755 36.9224665,21.8234755 L36.9224665,21.8234755 Z M43.9665135,13.4874348 L47.8749082,6.46992424 C47.1628573,6.35560359 46.4319299,6.29532106 45.6842765,6.29532106 C44.8924186,6.29532106 44.1144194,6.35560359 43.3433495,6.46992424 L39.5553822,13.69326 L43.9956646,21.6462304 C44.7655397,21.7643938 45.4933609,21.8229951 46.1853405,21.8229951 C46.9349055,21.8229951 47.7172057,21.7643938 48.5274622,21.6462304 L43.9665135,13.4874348 Z M87.2142857,21.6462304 L87.2142857,11.9916596 C87.2142857,9.97423637 86.804498,8.49455252 85.9882679,7.54252091 C85.1665421,6.59505251 83.891302,6.11951704 82.1525119,6.11951704 C81.0454879,6.11951704 80.1365477,6.38898714 79.4135055,6.92792734 C78.6938084,7.46542652 78.1363538,8.09539093 77.7411417,8.82166328 C77.0718616,7.01943189 75.541908,6.11951704 73.1531924,6.11951704 C72.5995609,6.11951704 72.1018421,6.19372939 71.6583634,6.34095325 C71.2146458,6.48793694 70.8141769,6.67646995 70.4583904,6.91135565 C70.1042765,7.14792253 69.7977123,7.41282941 69.5427599,7.70367459 C69.2839843,7.99572062 69.0777763,8.29064868 68.9195959,8.58485623 C68.9002415,8.44771948 68.8756303,8.28392393 68.8445677,8.08458331 C68.8158945,7.8929281 68.7812477,7.69094561 68.7425389,7.48343923 C68.7014407,7.28313792 68.6586699,7.08043493 68.6094476,6.89718565 C68.5595084,6.71321587 68.5071798,6.57031506 68.4467272,6.46992424 C68.1685973,6.4144451 67.904326,6.37025392 67.647701,6.34095325 C67.3896423,6.31213292 67.0947863,6.29532106 66.7581153,6.29532106 C66.4228779,6.29532106 66.1182252,6.31213292 65.8434405,6.34095325 C65.563399,6.37025392 65.2888532,6.4144451 65.0114401,6.46992424 L65.0114401,21.6462304 C65.7244468,21.7643938 66.4228779,21.8229951 67.1134239,21.8229951 C67.8054035,21.8229951 68.5071798,21.7643938 69.2168413,21.6462304 L69.2168413,13.69326 C69.2168413,12.8709198 69.29402,12.20493 69.4531562,11.6972119 C69.6120534,11.1878125 69.8216067,10.7948953 70.0908957,10.5078928 C70.3577953,10.2252134 70.6559965,10.0337984 70.990517,9.93749045 C71.3276659,9.83782013 71.6631423,9.7917076 71.9983796,9.7917076 C72.8083973,9.7917076 73.3419575,10.0731862 73.6114855,10.6383048 C73.8795798,11.2094277 74.0112376,12.0209602 74.0112376,13.0781861 L74.0112376,21.6462304 C74.7230495,21.7643938 75.4214806,21.8229951 76.1120266,21.8229951 C76.8037673,21.8229951 77.503871,21.7643938 78.2161609,21.6462304 L78.2161609,13.4578939 C78.2161609,12.6951158 78.2993131,12.074518 78.4670513,11.592498 C78.6345505,11.1131198 78.851511,10.7418179 79.1196053,10.4785922 C79.3857881,10.2129648 79.6796883,10.0337984 80.0082352,9.93749045 C80.3329591,9.83782013 80.6610282,9.7917076 80.9988939,9.7917076 C81.8065221,9.7917076 82.346056,10.0731862 82.6100883,10.6383048 C82.8767489,11.2094277 83.011274,12.0209602 83.011274,13.0781861 L83.011274,21.6462304 C83.7230859,21.7643938 84.421517,21.8229951 85.1113462,21.8229951 C85.8038037,21.8229951 86.5043853,21.7643938 87.2142857,21.6462304 L87.2142857,21.6462304 Z M22.2207663,12.4302089 L16.2428841,12.4302089 C16.3401341,11.4339862 16.6462204,10.6596799 17.1616209,10.1106526 C17.6746321,9.56498766 18.4230023,9.29023384 19.4088822,9.29023384 C20.2803082,9.29023384 20.9567566,9.58107902 21.4384661,10.1548438 C21.9199368,10.7338923 22.1827744,11.4928277 22.2207663,12.4302089 L22.2207663,12.4302089 Z M26.1900916,13.3675902 C26.1900916,12.3514334 26.0405131,11.3977206 25.746374,10.5078928 C25.4505622,9.61662409 25.0113845,8.85096395 24.4266904,8.2025065 C23.8465362,7.55645073 23.139981,7.04897273 22.3113258,6.67646995 C21.4817149,6.3075697 20.5364554,6.11951704 19.4693348,6.11951704 C18.2445117,6.11951704 17.1754796,6.32870461 16.2581765,6.7506823 C15.3394397,7.17145914 14.5705204,7.74498373 13.9504626,8.4664527 C13.3277765,9.19464641 12.8575362,10.0458069 12.5421311,11.0213751 C12.2262481,12.0029475 12.0685456,13.0448025 12.0685456,14.1668741 C12.0685456,15.2968712 12.2214693,16.3418484 12.5289892,17.3039672 C12.832925,18.2622432 13.3060327,19.0886662 13.9504626,19.7861182 C14.5884411,20.4768455 15.4180521,21.0225104 16.4337998,21.4130259 C17.451698,21.8047423 18.6691139,22 20.0893926,22 C22.0272223,22 23.7626671,21.7057924 25.3007448,21.1180979 C25.2828241,20.4934172 25.1922646,19.9064431 25.034562,19.3574158 C24.8770984,18.8086286 24.689528,18.3405384 24.4725675,17.9493024 C23.8419963,18.1817864 23.1746278,18.3664767 22.4742851,18.4913648 C21.7737035,18.6208161 21.0850691,18.6820593 20.415789,18.6820593 C19.1919217,18.6820593 18.205325,18.4173926 17.456238,17.8909412 C16.7071509,17.3649702 16.2909117,16.5116482 16.214211,15.3369795 L26.0405131,15.3369795 C26.0818503,15.119386 26.1143466,14.8319032 26.1444534,14.4723696 C26.1747992,14.1097138 26.1900916,13.741534 26.1900916,13.3675902 L26.1900916,13.3675902 Z M58.4426513,12.0382524 C58.4426513,10.4906006 57.1755352,9.23739656 55.6154748,9.23739656 C54.0549364,9.23739656 52.7842362,10.4906006 52.7856687,12.0382524 L52.7856687,16.0471605 C52.7856687,17.5955328 54.0549364,18.8513788 55.6154748,18.8513788 C57.1774468,18.8513788 58.4426513,17.5955328 58.4426513,16.0471605 L58.4426513,12.0382524 Z M62.4793585,17.1757167 C62.186653,18.1299098 61.7350503,18.9596952 61.1283734,19.6698762 C60.5190681,20.3778957 59.7570781,20.9346084 58.8345182,21.3320888 C57.9150646,21.7298094 56.8350411,21.9303509 55.6030497,21.9303509 C54.3662795,21.9303509 53.2912738,21.7298094 52.3789885,21.3320888 C51.4705262,20.9346084 50.7128372,20.3778957 50.1185853,19.6698762 C49.5181209,18.9596952 49.0696245,18.1299098 48.764255,17.1757167 C48.4615139,16.2248859 48.3085902,15.1938386 48.3085902,14.0866575 C48.3085902,12.9785158 48.4615139,11.9421847 48.764255,10.9666164 C49.0696245,9.99705247 49.5181209,9.15525862 50.1185853,8.44435711 C50.7128372,7.73777865 51.4705262,7.17818388 52.3789885,6.76869501 C53.2912738,6.36280867 54.3662795,6.15770398 55.6030497,6.15770398 C56.8350411,6.15770398 57.9150646,6.36280867 58.8345182,6.76869501 C59.7570781,7.17818388 60.5190681,7.73777865 61.1283734,8.44435711 C61.7350503,9.15525862 62.186653,9.99705247 62.4793585,10.9666164 C62.7715861,11.9421847 62.9199699,12.9785158 62.9199699,14.0866575 C62.9199699,15.1938386 62.7715861,16.2248859 62.4793585,17.1757167 L62.4793585,17.1757167 Z M32.4188642,21.6495928 L32.4188642,16.5450318 L32.4188642,6.27058361 L32.4188642,0.177245038 C31.708247,0.0581210017 31.0105327,0 30.3211814,0 C29.6528571,0 28.9608775,0.0581210017 28.2502603,0.177245038 L28.2502603,5.36130215 L28.2502603,15.6364708 L28.2502603,19.4530032 C28.2502603,22.4205367 31.5166145,21.8868802 32.4188642,21.6495928 L32.4188642,21.6495928 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 24 24","id":"coupon"}},[_c('path',{attrs:{"d":"M15.6612529,0.0327570519 C15.87471,0.0909918107 16.0278422,0.226872915 16.1206497,0.440400364 L17.87471,3.58507734 L21.2993039,4.31301183 C21.5034803,4.351835 21.675174,4.46345162 21.8143852,4.64786169 C21.9361949,4.8092205 21.9905017,4.98915681 21.9773057,5.18767061 L21.5777262,8.76797088 L23.7772622,11.4176524 C23.9257541,11.5729451 24,11.767061 24,12 C24,12.232939 23.9257541,12.4270549 23.7772622,12.5823476 L21.5777262,15.2611465 L21.9675174,18.755232 C22.0046404,18.9881711 21.9535963,19.1968456 21.8143852,19.3812557 C21.675174,19.5656658 21.5034803,19.6772824 21.2993039,19.7161056 L17.87471,20.44404 L16.1206497,23.5595996 C16.0278422,23.7731271 15.87471,23.9090082 15.6612529,23.9672429 C15.4477958,24.0254777 15.2389791,24.0060661 15.0348028,23.9090082 L12,22.4240218 L8.96519722,23.9090082 C8.76102088,24.0060661 8.55684455,24.0157719 8.35266821,23.9381256 C8.14849188,23.8604792 7.99071926,23.7245981 7.87935035,23.5304823 L6.15313225,20.44404 L2.70069606,19.7161056 C2.49651972,19.6772824 2.32482599,19.5656658 2.18561485,19.3812557 C2.0638051,19.2198969 2.00949826,19.0399606 2.02269432,18.8414468 L2.42227378,15.2611465 L0.222737819,12.5823476 C0.0742459397,12.4270549 0,12.232939 0,12 C0,11.767061 0.0742459397,11.5729451 0.222737819,11.4176524 L2.42227378,8.76797088 L2.0324826,5.27388535 C1.99535963,5.04094631 2.04640371,4.83227176 2.18561485,4.64786169 C2.32482599,4.46345162 2.49651972,4.351835 2.70069606,4.31301183 L6.15313225,3.58507734 L7.87935035,0.469517743 C7.99071926,0.27540188 8.14849188,0.139520776 8.35266821,0.0618744313 C8.55684455,-0.0157719139 8.76102088,-0.00606612072 8.96519722,0.0909918107 L12,1.57597816 L15.0348028,0.0909918107 C15.2389791,-0.00606612072 15.4477958,-0.025477707 15.6612529,0.0327570519 Z M15.5560917,11.7571429 C15.1415934,11.7571429 14.7650066,11.8285714 14.4263312,11.9714286 C14.0876558,12.1142857 13.799529,12.3071429 13.5619507,12.55 C13.3243725,12.7928571 13.1398702,13.0761905 13.0084439,13.4 C12.8957928,13.677551 12.8314208,13.9725948 12.8153278,14.2851312 L12.8113045,14.4714286 C12.8113045,14.8333333 12.8770176,15.1761905 13.0084439,15.5 C13.1398702,15.8238095 13.3243725,16.1071429 13.5619507,16.35 C13.799529,16.5928571 14.0876558,16.7857143 14.4263312,16.9285714 C14.7650066,17.0714286 15.1365386,17.1428571 15.5409271,17.1428571 C15.9554254,17.1428571 16.3294847,17.0714286 16.6631053,16.9285714 C16.9967258,16.7857143 17.2848527,16.5928571 17.5274858,16.35 C17.7701189,16.1071429 17.9571486,15.8214286 18.0885749,15.4928571 C18.201226,15.2112245 18.265598,14.9173469 18.281691,14.6112245 L18.2857143,14.4285714 C18.2857143,14.0571429 18.2200011,13.7095238 18.0885749,13.3857143 C17.9571486,13.0619048 17.7726463,12.7785714 17.5350681,12.5357143 C17.2974898,12.2928571 17.0118904,12.102381 16.6782699,11.9642857 C16.3446493,11.8261905 15.9705899,11.7571429 15.5560917,11.7571429 Z M17.1180424,7 L15.0708254,7 L11.3555058,11.6142857 L6.88195761,17 L8.92917456,17 L12.5990005,12.4428571 L17.1180424,7 Z M15.5409271,13.3142857 C15.8037797,13.3142857 16.0186111,13.4214286 16.1854213,13.6357143 C16.3313803,13.8232143 16.4134823,14.0526414 16.4317271,14.3239955 L16.4356367,14.4714286 C16.4356367,14.7857143 16.354759,15.047619 16.1930036,15.2571429 C16.0312482,15.4666667 15.8189442,15.5714286 15.5560917,15.5714286 C15.3033488,15.5714286 15.0910449,15.4642857 14.9191797,15.25 C14.7687977,15.0625 14.6842079,14.8367188 14.6654101,14.5726562 L14.661382,14.4285714 C14.661382,14.1047619 14.7397323,13.8380952 14.8964329,13.6285714 C15.0531334,13.4190476 15.2679648,13.3142857 15.5409271,13.3142857 Z M8.45907289,6.85714286 C8.04457465,6.85714286 7.66798782,6.92857143 7.32931242,7.07142857 C6.99063703,7.21428571 6.7025102,7.40714286 6.46493193,7.65 C6.22735367,7.89285714 6.0428514,8.17619048 5.91142512,8.5 C5.79877403,8.77755102 5.73440198,9.07259475 5.71830897,9.3851312 L5.71428571,9.57142857 C5.71428571,9.93333333 5.77999885,10.2761905 5.91142512,10.6 C6.0428514,10.9238095 6.2298811,11.2071429 6.47251422,11.45 C6.71514734,11.6928571 7.00327417,11.8833333 7.33689471,12.0214286 C7.67051525,12.1595238 8.03951979,12.2285714 8.44390832,12.2285714 C8.85840657,12.2285714 9.23246597,12.1571429 9.56608651,12.0142857 C9.89970705,11.8714286 10.1878339,11.6785714 10.430467,11.4357143 C10.6731001,11.1928571 10.8601298,10.9095238 10.9915561,10.5857143 C11.1042072,10.3081633 11.1685792,10.0166181 11.1846722,9.71107872 L11.1886955,9.52857143 C11.1886955,9.15714286 11.1229824,8.80952381 10.9915561,8.48571429 C10.8601298,8.16190476 10.6756275,7.87857143 10.4380493,7.63571429 C10.200471,7.39285714 9.91487162,7.20238095 9.58125108,7.06428571 C9.24763054,6.92619048 8.87357114,6.85714286 8.45907289,6.85714286 Z M8.44390832,8.41428571 C8.70676087,8.41428571 8.92159228,8.52142857 9.08840255,8.73571429 C9.23436154,8.92321429 9.31646347,9.15264137 9.33470834,9.42399554 L9.33861796,9.57142857 C9.33861796,9.88571429 9.25774025,10.147619 9.09598484,10.3571429 C8.93422942,10.5666667 8.72192544,10.6714286 8.45907289,10.6714286 C8.20633006,10.6714286 7.99402608,10.5642857 7.82216095,10.35 C7.67177896,10.1625 7.5871891,9.93671875 7.56839135,9.67265625 L7.56436326,9.52857143 C7.56436326,9.2047619 7.64524097,8.93809524 7.80699638,8.72857143 C7.9687518,8.51904762 8.18105578,8.41428571 8.44390832,8.41428571 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 9 12","id":"padlock"}},[_c('path',{attrs:{"d":"M7.875,4 L7.3125,4 L7.3125,2.85714286 C7.3125,1.28 6.0525,0 4.5,0 C2.9475,0 1.6875,1.28 1.6875,2.85714286 L1.6875,4 L1.125,4 C0.50625,4 0,4.51428571 0,5.14285714 L0,10.8571429 C0,11.4857143 0.50625,12 1.125,12 L7.875,12 C8.49375,12 9,11.4857143 9,10.8571429 L9,5.14285714 C9,4.51428571 8.49375,4 7.875,4 Z M4.5,9.14285714 C3.88125,9.14285714 3.375,8.62857143 3.375,8 C3.375,7.37142857 3.88125,6.85714286 4.5,6.85714286 C5.11875,6.85714286 5.625,7.37142857 5.625,8 C5.625,8.62857143 5.11875,9.14285714 4.5,9.14285714 Z M6.24375,4 L2.75625,4 L2.75625,2.85714286 C2.75625,1.88 3.538125,1.08571429 4.5,1.08571429 C5.461875,1.08571429 6.24375,1.88 6.24375,2.85714286 L6.24375,4 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 13 13","id":"cross"}},[_c('polygon',{attrs:{"fill-rule":"nonzero","points":"12.2 1.23878571 10.9712857 0 6.1 4.91121429 1.22871429 0 0 1.23878571 4.87128571 6.15 0 11.0612143 1.22871429 12.3 6.1 7.38878571 10.9712857 12.3 12.2 11.0612143 7.32871429 6.15"}})]),_c('symbol',{attrs:{"viewBox":"0 0 20 20","id":"search"}},[_c('path',{attrs:{"d":"M7.507,0 L7.74995865,0.00383306571 C11.7835506,0.131280277 15.015,3.42078431 15.015,7.46 L15.015,7.46 L15.0080207,7.7846877 C14.9431022,9.29169333 14.4284,10.6808667 13.594,11.827 L13.594,11.827 L19.632,17.856 L19.7236409,17.9578987 C20.1206933,18.4507733 20.0893333,19.1746667 19.632,19.632 L19.632,19.632 L19.5221399,19.7295277 C19.294,19.9096327 19.018,20 18.742,20 L18.742,20 L18.6041691,19.9924723 C18.3293061,19.9623673 18.062,19.842 17.852,19.632 L17.852,19.632 L11.802,13.59 L11.836,13.555 L11.5878444,13.7222222 C10.4134,14.4800889 9.01246667,14.92 7.507,14.92 L7.507,14.92 L7.26404249,14.9161669 C3.23048827,14.7887197 -8.70414851e-14,11.4992157 -8.70414851e-14,7.46 C-8.70414851e-14,3.34 3.361,0 7.507,0 L7.507,0 Z M7.507,2.444 L7.28802325,2.44863482 C4.60161773,2.56257341 2.459,4.76289474 2.459,7.46 C2.459,10.23 4.719,12.476 7.507,12.476 L7.507,12.476 L7.72589986,12.4713652 C10.4113823,12.3574266 12.554,10.1571053 12.554,7.46 L12.554,7.46 L12.5493363,7.24243581 C12.4346877,4.57334488 10.2206579,2.444 7.507,2.444 L7.507,2.444 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 21 30","id":"pin"}},[_c('path',{attrs:{"d":"M10.5,0 C4.695,0 0,4.695 0,10.5 C0,18.375 10.5,30 10.5,30 C10.5,30 21,18.375 21,10.5 C21,4.695 16.305,0 10.5,0 Z M10.5,14.25 C8.43,14.25 6.75,12.57 6.75,10.5 C6.75,8.43 8.43,6.75 10.5,6.75 C12.57,6.75 14.25,8.43 14.25,10.5 C14.25,12.57 12.57,14.25 10.5,14.25 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 30 30","id":"error"}},[_c('path',{attrs:{"d":"M13.5,19.5 L16.5,19.5 L16.5,22.5 L13.5,22.5 L13.5,19.5 Z M13.5,7.5 L16.5,7.5 L16.5,16.5 L13.5,16.5 L13.5,7.5 Z M14.985,0 C6.705,0 0,6.72 0,15 C0,23.28 6.705,30 14.985,30 C23.28,30 30,23.28 30,15 C30,6.72 23.28,0 14.985,0 Z M15,27 C8.37,27 3,21.63 3,15 C3,8.37 8.37,3 15,3 C21.63,3 27,8.37 27,15 C27,21.63 21.63,27 15,27 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 82 29","id":"product-fibre"}},[_c('path',{attrs:{"d":"M56.5064542,7.79998996 L55.9749342,10.4416002 C58.1607809,8.68057085 60.2800113,7.79998996 62.3330284,7.79998996 L61.5039512,12.0187808 C59.5308468,12.0187808 57.6055557,12.8270668 55.7284137,14.4436388 L52.9659198,28.4999633 L47.6664335,28.4999633 L51.7345259,7.79998996 L56.5064542,7.79998996 Z M73.735836,7.79998996 C80.1491421,7.79998996 82.7788747,11.0069982 81.6242903,17.42075 C81.4705305,18.274968 81.2562129,19.1292522 80.9818783,19.9834702 L66.9538443,19.9834702 C66.4286277,22.9010387 68.3530251,24.359823 72.7271715,24.359823 C74.860547,24.359823 77.0294732,24.1629351 79.2338148,23.7685635 L78.4886034,27.9086376 C76.5523108,28.3030092 74.2492925,28.4999633 71.579481,28.4999633 C63.9179154,28.4999633 60.7225494,24.9713406 61.9929774,17.9135655 C63.2067001,11.1714466 67.1209863,7.79998996 73.735836,7.79998996 Z M30.630684,0.00436155981 C33.4350232,0.00436155981 35.5595453,2.47966328 35.0725508,5.17963527 L34.3607215,9.12641407 C36.1606941,8.06858599 38.047849,7.53967195 40.022186,7.53967195 C46.0800573,7.53967195 48.5084913,10.8712378 47.3067386,17.5343028 C46.0048627,24.752651 41.8853658,28.4690995 34.9483161,28.4690995 C32.0274388,28.4690995 29.6648002,28.3596276 25.6699467,28.3487071 L30.630684,0.00436155981 Z M19.8610139,0.0193945457 L19.8216563,0.351941843 C19.7861666,0.652704452 19.7333731,0.952738662 19.6358612,1.24025765 C19.0961866,2.83267051 17.6580045,4.15246346 15.8404284,4.14537812 L15.5061675,4.14445843 L15.5061675,4.14445843 L14.8484126,4.14438485 C11.7623672,4.14815928 9.70253808,3.75416159 9.46571371,7.49561666 L15.8307926,7.49561666 L15.0086253,11.6364331 L8.64354638,11.6364331 L5.35494492,28.1999637 L0,28.1999637 L4.11076879,7.49561666 C5.23829705,1.81661999 7.56134726,0.0193945457 13.9199118,0.0193945457 C15.6575511,0.0193945457 17.7276947,-0.0242431821 19.8610139,0.0193945457 Z M26.0057831,7.49372582 L21.8773618,28.1999637 L16.4999193,28.1999637 L20.6282724,7.49372582 L26.0057831,7.49372582 Z M38.8093994,11.9027633 C36.9972349,11.9027633 34.9870032,12.7582949 33.518255,13.9654149 L31.4743084,23.9301474 C32.635603,24.313898 34.8159762,24.3053901 35.6506099,24.3053901 C38.8960368,24.3053901 41.2092267,21.8772178 42.0175014,17.3956651 C42.6779749,13.7337528 41.6085622,11.9027633 38.8093994,11.9027633 Z M72.9976536,11.9006733 C70.1798947,11.9006733 68.382966,13.386005 67.6068674,16.3558739 L76.6233445,16.3558739 L76.6516633,16.1983106 C77.1674177,13.3333735 75.9493695,11.9006733 72.9976536,11.9006733 Z M27.4998655,1.13686838e-13 L27.072167,2.14506635 C26.8410763,3.30412138 25.7967724,4.14126082 24.5818253,4.14126082 L21.2966705,4.14126082 L21.6052458,2.59353628 C21.905507,1.08766539 23.262407,1.13686838e-13 24.840925,1.13686838e-13 L27.4998655,1.13686838e-13 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 44 29","id":"product-lte"}},[_c('path',{attrs:{"d":"M5.32623308,0 C8.19826975,0 10.3740944,2.47806104 9.87531866,5.18105659 L5.59325649,28.389277 L0.0882352941,28.389277 L5.32623308,0 Z M18.9841916,4.83221737 L18.3352993,8.09058115 L25.3507375,8.09058115 L25.2513395,8.365023 C24.4373852,10.6110821 22.2543709,12.1135636 19.8048259,12.1135636 L19.8048259,12.1135636 L17.5295613,12.1135636 L15.6434717,21.557844 C15.4591045,22.4828676 15.3645829,23.1789732 15.5144815,23.648109 C15.6749343,24.1151018 16.0894933,24.3488254 16.9216172,24.3488254 L16.9216172,24.3488254 L19.7106383,24.3488254 L18.9035643,28.3887575 L14.7318562,28.3887575 C14.5572417,28.3899265 14.4203024,28.3887575 14.2610519,28.3887575 C11.8747661,28.3887575 10.4799216,27.5411439 10.0765182,25.8300711 C9.88700742,25.0496717 9.90477614,24.0903591 10.1319619,22.9503799 L10.1319619,22.9503799 L13.7547769,4.83221737 L18.9841916,4.83221737 Z M35.2548913,7.88685263 C41.5055337,7.88685263 44.0688194,11.062071 42.9435613,17.4119829 C42.793672,18.2577367 42.5845655,19.1034249 42.3170991,19.9491787 L28.6445935,19.9491787 C28.132609,22.8377988 30.008237,24.282076 34.2718072,24.282076 C36.3509364,24.282076 38.4650157,24.0870736 40.6134515,23.6966752 L39.8870191,27.7955303 C37.999851,28.1859287 35.7553357,28.3809967 33.1530115,28.3809967 C25.6855816,28.3809967 22.5710751,24.8874231 23.8093601,17.8998824 C24.9923187,11.2248573 28.8073418,7.88685263 35.2548913,7.88685263 Z M34.5354488,11.9467991 C31.7890384,11.9467991 30.0377137,13.4173872 29.2810132,16.3577104 L38.0692894,16.3577104 L38.0968537,16.2016823 C38.5996062,13.3652247 37.4121635,11.9467991 34.5354488,11.9467991 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 114 30","id":"product-dsl"}},[_c('path',{attrs:{"d":"M11.3846183,6.75040909 C17.2340299,6.75040909 19.6778704,9.45259091 18.7158646,14.8561909 C17.6535719,20.8231909 14.4000559,23.8065545 8.9549313,23.8065545 C7.79576609,23.8065545 6.67416029,23.5359545 5.58972841,22.9943727 L5.10090522,25.7400818 C4.66445594,28.1917909 2.51360087,29.9793 -1.65217391e-05,29.9793 L4.01107623,7.44902727 C6.37902696,6.98364545 8.83696609,6.75040909 11.3846183,6.75040909 Z M26.4497348,6.75042545 L24.5354159,17.5032982 C24.1999145,19.3875164 24.863042,20.3294073 26.5250739,20.3294073 C27.6138565,20.3294073 28.8308478,19.7001164 30.0947058,18.8999345 C30.8078391,18.4484618 31.3017841,17.7253527 31.4487725,16.8998073 L33.2556449,6.75042545 L37.6015783,6.75042545 L35.3268101,19.5276436 C34.8863957,22.0016618 32.7160449,23.8054255 30.1795174,23.8054255 L30.5090159,21.9550255 C28.271642,23.4063709 26.5675348,23.8054255 24.3482246,23.8054255 C20.8276072,23.8054255 19.4347145,21.74268 20.169271,17.6168618 L22.1038014,6.75042545 L26.4497348,6.75042545 Z M44.28938,6.75058364 L43.8534814,8.92700182 C45.6460901,7.47603818 47.384122,6.75058364 49.0677423,6.75058364 L48.3878177,10.2264382 C46.7696786,10.2264382 45.190751,10.8923836 43.6513104,12.2242745 L41.3857945,23.8052564 L37.0396959,23.8052564 L40.3759858,6.75058364 L44.28938,6.75058364 Z M58.394253,6.75041455 C63.6201342,6.75041455 65.7628936,9.39276 64.8220907,14.6771236 C64.6968559,15.3809236 64.5222212,16.0847236 64.298627,16.7885236 L52.8680067,16.7885236 C52.4400386,19.1923964 54.0081168,20.39436 57.5723516,20.39436 C59.3107139,20.39436 61.0780443,20.2320327 62.8742878,19.9071055 L62.2670038,23.31816 C60.6892328,23.6430873 58.8126386,23.8054145 56.6372212,23.8054145 C50.3942067,23.8054145 47.7904907,20.8980873 48.8257429,15.08316 C49.8146791,9.52825091 53.0042009,6.75041455 58.394253,6.75041455 Z M113.992361,0.0545781818 L109.764008,23.8052509 L105.320101,23.8052509 L108.776779,4.38908727 C109.223031,1.88223273 111.42224,0.0545781818 113.992361,0.0545781818 Z M90.7832391,0.488705455 L86.5272942,23.7066873 L85.4950113,23.7124234 C82.8572455,23.7344415 81.0893351,23.8052509 78.9900217,23.8052509 C73.3809464,23.8052509 71.1340449,20.7610145 72.1866449,14.8481782 C73.1583986,9.39014182 76.0935957,6.66112364 80.9917957,6.66112364 C82.5882362,6.66112364 83.959871,7.09437818 85.1067,7.96094182 L85.6822623,4.72797818 C86.0759754,2.51632364 88.5157406,0.488705455 90.7832391,0.488705455 Z M99.6050548,6.35356967 L106.497043,6.35396182 L106.413058,6.58987091 C105.750619,8.45197675 104.013918,9.71960609 102.037182,9.80777591 L101.8166,9.81268909 L99.3855359,9.81268909 L98.8136635,9.80434364 L98.8136635,9.80434364 C96.429907,9.80434364 95.1202287,10.4084345 94.8839678,11.6160709 C94.6683041,12.7188187 95.1893583,13.2942652 96.4479498,13.3422195 L96.6241475,13.3454891 L99.4511823,13.3454891 C103.331203,13.3454891 104.933206,15.0746891 104.25664,18.5334164 C103.591937,21.9313579 101.059113,23.5806229 96.6692345,23.7846446 L96.2007504,23.8004345 L87.9565678,23.8043618 C88.2840097,21.9651041 89.8530545,20.6069247 91.7187585,20.5152968 L91.9197475,20.5103618 L96.6196316,20.5099255 C98.5152258,20.5099255 99.5812084,19.9062164 99.8175794,18.6981982 C100.03285,17.5976767 99.5643728,17.0224289 98.4125785,16.9724075 L98.2433881,16.9688345 L95.0840461,16.9688345 C91.5363881,16.9688345 90.1009794,15.2394709 90.7775997,11.7807436 C91.4863823,8.15734364 94.4276374,6.35356967 99.6050548,6.35356967 Z M80.6998014,10.23516 C78.4365986,10.23516 77.037813,11.7349418 76.5038304,14.73456 C75.8502855,18.4055782 77.0124797,20.3945977 79.6365725,20.3945977 L79.9601778,20.3941934 C80.7683236,20.3907548 82.2120509,20.3596945 83.1228246,20.0872145 L84.3765493,11.92476 C83.5409899,10.9359055 82.1651696,10.23516 80.6998014,10.23516 Z M10.9461864,10.2266455 C9.71047043,10.2266455 8.66927043,10.3024636 7.82225594,10.4542091 L6.23749072,19.3558636 C7.21596319,19.9404818 8.32837188,20.2329545 9.57477188,20.2329545 C12.1660414,20.2329545 13.7828038,18.4297364 14.4247835,14.8237364 C14.9703864,11.7592636 13.8106704,10.2266455 10.9461864,10.2266455 Z M57.7927516,10.1290691 C55.4967255,10.1290691 54.0325139,11.3528509 53.4001168,13.79976 L60.7471139,13.79976 L60.7702443,13.6699418 C61.1904472,11.3094327 60.1979864,10.1290691 57.7927516,10.1290691 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 8 12","id":"speed-down"}},[_c('polygon',{attrs:{"points":"3.5 0 3.5 10.2323077 0.71 7.65230769 0 8.30769231 4 12 8 8.30769231 7.295 7.65692308 4.5 10.2323077 4.5 0"}})]),_c('symbol',{attrs:{"viewBox":"0 0 8 12","id":"speed-up"}},[_c('polygon',{attrs:{"points":"4.5 12 4.5 1.76769231 7.29 4.34769231 8 3.69230769 4 0 0 3.69230769 0.705 4.34307692 3.5 1.76769231 3.5 12"}})]),_c('symbol',{attrs:{"viewBox":"0 0 11 11","id":"plus"}},[_c('polygon',{attrs:{"fill-rule":"nonzero","points":"7.04960317 11 7.04960317 7.02409639 11 7.02409639 11 3.97590361 7.04960317 3.97590361 7.04960317 0 3.95039683 0 3.95039683 3.97590361 0 3.97590361 0 7.02409639 3.95039683 7.02409639 3.95039683 11"}})]),_c('symbol',{attrs:{"viewBox":"0 0 40 40","id":"social-google"}},[_c('circle',{attrs:{"fill":"#FFFFFF","cx":"20","cy":"20","r":"20"}}),_c('g',{attrs:{"transform":"translate(10.000000, 10.000000)","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M4.18478261,12.1270518 L3.52750583,14.7287233 L1.12517434,14.7826087 C0.407229837,13.3706783 0,11.7552504 0,10.0385821 C0,8.37857552 0.38074994,6.8131617 1.05565539,5.43478261 L1.05617171,5.43478261 L3.19492128,5.850537 L4.13182281,8.10465156 C3.93573143,8.71080363 3.82885296,9.36149523 3.82885296,10.0385821 C3.82892672,10.7734256 3.95446651,11.4774942 4.18478261,12.1270518 Z","fill":"#FBBB00"}}),_c('path',{attrs:{"d":"M19.0817835,8.26086957 C19.1923483,8.85945422 19.25,9.47763609 19.25,10.1094239 C19.25,10.8178612 19.1775311,11.5089045 19.0394755,12.1754803 C18.5708161,14.4437705 17.3462166,16.4244418 15.6497986,17.826087 L15.6492721,17.8255458 L12.9023003,17.681485 L12.5135182,15.1869958 C13.6391735,14.5084761 14.5188784,13.4466319 14.9822729,12.1754803 L9.83423913,12.1754803 L9.83423913,8.26086957 L15.0573742,8.26086957 L19.0817835,8.26086957 L19.0817835,8.26086957 Z","fill":"#518EF8"}}),_c('path',{attrs:{"d":"M15.6924108,17.8221961 L15.6929348,17.8227369 C14.051005,19.184946 11.9652365,20 9.69473173,20 C6.04600296,20 2.87371117,17.8950136 1.25543478,14.7972752 L4.36035921,12.173913 C5.16947869,14.4027858 7.2525899,15.9894351 9.69473173,15.9894351 C10.7444276,15.9894351 11.7278414,15.6965426 12.5716925,15.1852361 L15.6924108,17.8221961 Z","fill":"#28B446"}}),_c('path',{attrs:{"d":"M15.6929348,2.29515471 L12.5845413,4.93924023 C11.7099273,4.37121514 10.6760574,4.04307999 9.56842544,4.04307999 C7.06737048,4.04307999 4.94221027,5.71596177 4.17250498,8.04347826 L1.04672038,5.38459433 L1.04619565,5.38459433 C2.64310176,2.18560757 5.86007709,0 9.56842544,0 C11.8965441,0 14.0311869,0.861656596 15.6929348,2.29515471 Z","fill":"#F14336"}})])]),_c('symbol',{attrs:{"viewBox":"0 0 40 40","id":"social-facebook"}},[_c('circle',{attrs:{"fill":"#FFFFFF","cx":"20","cy":"20","r":"20"}}),_c('path',{attrs:{"d":"M14.3352968,20.6519922 L16.6137646,20.6519922 L16.6137646,29.6774219 C16.6137646,29.855625 16.7638139,30 16.9490208,30 L20.8122625,30 C20.9974694,30 21.1475187,29.855625 21.1475187,29.6774219 L21.1475187,20.6945313 L23.7668452,20.6945313 C23.9371527,20.6945313 24.0804628,20.5715625 24.0999091,20.4087891 L24.4977265,17.0860937 C24.5086473,16.9946875 24.4785644,16.903125 24.4149883,16.8345312 C24.3513716,16.7658984 24.2603109,16.7266016 24.1647438,16.7266016 L21.1476811,16.7266016 L21.1476811,14.64375 C21.1476811,14.0158984 21.4990141,13.6975 22.1920989,13.6975 C22.2908732,13.6975 24.1647438,13.6975 24.1647438,13.6975 C24.3499507,13.6975 24.5,13.5530469 24.5,13.3749219 L24.5,10.3249609 C24.5,10.1467578 24.3499507,10.0023828 24.1647438,10.0023828 L21.4461152,10.0023828 C21.426953,10.0014844 21.384366,10 21.3216019,10 C20.8498966,10 19.2102751,10.0891016 17.915085,11.2355469 C16.4800356,12.5060156 16.6795329,14.0271484 16.7271947,14.2908984 L16.7271947,16.7265234 L14.3352562,16.7265234 C14.1500493,16.7265234 14,16.8708984 14,17.0491016 L14,20.329375 C14,20.5075391 14.1500899,20.6519922 14.3352968,20.6519922 Z","fill":"#3B5998","fill-rule":"nonzero"}})]),_c('symbol',{attrs:{"viewBox":"0 0 40 40","id":"social-github"}},[_c('circle',{attrs:{"fill":"#FFFFFF","cx":"20","cy":"20","r":"20"}}),_c('path',{attrs:{"d":"M28.7751832,15.1053428 C27.8753666,13.5347701 26.6548227,12.2913456 25.1132304,11.3747887 C23.5714087,10.458185 21.888199,10 20.0624082,10 C18.2368469,10 16.5530865,10.4583252 15.011586,11.3747887 C13.4698561,12.2912988 12.2493581,13.5347701 11.3495414,15.1053428 C10.4498624,16.6758686 10,18.390895 10,20.2503752 C10,22.4840328 10.6397105,24.4925949 11.9194529,26.2765758 C13.1990575,28.060697 14.8521173,29.2952392 16.8784945,29.9803429 C17.1143706,30.0249412 17.2889831,29.9935728 17.4025156,29.8870323 C17.5160941,29.7803515 17.5728145,29.6467434 17.5728145,29.486769 C17.5728145,29.4600755 17.5705659,29.2199269 17.5662063,28.7660428 C17.561709,28.3121587 17.5595981,27.9161964 17.5595981,27.5783429 L17.2582366,27.6314495 C17.066094,27.6673058 16.8237015,27.6824992 16.5310592,27.6781983 C16.2385545,27.6740376 15.9348985,27.6428094 15.6205042,27.5847474 C15.3059722,27.5271997 15.0134216,27.3937319 14.7426231,27.1846245 C14.4719622,26.9755171 14.2798196,26.7018029 14.1662411,26.3639026 L14.0352244,26.056763 C13.9478951,25.8522837 13.8104079,25.6251313 13.6225789,25.3761472 C13.43475,25.1269294 13.2448101,24.9579792 13.0526675,24.8690163 L12.9609328,24.8021187 C12.899807,24.7576606 12.8430866,24.7040397 12.790634,24.6418171 C12.7382273,24.5795944 12.6989911,24.517325 12.6727877,24.4549621 C12.6465385,24.3925525 12.6682905,24.3413626 12.7382732,24.3012054 C12.8082559,24.2610481 12.9347295,24.2415539 13.1182447,24.2415539 L13.3801865,24.2814306 C13.5548908,24.3170999 13.7709881,24.4236405 14.0287538,24.6017066 C14.2863819,24.7796326 14.4981655,25.0109456 14.6641507,25.2955523 C14.8651501,25.6604734 15.1073131,25.9385353 15.3913281,26.1298781 C15.6751136,26.3212209 15.9612395,26.4167287 16.2494305,26.4167287 C16.5376215,26.4167287 16.7865304,26.3944763 16.996249,26.3502052 C17.2057381,26.3057003 17.4022862,26.2388028 17.5858014,26.1498866 C17.6644115,25.5534654 17.8784438,25.0952804 18.2277147,24.7750044 C17.7298969,24.7217108 17.282329,24.6414431 16.8847815,24.5347156 C16.4874634,24.4278478 16.076883,24.2544098 15.6533157,24.013934 C15.229519,23.7737854 14.8779535,23.4755748 14.5985276,23.1198165 C14.3190558,22.7638711 14.0896961,22.2965701 13.9107699,21.7183343 C13.7317519,21.1398646 13.64222,20.4725723 13.64222,19.7162702 C13.64222,18.6394117 13.9873149,17.7230417 14.6773671,16.9666462 C14.3541159,16.1570505 14.384633,15.2494693 14.76901,14.2439961 C15.0223243,14.163822 15.3979822,14.2239877 15.8958,14.4241193 C16.3937096,14.6243444 16.758262,14.7958657 16.9898243,14.9380756 C17.2213867,15.0802386 17.4069211,15.2007103 17.5467029,15.2984153 C18.3591904,15.067149 19.1976517,14.9514925 20.0623164,14.9514925 C20.9269811,14.9514925 21.7656261,15.067149 22.5781594,15.2984153 L23.0760231,14.9782328 C23.4164831,14.7645908 23.8185279,14.5688068 24.2811937,14.3908341 C24.7441349,14.2129549 25.0981325,14.1639622 25.3428195,14.2441364 C25.7357321,15.2496563 25.7707464,16.1571907 25.4474035,16.9667864 C26.1374098,17.723182 26.4826424,18.6397856 26.4826424,19.7164105 C26.4826424,20.4727125 26.3927892,21.1421086 26.2140465,21.7250193 C26.0350744,22.3080236 25.8037415,22.7748571 25.519956,23.1265015 C25.2358493,23.4780993 24.8820352,23.7739724 24.4584679,24.0140742 C24.0348088,24.2543631 23.6240907,24.4278011 23.2267727,24.5346688 C22.829271,24.6415366 22.3817031,24.721851 21.8838853,24.7752382 C22.3379238,25.1755014 22.5649889,25.8073114 22.5649889,26.6703877 L22.5649889,29.4863951 C22.5649889,29.6463694 22.6195983,29.7799308 22.728909,29.8866583 C22.838082,29.9931988 23.0104918,30.0245672 23.2463678,29.9799221 C25.2730204,29.294912 26.9260802,28.060323 28.2056389,26.2762018 C29.48506,24.4922209 30.125,22.4836588 30.125,20.2500012 C30.1245411,18.3907548 29.6744492,16.6758686 28.7751832,15.1053428 Z","fill":"#181717","fill-rule":"nonzero"}})]),_c('symbol',{attrs:{"viewBox":"0 0 22 15","id":"eye-show"}},[_c('path',{attrs:{"d":"M11,0 C6,0 1.73,3.11 0,7.5 C1.73,11.89 6,15 11,15 C16,15 20.27,11.89 22,7.5 C20.27,3.11 16,0 11,0 Z M11,12.5 C8.24,12.5 6,10.26 6,7.5 C6,4.74 8.24,2.5 11,2.5 C13.76,2.5 16,4.74 16,7.5 C16,10.26 13.76,12.5 11,12.5 Z M11,4.5 C9.34,4.5 8,5.84 8,7.5 C8,9.16 9.34,10.5 11,10.5 C12.66,10.5 14,9.16 14,7.5 C14,5.84 12.66,4.5 11,4.5 Z","fill-rule":"nonzero"}})]),_c('symbol',{attrs:{"viewBox":"0 0 22 19","id":"eye-hide"}},[_c('path',{attrs:{"d":"M11,4 C13.76,4 16,6.24 16,9 C16,9.65 15.87,10.26 15.64,10.83 L18.56,13.75 C20.07,12.49 21.26,10.86 21.99,9 C20.26,4.61 15.99,1.5 10.99,1.5 C9.59,1.5 8.25,1.75 7.01,2.2 L9.17,4.36 C9.74,4.13 10.35,4 11,4 Z M1,1.27 L3.28,3.55 L3.74,4.01 C2.08,5.3 0.78,7.02 0,9 C1.73,13.39 6,16.5 11,16.5 C12.55,16.5 14.03,16.2 15.38,15.66 L15.8,16.08 L18.73,19 L20,17.73 L2.27,0 L1,1.27 Z M6.53,6.8 L8.08,8.35 C8.03,8.56 8,8.78 8,9 C8,10.66 9.34,12 11,12 C11.22,12 11.44,11.97 11.65,11.92 L13.2,13.47 C12.53,13.8 11.79,14 11,14 C8.24,14 6,11.76 6,9 C6,8.21 6.2,7.47 6.53,6.8 L6.53,6.8 Z M10.84,6.02 L13.99,9.17 L14.01,9.01 C14.01,7.35 12.67,6.01 11.01,6.01 L10.84,6.02 Z","fill-rule":"nonzero"}})]),_c('symbol',{attrs:{"viewBox":"0 0 12 8","id":"select-arrow"}},[_c('polygon',{attrs:{"fill-rule":"nonzero","points":"1.41 0 6 4.58 10.59 0 12 1.41 6 7.41 0 1.41"}})]),_c('symbol',{attrs:{"viewBox":"0 0 33 24","id":"deliver"}},[_c('path',{attrs:{"d":"M28.5,6 L24,6 L24,0 L3,0 C1.35,0 0,1.35 0,3 L0,19.5 L3,19.5 C3,21.99 5.01,24 7.5,24 C9.99,24 12,21.99 12,19.5 L21,19.5 C21,21.99 23.01,24 25.5,24 C27.99,24 30,21.99 30,19.5 L33,19.5 L33,12 L28.5,6 Z M7.5,21.75 C6.255,21.75 5.25,20.745 5.25,19.5 C5.25,18.255 6.255,17.25 7.5,17.25 C8.745,17.25 9.75,18.255 9.75,19.5 C9.75,20.745 8.745,21.75 7.5,21.75 Z M27.75,8.25 L30.69,12 L24,12 L24,8.25 L27.75,8.25 Z M25.5,21.75 C24.255,21.75 23.25,20.745 23.25,19.5 C23.25,18.255 24.255,17.25 25.5,17.25 C26.745,17.25 27.75,18.255 27.75,19.5 C27.75,20.745 26.745,21.75 25.5,21.75 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 33 31","id":"collect"}},[_c('path',{attrs:{"d":"M9.5515319,16.578125 C12.8917501,16.8612122 13.9395813,17.7501335 15.9560075,18.8742771 C18.0106856,19.1874509 22.0708608,19.5594303 22.0708608,21.9526799 C22.0708608,22.9359636 21.4642936,23.6621439 19.338576,23.6621439 C17.2128585,23.6621439 13.5324708,22.9783583 13.5324708,22.9783583 C13.5324708,22.9783583 16.6062912,25.0721098 19.338576,25.0721098 C20.5633934,25.0721098 22.3372667,24.3765527 24.167939,23.6090414 L25.0151052,23.251967 L25.7112277,22.9598614 C27.444249,22.2388264 29.1038616,21.6107871 30.2677152,21.6107871 C31.6338576,21.6107871 33,22.2945727 33,23.6621439 C33,25.0297151 22.0708608,30.5 17.9724336,30.5 C15.2604996,30.5 10.1772154,28.4104683 7.03245001,26.9923598 L6.703125,26.8431146 L9.44770508,17.1607103 C9.50235077,16.9678828 9.5324059,16.7736877 9.5515319,16.578125 Z M6.33135584,14.8717416 C6.95449756,15.1053639 7.31338864,15.768463 7.19695443,16.4285796 L7.16726738,16.560435 L4.18360246,27.4165199 C4.11049765,27.6825777 3.8935801,27.8749368 3.63416974,27.9143986 L3.53509689,27.921875 L0.337061107,27.921875 C0.174260592,27.921875 0.0382985683,27.802497 0.00685182032,27.6439482 L0,27.5738343 L0,14.6991134 C0,14.319053 0.29526553,14.0099929 0.661988014,14.0030321 C3.23578663,13.9584829 5.10984638,14.4123279 6.33135584,14.8717416 Z M29,0 C29.5522847,-1.01453063e-16 30,0.44771525 30,1 L30,13 C30,13.5522847 29.5522847,14 29,14 L15,14 C14.4477153,14 14,13.5522847 14,13 L14,1 C14,0.44771525 14.4477153,1.01453063e-16 15,0 L29,0 Z M25,3 L19,3 L19,4 L25,4 L25,3 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 73 73","id":"tick-circle"}},[_c('path',{attrs:{"d":"M36.5,0 C56.6583934,0 73,16.3416066 73,36.5 C73,56.6583934 56.6583934,73 36.5,73 C16.3416066,73 0,56.6583934 0,36.5 C0,16.3416066 16.3416066,0 36.5,0 Z M36.5,3 C17.9984609,3 3,17.9984609 3,36.5 C3,55.0015391 17.9984609,70 36.5,70 C55.0015391,70 70,55.0015391 70,36.5 C70,17.9984609 55.0015391,3 36.5,3 Z M45.91013,27.890625 L47.8249266,29.8054216 L31.5287857,46.1015625 L23.9375,38.5102768 L25.8658767,36.5954803 L31.5287857,42.2583893 L45.91013,27.890625 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 73 73","id":"warning-circle"}},[_c('path',{attrs:{"d":"M36.5,0 C56.6583934,0 73,16.3416066 73,36.5 C73,56.6583934 56.6583934,73 36.5,73 C16.3416066,73 0,56.6583934 0,36.5 C0,16.3416066 16.3416066,0 36.5,0 Z M36.5,3 C17.9984609,3 3,17.9984609 3,36.5 C3,55.0015391 17.9984609,70 36.5,70 C55.0015391,70 70,55.0015391 70,36.5 C70,17.9984609 55.0015391,3 36.5,3 Z M38.3333333,43.6666667 L38.3333333,47 L35,47 L35,43.6666667 L38.3333333,43.6666667 Z M38.3333333,25 L38.3333333,41 L35,41 L35,25 L38.3333333,25 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 30 30","id":"plus-circle"}},[_c('path',{attrs:{"d":"M15,0 C6.72,0 0,6.72 0,15 C0,23.28 6.72,30 15,30 C23.28,30 30,23.28 30,15 C30,6.72 23.28,0 15,0 Z M22.5,16.5 L16.5,16.5 L16.5,22.5 L13.5,22.5 L13.5,16.5 L7.5,16.5 L7.5,13.5 L13.5,13.5 L13.5,7.5 L16.5,7.5 L16.5,13.5 L22.5,13.5 L22.5,16.5 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 29 32","id":"bank"}},[_c('path',{attrs:{"d":"M3,13.5 L3,24 L7.5,24 L7.5,13.5 L3,13.5 Z M12,13.5 L12,24 L16.5,24 L16.5,13.5 L12,13.5 Z M0,31.5 L28.5,31.5 L28.5,27 L0,27 L0,31.5 Z M21,13.5 L21,24 L25.5,24 L25.5,13.5 L21,13.5 Z M14.25,0 L0,7.5 L0,10.5 L28.5,10.5 L28.5,7.5 L14.25,0 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 30 24","id":"card"}},[_c('path',{attrs:{"d":"M27,0 L3,0 C1.335,0 0.015,1.335 0.015,3 L0,21 C0,22.665 1.335,24 3,24 L27,24 C28.665,24 30,22.665 30,21 L30,3 C30,1.335 28.665,0 27,0 Z M27,21 L3,21 L3,12 L27,12 L27,21 Z M27,6 L3,6 L3,3 L27,3 L27,6 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 29 17","id":"mastercard"}},[_c('path',{attrs:{"d":"M8.82608696,0.000607142857 C10.6341739,0.000607142857 12.3136522,0.523964286 13.7119565,1.42010714 C13.640087,1.47717857 13.5682174,1.53303571 13.4988696,1.59132143 C11.4196957,3.33382143 10.226913,5.85225 10.226913,8.50060714 C10.226913,11.1489643 11.4196957,13.6673929 13.4988696,15.4098929 C13.5682174,15.4669643 13.640087,15.5240357 13.7119565,15.5798929 C12.3136522,16.47725 10.6341739,17.0006071 8.82608696,17.0006071 C3.95156522,17.0006071 0,13.1950357 0,8.50060714 C0,3.80617857 3.95156522,0.000607142857 8.82608696,0.000607142857 Z M19.7355087,0 C24.6100304,0 28.5615957,3.80557143 28.5615957,8.5 C28.5615957,13.1944286 24.6100304,17 19.7355087,17 C17.9286826,17 16.2479435,16.4766429 14.8496391,15.5792857 C14.9215087,15.5234286 14.9933783,15.4663571 15.0627261,15.4092857 C17.1419,13.668 18.3346826,11.1495714 18.3346826,8.5 C18.3346826,5.85164286 17.1419,3.33321429 15.0627261,1.59192857 C14.9933783,1.53364286 14.9215087,1.47778571 14.8496391,1.42071429 C16.2479435,0.524571429 17.9286826,0 19.7355087,0 Z M14.2808609,1.82033571 C14.3956,1.90655 14.5065565,1.99640714 14.6149913,2.08747857 C16.4747739,3.64540714 17.6524261,5.94040714 17.6524261,8.50012143 C17.6524261,11.06105 16.4747739,13.3548357 14.6149913,14.9127643 C14.5065565,15.00505 14.3956,15.0936929 14.2808609,15.1799071 C14.1673826,15.0936929 14.0551652,15.00505 13.9467304,14.9127643 C12.0869478,13.3548357 10.9092957,11.06105 10.9092957,8.50012143 C10.9092957,5.94040714 12.0869478,3.64540714 13.9467304,2.08747857 C14.0551652,1.99640714 14.1673826,1.90655 14.2808609,1.82033571 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 53 16","id":"visa"}},[_c('path',{attrs:{"d":"M37.9445351,0.654703643 C37.1027732,0.33713975 35.7911909,0 34.1598695,0 C29.9836868,0 27.0364328,2.10549212 27.0146819,5.1223491 C26.9885808,7.34094617 29.1114736,8.58945079 30.7145188,9.33333333 C32.3610658,10.0946166 32.9113649,10.5731376 32.9070147,11.2582926 C32.8961392,12.2958129 31.5910821,12.7656335 30.3795541,12.7656335 C28.7134312,12.7656335 27.7998912,12.5328983 26.3969549,11.9499728 L25.8771071,11.7085372 L25.2876563,15.1843393 C26.3012507,15.6084829 28.1283306,15.9717238 30.0184883,16 C34.4578575,16 37.3594345,13.9097336 37.394236,10.6949429 C37.4290375,8.92659054 36.2849375,7.58455682 33.8684067,6.47960848 C32.4023926,5.76182708 31.4888526,5.28113105 31.4888526,4.55247417 C31.4888526,3.908646 32.2697118,3.22131593 33.9010332,3.22131593 C35.3039695,3.19956498 36.2849375,3.50190321 37.0657966,3.81511691 L37.4573138,3.99129962 L38.0467645,0.632952692 L37.9445351,0.654703643 L37.9445351,0.654703643 Z M48.7830343,0.284937466 L45.5203915,0.284937466 C44.5046221,0.284937466 43.7455139,0.561174551 43.2996194,1.57041871 L37.0244698,15.7824905 L41.463839,15.7824905 L42.3512779,13.4551387 L47.7672648,13.4594889 C47.8999456,14.0032626 48.2892877,15.7824905 48.2892877,15.7824905 L52.2022838,15.7824905 L48.7830343,0.284937466 Z M21.0114192,0.154431756 L25.2376291,0.154431756 L22.5948885,15.6606852 L18.3665035,15.6606852 L21.0114192,0.150081566 L21.0114192,0.154431756 Z M10.2686243,8.70038064 L10.7079935,10.8537249 L14.8428494,0.284937466 L19.3213703,0.284937466 L12.663404,15.7607395 L8.19575856,15.7607395 L4.54159869,2.6536161 C4.46547036,2.42958129 4.37194127,2.27732463 4.15008157,2.13811854 C2.91462751,1.49211528 1.53344209,0.965742251 0,0.600326264 L0.054377379,0.27406199 L6.86460033,0.27406199 C7.78684067,0.308863513 8.53072322,0.600326264 8.78520935,1.58781947 L10.2686243,8.70690593 L10.2686243,8.70038064 L10.2686243,8.70038064 Z M43.564981,10.2816748 L45.2506797,5.94453507 C45.2289288,5.98803698 45.5986949,5.04839587 45.8118543,4.46547036 L46.1011419,5.80315389 L47.0777597,10.2773246 L43.564981,10.2773246 L43.564981,10.2816748 L43.564981,10.2816748 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 15 30","id":"bolt"}},[_c('polygon',{attrs:{"points":"0 0 0 16.5 4.5 16.5 4.5 30 15 12 9 12 15 0"}})]),_c('symbol',{attrs:{"viewBox":"0 0 29 29","id":"blocks"}},[_c('path',{attrs:{"d":"M15,16.965 L15,28.965 L27,28.965 L27,16.965 L15,16.965 Z M0,28.965 L12,28.965 L12,16.965 L0,16.965 L0,28.965 Z M0,1.965 L0,13.965 L12,13.965 L12,1.965 L0,1.965 Z M20.49,0 L12,8.475 L20.49,16.965 L28.98,8.475 L20.49,0 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 28 29","id":"cog"}},[_c('path',{attrs:{"d":"M24.7170005,15.81 C24.7770005,15.36 24.8070005,14.895 24.8070005,14.4 C24.8070005,13.92 24.7770005,13.44 24.7020005,12.99 L27.7470005,10.62 C28.0170005,10.41 28.0920005,10.005 27.9270005,9.705 L25.0470005,4.725 C24.8670005,4.395 24.4920005,4.29 24.1620005,4.395 L20.5770005,5.835 C19.8270005,5.265 19.0320005,4.785 18.1470005,4.425 L17.6070005,0.615 C17.5470005,0.255 17.2470005,0 16.8870005,0 L11.1270005,0 C10.7670005,0 10.4820005,0.255 10.4220005,0.615 L9.8820005,4.425 C8.9970005,4.785 8.1870005,5.28 7.4520005,5.835 L3.8670005,4.395 C3.5370005,4.275 3.1620005,4.395 2.9820005,4.725 L0.117000495,9.705 C-0.0629995045,10.02 -0.00299950452,10.41 0.297000495,10.62 L3.3420005,12.99 C3.2670005,13.44 3.2070005,13.935 3.2070005,14.4 C3.2070005,14.865 3.2370005,15.36 3.3120005,15.81 L0.267000495,18.18 C-0.00299950452,18.39 -0.0779995045,18.795 0.0870004955,19.095 L2.9670005,24.075 C3.1470005,24.405 3.5220005,24.51 3.8520005,24.405 L7.4370005,22.965 C8.1870005,23.535 8.9820005,24.015 9.8670005,24.375 L10.4070005,28.185 C10.4820005,28.545 10.7670005,28.8 11.1270005,28.8 L16.8870005,28.8 C17.2470005,28.8 17.5470005,28.545 17.5920005,28.185 L18.1320005,24.375 C19.0170005,24.015 19.8270005,23.535 20.5620005,22.965 L24.1470005,24.405 C24.4770005,24.525 24.8520005,24.405 25.0320005,24.075 L27.9120005,19.095 C28.0920005,18.765 28.0170005,18.39 27.7320005,18.18 L24.7170005,15.81 Z M14.0070005,19.8 C11.0370005,19.8 8.6070005,17.37 8.6070005,14.4 C8.6070005,11.43 11.0370005,9 14.0070005,9 C16.9770005,9 19.4070005,11.43 19.4070005,14.4 C19.4070005,17.37 16.9770005,19.8 14.0070005,19.8 Z"}})]),_c('symbol',{attrs:{"viewBox":"0 0 24 24","id":"pencil"}},[_c('path',{attrs:{"d":"M0,19.0036632 L0,24.00375 L5.00008679,24.00375 L19.7470094,9.25682735 L14.7469226,4.25674056 L0,19.0036632 Z M23.6137432,5.39009356 C24.1337523,4.87008454 24.1337523,4.03006996 23.6137432,3.51006093 L20.4936891,0.39000677 C19.97368,-0.130002257 19.1336655,-0.130002257 18.6136564,0.39000677 L16.1736141,2.83004913 L21.1737009,7.83013592 L23.6137432,5.39009356 Z"}})])])
}
var IconSymbolsvue_type_template_id_8af2b0e6_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1001);
;// CONCATENATED MODULE: ./src/components/global/IconSymbols.vue

var script = {}


/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  script,
  IconSymbolsvue_type_template_id_8af2b0e6_render,
  IconSymbolsvue_type_template_id_8af2b0e6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IconSymbols = (component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Loader.vue?vue&type=template&id=9e305d4c&
var Loadervue_type_template_id_9e305d4c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-loader",class:{'cover': _vm.cover}},[_c('span'),_c('span'),_c('span')])
}
var Loadervue_type_template_id_9e305d4c_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Loader.vue?vue&type=script&lang=js&

    /* harmony default export */ var Loadervue_type_script_lang_js_ = ({
        props: ['cover']
    });

;// CONCATENATED MODULE: ./src/components/Loader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadervue_type_script_lang_js_ = (Loadervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Loader.vue?vue&type=style&index=0&id=9e305d4c&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Loader.vue?vue&type=style&index=0&id=9e305d4c&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Loader.vue



;


/* normalize component */

var Loader_component = (0,componentNormalizer/* default */.Z)(
  components_Loadervue_type_script_lang_js_,
  Loadervue_type_template_id_9e305d4c_render,
  Loadervue_type_template_id_9e305d4c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Loader = (Loader_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchPredictions.vue?vue&type=template&id=19de29ca&
var SearchPredictionsvue_type_template_id_19de29ca_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"search-predictions"},_vm._l((_vm.predictions),function(p,i){return _c('li',{key:`prediction-${i}`,class:{'predict': _vm.index === i},on:{"click":function($event){return _vm.setPlace(p)}}},[_vm._v(" "+_vm._s(p.description)+" ")])}),0)
}
var SearchPredictionsvue_type_template_id_19de29ca_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchPredictions.vue?vue&type=script&lang=js&

    /* harmony default export */ var SearchPredictionsvue_type_script_lang_js_ = ({
        props: ['predictions', 'index'],
        methods: {
            setPlace(place) {
                this.$emit('select', place)
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/SearchPredictions.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SearchPredictionsvue_type_script_lang_js_ = (SearchPredictionsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchPredictions.vue?vue&type=style&index=0&id=19de29ca&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SearchPredictions.vue?vue&type=style&index=0&id=19de29ca&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/SearchPredictions.vue



;


/* normalize component */

var SearchPredictions_component = (0,componentNormalizer/* default */.Z)(
  components_SearchPredictionsvue_type_script_lang_js_,
  SearchPredictionsvue_type_template_id_19de29ca_render,
  SearchPredictionsvue_type_template_id_19de29ca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SearchPredictions = (SearchPredictions_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CurrentLocation.vue?vue&type=template&id=941df8d0&
var CurrentLocationvue_type_template_id_941df8d0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current-location",on:{"click":_vm.getGeoLocation}},[_c('p',[_vm._v("Use my current location")]),_c('svg',{staticClass:"signup-icon"},[_c('use',{attrs:{"href":"#pin"}})])])
}
var CurrentLocationvue_type_template_id_941df8d0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CurrentLocation.vue?vue&type=script&lang=js&

    /* harmony default export */ var CurrentLocationvue_type_script_lang_js_ = ({
        props: ['loading'],
        methods: {
            getGeoLocation() {

                if(this.loading) {
                    return;
                }

                let that = this;
                that.$emit('toggleLoader', true);
                navigator.geolocation.getCurrentPosition(function(position) {
                    that.$emit('location', {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                }, function(error) {
                    that.$emit('error');
                    console.error('Error getting current location', error);
                });
            },
        }
    });

;// CONCATENATED MODULE: ./src/components/CurrentLocation.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CurrentLocationvue_type_script_lang_js_ = (CurrentLocationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CurrentLocation.vue?vue&type=style&index=0&id=941df8d0&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/CurrentLocation.vue?vue&type=style&index=0&id=941df8d0&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/CurrentLocation.vue



;


/* normalize component */

var CurrentLocation_component = (0,componentNormalizer/* default */.Z)(
  components_CurrentLocationvue_type_script_lang_js_,
  CurrentLocationvue_type_template_id_941df8d0_render,
  CurrentLocationvue_type_template_id_941df8d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CurrentLocation = (CurrentLocation_component.exports);
// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__(6292);
// EXTERNAL MODULE: ./node_modules/vue-clickaway/dist/vue-clickaway.common.js
var vue_clickaway_common = __webpack_require__(5463);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchBar.vue?vue&type=script&lang=js&

    
    
    
    
    
	

    /* harmony default export */ var SearchBarvue_type_script_lang_js_ = ({
		mixins: [ vue_clickaway_common/* mixin */.jB ],
        props: ['showGeoLocation', 'ctas', 'shouldCheckCoverage', 'bindPlace'],
        components: {
            Icons: IconSymbols,
            Loader: Loader,
            CurrentLocation: CurrentLocation,
            SearchPredictions: SearchPredictions,
        },
        computed: {
            place() {
            	if (this.bindPlace !== undefined) {
            		return this.bindPlace;
				} else {
                	return this.$signup.$store.getters['signupCoverage/place'];
				}
            },
            showCurrentLocation() {
                return !this.searchAddress || this.searchAddress.length === 0;
            },
            hasPredictions() {
                return this.predictions.length && this.showPredictions
            },
        },
        watch: {
            place: function (newVal) {
                if (newVal) {
                    this.setSearchBarValue(newVal.formatted_address);
                } else {
	                this.setSearchBarValue("");
				}
            },
            searchAddress: function (newVal, oldVal) {

                // clear current list of predictions
                this.predictions = false;

                // hide predictions list
                this.showPredictions = false;

                // clear place
                if (!this.searchAddress || this.searchAddress.length === 0) {
                    this.setPlace(false);
                }

                if (!this.searchAddress || this.searchAddress.length < 3 || newVal === oldVal || this.disablePredictions) {
                    return false;
                }

                // cancel the timer to get predictions
                clearTimeout(this.timer);

                // hide loading indicator
                this.loading = false;

                if (this.searchAddress.length >= 3) {
                    // set timeout to get predictions
                    this.timer = setTimeout(() => {
                        this.getPredictions();
                    }, 1000);
                }
            }
        },
        methods: {
            handleCtaEvent(event) {
				this.$tracking.gtm.push({
					event: `SearchBar.cta.Click.${event}`,
				});
                this.$emit(event);
            },
			checkAddressInUrl() {
				const params = new Proxy(new URLSearchParams(window.location.search), {
					get: (searchParams, prop) => searchParams.get(prop),
				});

				if(!params.address) return

				// console.log('has an address!')
				this.toggleLoading(true)

				// set auto search store flag for use later in the process
				this.$signup.$store.commit('signupCoverage/updateAutoSearch', true)
				setTimeout(() => {
					this.getPredictions(params.address)
				}, 1000)
			},
            clearAddress() {
                this.setPlace(false);
				this.predictionIndex = -1;
            },
            getPlaceFromPosition(position) {
                let that = this;

                // create a google service
                let google = (0,main.gmapApi)();
                let service = new google.maps.Geocoder();

                // reverse geocode the coordinates to get a place
                service.geocode({
                    'location': {
                        lat: position.lat,
                        lng: position.lng,
                    }
                }, function (results, status) {
                    if (status === 'OK' && results.length) {
                        that.setPlace(results[0]);
                        that.checkCoverage();
                    } else {
                        that.wobbleBar();
                        throw new Error('Unable to geocode current location')
                    }
                });
            },
            setPlace(place) {
            	if (this.shouldCheckCoverage !== false) {
                	this.$signup.$store.commit('signupCoverage/updatePlace', place);

                	if (place) {
						let latLng = {
							lat: place.geometry.location.lat(),
							lng: place.geometry.location.lng(),
						};

						this.$signup.$store.commit('signupCoverage/updateCoordinates', latLng);
		                this.$signup.$store.commit('signupSolutions/updateSolutionLocation', {
			                latitude: parseFloat(latLng.lat.toFixed(9)),
			                longitude: parseFloat(latLng.lng.toFixed(9)),
		                });
					}
				}
				this.$emit('selectPlace', place);
				this.searchAddress = place.formatted_address;
            },
            checkCoverage() {
                // disable loader
                this.loading = false;
				if (this.shouldCheckCoverage !== undefined && !this.shouldCheckCoverage) return;
				//set place
				let place = this.$signup.$store.getters['signupCoverage/place'];
                // if no place, wobble the UI
                // and prevent modal open
                if (!place) {
                    this.wobbleBar();
                    console.error('no place to check coverage');
                    return false;
                }

	            this.$tracking.gtm.push({event: 'SearchBar.Click'})

                // show the map modal
                this.$modal.push('coverage');
                this.$modal.toggle(true);
            },
            inputBlur() {
                let that = this;
                setTimeout(() => {
                    that.showPredictions = false;
                    that.predictionIndex = -1;
                }, 200);
            },
			inputFocus() {
				this.showPredictions = true
			},
            getPredictions(address = false) {
                let that = this;

                // show loading indicator
                that.loading = true;

                // create a google service
                let google = (0,main.gmapApi)();
                let service = new google.maps.places.AutocompleteService;

                // get place predictions based
                // on the search bar value
                service.getPlacePredictions({
                    input: address ? address : that.searchAddress,
                    componentRestrictions: {
                        country: 'za'
                    }
                }, function (predictions, status) {
                    if (status === 'OK') {
						if(address) {
							that.selectPrediction(predictions[0])
						} else {
							that.predictions = predictions;
							that.loading = false;
							that.showPredictions = true;
						}

                    } else {
                        that.wobbleBar();
                        that.loading = false;
                    }

                    // cleanup
                    if(service) service = undefined;
                    if(google) google = undefined;
                });
            },
            selectPrediction(prediction) {
                let that = this;
                let google = (0,main.gmapApi)();

                // disable search predictions
                that.disablePredictions = true;

                // set the search address
                that.searchAddress = prediction.description;

                let service = new google.maps.Geocoder();
                service.geocode({
                    placeId: prediction.place_id,
                }, function (results, status) {
                    if (status === 'OK') {
                        that.setPlace(results[0]);
						that.checkCoverage();

                        // re-enable the predictions
                        that.disablePredictions = false;
                    } else {
						// @TODO wobble
					}
                });
            },
			navigatePredictions(key) {
                if (this.showPredictions && this.predictions) {
                    switch (key.keyCode) {
						// up key
                        case 38:
							if (this.predictionIndex > 0) {
								this.predictionIndex--;
							}
                            break;

                        // down key
                        case 40:
							if (this.predictionIndex < this.predictions.length - 1) {
								this.predictionIndex++;
							}
                            break;

                        // enter key
                        case 13:
							if(this.predictions[this.predictionIndex]) {
								this.selectPrediction(this.predictions[this.predictionIndex]);
							}
                            break;
                    }
                    return false;
                }
            },
            setSearchBarValue(value) {
                // disable search predictions
                this.disablePredictions = true;

                this.searchAddress = value;

                setTimeout(() => {
                    // re-enable the predictions
                    this.disablePredictions = false;
                }, 100);
            },
            toggleLoading(value) {
                this.loading = value;
            },
            wobbleBar() {
                let that = this;
                that.loading = false;
                that.wobble = true;
                setTimeout(() => {
                    that.wobble = false;
                }, 500);
            },
			async checkCallbackUrl() {

            	// check for query params in the url
				let q = window.location.search;
				if(!q) return

				const urlSearchParams = new URLSearchParams(q);
				const params = Object.fromEntries(urlSearchParams.entries());

				// skip if we don't have a callback
				if(!params.signupCallback) return

				// check if the id param is in the callback (dev still to fix)
				// redirect currently looks like /?signupCallback=new-payment-added&id=1616969
				// (two ? in url)
				let callbackMethod, paymentId = false;
				let hasIdInCallback = params.signupCallback.indexOf('?id=') >= 0;
				if(hasIdInCallback) {
					let parts = params.signupCallback.split('?')
					callbackMethod = parts[0];
					paymentId = parts[1].replace('id=', '');
				} else {
					callbackMethod = params.signupCallback;
					paymentId = params.id;
				}

				// console.log('method', callbackMethod);
				// console.log('id', paymentId);

				if(callbackMethod) {
					//refresh JWT token
					await this.$signup.$store.dispatch('signupUser/refreshToken', { resetState: false })
						.catch((err) => {
							console.error(err)
							this.$modal.toggleLoader(false);
						});
					await this.$signup.$store.dispatch('signupUser/getClientContact');
					this.$modal.open(callbackMethod);
					window.history.pushState({},"", window.location.pathname);
				}
			},
        },
        data() {
            return {
                inputFocused: false,
                searchAddress: '',
                predictions: [],
                loading: false,
                geoLocationSupported: !!navigator.geolocation,
                disablePredictions: false,
                wobble: false,
                timer: null,
                showPredictions: false,
                predictionIndex: -1,
            }
        },
        mounted() {
            // preset the search bar input value
            // if a place has already been set
            if (this.place) {
                this.setSearchBarValue(this.place.formatted_address);
            }

            // listen for the `checkCoverage` event from the CTAs
            this.$on('checkCoverage', function () {
                this.checkCoverage();
            });

            this.checkCallbackUrl();
            // this.$modal.open('payment-methods')

			this.checkAddressInUrl();

			// this.$tracking.fbq('track', 'Fibre Conversion', { currency: "ZAR", value: '0' });
        },
        beforeDestroy() {
            // remove listener
            this.$off('checkCoverage')
        }
    });

;// CONCATENATED MODULE: ./src/components/SearchBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SearchBarvue_type_script_lang_js_ = (SearchBarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchBar.vue?vue&type=style&index=0&id=2deab18e&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SearchBar.vue?vue&type=style&index=0&id=2deab18e&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/SearchBar.vue



;


/* normalize component */

var SearchBar_component = (0,componentNormalizer/* default */.Z)(
  components_SearchBarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SearchBar = (SearchBar_component.exports);
;// CONCATENATED MODULE: ./src/plugin/SearchBar.js


/* harmony default export */ var plugin_SearchBar = (SearchBar);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal.vue?vue&type=template&id=b9dc7a68&
var Modalvue_type_template_id_b9dc7a68_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"signup-modal-holder",class:[{'closing': _vm.closing, 'opening': _vm.opening}, _vm.promos]},[_c('div',{staticClass:"signup-modal-backdrop",on:{"click":function($event){return _vm.close()}}}),_c('div',{staticClass:"signup-modal",class:[{'has-sidebar': !!_vm.current.sidebar}, {'full-page': _vm.current.fullPage}]},[_c('modal-header',{attrs:{"fullpage":_vm.current.fullPage,"text":_vm.current.title},on:{"close":function($event){return _vm.close()}}}),(_vm.current)?_c(_vm.current.component,{tag:"component"}):_vm._e(),(_vm.current && _vm.current.sidebar)?_c(_vm.current.sidebar,{tag:"component"}):_vm._e(),(_vm.current && _vm.current.buttons && !_vm.current.fullPage)?_c('modal-footer',{attrs:{"buttons":_vm.current.buttons}}):_vm._e(),(_vm.loading)?_c('loader',{attrs:{"cover":true}}):_vm._e()],1)]):_vm._e()
}
var Modalvue_type_template_id_b9dc7a68_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModalHeader.vue?vue&type=template&id=5ab06e7e&
var ModalHeadervue_type_template_id_5ab06e7e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-header",class:_vm.fullpage},[(!_vm.fullpage)?_c('dl',[_c('dt',[_c('icon',{attrs:{"name":"padlock"}}),_c('span',{staticClass:"text"},[_vm._v("Secure Signup")])],1),(_vm.text)?_c('dd',[_vm._v(_vm._s(_vm.text))]):_vm._e()]):_vm._e(),_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.close()}}},[_c('icon',{attrs:{"name":"cross"}})],1)])
}
var ModalHeadervue_type_template_id_5ab06e7e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/Icon.vue?vue&type=template&id=95520ca2&
var Iconvue_type_template_id_95520ca2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"signup-icon"},[_c('svg',[_c('use',{attrs:{"href":`#${_vm.name.replace(/_/g, '-')}`}})])])
}
var Iconvue_type_template_id_95520ca2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/Icon.vue?vue&type=script&lang=js&

    /* harmony default export */ var Iconvue_type_script_lang_js_ = ({
        props: ['name'],
    });

;// CONCATENATED MODULE: ./src/components/global/Icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var global_Iconvue_type_script_lang_js_ = (Iconvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/Icon.vue?vue&type=style&index=0&id=95520ca2&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/global/Icon.vue?vue&type=style&index=0&id=95520ca2&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/global/Icon.vue



;


/* normalize component */

var Icon_component = (0,componentNormalizer/* default */.Z)(
  global_Iconvue_type_script_lang_js_,
  Iconvue_type_template_id_95520ca2_render,
  Iconvue_type_template_id_95520ca2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Icon = (Icon_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModalHeader.vue?vue&type=script&lang=js&

    

    /* harmony default export */ var ModalHeadervue_type_script_lang_js_ = ({
        props: ['text', 'fullpage'],
        components: {
            Icon: Icon
        },
        computed: {
            header() {
                return this.$modal.state.header;
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/ModalHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ModalHeadervue_type_script_lang_js_ = (ModalHeadervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModalHeader.vue?vue&type=style&index=0&id=5ab06e7e&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ModalHeader.vue?vue&type=style&index=0&id=5ab06e7e&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/ModalHeader.vue



;


/* normalize component */

var ModalHeader_component = (0,componentNormalizer/* default */.Z)(
  components_ModalHeadervue_type_script_lang_js_,
  ModalHeadervue_type_template_id_5ab06e7e_render,
  ModalHeadervue_type_template_id_5ab06e7e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModalHeader = (ModalHeader_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModalFooter.vue?vue&type=template&id=71befabb&
var ModalFootervue_type_template_id_71befabb_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-footer",class:{'show-overlay': _vm.showOverlay}},_vm._l((_vm.buttons),function(b,i){return _c('button',{key:i,class:`signup-button ${b.type}`,on:{"click":function($event){$event.preventDefault();return _vm.emit(b.action)}}},[_c('span',[_vm._v(_vm._s(b.label))])])}),0)
}
var ModalFootervue_type_template_id_71befabb_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(144);
;// CONCATENATED MODULE: ./src/services/EventBus.js

const EventBus = new vue_runtime_esm["default"]();
/* harmony default export */ var services_EventBus = (EventBus);

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModalFooter.vue?vue&type=script&lang=js&

    
    /* harmony default export */ var ModalFootervue_type_script_lang_js_ = ({
        props: ['buttons'],
		computed: {
			showOverlay() {
				return this.$signup.$store.getters['signupGeneral/hideFooter']
			}
		},
        methods: {
            emit(action) {
                services_EventBus.$emit(action)
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/ModalFooter.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ModalFootervue_type_script_lang_js_ = (ModalFootervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModalFooter.vue?vue&type=style&index=0&id=71befabb&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ModalFooter.vue?vue&type=style&index=0&id=71befabb&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/ModalFooter.vue



;


/* normalize component */

var ModalFooter_component = (0,componentNormalizer/* default */.Z)(
  components_ModalFootervue_type_script_lang_js_,
  ModalFootervue_type_template_id_71befabb_render,
  ModalFootervue_type_template_id_71befabb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModalFooter = (ModalFooter_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal.vue?vue&type=script&lang=js&

    
    
    

    /* harmony default export */ var Modalvue_type_script_lang_js_ = ({
        components: {
            Loader: Loader,
            ModalHeader: ModalHeader,
            ModalFooter: ModalFooter,
        },
        computed: {
            isOpen() {
                return this.$modal.state.open;
            },
            loading() {
                return this.$modal.state.loading;
            },
            current() {
                return this.$modal.state.current;
            },
            props() {
                return this.$modal.state.props;
            },
            closing() {
                return this.$modal.state.closing;
            },
            opening() {
                return this.$modal.state.opening;
            },
	        promos() {
				let LTEPromos = this.$signup.$store.getters['signupGeneral/currentLTEPromotions'].map(p => {
					return p.slug;
				});
				return LTEPromos;
			}
        },
        methods: {
            close() {
                this.$modal.close()
            }
        },
        data() {
            return {

            }
        },
        mounted() {
            // this.$modal.push('coverage');
            // this.$modal.toggle(true);

			//check if LTE, get promos
			if (this.$signup.$store.getters['signupCoverage/solutionTypes'].find(s => {return s === "connectivity_mobile"})) {
				this.$signup.$store.dispatch('signupGeneral/fetchLTEPromotions');
			}
        }
    });

;// CONCATENATED MODULE: ./src/components/Modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Modalvue_type_script_lang_js_ = (Modalvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal.vue?vue&type=style&index=0&id=b9dc7a68&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal.vue?vue&type=style&index=0&id=b9dc7a68&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Modal.vue



;


/* normalize component */

var Modal_component = (0,componentNormalizer/* default */.Z)(
  components_Modalvue_type_script_lang_js_,
  Modalvue_type_template_id_b9dc7a68_render,
  Modalvue_type_template_id_b9dc7a68_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Modal = (Modal_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/bundle/PromoAvailable.vue?vue&type=template&id=e996d542&scoped=true&
var PromoAvailablevue_type_template_id_e996d542_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var PromoAvailablevue_type_template_id_e996d542_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('h6',{staticClass:"thick"},[_vm._v("Bundle Pure Fibre + Air Mobile Prepaid and get 3GB FREE mobile data every month for a year!")]),_c('p',[_vm._v("Your area qualifies for our Bundle promotion. If you bundle your Fibre with an Air Mobile Prepaid package, you can get FREE mobile data every month! You can bundle your products later in the sign up flow.")]),_c('p',{staticClass:"disclaimer"},[_vm._v("Maximum of 3 promotions per legal entity (business or individual). Afrihost reserves the right to change the promotion at any time. While stocks last. E&OE. Offer subject to Cancellation Policy.")])])
}]


;// CONCATENATED MODULE: ./src/modals/bundle/PromoAvailable.vue?vue&type=template&id=e996d542&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/bundle/PromoAvailable.vue?vue&type=script&lang=js&



/* harmony default export */ var PromoAvailablevue_type_script_lang_js_ = ({
	components: {
	},
	computed: {
	},
	methods: {
	},
	mounted() {

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.$modal.push('fibre-providers');
			/** /
			let place = that.$signup.$store.getters['signupCoverage/place']
			let vendorSlug = that.$signup.$store.getters['signupCoverage/bundleProvider']
			//push to order form BUNDLES TODO: update this logic/url
			let url = `https://clientzone.afrihost.com/order/#!/fibre-air-bundle/inject/place=${place}&vendor_slug=${vendorSlug}`;
			window.location.href = url;
			/**/
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/bundle/PromoAvailable.vue?vue&type=script&lang=js&
 /* harmony default export */ var bundle_PromoAvailablevue_type_script_lang_js_ = (PromoAvailablevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/bundle/PromoAvailable.vue?vue&type=style&index=0&id=e996d542&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/bundle/PromoAvailable.vue?vue&type=style&index=0&id=e996d542&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/bundle/PromoAvailable.vue



;


/* normalize component */

var PromoAvailable_component = (0,componentNormalizer/* default */.Z)(
  bundle_PromoAvailablevue_type_script_lang_js_,
  PromoAvailablevue_type_template_id_e996d542_scoped_true_render,
  PromoAvailablevue_type_template_id_e996d542_scoped_true_staticRenderFns,
  false,
  null,
  "e996d542",
  null
  
)

/* harmony default export */ var PromoAvailable = (PromoAvailable_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/bundle/PromoUnavailable.vue?vue&type=template&id=62a20fbe&scoped=true&
var PromoUnavailablevue_type_template_id_62a20fbe_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var PromoUnavailablevue_type_template_id_62a20fbe_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('h6',{staticClass:"thick"},[_vm._v("Unfortunately your area does not qualify for the Pure Fibre and Air Mobile Prepaid Bundle promotion.")]),_c('p',{staticClass:"highlight"},[_vm._v("You can, however, still sign up for a Pure Fibre package.")]),_c('p',[_vm._v("If you made a mistake when entering your address, click on the 'Edit address' button below to check coverage at another location. Alternatively, click on the 'Sign up for Fibre' button to complete your Pure Fibre order.")])])
}]


;// CONCATENATED MODULE: ./src/modals/bundle/PromoUnavailable.vue?vue&type=template&id=62a20fbe&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/bundle/PromoUnavailable.vue?vue&type=script&lang=js&



/* harmony default export */ var PromoUnavailablevue_type_script_lang_js_ = ({
	mounted() {

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.$modal.push('fibre-providers');
			/** /
			//push to fibre page BUNDLES TODO: update logic
			let url = 'https://www.afrihost.com/fibre';
			window.location.href = url;
			/**/
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/bundle/PromoUnavailable.vue?vue&type=script&lang=js&
 /* harmony default export */ var bundle_PromoUnavailablevue_type_script_lang_js_ = (PromoUnavailablevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/bundle/PromoUnavailable.vue?vue&type=style&index=0&id=62a20fbe&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/bundle/PromoUnavailable.vue?vue&type=style&index=0&id=62a20fbe&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/bundle/PromoUnavailable.vue



;


/* normalize component */

var PromoUnavailable_component = (0,componentNormalizer/* default */.Z)(
  bundle_PromoUnavailablevue_type_script_lang_js_,
  PromoUnavailablevue_type_template_id_62a20fbe_scoped_true_render,
  PromoUnavailablevue_type_template_id_62a20fbe_scoped_true_staticRenderFns,
  false,
  null,
  "62a20fbe",
  null
  
)

/* harmony default export */ var PromoUnavailable = (PromoUnavailable_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/CoverageMap.vue?vue&type=template&id=1ecf5f6a&
var CoverageMapvue_type_template_id_1ecf5f6a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body",class:{'has-overlay': _vm.showCouponOverlay}},[_c('div',{staticClass:"coverage-map-holder"},[_c('search-bar',{attrs:{"bind-place":_vm.place},on:{"selectPlace":_vm.updatePlace}}),_c('GmapMap',{attrs:{"center":_vm.mapCenter,"zoom":17,"options":_vm.mapOptions}},[(_vm.mapCenter && _vm.place)?_c('GmapMarker',{attrs:{"position":_vm.mapCenter,"draggable":true},on:{"dragend":_vm.markerDrop}}):_vm._e()],1)],1),_c('dl',{staticClass:"map-address"},[_c('dt',[_vm._v("Check coverage at:")]),_c('dd',[_c('formatted-address',{attrs:{"place":_vm.place}})],1)]),_c('error-bar',{attrs:{"error":_vm.error,"centered":true}}),(_vm.showCouponOverlay)?_c('div',{staticClass:"modal-overlay"},[_c('icon',{attrs:{"name":"coupon"}}),_vm._m(0),_c('button',{staticClass:"signup-button primary",on:{"click":function($event){$event.preventDefault();return _vm.dismissCouponOverlay()}}},[_c('span',[_vm._v("Continue")])])],1):_vm._e()],1)
}
var CoverageMapvue_type_template_id_1ecf5f6a_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("You have a coupon!")]),_c('dd',[_vm._v("Your coupon will be applied during checkout.")])])
}]


;// CONCATENATED MODULE: ./src/modals/coverage/CoverageMap.vue?vue&type=template&id=1ecf5f6a&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FormattedAddress.vue?vue&type=template&id=53ecc45c&
var FormattedAddressvue_type_template_id_53ecc45c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.address))])
}
var FormattedAddressvue_type_template_id_53ecc45c_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FormattedAddress.vue?vue&type=script&lang=js&

    /* harmony default export */ var FormattedAddressvue_type_script_lang_js_ = ({
        props: ['place'],
        computed: {
            address() {
                if(!this.place) return '';

                let address = this.place.formatted_address;
				let formattedAddress = '';

                if (!address) {
                	formattedAddress =  `${this.place.street_number} ${this.place.street_name}, ${this.place.suburb}`;
				} else {

					// build the address from the first 3 parts of the string
					address.split(',').forEach((a, index) => {
						if(index < 3) {
							formattedAddress += `${a}, `;
						}
					});

					// trim whitespace and remove comma from end of string
				}
				return formattedAddress.trim().replace(/,$/, '');
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/FormattedAddress.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FormattedAddressvue_type_script_lang_js_ = (FormattedAddressvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/FormattedAddress.vue





/* normalize component */
;
var FormattedAddress_component = (0,componentNormalizer/* default */.Z)(
  components_FormattedAddressvue_type_script_lang_js_,
  FormattedAddressvue_type_template_id_53ecc45c_render,
  FormattedAddressvue_type_template_id_53ecc45c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormattedAddress = (FormattedAddress_component.exports);
;// CONCATENATED MODULE: ./src/assets/map_styles.json
var map_styles_namespaceObject = JSON.parse('[{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]');
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ErrorBar.vue?vue&type=template&id=7e32b0c1&
var ErrorBarvue_type_template_id_7e32b0c1_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"signup-error-bar",class:{'centered': _vm.centered}},[_c('icon',{attrs:{"name":"error"}}),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])],1):_vm._e()
}
var ErrorBarvue_type_template_id_7e32b0c1_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ErrorBar.vue?vue&type=script&lang=js&

    

    /* harmony default export */ var ErrorBarvue_type_script_lang_js_ = ({
        props: ['error', 'centered', 'message'],
        components: {
            Icon: Icon
        },
        computed: {
            errorMessage() {
            	if(this.message) return this.message;
            	if(this.error.message && typeof this.error.message === 'string') return this.error.message;
                return this.error.data && this.error.data.message ? this.error.data.message : 'Something went wrong, please try again.';
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/ErrorBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ErrorBarvue_type_script_lang_js_ = (ErrorBarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ErrorBar.vue?vue&type=style&index=0&id=7e32b0c1&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ErrorBar.vue?vue&type=style&index=0&id=7e32b0c1&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/ErrorBar.vue



;


/* normalize component */

var ErrorBar_component = (0,componentNormalizer/* default */.Z)(
  components_ErrorBarvue_type_script_lang_js_,
  ErrorBarvue_type_template_id_7e32b0c1_render,
  ErrorBarvue_type_template_id_7e32b0c1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ErrorBar = (ErrorBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/CoverageMap.vue?vue&type=script&lang=js&

    
    
    
    
    
	

    /* harmony default export */ var CoverageMapvue_type_script_lang_js_ = ({
        components: {
			Icon: Icon,
            ErrorBar: ErrorBar,
            FormattedAddress: FormattedAddress
        },
        computed: {
            place() {
				return this.$signup.$store.getters['signupCoverage/place'];
            },
			formattedAddress() {
				return this.$signup.$store.getters['signupCoverage/formattedAddress'];
			},
			vendorScope() {
				return this.$signup.$store.getters['signupCoverage/vendorScope'];
            },
			coordinates() {
				return this.$signup.$store.getters['signupCoverage/coordinates'];
			},
            mapCenter() {
                return this.place ? this.coordinates : {
                    lat: -26.04606,
                    lng: 28.05986
                };
            }
        },
        watch: {
            place: function(val) {
                this.error = false;
                this.setFormattedAddress();
            }
        },
        data() {
            return {
                error: false,
				showCouponOverlay: false,
                mapOptions: {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: false,
                    styles: map_styles_namespaceObject
                },
            }
        },
        methods: {
            setFormattedAddress() {

                if(!this.place) {
					this.$signup.$store.commit('signupCoverage/updateFormattedAddress', '');
                    //
                    this.$modal.updateHeader('');
                    return;
                }

                let p = this.place.address_components;

                let streetNumber = p.find(c => {
                    return c.types.indexOf('street_number') >= 0;
                });

                let streetName = p.find(c => {
                    return c.types.indexOf('route') >= 0;
                });

                let suburb = p.find(c => {
                    return c.types.indexOf('sublocality') >= 0;
                });

                let city = p.find(c => {
                    return c.types.indexOf('locality') >= 0;
                });

                streetNumber = streetNumber ? streetNumber.long_name : '';
                streetName = streetName ? streetName.long_name : '';
                suburb = suburb ? suburb.long_name : '';
                city = city ? city.long_name : '';

                let formatted = `${streetNumber} ${streetName}, ${suburb}, ${city}`;

                this.$signup.$store.commit('signupCoverage/updateFormattedAddress', formatted);
                this.$modal.updateHeader(formatted);
            },
            markerDrop(event) {
                let that = this,
                    google = (0,main.gmapApi)(),
                    service = new google.maps.Geocoder(),
					latLng = {
						lat: event.latLng.lat(),
						lng: event.latLng.lng(),
					}

                this.$signup.$store.commit('signupCoverage/updateCoordinates', latLng);
                // this.coordinates = latLng;

                //distance to address
				let distance = that.getDistanceFromLatLonInKm(latLng.lat, latLng.lng, that.place.geometry.location.lat(), that.place.geometry.location.lng())
				//if distance is longer than 200m update address
				if (distance > 0.2) {
					service.geocode({
						'location': latLng
					}, function(results, status) {
						if(status === 'OK' && results.length) {
							that.$signup.$store.commit('signupCoverage/updatePlace', results[0]);
						} else {
							throw new Error('Unable to GeoCode marker position');
						}
					});
				}
            },
			updatePlace(place) {
				// debugger;
				if (place) {
					let latLng = {
						lat: place.geometry.location.lat(),
						lng: place.geometry.location.lng(),
					};
					// this.coordinates = latLng;
					this.$signup.$store.commit('signupCoverage/updateCoordinates', latLng);
					this.$signup.$store.commit('signupSolutions/updateSolutionLocation', {
						latitude: parseFloat(latLng.lat.toFixed(9)),
						longitude: parseFloat(latLng.lng.toFixed(9)),
					});
				}
			},
            checkCoverage() {
                // show loader
                this.$modal.toggleLoader(true);

                // clear error
                this.error = false;

                // do coverage check
                this.$signup.$store.dispatch('signupCoverage/checkCoverage')
                    .then(() => {

                        let availableSolutionTypes = this.$signup.$store.getters['signupCoverage/availableSolutionTypes'];
						let availableUpsellSolutionTypes = this.$signup.$store.getters['signupCoverage/availableUpsellSolutionTypes'];

                        this.$modal.toggleLoader(false);

						//check if page is bundles page && shoot to api if it is
						if (this.$signup.$store.getters['signupGeneral/showBundleOnPages'].includes(this.$signup.$store.getters['signupGeneral/pageRequestedFrom'])) {

							//check if we are eligible for promo
							this.$signup.$store.dispatch('signupCoverage/checkBundleCoverage')
								.then((result) => {
									// filter providers and check if they're eligible
									let bundlable = result.filter((provider) => {
										return provider.bundle_allowed
									})
									if (bundlable.length > 0) {// at least one of them is eligible
										this.$modal.push('bundle-promo-available');
									} else { // we are not eligible
										this.$modal.push('bundle-promo-unavailable');
									}
								}).catch((err) => {
								console.error(err);
								this.error = err;
							})
						}
                        // show solution type selector for selling
                        // multiple types of solutions
                        else if(availableSolutionTypes.length > 1) {
                            this.$modal.push('solution-type-selection');
                        }

                        // show solutions for the product
                        else if(availableSolutionTypes.length === 1) {
                            switch(availableSolutionTypes[0]) {
                                case 'composite_dsl':
                                    this.$modal.push('dsl-solutions');
                                    break;
								case 'composite_fibre':
                                    // this.$modal.push('fibre-providers');
									let vendors = this.$signup.$store.getters['signupCoverage/coverage'].map(c => c.vendor.name)
									this.$signup.$store.dispatch('signupSignal/sendEvent', {
										type: 'coverage-check',
										value: 'fibre',
										meta: {
											address: this.formattedAddress,
											lat: this.coordinates.lat,
											lng: this.coordinates.lng,
											vendors: vendors
										},
									})
                                    this.$modal.push('fibre-experience');
                                    break;
                                case 'connectivity_mobile':
                                    this.$modal.push('lte-providers');
                                    break;
                            }
                        }

                        // show the no coverage options
                        else {
                            if(availableUpsellSolutionTypes.length) {
                                // show upsell
                                this.$modal.push('coverage-upsell');
                            } else {
                                // show interest form
								if(this.vendorScope) {
									this.$modal.push('no-coverage-promo');
								} else {
									this.$modal.push('no-coverage');
								}
                            }
                        }

                    }).catch(e => {

                        // @TODO - shoot error up to sentry
                        console.error(e);

                        // display error
                        this.error = 'Something went wrong, please try again';

                        // hide loader
                        this.$modal.toggleLoader(false);
                    });
            },

            //utility
			getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
				var R = 6371; // Radius of the earth in km
				var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
				var dLon = this.deg2rad(lon2-lon1);
				var a =
					Math.sin(dLat/2) * Math.sin(dLat/2) +
					Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
					Math.sin(dLon/2) * Math.sin(dLon/2)
				;
				var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
				var d = R * c; // Distance in km
				return d;
			},

			deg2rad(deg) {
				return deg * (Math.PI/180)
			},

			checkForCouponInUrl() {
				const params = new Proxy(new URLSearchParams(window.location.search), {
					get: (searchParams, prop) => searchParams.get(prop),
				});

				if(!params.ac_coupon) {
					this.autoSearch()
					return
				}

				// show the overlay
				this.showCouponOverlay = true
				this.$signup.$store.commit('signupGeneral/hideFooter', true)
				this.$signup.$store.commit('signupCart/addPreLoadedCoupon', params.ac_coupon)
			},
			dismissCouponOverlay() {
				this.showCouponOverlay = false
				this.$signup.$store.commit('signupGeneral/hideFooter', false)
				this.autoSearch()
			},
			autoSearch() {
				// check if the auto search flag is set
				let autoSearch = this.$signup.$store.getters['signupCoverage/autoSearch'];
				if(autoSearch) {
					this.checkCoverage();
					this.$signup.$store.commit('signupCoverage/updateAutoSearch', false)
				}
			}
        },
        mounted() {
        	// this.place = this.$signup.$store.getters['signupCoverage/place'];
        	// this.coordinates = this.$signup.$store.getters['signupCoverage/coordinates'];
            let that = this;
            that.setFormattedAddress();

            // if coupon in url
			// show overlay, dismiss should call autoSearch()
			// else autoSearch()
			that.checkForCouponInUrl()

            // listen for back button event
            services_EventBus.$on('back', function() {
                that.$modal.close();
            })

            // listen for next button event
            services_EventBus.$on('next', function() {
                that.checkCoverage();
            })
        },
        beforeDestroy(){
            services_EventBus.$off('back')
            services_EventBus.$off('next')
        }
    });

;// CONCATENATED MODULE: ./src/modals/coverage/CoverageMap.vue?vue&type=script&lang=js&
 /* harmony default export */ var coverage_CoverageMapvue_type_script_lang_js_ = (CoverageMapvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/CoverageMap.vue?vue&type=style&index=0&id=1ecf5f6a&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/coverage/CoverageMap.vue?vue&type=style&index=0&id=1ecf5f6a&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/coverage/CoverageMap.vue



;


/* normalize component */

var CoverageMap_component = (0,componentNormalizer/* default */.Z)(
  coverage_CoverageMapvue_type_script_lang_js_,
  CoverageMapvue_type_template_id_1ecf5f6a_render,
  CoverageMapvue_type_template_id_1ecf5f6a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CoverageMap = (CoverageMap_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoverage.vue?vue&type=template&id=d5ebadd2&
var NoCoveragevue_type_template_id_d5ebadd2_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.solution !== 'composite_dsl')?_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Enter your details below to be notified when "+_vm._s(_vm.product)+" becomes available in you area.")]),_c('p',{staticClass:"im-sure-banner"},[_vm._v(" Sure you have "+_vm._s(_vm.product)+" in your area? "),_c('a',{attrs:{"href":"https://clientzone.afrihost.com/order/#!/pure-fibre/address-lookup","target":"_blank"}},[_vm._v("Sign up here")])]),_c('form',{staticClass:"signup-interest-form",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('signup-input',{attrs:{"type":"text","required":"true","label":"First name"},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}}),_c('signup-input',{attrs:{"type":"text","required":"true","label":"Last name"},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}}),_c('signup-input',{attrs:{"type":"email","required":"true","label":"Email address"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._l((_vm.locationFields),function(field){return _c('signup-input',{key:field.model,attrs:{"type":"text","required":"true","label":`${field.label} `},model:{value:(_vm.currentLocation[field.model]),callback:function ($$v) {_vm.$set(_vm.currentLocation, field.model, $$v)},expression:"currentLocation[field.model]"}})})],2),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error}})],1):_c('div',{staticClass:"modal-body"},[_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error}}),_c('p',{staticClass:"im-sure-banner",staticStyle:{"margin-top":"0"}},[_vm._v(" Sure you have "+_vm._s(_vm.product)+" in your area? "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showProducts()}}},[_vm._v("Sign up here")])])],1)
}
var NoCoveragevue_type_template_id_d5ebadd2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextInput.vue?vue&type=template&id=66636e1e&
var TextInputvue_type_template_id_66636e1e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"signup-text-input"},[_c('input',{ref:"input",class:{'filled': _vm.filled},attrs:{"type":_vm.type,"required":""},on:{"input":function($event){return _vm.update()},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}}),_c('span',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.label))])])
}
var TextInputvue_type_template_id_66636e1e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextInput.vue?vue&type=script&lang=js&

/* harmony default export */ var TextInputvue_type_script_lang_js_ = ({
	props: ['value', 'label', 'type'],
	computed: {
		filled() {
			return this.value.length > 0;
		}
	},
	methods: {
		update() {
			this.$emit('input', this.$refs.input.value)
		}
	},
	data() {
		return {

		}
	}
});

;// CONCATENATED MODULE: ./src/components/TextInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TextInputvue_type_script_lang_js_ = (TextInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextInput.vue?vue&type=style&index=0&id=66636e1e&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/TextInput.vue?vue&type=style&index=0&id=66636e1e&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/TextInput.vue



;


/* normalize component */

var TextInput_component = (0,componentNormalizer/* default */.Z)(
  components_TextInputvue_type_script_lang_js_,
  TextInputvue_type_template_id_66636e1e_render,
  TextInputvue_type_template_id_66636e1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextInput = (TextInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupInput.vue?vue&type=template&id=5f200b18&
var SignupInputvue_type_template_id_5f200b18_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-input",class:{'has-value': _vm.value && _vm.value.length, 'focused': _vm.focused}},[_c('input',{ref:"input",attrs:{"name":_vm.name,"type":_vm.filteredType,"autocomplete":_vm.autocomplete,"maxlength":_vm.maxlength,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.update()},"focus":_vm.focusInput,"blur":function($event){_vm.focused = false}}}),_c('span',{staticClass:"label-text",class:{'required': _vm.required}},[_vm._v(_vm._s(_vm.label))]),(_vm.type === 'password')?_c('span',{staticClass:"signup-input-toggle",on:{"click":function($event){$event.preventDefault();return _vm.toggleVisibility()}}},[_c('icon',{attrs:{"name":_vm.visible ? 'eye-hide' : 'eye-show'}})],1):_vm._e()])
}
var SignupInputvue_type_template_id_5f200b18_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupInput.vue?vue&type=script&lang=js&

	

	/* harmony default export */ var SignupInputvue_type_script_lang_js_ = ({
		components: {
			Icon: Icon,
		},
		props: [
			'disabled',
			'label',
			'required',
			'value',
			'type',
			'autocomplete',
			'maxlength',
			'focus',
			'name',
		],
		computed: {
			filteredType() {
				switch (this.type) {
					case 'password':
						return this.visible ? 'text' : 'password';
					default:
						return this.type;
				}
			},
		},
		methods: {
			update() {
				this.$emit('input', this.$refs.input.value)
			},
			toggleVisibility() {
				this.visible = !this.visible;
			},
			focusInput(e) {
				this.focused = true;
				this.$emit('focus', e);
			}
		},
		data() {
			return {
				focused: false,
				visible: false
			}
		},
	});

;// CONCATENATED MODULE: ./src/components/forms/SignupInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_SignupInputvue_type_script_lang_js_ = (SignupInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupInput.vue?vue&type=style&index=0&id=5f200b18&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/forms/SignupInput.vue?vue&type=style&index=0&id=5f200b18&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/forms/SignupInput.vue



;


/* normalize component */

var SignupInput_component = (0,componentNormalizer/* default */.Z)(
  forms_SignupInputvue_type_script_lang_js_,
  SignupInputvue_type_template_id_5f200b18_render,
  SignupInputvue_type_template_id_5f200b18_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignupInput = (SignupInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoverage.vue?vue&type=script&lang=js&






/* harmony default export */ var NoCoveragevue_type_script_lang_js_ = ({
	components: {
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		TextInput: TextInput,
	},
	computed: {
		solution() {
			let solutionType = this.$signup.$store.getters['signupCoverage/solutionTypes'];
			return solutionType[0]
		},
		product() {
			let solutionType = this.$signup.$store.getters['signupCoverage/solutionTypes'];
			if(solutionType.length > 1) {
				return 'coverage';
			}

			switch (solutionType[0]) {
				case 'connectivity_mobile':
					return 'LTE coverage';
				case 'composite_fibre':
					return 'Fibre coverage';
				case 'composite_dsl':
					return 'DSL coverage';
				default:
					return 'coverage';
			}
		},
		locationFields() {
			return [
				{
					type: 'text',
					label: 'Street Number',
					required: true,
					model: 'streetNumber',
				},
				{
					type: 'text',
					label: 'Street Name',
					required: true,
					model: 'streetName',
				},
				{
					type: 'text',
					label: 'Suburb',
					required: true,
					model: 'suburb',
				},
				{
					type: 'text',
					label: 'City',
					required: true,
					model: 'city',
				},
				{
					type: 'text',
					label: 'Postal Code',
					required: true,
					model: 'postalCode',
				},
				{
					type: 'text',
					label: 'Province',
					required: true,
					model: 'province',
				},
			]
		}
	},
	methods: {
		async submit() {
			// clear errors
			this.error = false;
			this.$modal.toggleLoader(false);

			// validate field existence
			if(!this.user.first_name) {
				this.error = 'The first name field is required';
				return
			}

			if(!this.user.last_name) {
				this.error = 'The last name field is required';
				return
			}

			if(!this.user.email) {
				this.error = 'The email field is required';
				return
			}

			this.$modal.toggleLoader(true);

			await this.$signup.$store.dispatch('signupCoverage/showInterest', {
				first_name: this.user.first_name,
				last_name: this.user.last_name,
				email: this.user.email,
				solutionType: this.$signup.$store.getters['signupCoverage/solutionTypes'][0],
				location: {
					province: this.currentLocation.province,
					city: this.currentLocation.city,
					suburb: this.currentLocation.suburb,
					postalCode: this.currentLocation.postalCode,
					streetName: this.currentLocation.streetName,
					streetNumber: this.currentLocation.streetNumber,
					longitude: this.currentLocation.longitude,
					latitude: this.currentLocation.latitude,
				},
			})
			.then(res => {
				if (res.interest) {
					this.$modal.toggleLoader(false);
					this.$modal.push('interest-recorded');
				} else {
					throw {
						data: {
							message:"Something went wrong. Please try again later."
						}
					}
				}
			})
			.catch((err) => {
				this.$modal.toggleLoader(false);
				this.error = err;
			})
		},

		showProducts() {
			this.$signup.$store.commit('signupGeneral/updateImSure', true);

			let solutionType = this.$signup.$store.getters['signupCoverage/solutionTypes'];
			switch (solutionType[0]) {
				case 'connectivity_mobile':
					this.$modal.push('lte-providers');
					break;
				case 'composite_fibre':
					this.$modal.push('fibre-providers');
					break;
				case 'composite_dsl':
					this.$modal.push('dsl-im-sure');
					break;
				default:
					break;
			}
		}
	},
	data() {
		return {
			error: false,
			user: {
				first_name: '',
				last_name: '',
				email: '',
			},
			currentLocation: {
				city: "",
				postal_code: "",
				province: "",
				street_name: "",
				street_number: "",
				suburb: "",
			},
		}
	},
	async mounted() {
		this.$modal.toggleLoader(false);
		// set CTAs if DSL
		if (this.solution === "composite_dsl") {
			// this.error = "No DSL coverage in your area";
			this.$modal.state.current.buttons = this.$modal.state.current.buttons.slice(0, 1);
		}

		this.$modal.updateTitle(`No ${this.product}`)

		//create location object
		this.currentLocation = await this.$signup.$store.dispatch('signupGeneral/mapsToLocation', {
			place: this.$signup.$store.getters['signupCoverage/place']
		});

		let that = this;

		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.submit();
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverage.vue?vue&type=script&lang=js&
 /* harmony default export */ var coverage_NoCoveragevue_type_script_lang_js_ = (NoCoveragevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoverage.vue?vue&type=style&index=0&id=d5ebadd2&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverage.vue?vue&type=style&index=0&id=d5ebadd2&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverage.vue



;


/* normalize component */

var NoCoverage_component = (0,componentNormalizer/* default */.Z)(
  coverage_NoCoveragevue_type_script_lang_js_,
  NoCoveragevue_type_template_id_d5ebadd2_render,
  NoCoveragevue_type_template_id_d5ebadd2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NoCoverage = (NoCoverage_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoverageUpsell.vue?vue&type=template&id=59d97d98&
var NoCoverageUpsellvue_type_template_id_59d97d98_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('h6',{staticClass:"thick"},[_vm._v("But don’t worry, we have other products available in your area!")]),_c('div',{staticClass:"upsell-skip"},[_c('p',[_vm._v("Sure you have "+_vm._s(_vm.product)+" in your area? "),_c('a',{attrs:{"href":"https://clientzone.afrihost.com/order/#!/pure-fibre/address-lookup","target":"_blank"}},[_vm._v("Sign up here")]),_vm._v(".")])]),_c('div',{staticClass:"upsell-skip"},[_c('p',[_vm._v("Want to get notified when "+_vm._s(_vm.product)+" becomes available in your area? "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.getNotified()}}},[_vm._v("Click here.")])])]),_c('div',{staticClass:"upsell-cards"},[(_vm.options.length === 1 && _vm.options[0] === 'composite_fibre')?_c('div',{staticClass:"upsell-card"},[_vm._m(0)]):_vm._e(),(_vm.options.length === 1 && _vm.options[0] === 'connectivity_mobile')?_c('div',{staticClass:"upsell-card"},[_vm._m(1)]):_vm._e(),(_vm.options.indexOf('composite_fibre') >= 0)?_c('div',{staticClass:"upsell-card"},[_c('div',{staticClass:"product-logo"},[_c('svg',{attrs:{"width":"81px","height":"29px","viewBox":"0 0 81 29"}},[_c('path',{attrs:{"d":"M55.6875201,7.79998996 L55.1637033,10.4416002 C57.317871,8.68057085 59.406388,7.79998996 61.4296512,7.79998996 L60.6125896,12.0187808 C58.6680809,12.0187808 56.7706926,12.8270668 54.9207555,14.4436388 L52.1982977,28.4999633 L46.9756156,28.4999633 L50.9847501,7.79998996 L55.6875201,7.79998996 Z M72.6672007,7.79998996 C78.9875603,7.79998996 81.5791808,11.0069982 80.4413296,17.42075 C80.2897982,18.274968 80.0785867,19.1292522 79.8082279,19.9834702 L65.9834988,19.9834702 C65.465894,22.9010387 67.3624015,24.359823 71.6731545,24.359823 C73.7756116,24.359823 75.913104,24.1629351 78.0854987,23.7685635 L77.3510874,27.9086376 C75.442857,28.3030092 73.1732158,28.4999633 70.5420972,28.4999633 C62.9915688,28.4999633 59.8425124,24.9713406 61.0945284,17.9135655 C62.290661,11.1714466 66.1482184,7.79998996 72.6672007,7.79998996 Z M30.186761,0.00436155981 C32.9504577,0.00436155981 35.0441896,2.47966328 34.564253,5.17963527 L33.86274,9.12641407 C35.6366261,8.06858599 37.4964309,7.53967195 39.4421544,7.53967195 C45.4122304,7.53967195 47.8054697,10.8712378 46.6211337,17.5343028 C45.3381255,24.752651 41.2783315,28.4690995 34.4418188,28.4690995 C31.563273,28.4690995 29.2348755,28.3596276 25.2979184,28.3487071 L30.186761,0.00436155981 Z M19.5731732,0.0193945457 L19.5343859,0.351941843 C19.4994106,0.652704452 19.4473822,0.952738662 19.3512835,1.24025765 C18.8194303,2.83267051 17.4020914,4.15246346 15.610857,4.14537812 L15.2814405,4.14445843 L15.2814405,4.14445843 L14.6332182,4.14438485 C11.5918981,4.14815928 9.56192158,3.75416159 9.32852946,7.49561666 L15.6013608,7.49561666 L14.7911089,11.6364331 L8.5182776,11.6364331 L5.27733703,28.1999637 L0,28.1999637 L4.05119243,7.49561666 C5.1623797,1.81661999 7.45176252,0.0193945457 13.7181739,0.0193945457 C15.4306301,0.0193945457 17.4707715,-0.0242431821 19.5731732,0.0193945457 Z M25.6288877,7.49372582 L21.5602986,28.1999637 L16.26079,28.1999637 L20.329312,7.49372582 L25.6288877,7.49372582 Z M38.2469443,11.9027633 C36.4610431,11.9027633 34.4799452,12.7582949 33.0324832,13.9654149 L31.018159,23.9301474 C32.1626232,24.313898 34.3113969,24.3053901 35.1339344,24.3053901 C38.3323261,24.3053901 40.6119915,21.8772178 41.4085521,17.3956651 C42.0594535,13.7337528 41.0055395,11.9027633 38.2469443,11.9027633 Z M71.9397166,11.9006733 C69.1627948,11.9006733 67.3919085,13.386005 66.6270578,16.3558739 L75.5128612,16.3558739 L75.5407696,16.1983106 C76.0490494,13.3333735 74.848654,11.9006733 71.9397166,11.9006733 Z M27.1013167,0 L26.6798168,2.14506635 C26.4520752,3.30412138 25.4229062,4.14126082 24.225567,4.14126082 L20.9880231,4.14126082 L21.2921263,2.59353628 C21.5880359,1.08766539 22.9252706,0 24.4809116,0 L27.1013167,0 Z"}})])]),_c('p',[_vm._v("Starting from R399.00pm")]),_vm._m(2),_vm._m(3)]):_vm._e(),(_vm.options.indexOf('connectivity_mobile') >= 0)?_c('div',{staticClass:"upsell-card"},[_c('div',{staticClass:"product-logo"},[_c('svg',{attrs:{"width":"43px","height":"29px","viewBox":"0 0 43 29"}},[_c('path',{attrs:{"d":"M5.16208478,0 C7.99249772,0 10.1367887,2.47806104 9.64524158,5.18105659 L5.42523828,28.389277 L0,28.389277 L5.16208478,0 Z M18.6221018,4.83221737 L17.9826138,8.09058115 L24.896379,8.09058115 L24.7984216,8.365023 C23.9962637,10.6110821 21.8448873,12.1135636 19.4308429,12.1135636 L19.4308429,12.1135636 L17.1885531,12.1135636 L15.3297982,21.557844 C15.148103,22.4828676 15.0549513,23.1789732 15.2026774,23.648109 C15.3608049,24.1151018 15.7693557,24.3488254 16.5894198,24.3488254 L16.5894198,24.3488254 L19.3380204,24.3488254 L18.5426431,28.3887575 L14.4313945,28.3887575 C14.2593107,28.3899265 14.1243559,28.3887575 13.9674134,28.3887575 C11.6157116,28.3887575 10.2410821,27.5411439 9.84352516,25.8300711 C9.65676093,25.0496717 9.67427214,24.0903591 9.89816537,22.9503799 L9.89816537,22.9503799 L13.4684758,4.83221737 L18.6221018,4.83221737 Z M34.6569943,7.88685263 C40.8170477,7.88685263 43.3431843,11.062071 42.2342344,17.4119829 C42.0865173,18.2577367 41.8804414,19.1034249 41.6168513,19.9491787 L28.142498,19.9491787 C27.6379335,22.8377988 29.4863785,24.282076 33.6881578,24.282076 C35.7371547,24.282076 37.8205952,24.0870736 39.9378942,23.6966752 L39.2219898,27.7955303 C37.362172,28.1859287 35.1501859,28.3809967 32.5855766,28.3809967 C25.2263702,28.3809967 22.1570015,24.8874231 23.3773404,17.8998824 C24.5431546,11.2248573 28.3028876,7.88685263 34.6569943,7.88685263 Z M33.9479786,11.9467991 C31.2413711,11.9467991 29.515428,13.4173872 28.7696942,16.3577104 L37.430604,16.3577104 L37.4577689,16.2016823 C37.9532351,13.3652247 36.7830017,11.9467991 33.9479786,11.9467991 Z"}})])]),_c('p',[_vm._v("Starting from R49.00pm")]),_vm._m(4),_vm._m(5)]):_vm._e()])])
}
var NoCoverageUpsellvue_type_template_id_59d97d98_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("But don't worry - you have Pure Fibre coverage in your area!")]),_c('dd',[_vm._v("Uncapped. Unshaped. Unthrottled.")]),_c('dd',[_vm._v("Blazing-fast Pure Fibre is your gateway to truly enjoying the internet the way it was intended. Everything is lightning fast and reliable.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("But don't worry - you have Pure LTE coverage in your area!")]),_c('dd',[_vm._v("Get connected in days, not weeks.")]),_c('dd',[_vm._v("Can't get ADSL or Fibre in your area? No problem! Get wireless speeds of up to 150Mbps.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-list"},[_c('li',[_vm._v("WiFi for multiple devices")]),_c('li',[_vm._v("For Uncapped Data")]),_c('li',[_vm._v("Save up to R5000 on setup")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsell-links"},[_c('a',{staticClass:"signup-button primary button",attrs:{"href":"https://www.afrihost.com/fibre/"}},[_c('span',[_vm._v("View Packages")])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-list"},[_c('li',[_vm._v("WiFi for multiple devices")]),_c('li',[_vm._v("From 5GB + 5GB")]),_c('li',[_vm._v("Save up to R1000 on hardware")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsell-links"},[_c('a',{staticClass:"signup-button primary button",attrs:{"href":"https://www.afrihost.com/fixed-lte/"}},[_c('span',[_vm._v("View Packages")])])])
}]


;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverageUpsell.vue?vue&type=template&id=59d97d98&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoverageUpsell.vue?vue&type=script&lang=js&

	

	/* harmony default export */ var NoCoverageUpsellvue_type_script_lang_js_ = ({
		computed: {
			product() {
				let solutionType = this.$signup.$store.getters['signupCoverage/solutionTypes'];
				if(solutionType.length > 1) {
					return 'coverage';
				}

				switch (solutionType[0]) {
					case 'connectivity_mobile':
						return 'LTE coverage';
					case 'composite_fibre':
						return 'Fibre coverage';
					case 'composite_dsl':
						return 'DSL coverage';
					default:
						return 'coverage';
				}
			},
			options() {
				let options = [];
				this.$signup.$store.getters['signupCoverage/coverage'].forEach(a => {
					if(a.solution_type_slug !== this.$signup.$store.getters['signupCoverage/solutionTypes'][0]) {
						options.push(a.solution_type_slug);
					}
				});

				return [...new Set(options)];
			}
		},
		methods: {
			getNotified() {
				this.$modal.push('no-coverage');
			},
			showProducts() {
				this.$signup.$store.commit('signupGeneral/updateImSure', true);

				let solutionType = this.$signup.$store.getters['signupCoverage/solutionTypes'];
				switch (solutionType[0]) {
					case 'connectivity_mobile':
						this.$modal.push('lte-providers');
						break;
					case 'composite_fibre':
						this.$modal.push('fibre-providers');
						break;
					case 'composite_dsl':
						this.$modal.push('dsl-im-sure');
						break;
					default:
						break;
				}
			}
		},
		mounted() {
			this.$modal.updateTitle(`No ${this.product}`);

			let that = this;
			// listen for back button event
			services_EventBus.$on('back', function () {
				that.$modal.push('coverage');
			});

		}
	});

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverageUpsell.vue?vue&type=script&lang=js&
 /* harmony default export */ var coverage_NoCoverageUpsellvue_type_script_lang_js_ = (NoCoverageUpsellvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoverageUpsell.vue?vue&type=style&index=0&id=59d97d98&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverageUpsell.vue?vue&type=style&index=0&id=59d97d98&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoverageUpsell.vue



;


/* normalize component */

var NoCoverageUpsell_component = (0,componentNormalizer/* default */.Z)(
  coverage_NoCoverageUpsellvue_type_script_lang_js_,
  NoCoverageUpsellvue_type_template_id_59d97d98_render,
  NoCoverageUpsellvue_type_template_id_59d97d98_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NoCoverageUpsell = (NoCoverageUpsell_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoveragePromo.vue?vue&type=template&id=3ee685fa&scoped=true&
var NoCoveragePromovue_type_template_id_3ee685fa_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"error"}})],1),_c('h1',[_vm._v("You don't have coverage for this promo")]),_c('p',[_vm._v("But don't worry, we have other fibre providers available.")]),_vm._m(0)])
}
var NoCoveragePromovue_type_template_id_3ee685fa_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"signup-button primary",attrs:{"href":"https://www.afrihost.com/fibre"}},[_c('span',[_vm._v("View other fibre providers")])])
}]


;// CONCATENATED MODULE: ./src/modals/coverage/NoCoveragePromo.vue?vue&type=template&id=3ee685fa&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoveragePromo.vue?vue&type=script&lang=js&



/* harmony default export */ var NoCoveragePromovue_type_script_lang_js_ = ({
	components: {
		Icon: Icon
	},
	// 42 Dassen Island Dr, Plettenberg Bay
	mounted() {
		// listen for back button event
		let that = this
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		});
	}
});

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoveragePromo.vue?vue&type=script&lang=js&
 /* harmony default export */ var coverage_NoCoveragePromovue_type_script_lang_js_ = (NoCoveragePromovue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/NoCoveragePromo.vue?vue&type=style&index=0&id=3ee685fa&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoveragePromo.vue?vue&type=style&index=0&id=3ee685fa&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/coverage/NoCoveragePromo.vue



;


/* normalize component */

var NoCoveragePromo_component = (0,componentNormalizer/* default */.Z)(
  coverage_NoCoveragePromovue_type_script_lang_js_,
  NoCoveragePromovue_type_template_id_3ee685fa_scoped_true_render,
  NoCoveragePromovue_type_template_id_3ee685fa_scoped_true_staticRenderFns,
  false,
  null,
  "3ee685fa",
  null
  
)

/* harmony default export */ var NoCoveragePromo = (NoCoveragePromo_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Providers.vue?vue&type=template&id=c6d48098&
var Providersvue_type_template_id_c6d48098_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"lte-provider-cards"},_vm._l((_vm.providers),function(p){return _c('provider-card',{key:p.slug,attrs:{"provider":p,"recommended":p.slug === 'mtn_lte',"promoted":p.slug === 'mtn_lte',"selected":_vm.selectedProvider && _vm.selectedProvider.slug === p.slug},on:{"select":_vm.selectProvider}})}),1)])
}
var Providersvue_type_template_id_c6d48098_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/ProviderCard.vue?vue&type=template&id=f3236ec4&
var ProviderCardvue_type_template_id_f3236ec4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lte-provider-card",class:{'large': _vm.recommended, 'selected': _vm.selected},on:{"click":function($event){$event.preventDefault();return _vm.select()}}},[(_vm.recommended)?_c('div',{staticClass:"recommended-tag"},[_vm._v("Recommended")]):_vm._e(),_c('div',{staticClass:"provider-logo",class:{large: _vm.promos.find(p => p.slug === 'black-friday-2021')}},[(_vm.promos.find(p => p.slug === 'black-friday-2021'))?_c('icon',{attrs:{"name":`provider-${_vm.provider.slug}-black-friday-2021`}}):_c('icon',{attrs:{"name":`provider-${_vm.provider.slug}`}})],1),_c('p',{staticClass:"starting-from"},[_vm._v("Starting from "),_c('formatted-price',{attrs:{"price":_vm.startingPrice}})],1),_c('ul',{staticClass:"provider-feature-table"},[_c('li',[_vm._v("Up to speed "),_c('formatted-speed',{attrs:{"speed":_vm.provider.max_download_speed}})],1),_c('li',[_vm._v(_vm._s(_vm.dataType))]),_c('li',[_vm._v("Save up to R1000 on hardware")])])])
}
var ProviderCardvue_type_template_id_f3236ec4_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/FormattedPrice.vue?vue&type=template&id=3d17a54d&
var FormattedPricevue_type_template_id_3d17a54d_render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.formatted))])
}
var FormattedPricevue_type_template_id_3d17a54d_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/FormattedPrice.vue?vue&type=script&lang=js&

    /* harmony default export */ var FormattedPricevue_type_script_lang_js_ = ({
        props: ['price'],
        computed: {
            formatted() {
                let p = this.price;
                return `R${p.toLocaleString('en-ZA')}.00pm`
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/global/FormattedPrice.vue?vue&type=script&lang=js&
 /* harmony default export */ var global_FormattedPricevue_type_script_lang_js_ = (FormattedPricevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/global/FormattedPrice.vue





/* normalize component */
;
var FormattedPrice_component = (0,componentNormalizer/* default */.Z)(
  global_FormattedPricevue_type_script_lang_js_,
  FormattedPricevue_type_template_id_3d17a54d_render,
  FormattedPricevue_type_template_id_3d17a54d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormattedPrice = (FormattedPrice_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/FormattedSpeed.vue?vue&type=template&id=583249af&
var FormattedSpeedvue_type_template_id_583249af_render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.formatted))])
}
var FormattedSpeedvue_type_template_id_583249af_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/FormattedSpeed.vue?vue&type=script&lang=js&

    /* harmony default export */ var FormattedSpeedvue_type_script_lang_js_ = ({
        props: ['speed'],
        computed: {
            formatted() {
                let bytes = this.speed;
                let sizes = ['Kbps', 'Mbps', 'Gbps', 'Tbps'];
                if (bytes === 0) {
                    return '0Bps';
                }

                let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return Math.round(bytes / Math.pow(1024, i), 2) + sizes[i];
            }
        }
    });

;// CONCATENATED MODULE: ./src/components/global/FormattedSpeed.vue?vue&type=script&lang=js&
 /* harmony default export */ var global_FormattedSpeedvue_type_script_lang_js_ = (FormattedSpeedvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/global/FormattedSpeed.vue





/* normalize component */
;
var FormattedSpeed_component = (0,componentNormalizer/* default */.Z)(
  global_FormattedSpeedvue_type_script_lang_js_,
  FormattedSpeedvue_type_template_id_583249af_render,
  FormattedSpeedvue_type_template_id_583249af_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormattedSpeed = (FormattedSpeed_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/ProviderCard.vue?vue&type=script&lang=js&

    
    
    

    /* harmony default export */ var ProviderCardvue_type_script_lang_js_ = ({
        components: {
            FormattedSpeed: FormattedSpeed,
            Icon: Icon,
            FormattedPrice: FormattedPrice
        },
        props: ['provider', 'recommended', 'selected'],
        computed: {
            startingPrice() {
				// return 199;
                switch(this.provider.slug) {
                    case 'mtn_lte':
                        return 49;
                    default:
                        return 97;
                }
            },
            dataType() {
				return 'Capped or Uncapped';
                switch(this.provider.slug) {
                    case 'mtn_lte':
                        return 'Capped or Uncapped';
                    default:
                        return 'Capped data';
                }
            },
			promos() {
				return this.$signup.$store.getters['signupGeneral/currentLTEPromotions'].filter(p => {
					return p.provider_slug === this.provider.slug
				})
			}
        },
        methods: {
            select() {
                this.$emit('select', this.provider);
            }
        }
    });

;// CONCATENATED MODULE: ./src/modals/lte/ProviderCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var lte_ProviderCardvue_type_script_lang_js_ = (ProviderCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/ProviderCard.vue?vue&type=style&index=0&id=f3236ec4&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/lte/ProviderCard.vue?vue&type=style&index=0&id=f3236ec4&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/lte/ProviderCard.vue



;


/* normalize component */

var ProviderCard_component = (0,componentNormalizer/* default */.Z)(
  lte_ProviderCardvue_type_script_lang_js_,
  ProviderCardvue_type_template_id_f3236ec4_render,
  ProviderCardvue_type_template_id_f3236ec4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProviderCard = (ProviderCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Providers.vue?vue&type=script&lang=js&




/* harmony default export */ var Providersvue_type_script_lang_js_ = ({
	components: {
		ProviderCard: ProviderCard
	},
	computed: {
		selectedProvider() {
			return this.$signup.$store.getters['signupSolutions/currentProvider'];
		},
		providers() {
			let providers = [];
			let coverage = this.$signup.$store.getters['signupCoverage/coverage'];
			coverage.forEach(v => {
				if (v.solution_type_slug !== 'connectivity_mobile') return;
				if (v.vendor.slug === 'mtn_5g') return; // exclude 5G provider
				providers.push({
					name: v.vendor.name,
					slug: v.vendor.slug,
					max_download_speed: v.max_download_speed
				});
			});

			return providers;
		}
	},
	methods: {
		selectProvider(provider) {
			this.$signup.$store.commit('signupSolutions/updateCurrentProvider', provider);
			// this.$signup.setSolution(false);
		}
	},
	mounted() {

		if(this.providers.length === 0) {
			this.$modal.push('no-coverage');
		}

		else if (this.providers.length === 1) {
			// set the selected provider
			this.selectProvider(this.providers[0]);

			// show the solutions
			this.$modal.push('lte-solutions');
		} else {
			let pureLteProvider = this.providers.find(p => {
				return p.slug === 'mtn_lte';
			});

			this.selectProvider(pureLteProvider);
		}

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.$modal.push('lte-solutions');
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/lte/Providers.vue?vue&type=script&lang=js&
 /* harmony default export */ var lte_Providersvue_type_script_lang_js_ = (Providersvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Providers.vue?vue&type=style&index=0&id=c6d48098&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/lte/Providers.vue?vue&type=style&index=0&id=c6d48098&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/lte/Providers.vue



;


/* normalize component */

var Providers_component = (0,componentNormalizer/* default */.Z)(
  lte_Providersvue_type_script_lang_js_,
  Providersvue_type_template_id_c6d48098_render,
  Providersvue_type_template_id_c6d48098_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Providers = (Providers_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Solutions.vue?vue&type=template&id=40b24760&
var Solutionsvue_type_template_id_40b24760_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"lte-solution-cards"},_vm._l((_vm.solutions),function(s){return _c('solution-card',{key:s.id,attrs:{"solution":s,"selected":_vm.selectedSolution.id === s.id},on:{"select":_vm.selectSolution}})}),1)])
}
var Solutionsvue_type_template_id_40b24760_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/SolutionCard.vue?vue&type=template&id=0bc16ef7&
var SolutionCardvue_type_template_id_0bc16ef7_render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"lte-solution-card",class:{'selected': _vm.selected, 'recommended': _vm.showRecommended, 'promotion': _vm.promotionActive && !_vm.showPromoted },attrs:{"href":"#","data-tracking":_vm.solution.display_name},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.select()}}},[(!_vm.isUncapped && _vm.nightTimeData)?_c('div',{staticClass:"data-allocations"},[_c('dl',{staticClass:"data-allocation"},[_c('dt',[_c('formatted-data',{attrs:{"bytes":_vm.anyTimeData}})],1),_c('dd',[_vm._v("Anytime data")])]),_c('div',{staticClass:"data-type-divider"},[_c('icon',{attrs:{"name":"plus"}})],1),_c('dl',{staticClass:"data-allocation"},[_c('dt',[_c('formatted-data',{attrs:{"bytes":_vm.nightTimeData}})],1),_c('dd',[_vm._v("Night time data")])])]):_vm._e(),(!_vm.isUncapped && !_vm.nightTimeData)?_c('div',{staticClass:"data-allocations"},[_c('dl',{staticClass:"data-allocation wide"},[_c('dt',[_c('formatted-data',{attrs:{"bytes":_vm.anyTimeData}})],1),_c('dd',[_vm._v("Anytime data")])])]):_vm._e(),(_vm.isUncapped)?_c('div',{staticClass:"data-allocations"},[(_vm.solution.speed_limit_kbps)?_c('dl',{staticClass:"data-allocation wide"},[_c('dt',[_vm._v(_vm._s(_vm.solution.speed_limit_kbps/1024)+"Mbps")]),_c('dd',[_vm._v("Uncapped Anytime data")])]):_c('dl',{staticClass:"data-allocation wide"},[_c('dt',[_vm._v("Uncapped")]),_c('dd',[_vm._v("Anytime data")])])]):_vm._e(),(_vm.showPromoted)?_c('div',{staticClass:"promo-strip"},[_vm._v(" + 100GB FREE ")]):_vm._e(),_c('p',{staticClass:"price"},[_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)])
}
var SolutionCardvue_type_template_id_0bc16ef7_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/FormattedData.vue?vue&type=template&id=37147a8b&
var FormattedDatavue_type_template_id_37147a8b_render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.formatted))])
}
var FormattedDatavue_type_template_id_37147a8b_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/FormattedData.vue?vue&type=script&lang=js&

    /* harmony default export */ var FormattedDatavue_type_script_lang_js_ = ({
        props: ['bytes'],
        computed: {
            formatted() {

                const decimals = 0;
                const bytes = this.bytes || 0;
                if (bytes === 0) return '0 Bytes';

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + '' + sizes[i];

            }
        }
    });

;// CONCATENATED MODULE: ./src/components/global/FormattedData.vue?vue&type=script&lang=js&
 /* harmony default export */ var global_FormattedDatavue_type_script_lang_js_ = (FormattedDatavue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/global/FormattedData.vue





/* normalize component */
;
var FormattedData_component = (0,componentNormalizer/* default */.Z)(
  global_FormattedDatavue_type_script_lang_js_,
  FormattedDatavue_type_template_id_37147a8b_render,
  FormattedDatavue_type_template_id_37147a8b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormattedData = (FormattedData_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/SolutionCard.vue?vue&type=script&lang=js&

    
    
    

    /* harmony default export */ var SolutionCardvue_type_script_lang_js_ = ({
        components: {
            Icon: Icon,
            FormattedData: FormattedData,
            FormattedPrice: FormattedPrice
        },
        props: ['solution', 'selected', 'promoted'],
        computed: {
            anyTimeData() {
                return this.solution.bandwidth_limit_bytes;
            },
			showRecommended() {
            	return this.solution.id === 1299220;
			},
			promotionActive() {
				return this.$signup.$store.getters['signupGeneral/currentLTEPromotions'].find(p => p.slug === 'black-friday-2021');
			},
			showPromoted() {
				// return false;
            	return this.promotionActive
					&& (
			            this.solution.id === 1308220 ||
			            this.solution.id === 1309220 ||
			            this.solution.id === 1310220 ||
			            this.solution.id === 1311220
					);
			},
            nightTimeData() {
                let attr = this.solution.attributes.find(a => {
                    return a.detail_type.slug === 'night_time_allocation';
                })
                return attr ? attr.value : false;
            },
			isUncapped() {
            	return !this.solution.is_capped_solution;
			}
        },
        methods: {
            select() {
                this.$emit('select', this.solution);
            }
        }
    });

;// CONCATENATED MODULE: ./src/modals/lte/SolutionCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var lte_SolutionCardvue_type_script_lang_js_ = (SolutionCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/SolutionCard.vue?vue&type=style&index=0&id=0bc16ef7&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/lte/SolutionCard.vue?vue&type=style&index=0&id=0bc16ef7&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/lte/SolutionCard.vue



;


/* normalize component */

var SolutionCard_component = (0,componentNormalizer/* default */.Z)(
  lte_SolutionCardvue_type_script_lang_js_,
  SolutionCardvue_type_template_id_0bc16ef7_render,
  SolutionCardvue_type_template_id_0bc16ef7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SolutionCard = (SolutionCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Solutions.vue?vue&type=script&lang=js&

    
    
    /* harmony default export */ var Solutionsvue_type_script_lang_js_ = ({
        components: {
            SolutionCard: SolutionCard
        },
        computed: {
	        selectedSolution() {
		        return this.$signup.$store.getters['signupSolutions/selectedSolution'];
	        },
            solutions() {
                let solutions = [...this.$signup.$store.getters['signupSolutions/solutions']];
                let provider = this.$signup.$store.getters['signupSolutions/currentProvider'];

                // filter out sim + device solutions
				solutions = solutions.filter(s => {
                    return !s.attributes.find(a => a.detail_type.slug === 'required_device_solution_id')
                }).sort((a, b) => (a.price > b.price) ? 1 : -1);

				// if provider === telkom, re-order things
				if(provider.slug === 'telkom_lte') {
					return solutions.filter(s => {
						return !s.attributes.find(a => a.detail_type.slug === 'required_device_solution_id')
					}).sort((a, b) => (parseInt(a.bandwidth_limit_bytes) > parseInt(b.bandwidth_limit_bytes)) ? 1 : -1);
				}

				return solutions;
            },
			place() {
				return this.$signup.$store.getters['signupCoverage/place'];
			}
        },
        methods: {
            selectSolution(solution) {
                // set the selected solution id to the local data scope for use with OF redirect.
				// @TODO - when setting up a full signup for the LTE product, this should be set in the store/on the cart.

	            this.$signup.$store.commit('signupSolutions/updateSelectedSolution', solution);
				// this.selectedSolutionId = id;
            }
        },
		data() {
        	return {

			}
		},
        mounted() {
            // show loader
            this.$modal.toggleLoader(true);

            // get solutions from the openAPI
			let provider = this.$signup.$store.getters['signupSolutions/currentProvider'];
            let sectionSlug = 'mobile';
            let categorySlug = `fixed_wireless_${provider.slug}`;

			this.$signup.$store.dispatch('signupSolutions/getSolutions', {
					sectionSlug: sectionSlug,
					categorySlug: categorySlug,
					vendorSlug: provider.slug
				})
                .then(r => {
                    this.$modal.toggleLoader(false);

                    // default the selected solution to the first in the array
                    this.selectSolution(this.solutions[0]);
                }, e => {
                    this.$modal.toggleLoader(false);
                    this.error = true;
                });

            // listen for back button event
            services_EventBus.$on('back', () => {
                this.$modal.push('lte-providers');
            });

            // listen for next button event
            services_EventBus.$on('next', () => {
	            let cartInfo = {
		            name: this.selectedSolution.display_name,
		            provider: this.selectedSolution.vendor.name,
		            price: this.selectedSolution.price,
	            }
	            //send event to GTM
	            this.$tracking.gtm.push({
		            event: 'LTE.Conversion',
		            ...cartInfo,
	            });
	            //send fb pixel event
	            this.$tracking.fbq('trackCustom', 'LTE Conversion', { currency: "ZAR", ...cartInfo });

				let place = encodeURIComponent(JSON.stringify(this.place));
				let url = `https://clientzone.afrihost.com/order/#!/wireless/fixed-wireless/data/${this.selectedSolution.id}?place=${place}`;
                window.location.href = url;
			});
        },
        beforeDestroy(){
            services_EventBus.$off('back')
            services_EventBus.$off('next')
        }
    });

;// CONCATENATED MODULE: ./src/modals/lte/Solutions.vue?vue&type=script&lang=js&
 /* harmony default export */ var lte_Solutionsvue_type_script_lang_js_ = (Solutionsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Solutions.vue?vue&type=style&index=0&id=40b24760&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/lte/Solutions.vue?vue&type=style&index=0&id=40b24760&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/lte/Solutions.vue



;


/* normalize component */

var Solutions_component = (0,componentNormalizer/* default */.Z)(
  lte_Solutionsvue_type_script_lang_js_,
  Solutionsvue_type_template_id_40b24760_render,
  Solutionsvue_type_template_id_40b24760_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Solutions = (Solutions_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Sidebar.vue?vue&type=template&id=634eb937&
var Sidebarvue_type_template_id_634eb937_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-modal-sidebar"},[_c('div',{staticClass:"provider-logo"},[_c('icon',{attrs:{"name":`provider-${_vm.provider.slug}`}})],1),_c('div',{staticClass:"signup-feature-table"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("WiFi Router")]),_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.device.price))]),_c('dd',[_vm._v("Save "+_vm._s(_vm.device.saving)+" with Afrihost")])])])]),(_vm.promos.find(p => p.slug === 'black-friday-2021'))?_c('LTEBlackFridayPromo',{attrs:{"provider":_vm.provider,"solution":_vm.selectedSolution}}):_vm._e()],1)
}
var Sidebarvue_type_template_id_634eb937_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("Installation")]),_c('dl',[_c('dt',[_vm._v("FREE")])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("Activation Fee")]),_c('dl',[_c('dt',[_vm._v("FREE")])])])
}]


;// CONCATENATED MODULE: ./src/modals/lte/Sidebar.vue?vue&type=template&id=634eb937&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/lte/LTEBlackFridayPromo.vue?vue&type=template&id=2fd8f220&
var LTEBlackFridayPromovue_type_template_id_2fd8f220_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promo)?_c('div',{staticClass:"promo-section",style:(`--promo-bg: url(${_vm.solution ? _vm.currentSolutionPromo : _vm.promo.promoImageDefault })`),attrs:{"id":""}}):_vm._e()
}
var LTEBlackFridayPromovue_type_template_id_2fd8f220_staticRenderFns = []


;// CONCATENATED MODULE: ./src/assets/images/promo/bf-lte-promo.png
var bf_lte_promo_namespaceObject = __webpack_require__.p + "img/bf-lte-promo.85b3f54e.png";
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/lte/LTEBlackFridayPromo.vue?vue&type=script&lang=js&

// Black friday 2021 promo


/* harmony default export */ var LTEBlackFridayPromovue_type_script_lang_js_ = ({
	props: ["provider", "solution"],
	data() {
		return {
			providerPromos: [
				{
					provider:'mtn_lte',
					promoImageDefault: undefined,
					promoNotApplicableImage: undefined,
					packages: [
						{
							solutionId: '1308220',
							image: bf_lte_promo_namespaceObject,
						},
						{
							solutionId: '1309220',
							image: bf_lte_promo_namespaceObject,
						},
						{
							solutionId: '1310220',
							image: bf_lte_promo_namespaceObject,
						},
						{
							solutionId: '1311220',
							image: bf_lte_promo_namespaceObject,
						},
					],
				},
			],
		}
	},
	computed: {
		promo() {
			return this.providerPromos.find((p) => {
				return p.provider === this.provider.slug;
			});
		},
		currentSolutionPromo() {
			let currentPromo = this.promo.packages.find((p) => {
				return p.solutionId == this.solution.id;
			})
			return currentPromo ? currentPromo.image :  this.promo.promoNotApplicableImage
		},
	}
});

;// CONCATENATED MODULE: ./src/components/lte/LTEBlackFridayPromo.vue?vue&type=script&lang=js&
 /* harmony default export */ var lte_LTEBlackFridayPromovue_type_script_lang_js_ = (LTEBlackFridayPromovue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/lte/LTEBlackFridayPromo.vue?vue&type=style&index=0&id=2fd8f220&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/lte/LTEBlackFridayPromo.vue?vue&type=style&index=0&id=2fd8f220&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/lte/LTEBlackFridayPromo.vue



;


/* normalize component */

var LTEBlackFridayPromo_component = (0,componentNormalizer/* default */.Z)(
  lte_LTEBlackFridayPromovue_type_script_lang_js_,
  LTEBlackFridayPromovue_type_template_id_2fd8f220_render,
  LTEBlackFridayPromovue_type_template_id_2fd8f220_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LTEBlackFridayPromo = (LTEBlackFridayPromo_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/lte/Sidebar.vue?vue&type=script&lang=js&




/* harmony default export */ var Sidebarvue_type_script_lang_js_ = ({
	components: {
		LTEBlackFridayPromo: LTEBlackFridayPromo,
		Icon: Icon
	},
	computed: {
		promos() {
			return this.$signup.$store.getters['signupGeneral/currentLTEPromotions'].filter(p => {
				return p.provider_slug === this.provider.slug
			})
		},
		selectedSolution() {
			return this.$signup.$store.getters['signupSolutions/selectedSolution'];
		},
		provider() {
			return this.$signup.$store.getters['signupSolutions/currentProvider'];
		},
		device() {
			switch(this.provider.slug) {
				case 'telkom_lte':
					return {
						price: 'R1499.00',
						saving: 'R1000'
					};
				default:
					return {
						price: 'R1499.00',
						saving: 'R1000'
					};
			}
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/lte/Sidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var lte_Sidebarvue_type_script_lang_js_ = (Sidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/lte/Sidebar.vue





/* normalize component */
;
var Sidebar_component = (0,componentNormalizer/* default */.Z)(
  lte_Sidebarvue_type_script_lang_js_,
  Sidebarvue_type_template_id_634eb937_render,
  Sidebarvue_type_template_id_634eb937_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sidebar = (Sidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Experience.vue?vue&type=template&id=1a0dbc4b&
var Experiencevue_type_template_id_1a0dbc4b_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"fibre-experience-cards"},[_c('div',{staticClass:"fibre-experience-card",class:{'selected': _vm.selected === 'fibre_uncapped_pure', 'disabled': !_vm.hasPureProviders},on:{"click":function($event){return _vm.selectFibreExperience('fibre_uncapped_pure')}}},[(!_vm.hasPureProviders)?_c('div',{staticClass:"tag"},[_vm._v("Not available at this location")]):_vm._e(),_c('div',{staticClass:"experience-logo"},[_c('svg',{attrs:{"width":"169px","height":"37px","viewBox":"0 0 169 37"}},[_c('path',{attrs:{"d":"M0,36.524 L4.86,9.02 C7.716,8.444 10.68,8.156 13.752,8.156 C20.832,8.156 23.796,11.456 22.644,18.056 C21.348,25.352 17.412,29 10.836,29 C9.396,29 8.04,28.664 6.768,27.992 L6.156,31.34 C6.036,32.108 5.79,32.804 5.418,33.428 C5.046,34.052 4.584,34.598 4.032,35.066 C3.48,35.534 2.862,35.894 2.178,36.146 C1.494,36.398 0.768,36.524 0,36.524 Z M7.524,23.564 C8.724,24.284 10.08,24.644 11.592,24.644 C14.736,24.644 16.68,22.436 17.424,18.02 C18.12,14.276 16.728,12.404 13.248,12.404 C12.48,12.404 11.784,12.428 11.16,12.476 C10.536,12.524 9.972,12.596 9.468,12.692 L7.524,23.564 Z M32.22,8.156 L29.916,21.296 C29.532,23.6 30.336,24.752 32.328,24.752 C32.976,24.752 33.666,24.584 34.398,24.248 C35.13,23.912 35.88,23.492 36.648,22.988 C37.536,22.436 38.076,21.632 38.268,20.576 L40.464,8.156 L45.72,8.156 L42.948,23.78 C42.828,24.524 42.582,25.22 42.21,25.868 C41.838,26.516 41.376,27.068 40.824,27.524 C40.272,27.98 39.648,28.34 38.952,28.604 C38.256,28.868 37.524,29 36.756,29 L37.152,26.732 C36.48,27.164 35.838,27.53 35.226,27.83 C34.614,28.13 34.008,28.364 33.408,28.532 C32.808,28.7 32.208,28.82 31.608,28.892 C31.008,28.964 30.372,29 29.7,29 C25.452,29 23.76,26.48 24.624,21.44 L26.964,8.156 L32.22,8.156 Z M53.82,8.156 L53.316,10.82 C55.5,9.044 57.6,8.156 59.616,8.156 L58.788,12.404 C56.868,12.404 54.96,13.22 53.064,14.852 L50.328,29 L45.072,29 L49.104,8.156 L53.82,8.156 Z M70.812,8.156 C77.124,8.156 79.716,11.384 78.588,17.84 L78.3,19.136 L78.3,19.136 C78.204,19.568 78.084,20 77.94,20.432 L64.116,20.432 C63.612,23.36 65.508,24.824 69.804,24.824 C70.884,24.824 71.952,24.776 73.008,24.68 C74.064,24.584 75.132,24.44 76.212,24.248 L75.492,28.388 C73.524,28.796 71.256,29 68.688,29 C61.152,29 57.996,25.448 59.22,18.344 C60.444,11.552 64.308,8.156 70.812,8.156 Z M70.092,12.296 C67.308,12.296 65.532,13.796 64.764,16.796 L73.656,16.796 L73.692,16.616 C74.196,13.736 72.996,12.296 70.092,12.296 Z M107.46,0.56 L107.424,0.884 C107.4,1.028 107.376,1.178 107.352,1.334 C107.328,1.49 107.292,1.64 107.244,1.784 C106.98,2.6 106.518,3.296 105.858,3.872 C105.253,4.4 104.542125,4.67591667 103.725375,4.69975 L100.458,4.7 C99.822,4.7 99.276,4.79 98.82,4.97 C98.364,5.15 97.998,5.48 97.722,5.96 C97.446,6.44 97.284,7.148 97.236,8.084 L103.5,8.084 L102.708,12.26 L96.408,12.26 L93.204,29 L87.912,29 L91.944,8.084 C92.232,6.644 92.604,5.444 93.06,4.484 C93.516,3.524 94.116,2.756 94.86,2.18 C95.604,1.604 96.528,1.19 97.632,0.938 C98.736,0.686 100.068,0.56 101.628,0.56 C102.468,0.56 103.386,0.548 104.382,0.524 C105.378,0.5 106.404,0.512 107.46,0.56 Z M112.5,8.192 L108.504,29 L103.212,29 L107.208,8.192 L112.5,8.192 Z M117.504,0.524 C118.2,0.524 118.836,0.668 119.412,0.956 C119.988,1.244 120.474,1.628 120.87,2.108 C121.266,2.588 121.554,3.14 121.734,3.764 C121.914,4.388 121.944,5.036 121.824,5.708 L121.14,9.668 C122.916,8.588 124.764,8.048 126.684,8.048 C132.588,8.048 134.964,11.384 133.812,18.056 C132.516,25.352 128.484,29 121.716,29 C120.996,29 120.306,28.994 119.646,28.982 C118.986,28.97 118.296,28.958 117.576,28.946 C116.856,28.934 116.1,28.916 115.308,28.892 C114.516,28.868 113.628,28.856 112.644,28.856 L117.504,0.524 Z M125.496,12.44 C124.608,12.44 123.702,12.626 122.778,12.998 C121.854,13.37 121.032,13.868 120.312,14.492 L118.332,24.464 C118.62,24.56 118.95,24.632 119.322,24.68 C119.694,24.728 120.078,24.764 120.474,24.788 C120.87,24.812 121.236,24.824 121.572,24.824 L122.4,24.824 L122.4,24.824 C123.984,24.824 125.316,24.236 126.396,23.06 C127.476,21.884 128.22,20.168 128.628,17.912 C129.276,14.264 128.232,12.44 125.496,12.44 Z M114.012,0.524 L113.58,2.684 C113.46,3.284 113.172,3.77 112.716,4.142 C112.26,4.514 111.732,4.7 111.132,4.7 L107.928,4.7 L108.216,3.152 C108.36,2.384 108.732,1.754 109.332,1.262 C109.932,0.77 110.616,0.524 111.384,0.524 L114.012,0.524 Z M143.64,8.156 L143.136,10.82 C145.32,9.044 147.42,8.156 149.436,8.156 L148.608,12.404 C146.688,12.404 144.78,13.22 142.884,14.852 L140.148,29 L134.892,29 L138.924,8.156 L143.64,8.156 Z M160.632,8.156 C166.944,8.156 169.536,11.384 168.408,17.84 C168.312,18.272 168.216,18.704 168.12,19.136 C168.024,19.568 167.904,20 167.76,20.432 L153.936,20.432 C153.432,23.36 155.328,24.824 159.624,24.824 C160.704,24.824 161.772,24.776 162.828,24.68 C163.884,24.584 164.952,24.44 166.032,24.248 L165.312,28.388 C163.344,28.796 161.076,29 158.508,29 C150.972,29 147.816,25.448 149.04,18.344 C150.264,11.552 154.128,8.156 160.632,8.156 Z M159.912,12.296 C157.128,12.296 155.352,13.796 154.584,16.796 L163.476,16.796 L163.512,16.616 C164.016,13.736 162.816,12.296 159.912,12.296 Z"}})])]),_c('p',{staticClass:"experience-type"},[_vm._v("Month-to-month")]),_vm._m(0)]),_c('div',{staticClass:"fibre-experience-card",class:{'selected': _vm.selected === 'fibre_prepaid', 'disabled': !_vm.hasPrepaidProviders},on:{"click":function($event){return _vm.selectFibreExperience('fibre_prepaid')}}},[(!_vm.hasPrepaidProviders)?_c('div',{staticClass:"tag"},[_vm._v("Not available at this location")]):_vm._e(),_c('div',{staticClass:"experience-logo"},[_c('svg',{attrs:{"width":"225px","height":"37px","viewBox":"0 0 225 37"}},[_c('path',{attrs:{"d":"M0.27,36.524 L5.13,9.02 C7.986,8.444 10.95,8.156 14.022,8.156 C21.102,8.156 24.066,11.456 22.914,18.056 C21.618,25.352 17.682,29 11.106,29 C9.666,29 8.31,28.664 7.038,27.992 L6.426,31.34 C6.306,32.108 6.06,32.804 5.688,33.428 C5.316,34.052 4.854,34.598 4.302,35.066 C3.75,35.534 3.132,35.894 2.448,36.146 C1.764,36.398 1.038,36.524 0.27,36.524 Z M7.794,23.564 C8.994,24.284 10.35,24.644 11.862,24.644 C15.006,24.644 16.95,22.436 17.694,18.02 C18.39,14.276 16.998,12.404 13.518,12.404 C12.75,12.404 12.054,12.428 11.43,12.476 C10.806,12.524 10.242,12.596 9.738,12.692 L7.794,23.564 Z M70.83,8.156 C77.91,8.156 80.874,11.456 79.722,18.056 C78.426,25.352 74.49,29 67.914,29 C66.474,29 65.118,28.664 63.846,27.992 L63.234,31.34 C63.114,32.108 62.868,32.804 62.496,33.428 C62.124,34.052 61.662,34.598 61.11,35.066 C60.558,35.534 59.94,35.894 59.256,36.146 C58.572,36.398 57.846,36.524 57.078,36.524 L61.938,9.02 C64.794,8.444 67.758,8.156 70.83,8.156 Z M32.706,8.156 L32.202,10.82 C34.386,9.044 36.486,8.156 38.502,8.156 L37.674,12.404 C35.754,12.404 33.846,13.22 31.95,14.852 L29.214,29 L23.958,29 L27.99,8.156 L32.706,8.156 Z M49.698,8.156 C56.01,8.156 58.602,11.384 57.474,17.84 C57.378,18.272 57.282,18.704 57.186,19.136 C57.09,19.568 56.97,20 56.826,20.432 L43.002,20.432 C42.498,23.36 44.394,24.824 48.69,24.824 C49.77,24.824 50.838,24.776 51.894,24.68 C52.95,24.584 54.018,24.44 55.098,24.248 L54.378,28.388 C52.41,28.796 50.142,29 47.574,29 C40.038,29 36.882,25.448 38.106,18.344 C39.33,11.552 43.194,8.156 49.698,8.156 Z M70.326,12.404 C69.558,12.404 68.862,12.428 68.238,12.476 C67.614,12.524 67.05,12.596 66.546,12.692 L64.602,23.564 C65.802,24.284 67.158,24.644 68.67,24.644 C71.814,24.644 73.758,22.436 74.502,18.02 C75.198,14.276 73.806,12.404 70.326,12.404 Z M48.978,12.296 C46.194,12.296 44.418,13.796 43.65,16.796 L52.542,16.796 L52.578,16.616 C53.082,13.736 51.882,12.296 48.978,12.296 Z M80.946,22.52 C81.738,18.368 85.146,16.292 91.17,16.292 C91.89,16.292 92.592,16.328 93.276,16.4 C93.96,16.472 94.65,16.568 95.346,16.688 L95.67,15.14 C96.03,13.268 94.866,12.332 92.178,12.332 C89.85,12.332 87.258,12.668 84.402,13.34 L85.23,9.164 C86.67,8.828 88.032,8.576 89.316,8.408 C90.6,8.24 91.818,8.156 92.97,8.156 C99.186,8.156 101.838,10.448 100.926,15.032 L98.802,26.012 C98.634,26.876 98.208,27.59 97.524,28.154 C96.84,28.718 96.054,29 95.166,29 L87.318,29 C82.23,29 80.106,26.84 80.946,22.52 Z M88.722,25.472 C89.586,25.472 90.426,25.454 91.242,25.418 C92.058,25.382 92.886,25.1 93.726,24.572 L94.662,20.252 C93.342,19.988 91.95,19.856 90.486,19.856 C87.966,19.856 86.538,20.72 86.202,22.448 C86.01,23.36 86.112,24.092 86.508,24.644 C86.904,25.196 87.642,25.472 88.722,25.472 Z M111.186,8.192 L107.19,29 L101.898,29 L105.894,8.192 L111.186,8.192 Z M134.838,0.524 C134.502,2.372 134.19,4.094 133.902,5.69 C133.614,7.286 133.332,8.828 133.056,10.316 C132.78,11.804 132.516,13.262 132.264,14.69 C132.012,16.118 131.748,17.576 131.472,19.064 C131.196,20.552 130.914,22.094 130.626,23.69 C130.338,25.286 130.026,27.008 129.69,28.856 C128.706,28.856 127.812,28.868 127.008,28.892 C126.204,28.916 125.442,28.934 124.722,28.946 C124.002,28.958 123.312,28.97 122.652,28.982 C121.992,28.994 121.302,29 120.582,29 C113.814,29 111.066,25.352 112.338,18.056 C113.538,11.384 117.09,8.048 122.994,8.048 C124.938,8.048 126.594,8.588 127.962,9.668 L128.682,5.708 C128.802,5.036 129.06,4.388 129.456,3.764 C129.852,3.14 130.338,2.588 130.914,2.108 C131.49,1.628 132.12,1.244 132.804,0.956 C133.488,0.668 134.166,0.524 134.838,0.524 Z M122.634,12.44 C119.898,12.44 118.206,14.264 117.558,17.912 C117.15,20.168 117.288,21.884 117.972,23.06 C118.656,24.236 119.79,24.824 121.374,24.824 L122.184,24.824 L122.184,24.824 C122.532,24.824 122.904,24.812 123.3,24.788 C123.696,24.764 124.098,24.728 124.506,24.68 C124.914,24.632 125.274,24.56 125.586,24.464 L127.098,14.492 C126.594,13.868 125.952,13.37 125.172,12.998 C124.392,12.626 123.546,12.44 122.634,12.44 Z M112.698,0.524 L112.266,2.684 C112.146,3.284 111.858,3.77 111.402,4.142 C110.946,4.514 110.418,4.7 109.818,4.7 L106.614,4.7 L106.902,3.152 C107.046,2.384 107.418,1.754 108.018,1.262 C108.618,0.77 109.302,0.524 110.07,0.524 L112.698,0.524 Z M163.458,0.56 L163.422,0.884 C163.398,1.028 163.374,1.178 163.35,1.334 C163.326,1.49 163.29,1.64 163.242,1.784 C162.978,2.6 162.516,3.296 161.856,3.872 C161.251,4.4 160.540125,4.67591667 159.723375,4.69975 L156.456,4.7 C155.82,4.7 155.274,4.79 154.818,4.97 C154.362,5.15 153.996,5.48 153.72,5.96 C153.444,6.44 153.282,7.148 153.234,8.084 L159.498,8.084 L158.706,12.26 L152.406,12.26 L149.202,29 L143.91,29 L147.942,8.084 C148.23,6.644 148.602,5.444 149.058,4.484 C149.514,3.524 150.114,2.756 150.858,2.18 C151.602,1.604 152.526,1.19 153.63,0.938 C154.734,0.686 156.066,0.56 157.626,0.56 C158.466,0.56 159.384,0.548 160.38,0.524 C161.376,0.5 162.402,0.512 163.458,0.56 Z M168.498,8.192 L164.502,29 L159.21,29 L163.206,8.192 L168.498,8.192 Z M173.502,0.524 C174.198,0.524 174.834,0.668 175.41,0.956 C175.986,1.244 176.472,1.628 176.868,2.108 C177.264,2.588 177.552,3.14 177.732,3.764 C177.912,4.388 177.942,5.036 177.822,5.708 L177.138,9.668 C178.914,8.588 180.762,8.048 182.682,8.048 C188.586,8.048 190.962,11.384 189.81,18.056 C188.514,25.352 184.482,29 177.714,29 C176.994,29 176.304,28.994 175.644,28.982 C174.984,28.97 174.294,28.958 173.574,28.946 C172.854,28.934 172.098,28.916 171.306,28.892 C170.514,28.868 169.626,28.856 168.642,28.856 L173.502,0.524 Z M181.494,12.44 C180.606,12.44 179.7,12.626 178.776,12.998 C177.852,13.37 177.03,13.868 176.31,14.492 L174.33,24.464 C174.618,24.56 174.948,24.632 175.32,24.68 C175.692,24.728 176.076,24.764 176.472,24.788 C176.868,24.812 177.234,24.824 177.57,24.824 L178.398,24.824 L178.398,24.824 C179.982,24.824 181.314,24.236 182.394,23.06 C183.474,21.884 184.218,20.168 184.626,17.912 C185.274,14.264 184.23,12.44 181.494,12.44 Z M170.01,0.524 L169.578,2.684 C169.458,3.284 169.17,3.77 168.714,4.142 C168.258,4.514 167.73,4.7 167.13,4.7 L163.926,4.7 L164.214,3.152 C164.358,2.384 164.73,1.754 165.33,1.262 C165.93,0.77 166.614,0.524 167.382,0.524 L170.01,0.524 Z M199.638,8.156 L199.134,10.82 C201.318,9.044 203.418,8.156 205.434,8.156 L204.606,12.404 C202.686,12.404 200.778,13.22 198.882,14.852 L196.146,29 L190.89,29 L194.922,8.156 L199.638,8.156 Z M216.63,8.156 C222.942,8.156 225.534,11.384 224.406,17.84 L224.118,19.136 L224.118,19.136 C224.022,19.568 223.902,20 223.758,20.432 L209.934,20.432 C209.43,23.36 211.326,24.824 215.622,24.824 C216.702,24.824 217.77,24.776 218.826,24.68 C219.882,24.584 220.95,24.44 222.03,24.248 L221.31,28.388 C219.342,28.796 217.074,29 214.506,29 C206.97,29 203.814,25.448 205.038,18.344 C206.262,11.552 210.126,8.156 216.63,8.156 Z M215.91,12.296 C213.126,12.296 211.35,13.796 210.582,16.796 L219.474,16.796 L219.51,16.616 C220.014,13.736 218.814,12.296 215.91,12.296 Z"}})])]),_c('p',{staticClass:"experience-type"},[_vm._v("Top up as needed")]),_vm._m(1)])]),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error}})],1)
}
var Experiencevue_type_template_id_1a0dbc4b_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("Internet allocated at beginning of every month.")]),_c('li',[_vm._v("Uncapped. Unshaped. Unthrottled.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("30 Day top up bundles available.")]),_c('li',[_vm._v("Uncapped. Unshaped. Unthrottled.")])])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/Experience.vue?vue&type=template&id=1a0dbc4b&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Experience.vue?vue&type=script&lang=js&



/* harmony default export */ var Experiencevue_type_script_lang_js_ = ({
	components: {
		ErrorBar: ErrorBar
	},
	methods: {
		selectFibreExperience(experience) {
			this.error = false

			// check that the experience is enabled
			switch(experience) {
				case 'fibre_uncapped_pure':
					if(!this.hasPureProviders) return
					break
				case 'fibre_prepaid':
					if(!this.hasPrepaidProviders) return
					break
			}

			this.selected = experience
		},
		next() {
			this.error = false
			if(!this.selected) {
				this.error = 'Please select a Fibre experience to continue'
				console.log(this.error)
				return
			}
			this.$signup.$store.commit('signupGeneral/setFibreExperience', this.selected)
			this.$modal.push('fibre-providers');
		},
		async getAvailableProviders() {
			let providers = [];
			let coverage = this.$signup.$store.getters['signupCoverage/coverage'];
			let experienceScope = this.$signup.$store.getters['signupGeneral/fibreTypeScope'];
			coverage.forEach(v => {
				if (v.solution_type_slug !== 'composite_fibre') return;
				if (!v.max_download_speed) return; //assume that provider is not available

				providers.push({
					name: v.vendor.name,
					slug: v.vendor.slug,
					max_download_speed: v.max_download_speed,
					pre_order: v.pre_order,
					metas: v.vendor.vendor_fibre_meta
				});
			});
			this.$signup.$store.commit('signupSolutions/updateProviders', providers);

			await this.$signup.$store.dispatch('signupSolutions/getCurrentlyActiveFibreProviders');
			let activeProviders = this.$signup.$store.getters['signupSolutions/activeProviders']

			let filteredProviders = activeProviders.filter(a => {
				return providers.find(p => a.vendor_slug === p.slug);
			});

			this.hasPrepaidProviders = !!filteredProviders.find(p => p.provider_type === 'fibre_prepaid')
			this.hasPureProviders = !!filteredProviders.find(p => p.provider_type === 'fibre_uncapped_pure')

			if(experienceScope === 'fibre_uncapped_pure' && this.hasPureProviders) {
				this.selectFibreExperience('fibre_uncapped_pure');
				this.next();
			}

			if(experienceScope === 'fibre_prepaid' && this.hasPrepaidProviders) {
				this.selectFibreExperience('fibre_prepaid');
				this.next();
			}

			this.$modal.toggleLoader(false)
		}
	},
	data() {
		return {
			hasPureProviders: false,
			hasPrepaidProviders: false,
			selected: false,
			error: false,
		}
	},
	mounted() {
		this.$modal.toggleLoader(true)
		this.getAvailableProviders()

		let that = this
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.next()
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/Experience.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_Experiencevue_type_script_lang_js_ = (Experiencevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Experience.vue?vue&type=style&index=0&id=1a0dbc4b&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Experience.vue?vue&type=style&index=0&id=1a0dbc4b&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/Experience.vue



;


/* normalize component */

var Experience_component = (0,componentNormalizer/* default */.Z)(
  fibre_Experiencevue_type_script_lang_js_,
  Experiencevue_type_template_id_1a0dbc4b_render,
  Experiencevue_type_template_id_1a0dbc4b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Experience = (Experience_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Providers.vue?vue&type=template&id=7f30f0fe&
var Providersvue_type_template_id_7f30f0fe_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[(_vm.providers.length > 0)?_c('div',{staticClass:"fibre-provider-cards",class:`t${_vm.providers.length > 4 ? 5 : _vm.providers.length }`},_vm._l((_vm.providers),function(p){return _c('provider-card',{key:p.slug,attrs:{"provider":p,"logo-only":_vm.imSure,"selected":_vm.selectedProvider.slug === p.slug},on:{"select":_vm.selectProvider}})}),1):_c('div',{staticClass:"fibre-provider-cards t1 loading"},[_c('provider-card',{key:"loading",attrs:{"provider":""}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var Providersvue_type_template_id_7f30f0fe_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/ProviderCard.vue?vue&type=template&id=65e795dc&
var ProviderCardvue_type_template_id_65e795dc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fibre-provider-card",class:[{'selected': _vm.selected}, {'logo-only':_vm.logoOnly}],on:{"click":function($event){$event.preventDefault();return _vm.select()}}},[(_vm.isPreorder)?_c('div',{staticClass:"tag pre-order-tag"},[_vm._v("Pre-order")]):_vm._e(),(_vm.bundleAllowed)?_c('div',{staticClass:"tag bundle-tag"},[_vm._v("Bundle with Air Mobile")]):_vm._e(),_c('div',{staticClass:"provider-logo"},[_c('icon',{attrs:{"name":`provider-${_vm.provider.slug}`}})],1),_c('div',{staticClass:"card-footer"},[(_vm.provider.slug !== 'cybersmart' && _vm.startingPrice > 0)?_c('p',[_vm._v("Starting from "),_c('formatted-price',{attrs:{"price":_vm.startingPrice}})],1):_c('p',[_vm._v("R0.00")])])])
}
var ProviderCardvue_type_template_id_65e795dc_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/ProviderCard.vue?vue&type=script&lang=js&





/* harmony default export */ var fibre_ProviderCardvue_type_script_lang_js_ = ({
	components: {
		FormattedSpeed: FormattedSpeed,
		Icon: Icon,
		FormattedPrice: FormattedPrice
	},
	props: ['provider', 'selected', 'logo-only'],
	computed: {
		bundleAllowed() {
			let bundles = this.$signup.$store.getters['signupSolutions/bundleProviders'].filter((p) => {
				return p.slug === this.provider.slug && p.bundle_allowed
			})

			return bundles.length > 0
		},
		startingPrice() {
			// return 0;

			switch (this.provider.slug) {
				case 'vuma_reach_prepaid':
					return 399
				case 'openserve_prepaid':
					return 219
				default:
					return (this.provider.solutions && this.provider.solutions.length > 0) ?
						this.provider.solutions
							.sort((a, b) => a.price > b.price ? 1 : -1)[0].price : 0
			}


		},
		isPreorder() {
			return this.provider.pre_order
		}
	},
	methods: {
		select() {
			this.$emit('select', this.provider);
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/ProviderCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_fibre_ProviderCardvue_type_script_lang_js_ = (fibre_ProviderCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/ProviderCard.vue?vue&type=style&index=0&id=65e795dc&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/ProviderCard.vue?vue&type=style&index=0&id=65e795dc&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/ProviderCard.vue



;


/* normalize component */

var fibre_ProviderCard_component = (0,componentNormalizer/* default */.Z)(
  modals_fibre_ProviderCardvue_type_script_lang_js_,
  ProviderCardvue_type_template_id_65e795dc_render,
  ProviderCardvue_type_template_id_65e795dc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var fibre_ProviderCard = (fibre_ProviderCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Providers.vue?vue&type=script&lang=js&





/* harmony default export */ var fibre_Providersvue_type_script_lang_js_ = ({
	components: {
		ErrorBar: ErrorBar,
		ProviderCard: fibre_ProviderCard
	},
	data() {
		return {
			error: false,
			providers: false,
			has_vt: false
		}
	},
	computed: {
		imSure() {
			return this.$signup.$store.getters['signupGeneral/imSure']
		},
		skipProvidersView() {
			return this.$signup.$store.getters['signupGeneral/skipProvidersView']
		},
		selectedProvider() {
			return this.$signup.$store.getters['signupSolutions/currentProvider'];
		},
		experienceSlug() {
			return this.$signup.$store.getters['signupGeneral/fibreExperience']
		},
		filteredProviders() {
			// return providers based on
			// - selected experience
			// - available on afrihost.com API
		}
	},
	methods: {
		selectProvider(provider) {
			this.$signup.$store.commit('signupSolutions/updateCurrentProvider', provider);
		},
		async next() {

			if (!this.selectedProvider) {
				this.error = { message: 'Please select a provider.' }
			} else if (!this.selectedProvider.solutions) {
				this.providers = [];
				this.error = true;
			} else {

				// FF Century Promo
				this.$modal.toggleLoader(true);
				await this.$signup.$store.dispatch('signupSolutions/getProviderPromos', this.selectedProvider)
				this.$modal.push('fibre-solutions');
			}


		},
		async getProvidersNew() {
			// let activeProviders = await this.$signup.$store.dispatch('signupSolutions/getCurrentlyActiveFibreProviders');
			let activeProviders = this.$signup.$store.getters['signupSolutions/activeProviders']
			if(!activeProviders.length) {
				activeProviders = await this.$signup.$store.dispatch('signupSolutions/getCurrentlyActiveFibreProviders')
			}
			let availableProvidersAtLocation = this.$signup.$store.getters['signupCoverage/coverage'];
			let filteredProviders = []
			availableProvidersAtLocation.forEach(p => {
				let activeProvider = activeProviders.find(ap => ap.vendor_slug === p.vendor.slug && ap.provider_type === this.experienceSlug)
				if(activeProvider) filteredProviders.push({
					name: p.vendor.name,
					slug: p.vendor.slug,
					max_download_speed: p.max_download_speed,
					pre_order: p.pre_order,
					metas: p.vendor.vendor_fibre_meta,
					location_promos: p.boundary_slugs,
					display_order: activeProvider.display_order
				})
			})

			let providerSlugs = [];
			filteredProviders.forEach((p) => {
				providerSlugs.push(p.slug);
			});

			let allSolutions = await this.$signup.$store.dispatch('signupSolutions/getSolutions', {
				vendorSlug: providerSlugs,
				sectionSlug: 'broadband',
				categorySlug: this.experienceSlug
			}).catch((err) => {
				filteredProviders = [];
				this.error = true;
			});

			filteredProviders.forEach(p => {
				p.solutions = allSolutions.solutions.filter(s => s.vendor.slug === p.slug)
				if (providerSlugs.includes('vumatel_tactical') && p.slug !== 'vumatel_tactical' && p.slug.includes('vuma')) {
					const solutions = allSolutions.solutions.filter(s => s.vendor.slug === 'vumatel_tactical')
					p.solutions.push(...solutions)
				}
			})

			this.has_vt = filteredProviders.some(p => p.slug === 'vumatel_tactical')
			filteredProviders = filteredProviders.filter(p => p.slug !== 'vumatel_tactical')

			this.providers = filteredProviders.sort((a, b) => {
				return a.display_order - b.display_order;
			});



		}
	},
	async mounted() {
		this.$modal.toggleLoader(true)
		this.selectProvider(false);
		await this.getProvidersNew()

		this.$modal.toggleLoader(false)
		// if (this.providers.length === 1) {
		// 	// set the selected provider
		// 	this.selectProvider(this.providers[0]);
		//
		// 	// show the solutions
		// 	await this.next();
		// }
		// always auto-select the first provider
		// set the selected provider
		if (!(this.has_vt && this.providers.length > 1)) {
			this.selectProvider(this.providers[0]);
		}

		if((this.skipProvidersView && !this.has_vt) || this.providers.length === 1) {
			await this.next();
		} else {
			let that = this;
			// listen for back button event
			services_EventBus.$on('back', function () {
				that.$modal.push('fibre-experience');
			});

			// listen for next button event
			services_EventBus.$on('next', async function () {
				await that.next();
			});
		}


	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/Providers.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_fibre_Providersvue_type_script_lang_js_ = (fibre_Providersvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Providers.vue?vue&type=style&index=0&id=7f30f0fe&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Providers.vue?vue&type=style&index=0&id=7f30f0fe&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/Providers.vue



;


/* normalize component */

var fibre_Providers_component = (0,componentNormalizer/* default */.Z)(
  modals_fibre_Providersvue_type_script_lang_js_,
  Providersvue_type_template_id_7f30f0fe_render,
  Providersvue_type_template_id_7f30f0fe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var fibre_Providers = (fibre_Providers_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Solutions.vue?vue&type=template&id=20f22ec7&
var Solutionsvue_type_template_id_20f22ec7_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[(_vm.eventPricingError)?_c('div',{staticClass:"error-block"},[_vm._v(" Error loading setup costs. Please contact Afrihost Support. ")]):_vm._e(),(!_vm.showAllSolutions && _vm.solutions.length >= 3)?_c('div',{staticClass:"fibre-solution-cards-triple"},[_vm._l((_vm.specialSolutions),function(s,i){return _c('solution-card-special',{key:s.id,attrs:{"index":i,"solution":s,"selected":_vm.selectedSolutionId === s.id},on:{"select":_vm.selectSolution}})}),_c('p',{staticClass:"view-all",on:{"click":function($event){_vm.showAllSolutions = true}}},[_vm._v("View all speed options.")])],2):_c('div',{staticClass:"fibre-solution-cards",class:`t${_vm.solutions.length}`},_vm._l((_vm.solutions),function(s){return _c('solution-card',{key:s.id,attrs:{"solution":s,"selected":_vm.selectedSolutionId === s.id},on:{"select":_vm.selectSolution}})}),1),(_vm.error)?_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}}):_vm._e()],1)
}
var Solutionsvue_type_template_id_20f22ec7_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/SolutionCard.vue?vue&type=template&id=0eec22b9&
var SolutionCardvue_type_template_id_0eec22b9_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vumaSolutionPromoPrice)?_c('div',{staticClass:"fibre-solution-card --vuma-promo",class:{'selected': _vm.selected},on:{"click":function($event){return _vm.select()}}},[_c('div',{staticClass:"card-price"},[_c('dl',[_c('dt',[_c('formatted-price',{attrs:{"price":_vm.vumaSolutionPromoPrice}})],1),_c('dt',[_vm._v("for the first 2 months*")]),_c('dd',[_vm._v("Thereafter "),_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)])]),_c('div',{staticClass:"card-footer"},[_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-down"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_download_speed}})],1)]),_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-up"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_upload_speed}})],1)])])]):(_vm.solution.id === 2258820)?_c('div',{staticClass:"fibre-solution-card --vuma-promo",class:{'selected': _vm.selected},on:{"click":function($event){return _vm.select()}}},[_c('div',{staticClass:"card-price"},[_c('dl',[_c('dt',[_c('formatted-price',{attrs:{"price":0}})],1),_c('dt',[_vm._v("until 30 June 2025*")]),_c('dd',[_vm._v("Thereafter "),_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)])]),_c('div',{staticClass:"card-footer"},[_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-down"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_download_speed}})],1)]),_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-up"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_upload_speed}})],1)])])]):_c('div',{staticClass:"fibre-solution-card",class:{'selected': _vm.selected},on:{"click":function($event){return _vm.select()}}},[(_vm.solution.price_promo || _vm.solution.id === 1831820)?_c('span',{staticClass:"card-tag promo"},[_vm._v("PROMO")]):_vm._e(),(_vm.solution.bill_recurrence_unit === 'onceoff')?_c('div',{staticClass:"card-price"},[_c('p',[_vm._v(_vm._s(_vm.prepaidPrice))])]):_c('div',{staticClass:"card-price"},[(_vm.promoPrice)?_c('p',[_c('formatted-price',{attrs:{"price":_vm.promoPrice}}),_c('span',{staticClass:"strike small"},[_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)],1):_c('p',[_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)]),_c('div',{staticClass:"card-footer"},[_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-down"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_download_speed}})],1)]),_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-up"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_upload_speed}})],1)])])])
}
var SolutionCardvue_type_template_id_0eec22b9_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/SolutionCard.vue?vue&type=script&lang=js&





/* harmony default export */ var fibre_SolutionCardvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon,
		FormattedSpeed: FormattedSpeed,
		FormattedPrice: FormattedPrice
	},
	props: ['solution', 'selected'],
	computed: {
		vumaSolutionPromoPrice() {
			switch (this.solution.id) {
				case 2096820: 	return 397
				case 2097820: 	return 497
				case 2099820: 	return 397
				case 2100820: 	return 497
				default: 		return false
			}
		},
		promoPrice() {
			return this.solution.price_promo ? this.solution.price_promo : false
		},
		lineChildSolution() {
			let metas = [...this.solution.solution_composite_child_metas]
			let lineChildSolution = metas.find(s => {
				return s.child_solution.display_category_slug === 'fibre_line';
			});

			return lineChildSolution ? lineChildSolution.child_solution : false;
		},
		prepaidPrice() {
			if(this.solution.bill_recurrence_unit !== 'onceoff') return false;
			switch (this.solution.id) {
				case 1825820: // VR100
					return 'R897.00'
				case 1814820: // VR40
					return 'R529.00'
				case 1813820: // VR20
					return 'R399.00'
				case 1826820: // OPPC20
					return 'R219.00'
				case 2370820:
					return 'R437.00'
				case 2372820:
					return 'R557.00'
				case 2373820:
					return 'R857.00'
				default:
					return 'R0.00'
			}
		}
	},
	methods: {
		select() {
			this.$emit('select', this.solution);
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/SolutionCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_fibre_SolutionCardvue_type_script_lang_js_ = (fibre_SolutionCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/SolutionCard.vue?vue&type=style&index=0&id=0eec22b9&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/SolutionCard.vue?vue&type=style&index=0&id=0eec22b9&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/SolutionCard.vue



;


/* normalize component */

var fibre_SolutionCard_component = (0,componentNormalizer/* default */.Z)(
  modals_fibre_SolutionCardvue_type_script_lang_js_,
  SolutionCardvue_type_template_id_0eec22b9_render,
  SolutionCardvue_type_template_id_0eec22b9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var fibre_SolutionCard = (fibre_SolutionCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/SolutionCardSpecial.vue?vue&type=template&id=43988894&
var SolutionCardSpecialvue_type_template_id_43988894_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fibre-solution-card-special",class:{'selected': _vm.selected, 'popular': _vm.index === 1},on:{"click":function($event){return _vm.select()}}},[(_vm.tag)?_c('span',{staticClass:"card-tag"},[_vm._v(_vm._s(_vm.tag))]):_vm._e(),_c('div',{staticClass:"speed-icon"},[(_vm.index === 0)?_c('svg',{attrs:{"width":"50px","height":"39px","viewBox":"0 0 50 39"}},[_c('g',[_c('path',{attrs:{"d":"M16.5438275,2.6353057 C25.7888275,-1.3236943 36.5338275,1.0803057 43.2038275,8.5993057 C49.8748275,16.1193057 50.9698275,27.0623057 45.9208275,35.7513057 C45.0918275,37.1853057 43.5648275,38.0723057 41.9078275,38.0823057 L9.59082745,38.0823057 L9.20682745,38.0673057 C7.96182745,37.9703057 6.81782745,37.3723057 6.01882745,36.4293057 C5.83682745,36.2693057 5.67082745,36.0893057 5.54282745,35.8693057 C4.94882745,34.8513057 4.42882745,33.7793057 3.99682745,32.6813057 C3.53082745,31.4993057 4.11182745,30.1643057 5.29382745,29.6993057 C6.47682745,29.2333057 7.81182745,29.8143057 8.27682745,30.9963057 C8.45882745,31.4573057 8.66182745,31.9123057 8.88082745,32.3593057 L8.89082745,32.3493057 C9.29882745,33.1143057 10.0988275,33.5903057 10.9678275,33.5843057 L40.4838275,33.5843057 L40.7718275,33.5673057 C41.3938275,33.4913057 41.9478275,33.1583057 42.3278275,32.6653057 C46.0008275,25.5013057 44.6428275,16.6313057 38.9168275,10.9053057 C36.2748275,8.2633057 32.9818275,6.5103057 29.4008275,5.7933057 C29.3618275,5.7853057 29.3228275,5.7793057 29.2838275,5.7723057 C28.8048275,5.6793057 28.3198275,5.6133057 27.8318275,5.5573057 C27.6758275,5.5413057 27.5208275,5.5193057 27.3638275,5.5063057 C26.9338275,5.4683057 26.5008275,5.4523057 26.0668275,5.4433057 C25.6198275,5.4373057 25.1728275,5.4453057 24.7228275,5.4723057 C24.7028275,5.4733057 24.6828275,5.4743057 24.6628275,5.4753057 C24.2438275,5.5013057 23.8238275,5.5403057 23.4038275,5.5953057 C21.7088275,5.7943057 20.0518275,6.2333057 18.4808275,6.9003057 L18.1928275,7.0183057 C18.1658275,7.0273057 18.1378275,7.0273057 18.1108275,7.0353057 C16.0328275,7.9573057 14.1138275,9.2493057 12.4588275,10.9053057 C10.6588275,12.7043057 9.27082745,14.8013057 8.32982745,17.1383057 C7.85682745,18.3163057 6.51782745,18.8893057 5.33782745,18.4133057 C4.15882745,17.9393057 3.58782745,16.5993057 4.06282745,15.4213057 C5.23482745,12.5053057 6.96582745,9.8923057 9.20582745,7.6523057 C11.2198275,5.6373057 13.5238275,4.0963057 15.9748275,2.9743057 C16.1458275,2.8373057 16.3348275,2.7213057 16.5438275,2.6353057 Z M25.3582951,18.4976948 L25.5937677,18.5037208 C27.3140523,18.587874 28.8826588,19.5463331 29.74728,21.0575012 L29.8703916,21.2857404 C30.6500025,22.822873 30.6070067,24.6601581 29.7444064,26.1616466 L29.6138776,26.3762423 C28.7569143,27.7102227 27.3321033,28.5625371 25.7662422,28.6893117 L25.3505506,28.7060903 L-3.88578059e-16,23.5507704 L25.3582951,18.4976948 Z"}})])]):_vm._e(),(_vm.index === 1)?_c('svg',{attrs:{"width":"52px","height":"43px","viewBox":"0 0 52 43"}},[_c('g',[_c('path',{attrs:{"d":"M17.0052296,4.43072149 C18.299,3.924242 19.759003,4.55517692 20.2675433,5.83436228 C20.7760837,7.11354765 20.1406816,8.55831284 18.8480049,9.06154566 C16.2331232,10.080998 13.8894631,11.6047653 11.8848298,13.5884766 C9.10371562,16.3394827 7.27515763,19.7311637 6.43087129,23.3273845 C6.36197228,23.8262884 6.30619688,24.3316857 6.22198698,24.8663029 C5.56471225,28.9267965 6.1793352,33.089019 7.98273958,36.7956263 C8.42894273,37.6235255 9.30385085,38.1386627 10.2542198,38.1321694 L42.5339551,38.1321694 L42.8489221,38.1137716 C43.5313504,38.0304406 44.1383179,37.6689788 44.5538993,37.1321971 C48.5839448,29.3629317 47.1294101,19.830728 40.8202288,13.5884766 C38.8549665,11.642643 36.5605199,10.1383557 34.0025073,9.1199856 C32.7142051,8.60593057 32.0897394,7.15575427 32.6092161,5.87981557 C33.1286928,4.60604131 34.5919766,3.98701083 35.8824661,4.50106586 C39.0725999,5.77267568 41.9302685,7.64600044 44.377824,10.0690935 C48.1596144,13.8103319 50.5273345,18.5071716 51.425209,23.4496755 C51.4394262,23.5265132 51.4503626,23.6044331 51.4645798,23.682353 C51.5433216,24.1390503 51.6176888,24.5957476 51.6701833,25.0556916 C51.7314268,25.5426911 51.7707977,26.0296906 51.8014195,26.5188546 C51.8068877,26.6000211 51.8156367,26.6811877 51.8189176,26.7634365 C52.072641,31.4364673 50.9986913,36.187418 48.4800495,40.4773426 C47.573426,42.0292477 45.9034451,42.9891778 44.0912916,43 L8.74828419,43 L8.32832829,42.9837667 C6.99628067,42.8809557 5.77031566,42.2586785 4.89868843,41.277104 C4.68871048,41.1007019 4.49513706,40.8994088 4.34749631,40.6504979 C-1.51110723,30.7600791 0.124970967,18.1846697 8.32723466,10.0690935 C10.8240037,7.59730049 13.742916,5.70016686 17.0052296,4.43072149 Z M26.4278808,0 L31.9922965,27.4353876 L31.9866466,27.679689 C31.9012855,29.5459875 30.8540046,31.2499465 29.1980587,32.189585 L28.9706072,32.312056 C27.2869054,33.1694002 25.2679143,33.1296587 23.6161448,32.1928317 L23.4023936,32.0651283 C21.9310812,31.1412437 20.9879904,29.5955502 20.8470606,27.8920849 L20.8284688,27.4429632 L26.4278808,0 Z"}})])]):_vm._e(),(_vm.index === 2)?_c('svg',{attrs:{"width":"49px","height":"39px","viewBox":"0 0 49 39"}},[_c('g',[_c('path',{attrs:{"d":"M32.5807622,2.6353057 C32.7897622,2.7213057 32.9787622,2.8373057 33.1497622,2.9743057 C35.6007622,4.0963057 37.9047622,5.6373057 39.9187622,7.6523057 C42.1587622,9.8923057 43.8897622,12.5053057 45.0617622,15.4213057 C45.5367622,16.5993057 44.9657622,17.9393057 43.7867622,18.4133057 C42.6067622,18.8893057 41.2677622,18.3163057 40.7947622,17.1383057 C39.8537622,14.8013057 38.4657622,12.7043057 36.6657622,10.9053057 C35.0107622,9.2493057 33.0917622,7.9573057 31.0137622,7.0353057 C30.9867622,7.0273057 30.9587622,7.0273057 30.9317622,7.0183057 L30.6437622,6.9003057 C29.0727622,6.2333057 27.4157622,5.7943057 25.7207622,5.5953057 C25.3007622,5.5403057 24.8807622,5.5013057 24.4617622,5.4753057 C24.4417622,5.4743057 24.4217622,5.4733057 24.4017622,5.4723057 C23.9517622,5.4453057 23.5047622,5.4373057 23.0577622,5.4433057 C22.6237622,5.4523057 22.1907622,5.4683057 21.7607622,5.5063057 C21.6037622,5.5193057 21.4487622,5.5413057 21.2927622,5.5573057 C20.8047622,5.6133057 20.3197622,5.6793057 19.8407622,5.7723057 C19.8017622,5.7793057 19.7627622,5.7853057 19.7237622,5.7933057 C16.1427622,6.5103057 12.8497622,8.2633057 10.2077622,10.9053057 C4.48176222,16.6313057 3.12376222,25.5013057 6.79676222,32.6653057 C7.17676222,33.1583057 7.73076222,33.4913057 8.35276222,33.5673057 L8.64076222,33.5843057 L38.1567622,33.5843057 C39.0257622,33.5903057 39.8257622,33.1143057 40.2337622,32.3493057 L40.2437622,32.3593057 C40.4627622,31.9123057 40.6657622,31.4573057 40.8477622,30.9963057 C41.3127622,29.8143057 42.6477622,29.2333057 43.8307622,29.6993057 C45.0127622,30.1643057 45.5937622,31.4993057 45.1277622,32.6813057 C44.6957622,33.7793057 44.1757622,34.8513057 43.5817622,35.8693057 C43.4537622,36.0893057 43.2877622,36.2693057 43.1057622,36.4293057 C42.3067622,37.3723057 41.1627622,37.9703057 39.9177622,38.0673057 L39.5337622,38.0823057 L7.21676222,38.0823057 C5.55976222,38.0723057 4.03276222,37.1853057 3.20376222,35.7513057 C-1.84523778,27.0623057 -0.750237784,16.1193057 5.92076222,8.5993057 C12.5907622,1.0803057 23.3357622,-1.3236943 32.5807622,2.6353057 Z M23.7662946,18.4976948 L49.1245897,23.5507704 L23.774039,28.7060903 L23.3583475,28.6893117 C21.7924864,28.5625371 20.3676754,27.7102227 19.5107121,26.3762423 L19.3801833,26.1616466 C18.517583,24.6601581 18.4745871,22.822873 19.2541981,21.2857404 L19.3773097,21.0575012 C20.2419309,19.5463331 21.8105374,18.587874 23.530822,18.5037208 L23.7662946,18.4976948 Z"}})])]):_vm._e()]),(_vm.vumaSolutionPromoPrice)?_c('div',{staticClass:"card-price"},[_c('dl',[_c('dt',[_c('formatted-price',{attrs:{"price":_vm.vumaSolutionPromoPrice}})],1),_c('dt',[_vm._v("for the first 2 months*")]),_c('dd',[_vm._v("Thereafter "),_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)])]):(_vm.solution.bill_recurrence_unit === 'onceoff')?_c('div',{staticClass:"card-price"},[_c('p',[_vm._v(_vm._s(_vm.prepaidPrice))])]):_c('div',{staticClass:"card-price"},[(_vm.promoPrice)?_c('p',[_c('formatted-price',{attrs:{"price":_vm.promoPrice}}),_c('span',{staticClass:"strike small"},[_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)],1):_c('p',[_vm._v("R"+_vm._s(_vm.solution.price)),_c('sup',{staticClass:"up"},[_vm._v("pm")])])]),_c('div',{staticClass:"card-footer"},[_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-down"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_download_speed}})],1)]),_c('dl',{staticClass:"speed"},[_c('dt',[_c('icon',{attrs:{"name":"speed-up"}})],1),_c('dd',[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolution.line_upload_speed}})],1)])])])
}
var SolutionCardSpecialvue_type_template_id_43988894_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/SolutionCardSpecial.vue?vue&type=script&lang=js&





/* harmony default export */ var SolutionCardSpecialvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon,
		FormattedSpeed: FormattedSpeed,
		FormattedPrice: FormattedPrice
	},
	props: ['solution', 'selected', 'index'],
	computed: {
		vumaSolutionPromoPrice() {
			switch (this.solution.id) {
				case 2096820: 	return 397
				case 2097820: 	return 497
				case 2099820: 	return 397
				case 2100820: 	return 497
				default: 		return false
			}
		},
		tag() {
			switch (this.index) {
				case 1: return 'Most popular'
				case 2: return 'Best value'
				default: return false
			}
		},
		promoPrice() {
			return this.solution.price_promo ? this.solution.price_promo : false
		},
		lineChildSolution() {
			let metas = [...this.solution.solution_composite_child_metas]
			let lineChildSolution = metas.find(s => {
				return s.child_solution.display_category_slug === 'fibre_line';
			});

			return lineChildSolution ? lineChildSolution.child_solution : false;
		},
		prepaidPrice() {
			if(this.solution.bill_recurrence_unit !== 'onceoff') return false;
			switch (this.solution.id) {
				case 1825820: // VR100
					return 'R897.00'
				case 1814820: // VR40
					return 'R529.00'
				case 1813820: // VR20
					return 'R399.00'
				case 1826820: // OPPC20
					return 'R219.00'
				case 2370820:
					return 'R437.00'
				case 2372820:
					return 'R557.00'
				case 2373820:
					return 'R857.00'
				default:
					return 'R0.00'
			}
		}
	},
	methods: {
		select() {
			this.$emit('select', this.solution);
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/SolutionCardSpecial.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_SolutionCardSpecialvue_type_script_lang_js_ = (SolutionCardSpecialvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/SolutionCardSpecial.vue?vue&type=style&index=0&id=43988894&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/SolutionCardSpecial.vue?vue&type=style&index=0&id=43988894&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/SolutionCardSpecial.vue



;


/* normalize component */

var SolutionCardSpecial_component = (0,componentNormalizer/* default */.Z)(
  fibre_SolutionCardSpecialvue_type_script_lang_js_,
  SolutionCardSpecialvue_type_template_id_43988894_render,
  SolutionCardSpecialvue_type_template_id_43988894_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SolutionCardSpecial = (SolutionCardSpecial_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Solutions.vue?vue&type=script&lang=js&







/* harmony default export */ var fibre_Solutionsvue_type_script_lang_js_ = ({
	components: {
		SolutionCardSpecial: SolutionCardSpecial,
		ErrorBar: ErrorBar,
		SolutionCard: fibre_SolutionCard
	},
	data() {
		return {
			showAllSolutions: false,
			error: false,
			eventPricingError: false,
			selectedSolutionId: false,
		}
	},
	computed: {
		solutions() {
			let solutions = [...this.$signup.$store.getters['signupSolutions/currentProvider'].solutions];
			return solutions.sort((a, b) => {
				// if the prices are the same then sort by download speed
				if (a.price === b.price) {
					let lineChildSolutionA = a.solution_composite_child_metas.find(s => s.child_solution.display_category_slug === 'fibre_line');
					let lineChildSolutionB = b.solution_composite_child_metas.find(s => s.child_solution.display_category_slug === 'fibre_line');
					return lineChildSolutionB.line_download_speed - lineChildSolutionA.line_download_speed;
				} else {
					// else sort by price
					return a.price > b.price ? 1 : -1;
				}
			});
		},
		specialSolutions() {
			if(this.solutions.length < 4) return this.solutions

			let solutions = [
				this.solutions[0]
			]

			let firstSolutionChild = this.solutions[0].solution_composite_child_metas.find(c => c.child_solution.display_category_slug === 'fibre_line')
			let secondSolutionChild = this.solutions[1].solution_composite_child_metas.find(c => c.child_solution.display_category_slug === 'fibre_line')

			if(!firstSolutionChild || !secondSolutionChild) {
				return [
					this.solutions[0],
					this.solutions[1],
					this.solutions[this.solutions.length-1],
				]
			}

			if(firstSolutionChild.child_solution.line_download_speed === secondSolutionChild.child_solution.line_download_speed) {
				solutions.push(this.solutions[2])
			} else {
				solutions.push(this.solutions[1])
			}

			solutions.push(this.solutions[this.solutions.length-1])
			return solutions
		}
	},
	methods: {
		selectSolution(solution) {
			this.error = false;

			if (!solution) {
				this.$signup.$store.commit('signupSolutions/updateSelectedSolution', false);
				this.$signup.$store.commit('signupCart/setCartItems', []);
				this.selectedSolutionId = false;
				return;
			}

			let lineChildSolution = solution.solution_composite_child_metas.find(s => {
				return s.child_solution.display_category_slug === 'fibre_line';
			});

			let dataChildSolution = solution.solution_composite_child_metas.find(s => {
				return s.child_solution.display_category_slug === 'fibre_data';
			});

			let cartItems = [
				{
					product_type_slug: "solution_composite_fibre",
					product_id: solution.id,
					cart_item_requirements: []
				},
				{
					product_type_slug: "solution_fibre_line",
					product_id: lineChildSolution.child_solution.id,
					cart_item_requirements: []
				},
				{
					product_type_slug: "solution_connectivity_data",
					product_id: dataChildSolution.child_solution.id,
					cart_item_requirements: []
				}

			];

			this.$signup.$store.commit('signupSolutions/updateSelectedSolution', solution);
			this.$signup.$store.commit('signupCart/setCartItems', cartItems);
			this.selectedSolutionId = solution.id;
		},
		sendToOF() {
			//TODO: update once on-page signup is finalised
			// <form method="post" action="https://clientzone.afrihost.com/en/api/of/fibre-injection" encType='application/json'>
			// <input type="hidden" name="place[latitude]" :value="place.latitude" />
			// <input type="hidden" name="place[longitude]" :value="place.longitude" />
			// <input type="hidden" name="product[id]" :value="productId" />
			// <input type="hidden" name="is_preorder" :value="preOrder ? 1 : 0" />

			let place = this.$signup.$store.getters['signupCoverage/place'];

			let form = document.createElement("FORM");
			form.method = "POST";
			form.action = "https://clientzone.afrihost.com/en/api/of/fibre-injection";
			form.enctype = "application/json";
			let long = document.createElement('INPUT');
			long.name = "place[longitude]";
			long.value = place.geometry.location.lng();
			let lat = document.createElement('INPUT');
			lat.name = "place[latitude]";
			lat.value = place.geometry.location.lat();
			let productId = document.createElement('INPUT');
			productId.name = "product[id]";
			productId.value = this.selectedSolutionId;
			let isPreOrder = document.createElement('INPUT');
			isPreOrder.name = "is_preorder"
			isPreOrder.value = this.$signup.$store.getters['signupSolutions/currentProvider'].pre_order ? 1 : 0;

			console.table({[lat["name"]]: lat.value,[long["name"]]: long.value,[productId["name"]]: productId.value,[isPreOrder["name"]]: isPreOrder.value})

			form.appendChild(long);
			form.appendChild(lat);
			form.appendChild(productId);
			form.appendChild(isPreOrder);
			document.body.appendChild(form);
			form.submit();
		}
	},
	async mounted() {
		// show loader
		this.$modal.toggleLoader(true);

		if (this.solutions.length === 0) {
			this.error = true;
			// this.$modal.toggleLoader(false);
		} else {
			// this.$modal.toggleLoader(false);
			this.selectSolution(false);

			if(this.solutions.length >= 3) {
				this.selectSolution(this.specialSolutions[1]);
			}

		}

		await this.$signup.$store.dispatch('signupSolutions/getSolutionEventPrices', {solutionId: this.solutions[0].id});
		this.eventPricingError = this.$signup.$store.getters['signupSolutions/currentProvider'].eventPrices === undefined;

		this.$modal.state.current.buttons[1].type = 'primary';
		if (this.eventPricingError) {
			this.$modal.state.current.buttons[1].type = 'primary disabled';
		}

		this.$modal.toggleLoader(false);

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$signup.$store.commit('signupGeneral/setSkipProvidersView', false)
			that.$modal.push('fibre-experience');
			// if (that.$signup.$store.getters['signupSolutions/providers'].length !== 1) {
			// 	that.$modal.push('fibre-providers');
			// } else {
			// 	that.$modal.push('fibre-experience');
			// }
		});

		// listen for next button event
		services_EventBus.$on('next', function () {

			if (!that.selectedSolutionId) {
				that.error = { message: "Please select a package" };
				return;
			}

			that.$modal.toggleLoader(true)

			//check whether we can process the order
			let unprocessable = ['vuma_reach', 'waterfall_access_networks', 'openserve_prepaid', 'vuma_reach_prepaid'];
			let providerSlug = that.$signup.$store.getters['signupSolutions/currentProvider'].slug;

			if (unprocessable.includes(providerSlug)) {
				that.sendToOF()
				return
			}

			// check for promos
			let promoFlag = false
			that.$signup.$store.dispatch('signupSolutions/getSolutionPromo', that.selectedSolutionId)
				.then(r => {
					r.solution_promotions.forEach(p => {
						if(p.slug === 'tt_connect_3_months_promo') {
							promoFlag = true
							that.$modal.push('promo-tt-connect')
						}
					})
				}, e => {
					console.log('error', e)
					that.$modal.push('auth-signup')
				})

			if(!promoFlag) {
				that.$modal.push('auth-signup')
			}

		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});


;// CONCATENATED MODULE: ./src/modals/fibre/Solutions.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_fibre_Solutionsvue_type_script_lang_js_ = (fibre_Solutionsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Solutions.vue?vue&type=style&index=0&id=20f22ec7&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Solutions.vue?vue&type=style&index=0&id=20f22ec7&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/Solutions.vue



;


/* normalize component */

var fibre_Solutions_component = (0,componentNormalizer/* default */.Z)(
  modals_fibre_Solutionsvue_type_script_lang_js_,
  Solutionsvue_type_template_id_20f22ec7_render,
  Solutionsvue_type_template_id_20f22ec7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var fibre_Solutions = (fibre_Solutions_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Sidebar.vue?vue&type=template&id=268ce6ca&scoped=true&
var Sidebarvue_type_template_id_268ce6ca_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-modal-sidebar"},[_c('div',{staticClass:"provider-logo"},[(_vm.provider.slug === 'octotel_winter_promo')?_c('icon',{attrs:{"name":`provider-octotel`}}):_c('icon',{attrs:{"name":`provider-${_vm.provider.slug}`}})],1),(_vm.provider.pre_order)?_c('div',{staticClass:"pre-order"},[_vm._m(0)]):_vm._e(),(_vm.prepaidMeta)?_c('dl',{staticClass:"prepaid-access-card"},[_c('dt',[_vm._v(_vm._s(_vm.prepaidMeta.includedAccess)+" Day internet access")]),_c('dd',[_vm._v("Included with your Fibre installation")])]):_vm._e(),_c('div',{staticClass:"signup-feature-table"},[_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("Installation")]),(_vm.provider.slug ==='waterfall_access_networks')?_c('dl',[_c('dt',[_vm._v("R9 543.85")]),_c('dd',[_vm._v("Payable to Fibre Provider")])]):(_vm.installation)?_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.installation.retail_price))+" with Afrihost")]),(_vm.installation.base_price > 0 && _vm.installation.base_price !== _vm.installation.retail_price)?_c('dd',{staticClass:"strike"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.installation.base_price)))]):_vm._e()]):_c('dl',[_c('dt',{staticClass:"error"},[_vm._v("Error loading data")]),_c('dd',[_vm._v("Contact Afrihost Support")])])]),_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("Activation Fee")]),(_vm.activation)?_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.activation.retail_price))+" with Afrihost")]),(_vm.activation.base_price > 0 && _vm.activation.base_price !== _vm.activation.retail_price)?_c('dd',{staticClass:"strike"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.activation.base_price)))]):_vm._e()]):_c('dl',[_c('dt',{staticClass:"error"},[_vm._v("Error loading data")]),_c('dd',[_vm._v("Contact Afrihost Support")])])]),(!_vm.noDeviceSolutions.find(s => s === _vm.provider.slug))?_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("WiFi Router")]),_c('dl',[_c('dt',[_vm._v("FREE with Afrihost")]),_c('dd',{staticClass:"strike"},[_vm._v(_vm._s(_vm._f("formatPrice")(999)))])])]):_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("WiFi Router")]),_vm._m(1)])]),(_vm.availableProviders.length > 1)?_c('div',{staticClass:"select-provider-link"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showAllProviders.apply(null, arguments)}}},[_vm._v("There are multiple providers available at your selected address. "),_c('span',[_vm._v("View them all")]),_vm._v(".")])]):_vm._e(),(_vm.hasVumaFlashPromo)?_c('picture',{staticClass:"promo-section",staticStyle:{"margin":"0 auto","display":"block","max-width":"100%","padding":"0 20px"}},[_c('source',{attrs:{"media":"(min-width: 465px)","srcset":"https://www.afrihost.com/fibre/assets/promos/23-05-vuma-flash/signupflow-mobile.png" + " 1x, " + "https://afrihost.com/fibre/assets/promos/23-05-vuma-flash/signupflow-mobile@2x.png" + " 2x"}}),_c('img',{attrs:{"src":"https://www.afrihost.com/fibre/assets/promos/23-05-vuma-flash/signupflow-desktop.png","srcset":"https://afrihost.com/fibre/assets/promos/23-05-vuma-flash/signupflow-desktop@2x.png" + " 2x"}})]):_vm._e(),(_vm.provider.slug === 'tt_connect')?_c('picture',{staticClass:"promo-section",staticStyle:{"margin":"0 auto","display":"block","max-width":"100%","padding":"0 20px"}},[_c('source',{attrs:{"media":"(min-width: 465px)","srcset":"https://www.afrihost.com/fibre/assets/promos/tt-connect-3-months-free/signup-mobile.png" + " 1x, " + "https://afrihost.com/fibre/assets/promos/tt-connect-3-months-free/signup-mobile@2x.png" + " 2x"}}),_c('img',{attrs:{"src":"https://www.afrihost.com/fibre/assets/promos/tt-connect-3-months-free/signup-desktop.png","srcset":"https://afrihost.com/fibre/assets/promos/tt-connect-3-months-free/signup-desktop@2x.png" + " 2x"}})]):_vm._e()])
}
var Sidebarvue_type_template_id_268ce6ca_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("You will be placing a pre-order. "),_c('br'),_vm._v("Your area is still in the rollout phase.")])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("Included with device "),_c('br'),_vm._v("installed at your home")])])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/Sidebar.vue?vue&type=template&id=268ce6ca&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/fibre/FibreSpeedUpgradePromoSidebar.vue?vue&type=template&id=392a0b64&
var FibreSpeedUpgradePromoSidebarvue_type_template_id_392a0b64_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promo)?_c('div',{staticClass:"promo-section",style:(`--promo-bg: url(${_vm.solution ? _vm.currentSolutionPromo : _vm.promo.promoImageDefault })`),attrs:{"id":""}}):_vm._e()
}
var FibreSpeedUpgradePromoSidebarvue_type_template_id_392a0b64_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/fibre/FibreSpeedUpgradePromoSidebar.vue?vue&type=script&lang=js&

/* harmony default export */ var FibreSpeedUpgradePromoSidebarvue_type_script_lang_js_ = ({
	props: ["provider", "solution"],
	data() {
		return {
			providerPromos: [
				// What a provider promo should be structured as
				// {
				// 	provider:'provider_slug',
				// 	promoImageDefault: importedImageForDefaultInfo,
				// 	promoNotApplicableImage: importedImageForExclusions,
				// 	packages: [
				// 		{
				// 			solutionId: '1550820',
				// 			image: cccImage1,
				// 		},
				// 		{
				// 			solutionId: '1551820',
				// 			image: cccImage2,
				// 		},
				// 		{
				// 			solutionId: '1552820',
				// 			image: cccImage3,
				// 		},
				// 	],
				// },
			],
		}
	},
	computed: {
		promo() {
			return this.providerPromos.find((p) => {
				return p.provider === this.provider.slug;
			});
		},
		currentSolutionPromo() {
			let currentPromo = this.promo.packages.find((p) => {
				return p.solutionId == this.solution.id;
			})
			return currentPromo ? currentPromo.image :  this.promo.promoNotApplicableImage
		},
	}
});

;// CONCATENATED MODULE: ./src/components/fibre/FibreSpeedUpgradePromoSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_FibreSpeedUpgradePromoSidebarvue_type_script_lang_js_ = (FibreSpeedUpgradePromoSidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/fibre/FibreSpeedUpgradePromoSidebar.vue?vue&type=style&index=0&id=392a0b64&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/fibre/FibreSpeedUpgradePromoSidebar.vue?vue&type=style&index=0&id=392a0b64&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/fibre/FibreSpeedUpgradePromoSidebar.vue



;


/* normalize component */

var FibreSpeedUpgradePromoSidebar_component = (0,componentNormalizer/* default */.Z)(
  fibre_FibreSpeedUpgradePromoSidebarvue_type_script_lang_js_,
  FibreSpeedUpgradePromoSidebarvue_type_template_id_392a0b64_render,
  FibreSpeedUpgradePromoSidebarvue_type_template_id_392a0b64_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FibreSpeedUpgradePromoSidebar = (FibreSpeedUpgradePromoSidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Sidebar.vue?vue&type=script&lang=js&





/* harmony default export */ var fibre_Sidebarvue_type_script_lang_js_ = ({
	components: {
		FibrePromoSidebar: FibreSpeedUpgradePromoSidebar,
		Icon: Icon
	},
	data() {
		return {
			// provider: this.$signup.$store.getters['signupSolutions/currentProvider'],
		}
	},
	computed: {
		solution() {
			return this.$signup.$store.getters['signupSolutions/selectedSolution'];
		},
		provider() {
			return this.$signup.$store.getters['signupSolutions/currentProvider'];
		},
		availableProviders() {
			return this.$signup.$store.getters['signupSolutions/providers'];
		},
		noDeviceSolutions() {
			return this.$signup.$store.getters['signupGeneral/noDeviceProviders'];
		},
		installation() {
			return this.provider.eventPrices ? this.provider.eventPrices.find((e) => {
				if (e.pricing_type.slug === 'installation') return true
			}) : null
		},
		activation() {
			return this.provider.eventPrices ? this.provider.eventPrices.find((e) => {
				if (e.pricing_type.slug === 'activation') return true
			}) : null
		},
		prepaidMeta() {
			if(['openserve_prepaid', 'vuma_reach_prepaid'].indexOf(this.provider.slug) < 0) return false
			switch(this.provider.slug) {
				case 'openserve_prepaid':
					return {
						includedAccess: 14
					}
				case 'vuma_reach_prepaid':
					return {
						includedAccess: 28
					}
			}
		},
		hasVumaFlashPromo() {
			return [
				1818820, 1815820, 1816820, // vumatel
				1819820, 1820820, 1821820  // vumatel aerial
			].indexOf(this.solution.id) >= 0 && (
				Date.now() < 1686095999000 // 06 June 2023 23:59:59
			)
		}
	},
	methods: {
		showAllProviders() {
			this.$signup.$store.commit('signupGeneral/setSkipProvidersView', false)
			this.$modal.push('fibre-providers')
		}
	},
	mounted() {
		if (this.provider.solutions.length < 1) {
			return;
		}
		// if (!this.provider.eventPrices) {
		// 	this.$signup.$store.dispatch('signupSolutions/getSolutionEventPrices', {solutionId: this.provider.solutions[0].id})
		// 	// .then(() => {
		// 	// 	this.provider = this.$signup.$store.getters['signupSolutions/currentProvider'];
		// 	// })
		// }
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/Sidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_fibre_Sidebarvue_type_script_lang_js_ = (fibre_Sidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Sidebar.vue?vue&type=style&index=0&id=268ce6ca&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Sidebar.vue?vue&type=style&index=0&id=268ce6ca&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/fibre/Sidebar.vue



;


/* normalize component */

var fibre_Sidebar_component = (0,componentNormalizer/* default */.Z)(
  modals_fibre_Sidebarvue_type_script_lang_js_,
  Sidebarvue_type_template_id_268ce6ca_scoped_true_render,
  Sidebarvue_type_template_id_268ce6ca_scoped_true_staticRenderFns,
  false,
  null,
  "268ce6ca",
  null
  
)

/* harmony default export */ var fibre_Sidebar = (fibre_Sidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Device.vue?vue&type=template&id=2875a7ba&
var Devicevue_type_template_id_2875a7ba_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('signup-tabs',{attrs:{"options":_vm.tabOptions,"selected":_vm.includeRouter},on:{"select":_vm.changeTab}}),(_vm.includeRouter)?_c('div',{staticClass:"tab-content"},[_c('h3',[_vm._v("Included with our Pure Fibre signup promotion")]),_c('p',[_vm._v("Our Wi‑Fi router provides excellent coverage and operates on both the 2.4GHz and 5GHz frequencies for future-proof, cutting‑edge connectivity.")]),_c('div',{staticClass:"device-config"},[_vm._m(0),_c('form',{staticClass:"signup-form"},[_c('signup-input',{attrs:{"type":"text","label":"WiFi network name","disabled":false,"required":true,"error":false},model:{value:(_vm.form.ssid),callback:function ($$v) {_vm.$set(_vm.form, "ssid", $$v)},expression:"form.ssid"}}),_c('signup-input',{attrs:{"type":"text","label":"WiFi network password","disabled":false,"required":true,"error":false},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1)])]):_vm._e(),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}}),(!_vm.includeRouter)?_c('div',{staticClass:"tab-content"},[_c('h3',[_vm._v("You’ll need a Fibre compatible WiFi router to wireless connect all your devices to your new Fibre broadband connection.")]),_c('p',[_vm._v("If your current router has a WAN port you may not need to add our Wi‑Fi Router. If you’re unsure about this hop onto live chat or WhatsApp so we can help you with your signup.")])]):_vm._e()],1)
}
var Devicevue_type_template_id_2875a7ba_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v("Configure your WiFi (Optional)")]),_vm._v(" "),_c('br'),_vm._v(" We'll set up the WiFi details for your device before we deliver it to you. ")])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/Device.vue?vue&type=template&id=2875a7ba&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/SignupTabs.vue?vue&type=template&id=087161ff&
var SignupTabsvue_type_template_id_087161ff_render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"signup-tabs",class:`t${_vm.options.length}`},_vm._l((_vm.options),function(option,i){return _c('li',{key:i,class:{'selected': _vm.selected === option.value},on:{"click":function($event){return _vm.select(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var SignupTabsvue_type_template_id_087161ff_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/SignupTabs.vue?vue&type=script&lang=js&

	/* harmony default export */ var SignupTabsvue_type_script_lang_js_ = ({
		props: ['options', 'selected'],
		methods: {
			select(value) {
				this.$emit('select', value);
			}
		}
	});

;// CONCATENATED MODULE: ./src/components/global/SignupTabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var global_SignupTabsvue_type_script_lang_js_ = (SignupTabsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/global/SignupTabs.vue?vue&type=style&index=0&id=087161ff&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/global/SignupTabs.vue?vue&type=style&index=0&id=087161ff&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/global/SignupTabs.vue



;


/* normalize component */

var SignupTabs_component = (0,componentNormalizer/* default */.Z)(
  global_SignupTabsvue_type_script_lang_js_,
  SignupTabsvue_type_template_id_087161ff_render,
  SignupTabsvue_type_template_id_087161ff_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignupTabs = (SignupTabs_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Device.vue?vue&type=script&lang=js&







/* harmony default export */ var Devicevue_type_script_lang_js_ = ({
	components: {
		SignupTabs: SignupTabs,
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {

	},
	methods: {
		getClientContact() {
			this.$modal.toggleLoader(true);
			this.$signup.$store.dispatch('signupUser/getClientContact')
				.then(() => {
					let user = this.$signup.$store.getters['signupUser/user'];
					this.form.ssid = `Afrihost ${user.first_name[0]}${user.last_name[0]}`;
					this.form.password = user.cell_number;

					this.hasClientContact = true;
					this.$modal.toggleLoader(false);
				})
				.catch((err) => {
					console.error(err)
					this.$modal.toggleLoader(false);
				});
		},
		changeTab(value) {
			this.includeRouter = value;
		},
		async next() {
			this.error = false;
			//check if form is filled
			if (this.form.password && !this.form.ssid) {
				this.error = {message: "Please fill in a WiFi network name."}
				return;
			} else if (this.form.ssid && this.form.password.length < 8) {
				this.error = {message: "Please fill in a WiFi network password that is at least 8 characters long."}
				return;
			}

			if(this.includeRouter) {
				//get router product_id
				// let device = {product_id: 600991}
				let device = await this.$signup.$store.dispatch('signupSolutions/getDevices')
					.then(res => {
						return res.solutions[0]
					})
					.catch((err) => {
						this.error = err;
					});
				if (this.error) { return }

				//save device in store
				this.$signup.$store.commit('signupSolutions/updateSelectedDevices', [{
					product_type_slug: "solution_tangible_fibre",
					product: device,
					ssid: this.form.ssid,
					password: this.form.password,
				}]);

			} else {
				this.$signup.$store.commit('signupDelivery/updateSelectedDeliveryQuote', false);
				this.$signup.$store.commit('signupSolutions/updateSelectedDevices', []);
				//remove item from cart
				let cartItems = this.$signup.$store.getters['signupCart/cartItems'];
			    cartItems = cartItems.filter(c => {
					return c.product_type_slug !== 'solution_tangible_fibre'
			    });
			    this.$signup.$store.commit('signupCart/setCartItems', cartItems);
			}
			this.$modal.toggleLoader(true);
			if (this.$signup.$store.getters['signupGeneral/noDeviceProvider']) {
				this.$modal.push('payment-methods');
			} else {
				this.$modal.push('fibre-device-upsell');
				// skip upsell because out of stock TODO: change when back in stock
				// this.$modal.push('payment-methods');
			}
		}
	},
	data() {
		return {
			error: false,
			includeRouter: true,
			hasClientContact: false,
			tabOptions: [
				{
					label: 'Yes, I need a router',
					value: true
				},
				{
					label: 'No, I have my own',
					value: false
				}
			],
			form: {
				ssid: '',
				password: '',
			}
		}
	},
	mounted() {

		// check if device should be skipped based on solution attribute
		const solution = this.$signup.$store.getters['signupSolutions/selectedSolution']
		const requiredAttr = solution.attributes.find(a => a.detail_type.slug === 'required_device_solution_id')
		if(requiredAttr && (typeof requiredAttr.value === 'string' && requiredAttr.value.length === 0)) {
			this.includeRouter = false
			this.next()
		}


		this.getClientContact();

		//push to payment if solution without device
		if (this.$signup.$store.getters['signupGeneral/noDeviceProviders'].find(s => s === this.$signup.$store.getters['signupSolutions/selectedSolution'].vendor.slug)) {
			this.$signup.$store.commit('signupGeneral/updateNoDeviceProvider', true);
			this.includeRouter = false;
			this.next();
		}

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('fibre-installation');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.next();
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/Device.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_Devicevue_type_script_lang_js_ = (Devicevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Device.vue?vue&type=style&index=0&id=2875a7ba&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Device.vue?vue&type=style&index=0&id=2875a7ba&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/Device.vue



;


/* normalize component */

var Device_component = (0,componentNormalizer/* default */.Z)(
  fibre_Devicevue_type_script_lang_js_,
  Devicevue_type_template_id_2875a7ba_render,
  Devicevue_type_template_id_2875a7ba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Device = (Device_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/MeshUpsell.vue?vue&type=template&id=ee4031bc&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&
var MeshUpsellvue_type_template_id_ee4031bc_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"options"},[_vm._l((_vm.devices),function(mesh){return _c('div',{staticClass:"radio",class:{selected: _vm.selectedDeviceId === mesh.id, 'out-of-stock': !mesh.inStock},on:{"click":function($event){return _vm.selectDevice(mesh.id)}}},[(!mesh.inStock)?_c('div',{staticClass:"out-of-stock"},[_vm._v("Temporarily out of stock")]):_vm._e(),_c('div',{staticClass:"details"},[_c('div',{staticClass:"hero"},[(mesh.id === 827991)?_c('img',{attrs:{"src":_vm.deviceHero2Pack1X,"srcset":`${_vm.deviceHero2Pack1X} 1x, ${_vm.deviceHero2Pack2X} 2x`,"alt":"2-pack"}}):_vm._e(),(mesh.id === 826991)?_c('img',{attrs:{"src":_vm.deviceHero3Pack1X,"srcset":`${_vm.deviceHero3Pack1X} 1x, ${_vm.deviceHero3Pack2X} 2x`,"alt":"3-pack"}}):_vm._e()]),_c('div',{staticClass:"price-holder"},[(mesh.id === 827991)?_c('h3',[_vm._v("Add 2-pack for")]):(mesh.id === 826991)?_c('h3',[_vm._v("Add 3-pack for")]):_vm._e(),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(mesh.price)))])])]),_vm._m(1,true)])}),_c('div',{staticClass:"radio",class:{selected: _vm.selectedDeviceId === 'none'},on:{"click":function($event){return _vm.selectDevice('none')}}},[_vm._m(2),_vm._m(3)])],2)]),_c('error-bar',{attrs:{"error":_vm.error}})],1)
}
var MeshUpsellvue_type_template_id_ee4031bc_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-copy"},[_c('h1',[_vm._v("TP-Link Deco X50")]),_c('h2',[_vm._v("Say goodbye to WiFi deadzones ")]),_c('p',[_vm._v("Kill WiFi dead zones with the TP-Link Deco X50. The Deco X50 is a mesh WiFi 6 system designed to deliver a huge boost in coverage, speed, and total WiFi capacity throughout your whole house.")]),_c('p',[_vm._v("TP-Link Deco units work together to form one unified network. With clearer and stronger signals enhanced by BSS Color and Beamforming, Deco X50 3-pack boosts broader whole home WiFi up to 603m"),_c('sup',[_vm._v("2")])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector"},[_c('i',{staticClass:"radio-selected"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details left"},[_c('h3',[_vm._v("No thank you")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector"},[_c('i',{staticClass:"radio-selected"})])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/MeshUpsell.vue?vue&type=template&id=ee4031bc&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&

;// CONCATENATED MODULE: ./src/assets/images/devices/2201-TPLink-DecoX50-hero.png
var _2201_TPLink_DecoX50_hero_namespaceObject = "data:image/png;base64,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";
;// CONCATENATED MODULE: ./src/assets/images/devices/2201-TPLink-DecoX50-hero@2x.png
var _2201_TPLink_DecoX50_hero_2x_namespaceObject = __webpack_require__.p + "img/2201-TPLink-DecoX50-hero@2x.f4dc3fe0.png";
;// CONCATENATED MODULE: ./src/assets/images/devices/2201-TPLink-Deco-X50-3-pack-hero.png
var _2201_TPLink_Deco_X50_3_pack_hero_namespaceObject = "data:image/png;base64,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";
;// CONCATENATED MODULE: ./src/assets/images/devices/2201-TPLink-Deco-X50-3-pack-hero@2x.png
var _2201_TPLink_Deco_X50_3_pack_hero_2x_namespaceObject = __webpack_require__.p + "img/2201-TPLink-Deco-X50-3-pack-hero@2x.98b79d18.png";
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/MeshUpsell.vue?vue&type=script&lang=js&












/* harmony default export */ var MeshUpsellvue_type_script_lang_js_ = ({
	components: {
		SignupTabs: SignupTabs,
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {
		device() {
			return this.$signup.$store.getters['signupSolutions/devices'][this.category].find(d => {
				return d.id ===this.selectedDeviceId
			});
		},
		devices() {
			return [
				{
					id:827991,
					price: 3999,
					inStock: this.$signup.$store.getters['signupGeneral/decoInStock'].twoPack
				},
				{
					id:826991,
					price: 5999,
					inStock: this.$signup.$store.getters['signupGeneral/decoInStock'].threePack
				},
			]
		}
	},
	data() {
		return {
			nextModal: 'fibre-ups-upsell',
			deviceHero2Pack1X: _2201_TPLink_DecoX50_hero_namespaceObject,
			deviceHero2Pack2X: _2201_TPLink_DecoX50_hero_2x_namespaceObject,
			deviceHero3Pack1X: _2201_TPLink_Deco_X50_3_pack_hero_namespaceObject,
			deviceHero3Pack2X: _2201_TPLink_Deco_X50_3_pack_hero_2x_namespaceObject,
			category: 'mesh_network',
			////
			selectedDeviceId: false,
			error: false
		}
	},
	methods: {
		async next() {
			if (this.selectedDeviceId === 'none') {
				this.$signup.$store.commit('signupCart/removeCartItem', 'solution_tangible_mesh');
				this.$modal.push(this.nextModal);
				return;
			} else if (this.device === undefined) { //check if device has actually come down from the API
				this.$modal.toggleLoader(false);
				this.error = { message: 'Sorry, this device is not available. Please select another option.' }
				return;
			}

			this.$modal.toggleLoader(true);
			//get user details for cart
			let user = this.$signup.$store.getters['signupUser/user'];
			let location = this.$signup.$store.getters['signupSolutions/solutionLocation'];
			//add device to cart item
			this.$signup.$store.commit('signupCart/replaceOrAddCartItem', {
				product_type_slug: 'solution_tangible_mesh',
				product_id: this.device.id,
				cart_item_requirements: [
					{ name: 'recipient_first_name', value: user.first_name },
					{ name: 'recipient_last_name', value: user.last_name },
					{ name: 'contact_number', value: location.contact_number },
					{ name: 'email_address', value: user.email },
					{ name: 'id_number', value: user.id_number },
				],
			});

			//add to selected devices
			this.$signup.$store.commit('signupSolutions/addSelectedDevices', {
				product_type_slug: this.category,
				product: this.device,
			})

			this.$modal.push(this.nextModal)
		},
		selectDevice(device) {
			this.selectedDeviceId = device;
		}
	},
	mounted() {

		//check if upsell is in stock
		this.$signup.$store.dispatch('signupSolutions/getDevices', { categorySlug: this.category })
			.then(r => {
				// hide loader
				this.$modal.toggleLoader(false);

				//use manual in-stock check for now
				if (this.devices.every(d => !d.inStock)) {
					this.$modal.push(this.nextModal);
				}
				// // find the deco x20 2 pack or 3 pack from APi
				// let device = r.solutions.find(s => s.id === 827991 || s.id === 826991);
				//
				// // skip if it does not come down from the API
				// if(!device) {
				// 	this.$modal.push(this.nextModal);
				// }
			}, () => {
				// skip the upsell if we get an error back
				this.$modal.toggleLoader(false);
				this.$modal.push(this.nextModal)
			});

		services_EventBus.$on('back', () => {
			this.$modal.push('fibre-device');
		})
		services_EventBus.$on('next', () => {
			if (!this.selectedDeviceId) {
				this.error = { message: "Please select one of the options." };
				return;
			}
			this.next();
		})
	},
	destroyed() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/MeshUpsell.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_MeshUpsellvue_type_script_lang_js_ = (MeshUpsellvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/MeshUpsell.vue?vue&type=style&index=0&id=ee4031bc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/MeshUpsell.vue?vue&type=style&index=0&id=ee4031bc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/fibre/MeshUpsell.vue



;


/* normalize component */

var MeshUpsell_component = (0,componentNormalizer/* default */.Z)(
  fibre_MeshUpsellvue_type_script_lang_js_,
  MeshUpsellvue_type_template_id_ee4031bc_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_render,
  MeshUpsellvue_type_template_id_ee4031bc_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_staticRenderFns,
  false,
  null,
  "ee4031bc",
  null
  
)

/* harmony default export */ var MeshUpsell = (MeshUpsell_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/UpsUpsell.vue?vue&type=template&id=1f79eea5&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&
var UpsUpsellvue_type_template_id_1f79eea5_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"options"},[_vm._l((_vm.devices),function(device){return _c('div',{key:device.id,staticClass:"radio",class:{selected: _vm.selectedDeviceId === device.id, 'out-of-stock': !device.inStock},on:{"click":function($event){return _vm.selectDevice(device.id)}}},[(!device.inStock)?_c('div',{staticClass:"out-of-stock"},[_vm._v("Temporarily out of stock")]):_vm._e(),_c('div',{staticClass:"details"},[_c('div',{staticClass:"hero"},[_c('img',{attrs:{"src":device.deviceHero1x,"srcset":`${device.deviceHero2x} 2x`,"alt":"UPS Device"}})]),_c('div',{staticClass:"price-holder"},[_c('h3',[_vm._v(_vm._s(device.display_name))]),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(device.price)))])])]),_c('ul',{staticClass:"selling-points"},_vm._l((device.sellingPoints),function(sellingPoint){return _c('li',[_vm._v(_vm._s(sellingPoint))])}),0),_vm._m(1,true)])}),_c('div',{staticClass:"radio",class:{selected: _vm.selectedDeviceId === false},on:{"click":function($event){return _vm.selectDevice(false)}}},[_vm._m(2),_vm._m(3)])],2)]),_c('error-bar',{attrs:{"error":_vm.error}})],1)
}
var UpsUpsellvue_type_template_id_1f79eea5_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-copy"},[_c('h2',[_vm._v("Don’t get caught in the dark")]),_c('h1',[_vm._v("Stay connected with a UPS")]),_c('p',[_vm._v("A UPS allows you to power your devices (Router/VoIP phone) during an outage.")]),_c('p',[_vm._v("For extra security these devices also feature an intelligent protective design which includes Over-Charge, Over-Discharge and Short Circuit Protection.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector"},[_c('i',{staticClass:"radio-selected"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details flex"},[_c('h3',[_vm._v("No thank you")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector"},[_c('i',{staticClass:"radio-selected"})])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/UpsUpsell.vue?vue&type=template&id=1f79eea5&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&

;// CONCATENATED MODULE: ./src/assets/images/devices/21-10 | DC100 Plus Hero.png
var _21_10_DC100_Plus_Hero_namespaceObject = "data:image/png;base64,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";
;// CONCATENATED MODULE: ./src/assets/images/devices/21-10 | DC100 Plus Hero@2x.png
var _21_10_DC100_Plus_Hero_2x_namespaceObject = __webpack_require__.p + "img/21-10 | DC100 Plus Hero@2x.7fad60f5.png";
;// CONCATENATED MODULE: ./src/assets/images/devices/Gizzu-GUP36W-OrderForms.png
var Gizzu_GUP36W_OrderForms_namespaceObject = "data:image/png;base64,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";
;// CONCATENATED MODULE: ./src/assets/images/devices/Gizzu-GUP36W-OrderForms@2x.png
var Gizzu_GUP36W_OrderForms_2x_namespaceObject = __webpack_require__.p + "img/Gizzu-GUP36W-OrderForms@2x.285cd260.png";
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/UpsUpsell.vue?vue&type=script&lang=js&












/* harmony default export */ var UpsUpsellvue_type_script_lang_js_ = ({
	components: {
		SignupTabs: SignupTabs,
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {
		device() {
			return this.$signup.$store.getters['signupSolutions/devices'][this.category].find(d => {
				return d.id ===this.selectedDeviceId
			});
		},
	},
	data() {
		return {
			nextModal: 'payment-methods',
			category: 'ups_tangible',
			selectedDeviceId: false,
			error: false,
			devices: [],
		}
	},
	methods: {
		async next() {
			if (this.selectedDeviceId === false) {
				this.$signup.$store.commit('signupCart/removeCartItem', 'solution_tangible_ups');
				this.$modal.push(this.nextModal);
				return;
			} else if (this.device === undefined) { //check if device has actually come down from the API
				this.$modal.toggleLoader(false);
				this.error = { message: 'Sorry, this device is not available. Please select another option.' }
				return;
			}

			this.$modal.toggleLoader(true);
			//get user details for cart
			let user = this.$signup.$store.getters['signupUser/user'];
			let location = this.$signup.$store.getters['signupSolutions/solutionLocation'];
			//add device to cart item
			this.$signup.$store.commit('signupCart/replaceOrAddCartItem', {
				product_type_slug: 'solution_tangible_ups',
				product_id: this.device.id,
				cart_item_requirements: [
					{ name: 'recipient_first_name', value: user.first_name },
					{ name: 'recipient_last_name', value: user.last_name },
					{ name: 'contact_number', value: location.contact_number },
					{ name: 'email_address', value: user.email },
					{ name: 'id_number', value: user.id_number },
				],
			});

			//add to selected devices
			this.$signup.$store.commit('signupSolutions/addSelectedDevices', {
				product_type_slug: this.category,
				product: this.device,
			})

			this.$modal.push(this.nextModal)
		},
		selectDevice(device) {
			if (this.selectedDeviceId !== device) {
				this.selectedDeviceId = device;
			} else {
				this.selectedDeviceId = false;
			}
		}
	},
	mounted() {

		//check if upsell is in stock
		this.$signup.$store.dispatch('signupSolutions/getDevices', { categorySlug: this.category })
			.then(r => {
				// hide loader
				this.$modal.toggleLoader(false);

				//add device details to the devices array
				r.solutions.forEach(d => {
					if (d.id === 798991) {
						this.devices.push({
							id: d.id,
							deviceHero1x: Gizzu_GUP36W_OrderForms_namespaceObject,
							deviceHero2x: Gizzu_GUP36W_OrderForms_2x_namespaceObject,
							price: d.price,
							display_name: d.display_name,
							inStock: true,
							sellingPoints: [
								'4 Lithium-Ion Cells',
								'Built-in Adapter',
								'5V/9V/12V 2x DC Outputs'
							]
						});
					} else if (d.id === 819991) {
						this.devices.push({
							id: d.id,
							deviceHero1x: _21_10_DC100_Plus_Hero_namespaceObject,
							deviceHero2x: _21_10_DC100_Plus_Hero_2x_namespaceObject,
							price: d.price,
							display_name: d.display_name,
							inStock: true,
							sellingPoints: [
								'8 Lithium-Ion Cells',
								'2x 2a USB Charging Ports',
								'6x 12V/1x 5V DC Output(s)'
							]
						});
					}
				});

				//use manual in-stock check for now
				if (this.devices.every(d => !d.inStock)) {
					this.$modal.push(this.nextModal);
				}
			}, () => {
				// skip the upsell if we get an error back
				this.$modal.toggleLoader(false);
				this.$modal.push(this.nextModal)
			});

		services_EventBus.$on('back', () => {
			this.$modal.push('fibre-device');
		})
		services_EventBus.$on('next', this.next)
	},
	destroyed() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/UpsUpsell.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_UpsUpsellvue_type_script_lang_js_ = (UpsUpsellvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/UpsUpsell.vue?vue&type=style&index=0&id=1f79eea5&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/UpsUpsell.vue?vue&type=style&index=0&id=1f79eea5&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/fibre/UpsUpsell.vue



;


/* normalize component */

var UpsUpsell_component = (0,componentNormalizer/* default */.Z)(
  fibre_UpsUpsellvue_type_script_lang_js_,
  UpsUpsellvue_type_template_id_1f79eea5_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_render,
  UpsUpsellvue_type_template_id_1f79eea5_scoped_true_xmlns_http_3A_2F_2Fwww_w3_org_2F1999_2Fhtml_staticRenderFns,
  false,
  null,
  "1f79eea5",
  null
  
)

/* harmony default export */ var UpsUpsell = (UpsUpsell_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Installation.vue?vue&type=template&id=d7c3e534&
var Installationvue_type_template_id_d7c3e534_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body has-columns",attrs:{"id":"install-modal"}},[_c('div',{staticClass:"modal-column"},[_c('h3',[_vm._v("Line location details")]),_c('address-preview',{on:{"changeAddress":function($event){return _vm.changeAddress()}}}),_c('signup-select',{attrs:{"disabled":false,"error":false,"options":_vm.locationTypeOptions,"required":true,"label":"Location Type"},model:{value:(_vm.form.location.type),callback:function ($$v) {_vm.$set(_vm.form.location, "type", $$v)},expression:"form.location.type"}}),_vm._l((_vm.locationFields),function(field,i){return _c('signup-input',{key:i,attrs:{"disabled":false,"label":field.label,"required":field.required,"type":field.type},model:{value:(_vm.form.location[field.model]),callback:function ($$v) {_vm.$set(_vm.form.location, field.model, $$v)},expression:"form.location[field.model]"}})})],2),_c('div',{staticClass:"modal-column"},[_c('h3',[_vm._v("Installation Details")]),_c('signup-select',{attrs:{"disabled":false,"error":false,"options":_vm.orderTypeOptions,"required":true,"label":"Order Type"},model:{value:(_vm.form.order.type),callback:function ($$v) {_vm.$set(_vm.form.order, "type", $$v)},expression:"form.order.type"}}),(_vm.form.order.type === 'transfer')?_c('signup-select',{attrs:{"disabled":false,"error":false,"options":_vm.transferOptions,"required":true,"label":"Existing Fibre Provider"},model:{value:(_vm.form.order.previousProvider),callback:function ($$v) {_vm.$set(_vm.form.order, "previousProvider", $$v)},expression:"form.order.previousProvider"}}):_vm._e(),(_vm.form.order.type === 'transfer')?_c('signup-input',{attrs:{"disabled":false,"label":`Email Address Used to Sign Up with ${_vm.namify(_vm.form.order.previousProvider)}`,"required":true,"type":"email"},model:{value:(_vm.form.order.previousProviderEmail),callback:function ($$v) {_vm.$set(_vm.form.order, "previousProviderEmail", $$v)},expression:"form.order.previousProviderEmail"}}):_vm._e(),(_vm.form.order.type === 'transfer')?_c('signup-input',{attrs:{"disabled":false,"label":`Object number or B Number (optional)`,"required":false,"type":"email"},model:{value:(_vm.form.order.previousProviderObjectNumber),callback:function ($$v) {_vm.$set(_vm.form.order, "previousProviderObjectNumber", $$v)},expression:"form.order.previousProviderObjectNumber"}}):_vm._e(),(_vm.form.order.type === 'transfer')?_c('signup-input',{attrs:{"disabled":false,"label":`FSAN number (printed on ONT device, optional)`,"required":false,"type":"email"},model:{value:(_vm.form.order.previousProviderFSAN),callback:function ($$v) {_vm.$set(_vm.form.order, "previousProviderFSAN", $$v)},expression:"form.order.previousProviderFSAN"}}):_vm._e(),_c('signup-input',{attrs:{"disabled":false,"required":true,"label":"Phone number of contact for installation","type":"tel"},model:{value:(_vm.form.order.phoneNumber),callback:function ($$v) {_vm.$set(_vm.form.order, "phoneNumber", $$v)},expression:"form.order.phoneNumber"}}),_c('signup-input',{attrs:{"disabled":false,"required":false,"label":"Alternate contact number for installation","type":"tel"},model:{value:(_vm.form.order.alternatePhoneNumber),callback:function ($$v) {_vm.$set(_vm.form.order, "alternatePhoneNumber", $$v)},expression:"form.order.alternatePhoneNumber"}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}}),_c('fibre-install-freeze')],1)
}
var Installationvue_type_template_id_d7c3e534_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupSelect.vue?vue&type=template&id=bc3dcb38&
var SignupSelectvue_type_template_id_bc3dcb38_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-select",class:{'has-value': _vm.value && _vm.value.length}},[_c('select',{ref:"input",attrs:{"disabled":_vm.disabled,"name":_vm.name},domProps:{"value":_vm.value},on:{"focus":_vm.focusInput,"input":function($event){return _vm.update()}}},[_c('option',{attrs:{"disabled":true},domProps:{"value":false}},[_vm._v("-- Please Select --")]),_vm._l((_vm.options),function(o,i){return _c('option',{key:i,attrs:{"disabled":o.disabled,"label":o.label},domProps:{"value":o.value}},[_vm._v(" "+_vm._s(o.label)+" ")])})],2),_c('span',{staticClass:"label-text",class:{'required': _vm.required}},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"select-arrow"},[_c('icon',{attrs:{"name":"select-arrow"}})],1)])
}
var SignupSelectvue_type_template_id_bc3dcb38_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupSelect.vue?vue&type=script&lang=js&



/* harmony default export */ var SignupSelectvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon,
	},
	props: [
		'disabled',
		'label',
		'required',
		'value',
		'options',
		'focus',
		'name',
	],
	methods: {
		update() {
			this.$emit('input', this.$refs.input.value)
		},
		focusInput(e) {
			// this.focus = true;
			this.$emit('focus', e);
		}
	},
});

;// CONCATENATED MODULE: ./src/components/forms/SignupSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_SignupSelectvue_type_script_lang_js_ = (SignupSelectvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupSelect.vue?vue&type=style&index=0&id=bc3dcb38&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/forms/SignupSelect.vue?vue&type=style&index=0&id=bc3dcb38&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/forms/SignupSelect.vue



;


/* normalize component */

var SignupSelect_component = (0,componentNormalizer/* default */.Z)(
  forms_SignupSelectvue_type_script_lang_js_,
  SignupSelectvue_type_template_id_bc3dcb38_render,
  SignupSelectvue_type_template_id_bc3dcb38_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignupSelect = (SignupSelect_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AddressPreview.vue?vue&type=template&id=7d4e4831&
var AddressPreviewvue_type_template_id_7d4e4831_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-preview"},[_c('img',{attrs:{"src":_vm.mapUrl,"alt":""}}),_c('div',{staticClass:"address"},[(_vm.place)?_c('p',[_c('formatted-address',{attrs:{"place":_vm.place}})],1):_c('p',[_vm._v("No place defined")]),(!_vm.hq)?_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.changeAddress()}}},[_vm._v("Change Address")]):_vm._e()])])
}
var AddressPreviewvue_type_template_id_7d4e4831_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AddressPreview.vue?vue&type=script&lang=js&


/* harmony default export */ var AddressPreviewvue_type_script_lang_js_ = ({
	props: [
		'hq',
		'delivery'
	],
	components: {
		FormattedAddress: FormattedAddress
	},
	computed: {
		place() {
			if (this.hq) {
				return {"address_components":[{"long_name":"376","short_name":"376","types":["street_number"]},{"long_name":"Rivonia Boulevard","short_name":"Rivonia Blvd","types":["route"]},{"long_name":"Edenburg","short_name":"Edenburg","types":["political","sublocality","sublocality_level_1"]},{"long_name":"Sandton","short_name":"Sandton","types":["locality","political"]},{"long_name":"City of Johannesburg Metropolitan Municipality","short_name":"City of Johannesburg Metropolitan Municipality","types":["administrative_area_level_2","political"]},{"long_name":"Gauteng","short_name":"GP","types":["administrative_area_level_1","political"]},{"long_name":"South Africa","short_name":"ZA","types":["country","political"]},{"long_name":"2128","short_name":"2128","types":["postal_code"]}],"formatted_address":"376 Rivonia Blvd, Edenburg, Sandton, 2128, South Africa","geometry":{"location":{"lat": () => { return -26.046102},"lng": () => { return 28.0598328}},"location_type":"ROOFTOP","viewport":{"northeast":{"lat":-26.0447897197085,"lng":28.0610311802915},"southwest":{"lat":-26.0474876802915,"lng":28.0583332197085}}},"place_id":"ChIJ6fN1C8pzlR4R4CovPk9uUoM","plus_code":{"compound_code":"X335+HW Sandton, South Africa","global_code":"5G5CX335+HW"},"types":["street_address"]}
			}
			else if (this.delivery) {
				return this.$signup.$store.getters['signupDelivery/deliveryLocation']
			}
			let place = this.$signup.$store.getters['signupCoverage/place'];
			if(place) {
				return place;
			}

			if(false) {}
		},
		mapUrl() {
			let apiKey = this.$signup.$store.getters['signupGeneral/googleMapsKey'];
			let base = 'https://maps.googleapis.com/maps/api/staticmap?';
			let latLng = '';

			if (this.place.geometry) {
				latLng = this.place.geometry.location.lat() + ',' + this.place.geometry.location.lng()

				// override if coverage and coordinates set
				let coords = this.$signup.$store.getters['signupCoverage/coordinates'];
				if (!this.hq && coords) {
					latLng = coords.lat + ',' + coords.lng;
				}
			} else {
				latLng = this.place.latitude + ',' + this.place.longitude;
			}

			let params = {
				// center: `40.714728,-73.998672`,
				center: `${latLng}`,
				zoom: 15,
				size: '100x80',
				scale: 2,
				key: apiKey,
				markers: `color:red|size:tiny| ${latLng}`
				// style: JSON.stringify(mapStyles)
			};

			let ret = [];
			for (let d in params) {
				ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(params[d]));
			}

			return base + ret.join('&');
		},
	},
	methods: {
		changeAddress() {
			this.$emit('changeAddress');
		}
	},
	mounted() {

	}
});

;// CONCATENATED MODULE: ./src/components/AddressPreview.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddressPreviewvue_type_script_lang_js_ = (AddressPreviewvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AddressPreview.vue?vue&type=style&index=0&id=7d4e4831&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AddressPreview.vue?vue&type=style&index=0&id=7d4e4831&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/AddressPreview.vue



;


/* normalize component */

var AddressPreview_component = (0,componentNormalizer/* default */.Z)(
  components_AddressPreviewvue_type_script_lang_js_,
  AddressPreviewvue_type_template_id_7d4e4831_render,
  AddressPreviewvue_type_template_id_7d4e4831_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddressPreview = (AddressPreview_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupTextarea.vue?vue&type=template&id=0f898135&
var SignupTextareavue_type_template_id_0f898135_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-textarea",class:{'has-value': _vm.value && _vm.value.length, 'focused': _vm.focused}},[_c('textarea',{ref:"input",attrs:{"disabled":_vm.disabled},on:{"input":function($event){return _vm.update()},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('span',{staticClass:"label-text",class:{'required': _vm.required}},[_vm._v(_vm._s(_vm.label))])])
}
var SignupTextareavue_type_template_id_0f898135_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupTextarea.vue?vue&type=script&lang=js&



/* harmony default export */ var SignupTextareavue_type_script_lang_js_ = ({
	components: {
		Icon: Icon,
	},
	props: [
		'disabled',
		'label',
		'required',
		'value'
	],
	methods: {
		update() {
			this.$emit('input', this.$refs.input.value)
		}
	},
	data() {
		return {
			focused: false
		}
	},
});

;// CONCATENATED MODULE: ./src/components/forms/SignupTextarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_SignupTextareavue_type_script_lang_js_ = (SignupTextareavue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupTextarea.vue?vue&type=style&index=0&id=0f898135&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/forms/SignupTextarea.vue?vue&type=style&index=0&id=0f898135&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/forms/SignupTextarea.vue



;


/* normalize component */

var SignupTextarea_component = (0,componentNormalizer/* default */.Z)(
  forms_SignupTextareavue_type_script_lang_js_,
  SignupTextareavue_type_template_id_0f898135_render,
  SignupTextareavue_type_template_id_0f898135_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignupTextarea = (SignupTextarea_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/FibreInstallFreeze.vue?vue&type=template&id=ac0c9b06&
var FibreInstallFreezevue_type_template_id_ac0c9b06_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"install-freeze",attrs:{"id":"freeze"}},[_c('icon',{attrs:{"name":"warning-circle"}}),_c('h1',[_vm._v("Fibre installation delay between 03 Dec 2021 - 15 Jan 2022")]),_c('h3',[_vm._v("Your Fibre may not be installed during the holiday season.")]),_c('p',[_vm._v("Please note that Fibre orders placed on or after 03 December 2021 may not be installed during the holiday season. Fibre orders placed during the freeze period may only be scheduled for installation from late January 2022.")]),_c('button',{staticClass:"signup-button primary",on:{"click":function($event){$event.preventDefault();return _vm.hide.apply(null, arguments)}}},[_vm._v("I understand, continue")])],1):_vm._e()
}
var FibreInstallFreezevue_type_template_id_ac0c9b06_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/FibreInstallFreeze.vue?vue&type=script&lang=js&


/* harmony default export */ var FibreInstallFreezevue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	computed: {
		show() {
			return false //this.$signup.$store.getters['signupGeneral/fibreFreeze'];
		}
	},
	methods: {
		hide() {
			this.$signup.$store.commit('signupGeneral/updateFibreFreeze', false)
		}
	},
});

;// CONCATENATED MODULE: ./src/modals/fibre/FibreInstallFreeze.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_FibreInstallFreezevue_type_script_lang_js_ = (FibreInstallFreezevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/FibreInstallFreeze.vue?vue&type=style&index=0&id=ac0c9b06&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/FibreInstallFreeze.vue?vue&type=style&index=0&id=ac0c9b06&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/FibreInstallFreeze.vue



;


/* normalize component */

var FibreInstallFreeze_component = (0,componentNormalizer/* default */.Z)(
  fibre_FibreInstallFreezevue_type_script_lang_js_,
  FibreInstallFreezevue_type_template_id_ac0c9b06_render,
  FibreInstallFreezevue_type_template_id_ac0c9b06_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FibreInstallFreeze = (FibreInstallFreeze_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Installation.vue?vue&type=script&lang=js&










/* harmony default export */ var Installationvue_type_script_lang_js_ = ({
	components: {
		SignupTextarea: SignupTextarea,
		AddressPreview: AddressPreview,
		SignupSelect: SignupSelect,
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon,
		FibreInstallFreeze: FibreInstallFreeze
	},
	computed: {
		solution() {
			return this.$signup.$store.getters['signupSolutions/selectedSolution'];
		},

		locationFields() {
			let fields = [];

			//check if any fields are missing
			if (this.form.missingFields.indexOf('streetNumber') > -1) {
				fields.push({
					type: 'number',
					label: 'Street Number',
					required: true,
					model: 'streetNumber'
				});
			}
			if (this.form.missingFields.indexOf('streetName') > -1) {
				fields.push({
					type: 'text',
					label: 'Street Name',
					required: true,
					model: 'streetName'
				});
			}
			if (this.form.missingFields.indexOf('suburb') > -1) {
				fields.push({
					type: 'text',
					label: 'Suburb',
					required: true,
					model: 'suburb'
				});
			}
			if (this.form.missingFields.indexOf('city') > -1) {
				fields.push({
					type: 'text',
					label: 'City',
					required: true,
					model: 'city'
				});
			}
			if (this.form.missingFields.indexOf('province') > -1) {
				fields.push({
					type: 'text',
					label: 'Province',
					required: true,
					model: 'province'
				});
			}
			if (this.form.missingFields.indexOf('postalCode') > -1) {
				fields.push({
					type: 'text',
					label: 'Postal Code',
					required: true,
					model: 'postalCode'
				});
			}

			if (['complex', 'business', 'estate', 'apartment'].indexOf(this.form.location.type) >= 0) {
				fields.push({
					type: 'number',
					label: 'Unit Number',
					required: true,
					model: 'buildingNumber'
				});
			}

			if (['business', 'apartment'].indexOf(this.form.location.type) >= 0) {
				fields.push({
					type: 'text',
					label: 'Building Name',
					required: true,
					model: 'buildingName'
				});
			}

			if (this.form.location.type === 'estate') {
				fields.push({
					type: 'text',
					label: 'Estate Name',
					required: true,
					model: 'buildingName'
				});
			}

			if (this.form.location.type === 'complex') {
				fields.push({
					type: 'text',
					label: 'Complex Name',
					required: true,
					model: 'buildingName'
				});
			}

			if (this.form.location.type === 'school') {
				fields.push({
					type: 'text',
					label: 'School Name',
					required: true,
					model: 'buildingName'
				});
			}

			fields.push({
				type: 'text',
				label: 'Custom name for this address (optional)',
				required: false,
				model: 'name'
			});

			return fields;
		},

		user() {
			return this.$signup.$store.getters['signupUser/user'];
		},

		transferOptions() {
			let availableProviders = this.$signup.$store.getters['signupSolutions/providers'].map(p => {
				return {
					value: p.slug,
					label: p.name,
				}
			});
			return [
				...availableProviders,
				{
					label: 'Openserve',
					value: 'openserve'
				},
				{
					label: 'Other',
					value: 'other'
				},
				{
					label: 'I\'m not sure',
					value: 'other'
				}
			]
		},

		transferFields() {
			let fields = [];

			if (this.form.order.previousProvider === 'vumatel') {
				fields.push({
					type: 'email',
					label: 'Email Address Used to Sign Up with Vumatel',
					required: true,
					model: 'previousProviderEmail'
				});
			}
			// leaving this here in-case we need it
			// else if (this.form.order.previousProvider === 'vodacom') {
			// 	fields.push({
			// 		type: 'email',
			// 		label: 'Serial number (optional)',
			// 		required: false,
			// 		model: 'previousProviderFSAN'
			// 	});
			// } else if (this.form.order.previousProvider === 'openserve') {
			// 	fields.push({
			// 		type: 'text',
			// 		label: 'Openserve Service Number (optional)',
			// 		required: false,
			// 		model: 'previousProviderFSAN'
			// 	});
			// }

			return fields;
		},

		orderTypeOptions() {

			return [
				{
					label: 'New Installation',
					value: 'new'
				},
				{
					label: 'Migrate/Transfer my existing Fibre line',
					value: 'transfer',
					disabled: this.solution && this.solution.id === 1831820
				}
			]
		}
	},
	methods: {
		changeAddress() {
			this.$modal.push('coverage')
		},
		//change provider slug into readable name
		namify(value) {
			return value.replace('_', '').replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},
		async next() {
			this.$modal.toggleLoader(true);
			//update store then push to next screen
			// let clientPlace = await this.$signup.$store.dispatch('signupGeneral/mapsToLocation', {
			// 	place: this.$signup.$store.getters['signupCoverage/place'],
			// 	coordinates: this.$signup.$store.getters['signupCoverage/coordinates']
			// });

			// this.form.location = {
			// 	...this.form.location,
			// 	...clientPlace,
			// }

			this.$signup.$store.dispatch('signupUser/addLocation', this.form.location)
			.then((res) => {
				let location = {
					...res.location,
					contact_number: this.form.order.phoneNumber,
					alternative_contact_number: this.form.order.alternatePhoneNumber,
					order_type: this.form.order.type,
					previous_provider: this.form.order.previousProvider,
					migrate_email_address: this.form.order.previousProviderEmail,
				};

				if (this.form.order.previousProviderFSAN) {
					location.migrate_fsan_number = this.form.order.previousProviderFSAN;
				}
				if (this.form.order.previousProviderObjectNumber) {
					location.migrate_object_number = this.form.order.previousProviderObjectNumber;
				}

				this.$signup.$store.commit('signupSolutions/updateSolutionLocation', location);

				this.$signup.$store.commit('signupDelivery/updateDeliveryLocation', location)

				// this.$modal.push('fibre-device');
				this.$modal.push('fibre-max-upsell');
			}).catch((err) => {
				this.$modal.toggleLoader(false);
				this.error = err;
			});
		}
	},
	data() {
		return {
			error: false,
			// orderTypeOptions: [
			// 	{
			// 		label: 'New Installation',
			// 		value: 'new'
			// 	},
			// 	{
			// 		label: 'Migrate/Transfer my existing Fibre line',
			// 		value: 'transfer'
			// 	}
			// ],
			locationTypeOptions: [
				{
					label: 'Freestanding Home',
					value: 'house'
				},
				{
					label: 'Complex',
					value: 'complex'
				},
				{
					label: 'Business/Office Building',
					value: 'business'
				},
				{
					label: 'School Campus',
					value: 'school'
				},
				{
					label: 'Estate',
					value: 'estate'
				},
				{
					label: 'Apartment',
					value: 'apartment'
				}
			],
			form: {
				location: {
					type: false,
					name: '',
					buildingNumber: '',
					buildingName: '',
					streetName: '',
					streetNumber: '',
					suburb: '',
					city: '',
					province: '',
					postalCode: '',
				},
				order: {
					type: false,
					previousProvider: '',
					previousProviderEmail: '',
					previousProviderFSAN: '',
					previousProviderObjectNumber: '',
					phoneNumber: '',
					alternatePhoneNumber: '',
				},
				missingFields: [],
			}
		}
	},
	async mounted() {
		//update store then push to next screen
		let location = await this.$signup.$store.dispatch('signupGeneral/mapsToLocation', {
			place: this.$signup.$store.getters['signupCoverage/place'],
			coordinates: this.$signup.$store.getters['signupCoverage/coordinates']
		});
		let solutionLocation = this.$signup.$store.getters['signupSolutions/solutionLocation'];

		// if (solutionLocation) {
		// 	location = {
		// 		...location,
		// 		...solutionLocation,
		// 	}
		// }

		this.form.order.phoneNumber = this.$signup.$store.getters['signupUser/user'].cell_number || '';

		if (location) {
			this.form.order.type = solutionLocation.order_type || '';
			this.form.order.previousProvider = solutionLocation.previous_provider || '';
			this.form.order.previousProviderEmail = solutionLocation.migrate_email_address || '';
			this.form.order.previousProviderObjectNumber = solutionLocation.migrate_object_number || '';
			this.form.order.previousProviderFSAN = solutionLocation.migrate_fsan_number || '';

			this.form.location.type = (solutionLocation.location_type) ? solutionLocation.location_type.name : '';
			this.form.location.name = solutionLocation.name || '';
			this.form.location.buildingNumber = solutionLocation.building_number || '';
			this.form.location.streetName = location.streetName || '';
			this.form.location.streetNumber = location.streetNumber || '';
			this.form.location.suburb = location.suburb || '';
			this.form.location.city = location.city || '';
			this.form.location.province = location.province || '';
			this.form.location.postalCode = location.postalCode || '';
			this.form.location.buildingName = solutionLocation.building_name || '';
			this.form.location.latitude = location.latitude.toFixed(6) || '';
			this.form.location.longitude = location.longitude.toFixed(6) || '';
		}

		let that = this;

		Object.keys(that.form.location).forEach(prop => {
			if (!that.form.location[prop]) {
				that.form.missingFields.push(prop);
			}
		})
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('fibre-solutions');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.error = false;
			//validate info
			if (!that.form.location.type) {
				that.error = {message: 'Please select the type of location.'};
				return;
			}

			if (['complex', 'business', 'estate', 'apartment'].indexOf(that.form.location.type) >= 0) {
				if (!that.form.location.buildingNumber) {
					that.error = {message: 'Unit number cannot be empty.'};
					return;
				}
			}
			if (['complex', 'business', 'estate', 'apartment', 'school'].indexOf(that.form.location.type) >= 0) {
				if (!that.form.location.buildingName) {
					if (['business', 'apartment'].indexOf(that.form.location.type) >= 0) {
						that.error = {message: `Building name cannot be empty.`};
					} else {
						that.error = {message: `${that.form.location.type.charAt(0).toUpperCase() + that.form.location.type.slice(1)} name cannot be empty.`};
					}
					return;
				}
			}

			if (!that.form.order.type) {
				that.error = {message: 'Please choose whether you are migrating or ordering a new installation.'};
				return;
			}

			if (that.form.order.type === 'transfer' &&
				(!that.form.order.previousProviderEmail || !that.form.order.previousProviderEmail.match(/^[\w\d._%+-]+@([\w\d.-]+\.)+[\w-]{2,}$/)) ) {
				that.error = {message: `Enter a valid email address that was used to sign up to ${that.namify(that.form.order.previousProvider)}.`};
				return;
			}
			let phoneRegex = /[0](\d{9})|([0](\d{2})( |-)((\d{3}))( |-)(\d{4}))|[0](\d{2})( |-)(\d{7})/;
			if (!that.form.order.phoneNumber || !that.form.order.phoneNumber.match(phoneRegex)) {
				that.error = {message: 'Enter a valid phone number.'};
				return;
			}
			if (that.form.order.alternatePhoneNumber && !that.form.order.alternatePhoneNumber.match(phoneRegex)) {
				that.error = {message: 'Enter a valid alternate contact number.'};
				return;
			}

			that.next();
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/Installation.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_Installationvue_type_script_lang_js_ = (Installationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Installation.vue?vue&type=style&index=0&id=d7c3e534&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Installation.vue?vue&type=style&index=0&id=d7c3e534&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/Installation.vue



;


/* normalize component */

var Installation_component = (0,componentNormalizer/* default */.Z)(
  fibre_Installationvue_type_script_lang_js_,
  Installationvue_type_template_id_d7c3e534_render,
  Installationvue_type_template_id_d7c3e534_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Installation = (Installation_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/MaxUpsell.vue?vue&type=template&id=fd02ae1a&
var MaxUpsellvue_type_template_id_fd02ae1a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"max-upsell"},[_vm._m(0),_c('div',{staticClass:"max-upsell-cards"},[_c('div',{staticClass:"max-upsell-card",class:{'--is-selected': _vm.selectedOption === 1},on:{"click":function($event){$event.preventDefault();_vm.selectedOption = 1}}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"logo"},[_c('svg',{attrs:{"width":"100px","height":"50px","viewBox":"0 0 100 50"}},[_c('path',{attrs:{"d":"M90.4672486,9.81373153 L100,0 L95.5910312,0 C94.9066466,0 94.2540497,0.132996556 93.633512,0.39953362 C93.012431,0.665798708 92.4742151,1.04031048 92.0180493,1.52198103 L87.9742305,5.65820111 L90.4672486,9.81373153 Z","fill":"#E0BA7B"}}),_c('path',{attrs:{"d":"M79.2970052,0.384852217 C80.1774809,0.384852217 80.9891485,0.606105539 81.7320078,1.04779975 C82.4740575,1.49003558 83.0720147,2.07715578 83.5250698,2.80943116 L86.1675765,7.24235115 L86.1905126,7.21879052 L88.6694985,11.3614002 L88.6592447,11.3719618 L95.2278692,22.3214286 L91.5659211,22.3214286 C90.6849057,22.3214286 89.8670319,22.1072164 89.1122998,21.6774379 C88.3572979,21.248201 87.7655469,20.6543105 87.3378564,19.8965788 L84.6575727,15.4639296 L79.4858906,20.8059652 C79.007201,21.2861147 78.459973,21.658481 77.843667,21.9236059 C77.2265514,22.1887307 76.5913568,22.3214286 75.9370038,22.3214286 L71.5581007,22.3214286 L82.2036816,11.3719618 L75.635057,0.384852217 L79.2970052,0.384852217 Z M64.7269325,0 C71.1967848,0 73.9945787,2.3643858 73.1197893,7.09236909 L70.8587425,18.7921794 C70.6820715,19.7012949 70.2343065,20.4530688 69.515177,21.0464176 C68.7960475,21.6400373 67.9689674,21.9365764 67.0358306,21.9365764 L58.784239,21.9365764 C53.4343267,21.9365764 51.2017245,19.6633813 52.0845385,15.1169911 C52.9173002,10.7474411 56.5005023,8.56253066 62.8344153,8.56253066 C63.5914222,8.56253066 64.3294904,8.60044433 65.0486199,8.67627166 C65.7677494,8.75182818 66.492831,8.85311183 67.2249471,8.97931018 L67.5658437,7.35010578 C67.9440766,5.37994921 66.7200954,4.39500633 63.8944414,4.39500633 C61.4464791,4.39500633 58.7212002,4.74895748 55.718334,5.45577654 L56.5889731,1.06077021 C58.1029869,0.707360683 59.5347526,0.442235833 60.8850819,0.26512485 C62.2345996,0.0888263033 63.5156674,0 64.7269325,0 Z M62.1150152,12.3132755 C59.4969293,12.3132755 57.9996831,13.2013904 57.6237989,14.9773588 L57.6108512,15.0411638 C57.4087482,16.0014627 57.5161577,16.7716518 57.9328091,17.3522725 C58.34919,17.9337057 59.1251356,18.2237452 60.2606459,18.2237452 C61.1688919,18.2237452 62.0519764,18.2047884 62.9101701,18.1668747 C63.7675521,18.128961 64.6381912,17.832422 65.5218168,17.2764452 L66.5058176,12.730055 C65.1178814,12.4524728 63.6541904,12.3132755 62.1150152,12.3132755 Z M16.0104987,21.9365764 L19.8819992,0 L20.982329,0 C21.4378156,0 21.8610194,0.0820560058 22.2538393,0.246168017 C22.6458453,0.410821653 22.9873925,0.638032837 23.2784807,0.928072382 C23.5690264,1.21892436 23.8034161,1.55960573 23.9808362,1.95092893 C24.1574424,2.34279375 24.2461524,2.75334459 24.2461524,3.18231064 C26.5995451,1.06077021 29.1547734,0 31.9129226,0 C34.645571,0 36.3535779,1.0103992 37.0366722,3.03065598 C39.6423595,1.0103992 42.1726296,0 44.6272115,0 C49.6622511,0 51.686847,2.7785301 50.6999141,8.33504867 L48.3088129,21.9365764 L42.7675565,21.9365764 L45.1966375,8.14575115 C45.6521241,5.6959867 44.7661091,4.47056285 42.5399488,4.47056285 C40.9203806,4.47056285 39.2123736,5.2158372 37.4161992,6.70584427 L34.7215306,21.9365764 L29.1802742,21.9365764 L31.6093553,8.183394 C32.0393411,5.70844405 31.2420361,4.47056285 29.2185253,4.47056285 C27.6244578,4.47056285 25.9666384,5.2158372 24.2461524,6.70584427 L21.5517551,21.9365764 L16.0104987,21.9365764 Z","fill":"#333F48"}}),_c('path',{attrs:{"d":"M99.7375328,26.9345238 L94.7648667,42.2293571 C93.2583599,46.8630424 88.9398829,50 84.0674501,50 L0,50 L4.89687426,34.938286 C6.44857623,30.1655901 10.8966075,26.9345238 15.9152134,26.9345238 L99.7375328,26.9345238 Z M27.6349784,33.8662509 L25.1593551,33.8662509 L25.1593551,38.5065965 C25.1593551,39.0463589 25.2678231,39.5559107 25.4847592,40.035252 C25.7016952,40.5145933 25.9994506,40.9335133 26.3780253,41.2920123 C26.7566,41.6505112 27.1989794,41.9324766 27.7051636,42.1379086 C28.2113477,42.3433406 28.7494342,42.4460565 29.3194231,42.4460565 C29.8894119,42.4460565 30.4253716,42.3433406 30.9273021,42.1379086 C31.4292326,41.9324766 31.8694852,41.6505112 32.2480599,41.2920123 C32.6266346,40.9335133 32.92439,40.5145933 33.141326,40.035252 C33.3582621,39.5559107 33.4667301,39.0463589 33.4667301,38.5065965 L33.4667301,33.8662509 L30.9911068,33.8662509 L30.9911068,38.5065965 C30.9911068,38.7241127 30.9464435,38.9295447 30.8571169,39.1228924 C30.7677903,39.3162401 30.6486882,39.4854194 30.4998105,39.6304302 C30.3509328,39.775441 30.1744064,39.8902412 29.9702313,39.9748308 C29.7660561,40.0594205 29.5491201,40.1017153 29.3194231,40.1017153 L29.2811402,40.1017153 C29.0514432,40.1017153 28.836634,40.0594205 28.6367125,39.9748308 C28.4367911,39.8902412 28.2623915,39.775441 28.1135138,39.6304302 C27.9646361,39.4854194 27.8476608,39.3162401 27.7625878,39.1228924 C27.6775148,38.9295447 27.6349784,38.7241127 27.6349784,38.5065965 L27.6349784,33.8662509 Z M39.1325896,33.8541667 L34.9342388,33.8541667 L34.9342388,42.31313 L37.4098621,42.31313 L37.4098621,40.1863049 L39.1325896,40.1863049 C39.5919836,40.1863049 40.0258557,40.1037293 40.434206,39.9385781 C40.8425562,39.7734269 41.1977358,39.5478546 41.4997449,39.2618611 C41.8017539,38.9758675 42.0399582,38.6395231 42.2143578,38.2528276 C42.3887573,37.8661321 42.4759571,37.4552682 42.4759571,37.0202358 C42.4759571,36.5852034 42.3887573,36.1743395 42.2143578,35.787644 C42.0399582,35.4009485 41.8017539,35.064604 41.4997449,34.7786105 C41.1977358,34.492617 40.8425562,34.2670446 40.434206,34.1018934 C40.0258557,33.9367423 39.5919836,33.8541667 39.1325896,33.8541667 Z M50.5408742,33.8541667 L42.7184151,33.8541667 L42.7184151,35.8359809 L45.3982135,35.8359809 L45.3982135,42.31313 L47.8738368,42.31313 L47.8738368,35.8359809 L50.5408742,35.8359809 L50.5408742,33.8541667 Z M54.1777435,33.8541667 L51.7021202,33.8541667 L51.7021202,42.31313 L54.1777435,42.31313 L54.1777435,33.8541667 Z M58.2995286,33.8541667 L55.8239054,33.8541667 L55.8239054,42.31313 L58.2995286,42.31313 L58.2995286,37.6848686 L60.5709768,40.2708946 L62.842425,37.6848686 L62.842425,42.31313 L65.3180483,42.31313 L65.3180483,33.8541667 L62.842425,33.8541667 L60.5709768,36.4522768 L58.2995286,33.8541667 Z M74.148622,33.8541667 L66.9004054,33.8541667 L66.9004054,42.31313 L74.148622,42.31313 L74.148622,40.3313157 L69.3760287,40.3313157 L69.3760287,39.0745555 L72.0047833,39.0745555 L72.0047833,37.0927412 L69.3760287,37.0927412 L69.3760287,35.8359809 L74.148622,35.8359809 L74.148622,33.8541667 Z M38.7880441,36.0293287 C39.0772922,36.0293287 39.3240038,36.1260025 39.5281789,36.3193503 C39.732354,36.512698 39.8344416,36.7463265 39.8344416,37.0202358 C39.8259343,37.2941451 39.7217199,37.5297876 39.5217984,37.7271634 C39.3218769,37.9245393 39.0772922,38.0232272 38.7880441,38.0232272 L37.4098621,38.0232272 L37.4098621,36.0293287 Z","fill":"#E0BA7B"}})])]),_vm._m(1),_c('div',{staticClass:"checkbox"},[_c('svg',{attrs:{"width":"20px","height":"20px","viewBox":"0 0 20 20"}},[(_vm.selectedOption === 1)?_c('path',{attrs:{"d":"M10,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 10,20 C4.48,20 0,15.52 0,10 C0,4.48 4.48,0 10,0 Z M10,2 C5.59,2 2,5.59 2,10 C2,14.41 5.59,18 10,18 C14.41,18 18,14.41 18,10 C18,5.59 14.41,2 10,2 Z M10,5 C12.7614237,5 15,7.23857625 15,10 C15,12.7614237 12.7614237,15 10,15 C7.23857625,15 5,12.7614237 5,10 C5,7.23857625 7.23857625,5 10,5 Z","fill":"#FFFFFF"}}):_c('path',{attrs:{"d":"M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M10,18 C5.59,18 2,14.41 2,10 C2,5.59 5.59,2 10,2 C14.41,2 18,5.59 18,10 C18,14.41 14.41,18 10,18 Z","id":"icon-colour","fill":"#768692","fill-rule":"nonzero"}})])])]),_c('div',{staticClass:"card-features"},[_c('dl',[_c('dt',[_vm._v("Uncapped LTE failover")]),_c('dd',[_c('svg',{attrs:{"width":"16.6666667px","height":"16.6666667px","viewBox":"0 0 16.6666667 16.6666667"}},[_c('path',{attrs:{"d":"M8.33333333,0 C12.9333333,0 16.6666667,3.73333333 16.6666667,8.33333333 C16.6666667,12.9333333 12.9333333,16.6666667 8.33333333,16.6666667 C3.73333333,16.6666667 0,12.9333333 0,8.33333333 C0,3.73333333 3.73333333,0 8.33333333,0 Z M13.0892557,5.24407768 C12.7888523,4.94367438 12.3161598,4.92056643 11.9892505,5.17475384 L11.9107443,5.24407768 L6.66666667,10.4875 L3.92258898,7.74407768 L3.84408287,7.67475384 C3.51717353,7.42056643 3.04448098,7.44367438 2.74407768,7.74407768 C2.44367438,8.04448098 2.42056643,8.51717353 2.67475384,8.84408287 L2.74407768,8.92258898 L6.07741102,12.2559223 L6.15591713,12.3252462 C6.26488691,12.4099753 6.39005482,12.4638938 6.51964041,12.4870018 L6.61747385,12.4985558 L6.71585949,12.4985558 L6.81369292,12.4870018 C6.94327851,12.4638938 7.06844642,12.4099753 7.1774162,12.3252462 L7.25592232,12.2559223 L13.0892557,6.42258898 L13.1585795,6.34408287 C13.4127669,6.01717353 13.389659,5.54448098 13.0892557,5.24407768 Z","fill":"#78BE20"}})])])]),_c('dl',[_c('dt',[_vm._v("TP-Link MR600 router")]),_c('dd',[_c('svg',{attrs:{"width":"16.6666667px","height":"16.6666667px","viewBox":"0 0 16.6666667 16.6666667"}},[_c('path',{attrs:{"d":"M8.33333333,0 C12.9333333,0 16.6666667,3.73333333 16.6666667,8.33333333 C16.6666667,12.9333333 12.9333333,16.6666667 8.33333333,16.6666667 C3.73333333,16.6666667 0,12.9333333 0,8.33333333 C0,3.73333333 3.73333333,0 8.33333333,0 Z M13.0892557,5.24407768 C12.7888523,4.94367438 12.3161598,4.92056643 11.9892505,5.17475384 L11.9107443,5.24407768 L6.66666667,10.4875 L3.92258898,7.74407768 L3.84408287,7.67475384 C3.51717353,7.42056643 3.04448098,7.44367438 2.74407768,7.74407768 C2.44367438,8.04448098 2.42056643,8.51717353 2.67475384,8.84408287 L2.74407768,8.92258898 L6.07741102,12.2559223 L6.15591713,12.3252462 C6.26488691,12.4099753 6.39005482,12.4638938 6.51964041,12.4870018 L6.61747385,12.4985558 L6.71585949,12.4985558 L6.81369292,12.4870018 C6.94327851,12.4638938 7.06844642,12.4099753 7.1774162,12.3252462 L7.25592232,12.2559223 L13.0892557,6.42258898 L13.1585795,6.34408287 C13.4127669,6.01717353 13.389659,5.54448098 13.0892557,5.24407768 Z","fill":"#78BE20"}})])])]),_vm._m(2),_vm._m(3)])]),_c('div',{staticClass:"max-upsell-card",class:{'--is-selected': _vm.selectedOption === 2},on:{"click":function($event){$event.preventDefault();_vm.selectedOption = 2}}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"logo"},[_c('svg',{attrs:{"width":"100px","height":"50px","viewBox":"0 0 100 50"}},[_c('path',{attrs:{"d":"M90.4672486,9.81373153 L100,0 L95.5910312,0 C94.9066466,0 94.2540497,0.132996556 93.633512,0.39953362 C93.012431,0.665798708 92.4742151,1.04031048 92.0180493,1.52198103 L87.9742305,5.65820111 L90.4672486,9.81373153 Z","fill":"#D2A054"}}),_c('path',{attrs:{"d":"M79.2970052,0.384852217 C80.1774809,0.384852217 80.9891485,0.606105539 81.7320078,1.04779975 C82.4740575,1.49003558 83.0720147,2.07715578 83.5250698,2.80943116 L86.1675765,7.24235115 L86.1905126,7.21879052 L88.6694985,11.3614002 L88.6592447,11.3719618 L95.2278692,22.3214286 L91.5659211,22.3214286 C90.6849057,22.3214286 89.8670319,22.1072164 89.1122998,21.6774379 C88.3572979,21.248201 87.7655469,20.6543105 87.3378564,19.8965788 L84.6575727,15.4639296 L79.4858906,20.8059652 C79.007201,21.2861147 78.459973,21.658481 77.843667,21.9236059 C77.2265514,22.1887307 76.5913568,22.3214286 75.9370038,22.3214286 L71.5581007,22.3214286 L82.2036816,11.3719618 L75.635057,0.384852217 L79.2970052,0.384852217 Z M64.7269325,0 C71.1967848,0 73.9945787,2.3643858 73.1197893,7.09236909 L70.8587425,18.7921794 C70.6820715,19.7012949 70.2343065,20.4530688 69.515177,21.0464176 C68.7960475,21.6400373 67.9689674,21.9365764 67.0358306,21.9365764 L58.784239,21.9365764 C53.4343267,21.9365764 51.2017245,19.6633813 52.0845385,15.1169911 C52.9173002,10.7474411 56.5005023,8.56253066 62.8344153,8.56253066 C63.5914222,8.56253066 64.3294904,8.60044433 65.0486199,8.67627166 C65.7677494,8.75182818 66.492831,8.85311183 67.2249471,8.97931018 L67.5658437,7.35010578 C67.9440766,5.37994921 66.7200954,4.39500633 63.8944414,4.39500633 C61.4464791,4.39500633 58.7212002,4.74895748 55.718334,5.45577654 L56.5889731,1.06077021 C58.1029869,0.707360683 59.5347526,0.442235833 60.8850819,0.26512485 C62.2345996,0.0888263033 63.5156674,0 64.7269325,0 Z M62.1150152,12.3132755 C59.4969293,12.3132755 57.9996831,13.2013904 57.6237989,14.9773588 L57.6108512,15.0411638 C57.4087482,16.0014627 57.5161577,16.7716518 57.9328091,17.3522725 C58.34919,17.9337057 59.1251356,18.2237452 60.2606459,18.2237452 C61.1688919,18.2237452 62.0519764,18.2047884 62.9101701,18.1668747 C63.7675521,18.128961 64.6381912,17.832422 65.5218168,17.2764452 L66.5058176,12.730055 C65.1178814,12.4524728 63.6541904,12.3132755 62.1150152,12.3132755 Z M16.0104987,21.9365764 L19.8819992,0 L20.982329,0 C21.4378156,0 21.8610194,0.0820560058 22.2538393,0.246168017 C22.6458453,0.410821653 22.9873925,0.638032837 23.2784807,0.928072382 C23.5690264,1.21892436 23.8034161,1.55960573 23.9808362,1.95092893 C24.1574424,2.34279375 24.2461524,2.75334459 24.2461524,3.18231064 C26.5995451,1.06077021 29.1547734,0 31.9129226,0 C34.645571,0 36.3535779,1.0103992 37.0366722,3.03065598 C39.6423595,1.0103992 42.1726296,0 44.6272115,0 C49.6622511,0 51.686847,2.7785301 50.6999141,8.33504867 L48.3088129,21.9365764 L42.7675565,21.9365764 L45.1966375,8.14575115 C45.6521241,5.6959867 44.7661091,4.47056285 42.5399488,4.47056285 C40.9203806,4.47056285 39.2123736,5.2158372 37.4161992,6.70584427 L34.7215306,21.9365764 L29.1802742,21.9365764 L31.6093553,8.183394 C32.0393411,5.70844405 31.2420361,4.47056285 29.2185253,4.47056285 C27.6244578,4.47056285 25.9666384,5.2158372 24.2461524,6.70584427 L21.5517551,21.9365764 L16.0104987,21.9365764 Z","fill":"#333F48"}}),_c('path',{attrs:{"d":"M99.7375328,26.9345238 L94.7648667,42.2293571 C93.2583599,46.8630424 88.9398829,50 84.0674501,50 L0,50 L4.89687426,34.938286 C6.44857623,30.1655901 10.8966075,26.9345238 15.9152134,26.9345238 L99.7375328,26.9345238 Z M17.1946007,33.8662666 L14.8668916,33.8662666 L14.8668916,38.5126366 C14.8668916,39.0530998 14.9688789,39.5633132 15.1728534,40.0432767 C15.3768279,40.5232403 15.6567929,40.9427043 16.0127484,41.3016686 C16.3687039,41.660633 16.7846519,41.9429645 17.2605924,42.1486632 C17.7365329,42.3543618 18.2424697,42.4572112 18.7784027,42.4572112 C19.3143357,42.4572112 19.8182727,42.3543618 20.2902137,42.1486632 C20.7621547,41.9429645 21.176103,41.660633 21.5320585,41.3016686 C21.888014,40.9427043 22.167979,40.5232403 22.3719535,40.0432767 C22.575928,39.5633132 22.6779153,39.0530998 22.6779153,38.5126366 L22.6779153,33.8662666 L20.3502062,33.8662666 L20.3502062,38.5126366 C20.3502062,38.7304352 20.3082115,38.9361339 20.224222,39.1297326 C20.1402325,39.3233314 20.0282465,39.4927303 19.888264,39.6379294 C19.7482815,39.7831284 19.5823022,39.8980777 19.3903262,39.9827771 C19.1983502,40.0674766 18.9943757,40.1098263 18.7784027,40.1098263 L18.7424072,40.1098263 C18.5264342,40.1098263 18.3244594,40.0674766 18.1364829,39.9827771 C17.9485064,39.8980777 17.7845269,39.7831284 17.6445444,39.6379294 C17.5045619,39.4927303 17.3945757,39.3233314 17.3145857,39.1297326 C17.2345957,38.9361339 17.1946007,38.7304352 17.1946007,38.5126366 L17.1946007,33.8662666 Z M28.0052493,33.8541667 L24.0577428,33.8541667 L24.0577428,42.324112 L26.3854518,42.324112 L26.3854518,40.1945258 L28.0052493,40.1945258 C28.4371954,40.1945258 28.8451444,40.111843 29.2290964,39.9464774 C29.6130484,39.7811118 29.9470066,39.5552466 30.2309711,39.2688817 C30.5149356,38.9825169 30.7389076,38.6457358 30.9028871,38.2585383 C31.0668666,37.8713407 31.1488564,37.4599434 31.1488564,37.0243462 C31.1488564,36.588749 31.0668666,36.1773517 30.9028871,35.7901542 C30.7389076,35.4029567 30.5149356,35.0661755 30.2309711,34.7798107 C29.9470066,34.4934459 29.6130484,34.2675807 29.2290964,34.1022151 C28.8451444,33.9368495 28.4371954,33.8541667 28.0052493,33.8541667 Z M38.7319085,33.8541667 L31.3768279,33.8541667 L31.3768279,35.8385539 L33.8965129,35.8385539 L33.8965129,42.324112 L36.224222,42.324112 L36.224222,35.8385539 L38.7319085,35.8385539 L38.7319085,33.8541667 Z M42.1514811,33.8541667 L39.823772,33.8541667 L39.823772,42.324112 L42.1514811,42.324112 L42.1514811,33.8541667 Z M46.0269966,33.8541667 L43.6992876,33.8541667 L43.6992876,42.324112 L46.0269966,42.324112 L46.0269966,37.6898419 L48.1627297,40.2792252 L50.2984627,37.6898419 L50.2984627,42.324112 L52.6261717,42.324112 L52.6261717,33.8541667 L50.2984627,33.8541667 L48.1627297,36.4556499 L46.0269966,33.8541667 Z M60.9291339,33.8541667 L54.1139858,33.8541667 L54.1139858,42.324112 L60.9291339,42.324112 L60.9291339,40.3397248 L56.4416948,40.3397248 L56.4416948,39.0813329 L58.9133858,39.0813329 L58.9133858,37.0969457 L56.4416948,37.0969457 L56.4416948,35.8385539 L60.9291339,35.8385539 L60.9291339,33.8541667 Z M67.168354,33.8541667 L64.7926509,33.8541667 L68.104237,42.3120121 L68.104237,42.324112 L70.4439445,42.324112 L70.4439445,42.3120121 L73.7555306,33.8541667 L71.3798275,33.8541667 L69.28009,39.2991315 L67.168354,33.8541667 Z M76.9591301,33.8541667 L74.6314211,33.8541667 L74.6314211,42.324112 L76.9591301,42.324112 L76.9591301,33.8541667 Z M82.4544432,33.8541667 L78.5069366,33.8541667 L78.5069366,42.324112 L80.8346457,42.324112 L80.8346457,40.1945258 L82.4544432,40.1945258 C82.8863892,40.1945258 83.2943382,40.111843 83.6782902,39.9464774 C84.0622422,39.7811118 84.3962005,39.5552466 84.680165,39.2688817 C84.9641295,38.9825169 85.1881015,38.6457358 85.352081,38.2585383 C85.5160605,37.8713407 85.5980502,37.4599434 85.5980502,37.0243462 C85.5980502,36.588749 85.5160605,36.1773517 85.352081,35.7901542 C85.1881015,35.4029567 84.9641295,35.0661755 84.680165,34.7798107 C84.3962005,34.4934459 84.0622422,34.2675807 83.6782902,34.1022151 C83.2943382,33.9368495 82.8863892,33.8541667 82.4544432,33.8541667 Z M27.6812898,36.0321526 C27.9532558,36.0321526 28.1852268,36.128952 28.3772028,36.3225507 C28.5691789,36.5161495 28.6651669,36.7500813 28.6651669,37.0243462 C28.6571679,37.2986111 28.5591801,37.5345596 28.3712036,37.7321916 C28.1832271,37.9298237 27.9532558,38.0286397 27.6812898,38.0286397 L26.3854518,38.0286397 L26.3854518,36.0321526 Z M82.1304837,36.0321526 C82.4024497,36.0321526 82.6344207,36.128952 82.8263967,36.3225507 C83.0183727,36.5161495 83.1143607,36.7500813 83.1143607,37.0243462 C83.1063617,37.2986111 83.008374,37.5345596 82.8203975,37.7321916 C82.6324209,37.9298237 82.4024497,38.0286397 82.1304837,38.0286397 L80.8346457,38.0286397 L80.8346457,36.0321526 Z","fill":"#D2A054"}})])]),_vm._m(4),_c('div',{staticClass:"checkbox"},[_c('svg',{attrs:{"width":"20px","height":"20px","viewBox":"0 0 20 20"}},[(_vm.selectedOption === 2)?_c('path',{attrs:{"d":"M10,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 10,20 C4.48,20 0,15.52 0,10 C0,4.48 4.48,0 10,0 Z M10,2 C5.59,2 2,5.59 2,10 C2,14.41 5.59,18 10,18 C14.41,18 18,14.41 18,10 C18,5.59 14.41,2 10,2 Z M10,5 C12.7614237,5 15,7.23857625 15,10 C15,12.7614237 12.7614237,15 10,15 C7.23857625,15 5,12.7614237 5,10 C5,7.23857625 7.23857625,5 10,5 Z","fill":"#FFFFFF"}}):_c('path',{attrs:{"d":"M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M10,18 C5.59,18 2,14.41 2,10 C2,5.59 5.59,2 10,2 C14.41,2 18,5.59 18,10 C18,14.41 14.41,18 10,18 Z","id":"icon-colour","fill":"#768692","fill-rule":"nonzero"}})])])]),_c('div',{staticClass:"card-features"},[_c('dl',[_c('dt',[_vm._v("All Max Uptime features")]),_c('dd',[_c('svg',{attrs:{"width":"16.6666667px","height":"16.6666667px","viewBox":"0 0 16.6666667 16.6666667"}},[_c('path',{attrs:{"d":"M8.33333333,0 C12.9333333,0 16.6666667,3.73333333 16.6666667,8.33333333 C16.6666667,12.9333333 12.9333333,16.6666667 8.33333333,16.6666667 C3.73333333,16.6666667 0,12.9333333 0,8.33333333 C0,3.73333333 3.73333333,0 8.33333333,0 Z M13.0892557,5.24407768 C12.7888523,4.94367438 12.3161598,4.92056643 11.9892505,5.17475384 L11.9107443,5.24407768 L6.66666667,10.4875 L3.92258898,7.74407768 L3.84408287,7.67475384 C3.51717353,7.42056643 3.04448098,7.44367438 2.74407768,7.74407768 C2.44367438,8.04448098 2.42056643,8.51717353 2.67475384,8.84408287 L2.74407768,8.92258898 L6.07741102,12.2559223 L6.15591713,12.3252462 C6.26488691,12.4099753 6.39005482,12.4638938 6.51964041,12.4870018 L6.61747385,12.4985558 L6.71585949,12.4985558 L6.81369292,12.4870018 C6.94327851,12.4638938 7.06844642,12.4099753 7.1774162,12.3252462 L7.25592232,12.2559223 L13.0892557,6.42258898 L13.1585795,6.34408287 C13.4127669,6.01717353 13.389659,5.54448098 13.0892557,5.24407768 Z","fill":"#78BE20"}})])])]),_vm._m(5),_vm._m(6)])]),_c('div',{staticClass:"max-upsell-card --short",class:{'--is-selected': _vm.selectedOption === 3},on:{"click":function($event){$event.preventDefault();_vm.selectedOption = 3}}},[_c('dl',[_c('dt',[_vm._v("No Thank You")]),_c('dd',[_c('svg',{attrs:{"width":"20px","height":"20px","viewBox":"0 0 20 20"}},[(_vm.selectedOption === 3)?_c('path',{attrs:{"d":"M10,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 10,20 C4.48,20 0,15.52 0,10 C0,4.48 4.48,0 10,0 Z M10,2 C5.59,2 2,5.59 2,10 C2,14.41 5.59,18 10,18 C14.41,18 18,14.41 18,10 C18,5.59 14.41,2 10,2 Z M10,5 C12.7614237,5 15,7.23857625 15,10 C15,12.7614237 12.7614237,15 10,15 C7.23857625,15 5,12.7614237 5,10 C5,7.23857625 7.23857625,5 10,5 Z","fill":"#FFFFFF"}}):_c('path',{attrs:{"d":"M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M10,18 C5.59,18 2,14.41 2,10 C2,5.59 5.59,2 10,2 C14.41,2 18,5.59 18,10 C18,14.41 14.41,18 10,18 Z","id":"icon-colour","fill":"#768692","fill-rule":"nonzero"}})])])])])])])])
}
var MaxUpsellvue_type_template_id_fd02ae1a_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-upsell-content"},[_c('h3',[_vm._v("Never go down again.")]),_c('h4',[_vm._v("And get help within 5 minutes.")]),_c('p',[_vm._v("You'll get unlimited and automatic internet connectivity failover via LTE if your Fibre line ever goes down.")]),_c('p',[_vm._v("And you'll get priority access to our support platforms, plus additional hardware to ensure you stay connected even during Fibre outages or loadshedding.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"price"},[_c('dt',[_vm._v("Add for an extra")]),_c('dd',[_vm._v("R499 pm")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("Priority support")]),_c('dd',[_vm._v("15 numbers")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("8800mAh UPS back-up power")]),_c('dd',[_vm._v("1 total")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"price"},[_c('dt',[_vm._v("Add for an extra")]),_c('dd',[_vm._v("R999 pm")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("Mesh WiFi")]),_c('dd',[_vm._v("2 WiFi points")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("8800mAh UPS back-up power")]),_c('dd',[_vm._v("3 total")])])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/MaxUpsell.vue?vue&type=template&id=fd02ae1a&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/MaxUpsell.vue?vue&type=script&lang=js&

	
	

	/* harmony default export */ var MaxUpsellvue_type_script_lang_js_ = ({
		components: {Icon: Icon},
		computed: {},
		methods: {
			next() {
				//
				// this.$modal.toggleLoader(false);
				let user = this.$signup.$store.getters['signupUser/user'];
				let location = this.$signup.$store.getters['signupSolutions/solutionLocation'];

				let maxCartItems = [
					{
						product_type_slug: "solution_max_uptime",
						product_id: this.selectedOption === 1 ? 1760 : 2760,
						cart_item_requirements: [
							{ name: "rica_contact_id", value: null },
							{ name: "usage_location_id", value: location.id }
						]
					},
					{
						product_type_slug: 'solution_tangible_mobile_router',
						product_id: 904991 , // 848991,
						cart_item_requirements: [
							{name: "configure_wifi_network_name", value: `Afrihost ${user.first_name[0]}${user.last_name[0]}`},
							{name: "configure_wifi_network_password", value: user.cell_number},
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
							{ name: "max_uptime_included", value: 1 }
						],
					},
					{
						product_type_slug: "solution_max_support",
						product_id: 1750,
						cart_item_requirements: [
							{ name: "max_uptime_included", value: 1 }
						]
					},
					{
						product_type_slug: "solution_tangible_ups",
						product_id: 798991,
						cart_item_requirements: [
							{ name: "max_uptime_included", value: 1 },
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
						]
					},
					{
						product_type_slug: "solution_tangible_lte_sim",
						product_id: 747991,
						cart_item_requirements: [
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
							{ name: "rica_contact_id", value: null }
						]
					},
					{
						product_type_slug: "solution_connectivity_data",
						product_id: 1405220,
						cart_item_requirements: [
							{ name: "rica_contact_id", value: null },
							{ name: "usage_location_id", value: location.id },
							{ name: "max_uptime_included", value: 1 }
						]
					}
				]

				let maxVipCartItems = [
					{
						product_type_slug: "solution_max_uptime",
						product_id: this.selectedOption === 1 ? 1760 : 2760,
						cart_item_requirements: [
							{ name: 'rica_contact_id', value: null },
							{ name: 'usage_location_id', value: location.id }
						]
					},
					{
						product_type_slug: 'solution_tangible_mobile_router',
						product_id: 904991,  // 848991,
						cart_item_requirements: [
							{ name: 'configure_wifi_network_name', value: `Afrihost ${user.first_name[0]}${user.last_name[0]}` },
							{ name: 'configure_wifi_network_password', value: user.cell_number },
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
							{ name: 'max_uptime_included', value: 1 }
						],
					},
					{
						product_type_slug: "solution_max_support",
						product_id: 1750,
						cart_item_requirements: [
							{ name: 'max_uptime_included', value: 1 }
						]
					},
					{
						product_type_slug: "solution_tangible_ups",
						product_id: 798991,
						cart_item_requirements: [
							{ name: 'max_uptime_included', value: 1 },
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
						]
					},
					{
						product_type_slug: "solution_tangible_ups",
						product_id: 798991,
						cart_item_requirements: [
							{ name: 'max_uptime_included', value: 1 },
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
						]
					},
					{
						product_type_slug: "solution_tangible_ups",
						product_id: 798991,
						cart_item_requirements: [
							{ name: 'max_uptime_included', value: 1 },
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
						]
					},
					{
						product_type_slug: "solution_tangible_mesh",
						product_id: 827991,
						cart_item_requirements: [
							{ name: 'max_uptime_included', value: 1 },
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
						]
					},
					{
						product_type_slug: "solution_tangible_lte_sim",
						product_id: 747991,
						cart_item_requirements: [
							{ name: 'recipient_first_name', value: user.first_name },
							{ name: 'recipient_last_name', value: user.last_name },
							{ name: 'contact_number', value: user.cell_number },
							{ name: 'email_address', value: user.email },
							{ name: 'id_number', value: user.id_number },
							{ name: "rica_contact_id", value: null }
						]
					},
					{
						product_type_slug: "solution_connectivity_data",
						product_id: 1405220,
						cart_item_requirements: [
							{ name: "rica_contact_id", value: null },
							{ name: "usage_location_id", value: location.id },
							{ name: "max_uptime_included", value: 1 }
						]
					}
				]

				// remove all max stuff from cart
				maxCartItems.forEach(i => {
					this.$signup.$store.commit('signupCart/removeCartItemByProductId', i.product_id);
				})

				this.$signup.$store.commit('signupCart/removeCartItemByProductId', 1760);
				this.$signup.$store.commit('signupCart/removeCartItemByProductId', 2760);

				switch (this.selectedOption) {
					case 1:
						maxCartItems.forEach(i => {
							this.$signup.$store.commit('signupCart/addCartItem', i);
						})
						this.$modal.push('rica-contacts');
						break;
					case 2:
						maxVipCartItems.forEach(i => {
							this.$signup.$store.commit('signupCart/addCartItem', i);
						})
						this.$modal.push('rica-contacts');
						break;
					default:
						this.$modal.push('fibre-addons');
						break;
				}
			}
		},
		data() {
			return {
				selectedOption: 3,
			}
		},
		mounted() {
			let that = this;
			this.$modal.toggleLoader(false);

			// listen for back button event
			services_EventBus.$on('back', function () {
				that.$modal.push('fibre-installation');
			});

			// listen for next button event
			services_EventBus.$on('next', function () {
				that.next();
			});
		},
		beforeDestroy() {
			services_EventBus.$off('back')
			services_EventBus.$off('next')
		}
	});

;// CONCATENATED MODULE: ./src/modals/fibre/MaxUpsell.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_MaxUpsellvue_type_script_lang_js_ = (MaxUpsellvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/MaxUpsell.vue?vue&type=style&index=0&id=fd02ae1a&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/MaxUpsell.vue?vue&type=style&index=0&id=fd02ae1a&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/MaxUpsell.vue



;


/* normalize component */

var MaxUpsell_component = (0,componentNormalizer/* default */.Z)(
  fibre_MaxUpsellvue_type_script_lang_js_,
  MaxUpsellvue_type_template_id_fd02ae1a_render,
  MaxUpsellvue_type_template_id_fd02ae1a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MaxUpsell = (MaxUpsell_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Addons.vue?vue&type=template&id=33d952f8&
var Addonsvue_type_template_id_33d952f8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"fibre-addons"},[_vm._m(0),_c('div',{staticClass:"fibre-addons-options"},_vm._l((_vm.devices),function(device){return _c('div',{staticClass:"fibre-addon-card",class:{'--is-selected': _vm.selectedDevices.indexOf(device.id) >= 0},on:{"click":function($event){return _vm.toggleDevice(device.id)}}},[_c('div',{staticClass:"fibre-addon-card-image"},[_c('img',{attrs:{"src":`https://www.afrihost.com/fibre/assets/signup/${device.id}.png`,"srcset":`https://www.afrihost.com/fibre/assets/signup/${device.id}@2x.png`,"alt":"","width":"60"}})]),_c('div',{staticClass:"fibre-addon-card-meta"},[_c('dl',[_c('dt',[_vm._v(_vm._s(device.title))]),_c('dd',[_vm._v(_vm._s(device.description))])]),(device.price_override === 0)?_c('p',{staticClass:"price"},[_c('span',{staticClass:"override"},[_vm._v("FREE with Afrihost.")]),_c('span',{staticClass:"strike"},[_vm._v("Usually R"+_vm._s(device.price)+".00")])]):_c('p',{staticClass:"price"},[_vm._v("R"+_vm._s(device.price)+".00")])]),_c('div',{staticClass:"fibre-addon-card-checkbox"},[(_vm.selectedDevices.indexOf(device.id) >= 0)?_c('svg',{staticClass:"selected",attrs:{"width":"20px","height":"20px","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M14,0 C17.3137085,0 20,2.6862915 20,6 L20,14 C20,17.3137085 17.3137085,20 14,20 L6,20 C2.6862915,20 0,17.3137085 0,14 L0,6 C0,2.6862915 2.6862915,0 6,0 L14,0 Z M15.2904379,5 C14.8553975,5 14.4189955,5.16575816 14.082498,5.50262364 L7.71224307,11.8798441 L5.91750199,10.0831405 L5.78683018,9.96482619 C5.47192525,9.70742549 5.09022249,9.5805169 4.70956211,9.5805169 C4.27452168,9.5805169 3.83811977,9.74627506 3.50162223,10.0831405 C3.16555499,10.4195752 3,10.8558454 3,11.2908549 C3,11.7258644 3.16555499,12.1621345 3.50162223,12.4985692 L6.49715395,15.4973764 L6.62745419,15.615289 C6.94183775,15.8720201 7.32536582,16 7.70866845,16 C8.14672861,16 8.5850832,15.8328425 8.92018296,15.4973764 L16.4980442,7.91838611 L16.6161964,7.78763058 C16.873247,7.47256977 17,7.0909713 17,6.71033797 C17,6.27532846 16.834445,5.83905835 16.4983778,5.50262364 C16.1618802,5.16575816 15.7254783,5 15.2904379,5 Z","id":"icon-colour","fill":"#FFFFFF"}})]):_c('svg',{staticClass:"deselected",attrs:{"width":"20px","height":"20px","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M14,0 C17.3137085,0 20,2.6862915 20,6 L20,14 C20,17.3137085 17.3137085,20 14,20 L6,20 C2.6862915,20 0,17.3137085 0,14 L0,6 C0,2.6862915 2.6862915,0 6,0 L14,0 Z M14,2 L6,2 C3.85780461,2 2.10892112,3.68396847 2.00489531,5.80035966 L2,6 L2,14 C2,16.1421954 3.68396847,17.8910789 5.80035966,17.9951047 L6,18 L14,18 C16.1421954,18 17.8910789,16.3160315 17.9951047,14.1996403 L18,14 L18,6 C18,3.85780461 16.3160315,2.10892112 14.1996403,2.00489531 L14,2 Z","id":"icon-colour"}})])])])}),0)])])
}
var Addonsvue_type_template_id_33d952f8_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fibre-addons-content"},[_c('h4',[_vm._v("Get a FREE WiFi router included with our Pure Fibre sign up promotion.")]),_c('p',[_vm._v("Our Fibre WiFi router provides excellent coverage and operates on both 2.4 GHz and 5 GHz frequencies for future-proof, cutting-edge connectivity.")]),_c('h4',[_vm._v("Improve your overall experience.")]),_c('p',[_vm._v("Our mesh WiFi 6 system boosts coverage, speed, and total WiFi capacity throughout your whole house. And our backup power UPS can power your fibre box and router in case of a power outage.")])])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/Addons.vue?vue&type=template&id=33d952f8&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Addons.vue?vue&type=script&lang=js&

	

	/* harmony default export */ var Addonsvue_type_script_lang_js_ = ({
		components: {},
		computed: {
			allDeviceSolutionIds() {
				return this.devices.map(i => i.id)
			}
		},
		data() {
			return {
				selectedDevices: [],
				canDisplayDevices: false,
				devices: [
					{
						id: 890991, // tp-link ex511
						title: 'TP-Link EX511',
						description: 'WiFi 6 Fibre router.',
						price: null,
						in_stock: false,
						price_override: 0
					},
					{
						id: 826991, // x50 3 pack
						title: 'TP-Link Deco X50',
						description: '3-Pack WiFi mesh system.',
						price: null,
						in_stock: false,
					},
					{
						id: 827991, // x50 2 pack
						title: 'TP-Link Deco X50',
						description: '2-Pack WiFi mesh system.',
						price: null,
						in_stock: false,
					},
					{
						id: 798991, // gizzu ups
						title: 'Gizzu GUDP36W',
						description: '8800mAh UPS power.',
						price: null,
						in_stock: false,
					},
				]
			}
		},
		methods: {
			toggleDevice(id) {
				if(this.selectedDevices.indexOf(id) >= 0) {
					// if in array, remove
					this.selectedDevices = this.selectedDevices.filter(d => d !== id)
				} else {
					// else add
					this.selectedDevices.push(id)
				}
			},
			next() {

				// remove all addons from cart
				this.$signup.$store.commit('signupCart/removeCartItem', 'solution_tangible_fibre');
				this.$signup.$store.commit('signupCart/removeCartItem', 'solution_tangible_mesh');
				this.$signup.$store.commit('signupCart/removeCartItem', 'solution_tangible_ups');

				let user = this.$signup.$store.getters['signupUser/user'];
				let location = this.$signup.$store.getters['signupSolutions/solutionLocation'];

				// add selected devices to the cart
				this.selectedDevices.forEach(sId => {
					switch (sId) {
						case 890991: // tp-link ex511
							this.$signup.$store.commit('signupCart/replaceOrAddCartItem', {
								product_type_slug: 'solution_tangible_fibre',
								product_id: sId,
								cart_item_requirements: [
									// { name: 'configure_wifi_network_name', value: d.ssid },
									// { name: 'configure_wifi_network_password', value: d.password },
									{ name: 'recipient_first_name', value: user.first_name },
									{ name: 'recipient_last_name', value: user.last_name },
									{ name: 'contact_number', value: location.contact_number },
									{ name: 'email_address', value: user.email },
									{ name: 'id_number', value: user.id_number },
								]
							});
							break;
						case 826991: // x50 3 pack
						case 827991: // x50 2 pack
							this.$signup.$store.commit('signupCart/replaceOrAddCartItem', {
								product_type_slug: 'solution_tangible_mesh',
								product_id: sId,
								cart_item_requirements: [
									{ name: 'recipient_first_name', value: user.first_name },
									{ name: 'recipient_last_name', value: user.last_name },
									{ name: 'contact_number', value: location.contact_number },
									{ name: 'email_address', value: user.email },
									{ name: 'id_number', value: user.id_number },
								],
							});
							break;
						case 798991: // gizzu ups
							this.$signup.$store.commit('signupCart/replaceOrAddCartItem', {
								product_type_slug: 'solution_tangible_ups',
								product_id: sId,
								cart_item_requirements: [
									{ name: 'recipient_first_name', value: user.first_name },
									{ name: 'recipient_last_name', value: user.last_name },
									{ name: 'contact_number', value: location.contact_number },
									{ name: 'email_address', value: user.email },
									{ name: 'id_number', value: user.id_number },
								],
							});
							break;
					}
				})

				this.$modal.push('payment-methods');
			},
			async checkStock() {

				try {
					let solutions = await this.$signup.$store.dispatch('signupSolutions/getAddonSolutions');

					// update price on internal solutions
					solutions.solutions.forEach(s => {
						let device = this.devices.find(d => d.id === s.id)
						if(device) device.price = s.price
					})

					// update stock on internal solutions
					let stock = await this.$signup.$store.dispatch('signupSolutions/checkStockAvailability', this.allDeviceSolutionIds);
					stock.stock_availability.forEach(s => {
						// update price on internal solutions
						let device = this.devices.find(d => d.id === s.solution_id)
						if(device) device.in_stock = (s.availability === 'in_stock')
					})

					this.canDisplayDevices = true
					this.$modal.toggleLoader(false);
				}

				catch (e) {
					// skip step
					this.$modal.toggleLoader(false);
				}
			}
		},
		mounted() {
			let that = this;
			this.$modal.toggleLoader(true);
			this.checkStock();

			// listen for back button event
			services_EventBus.$on('back', function () {
				that.$modal.push('fibre-max-upsell');
			});

			// listen for next button event
			services_EventBus.$on('next', function () {
				that.next();
			});
		},
		beforeDestroy() {
			services_EventBus.$off('back')
			services_EventBus.$off('next')
		}
	});

;// CONCATENATED MODULE: ./src/modals/fibre/Addons.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_Addonsvue_type_script_lang_js_ = (Addonsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/Addons.vue?vue&type=style&index=0&id=33d952f8&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/Addons.vue?vue&type=style&index=0&id=33d952f8&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/Addons.vue



;


/* normalize component */

var Addons_component = (0,componentNormalizer/* default */.Z)(
  fibre_Addonsvue_type_script_lang_js_,
  Addonsvue_type_template_id_33d952f8_render,
  Addonsvue_type_template_id_33d952f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Addons = (Addons_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/RicaContacts.vue?vue&type=template&id=464b90b8&
var RicaContactsvue_type_template_id_464b90b8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"rica-contacts"},[_vm._l((_vm.contacts),function(c){return _c('div',{key:c.id,staticClass:"rica-contact-card",class:{'--is-selected': _vm.selected === c.id},on:{"click":function($event){$event.preventDefault();_vm.selected = c.id}}},[_c('dl',[_c('dt',[_vm._v(_vm._s(c.first_name)+" "+_vm._s(c.last_name))]),_c('dd',[_vm._v(_vm._s(c.address_line_1)+" "),_c('br'),_vm._v(_vm._s(c.suburb)+", "+_vm._s(c.city))])]),_c('svg',{attrs:{"width":"16px","height":"16px","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8,8 C10.21,8 12,6.21 12,4 C12,1.79 10.21,0 8,0 C5.79,0 4,1.79 4,4 C4,6.21 5.79,8 8,8 Z M8,10 C5.33,10 0,11.34 0,14 L0,16 L16,16 L16,14 C16,11.34 10.67,10 8,10 Z"}})])])}),_c('div',{staticClass:"rica-contact-card --create",on:{"click":function($event){return _vm.create()}}},[_vm._m(0)])],2)])
}
var RicaContactsvue_type_template_id_464b90b8_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("New RICA Contact")]),_c('dd',[_vm._v("Create a new RICA contact")])])
}]


;// CONCATENATED MODULE: ./src/modals/fibre/RicaContacts.vue?vue&type=template&id=464b90b8&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/RicaContacts.vue?vue&type=script&lang=js&




/* harmony default export */ var RicaContactsvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon
	},
	methods: {
		create() {
			this.$signup.$store.commit("signupUser/selectRicaContact", false);
			this.$modal.push('rica-create-contact');
		},
		async getContacts() {
			this.$modal.toggleLoader(true);
			this.contacts = await this.$signup.$store.dispatch("signupUser/getRicaContacts")
			this.$modal.toggleLoader(false);

			if(!this.contacts.length) {
				this.$modal.push('rica-create-contact');
			}

		},
		next() {
			if(!this.selected) return
			this.$signup.$store.commit("signupUser/selectRicaContact", this.selected);
			this.$signup.$store.dispatch("signupCart/addRicaContactIdToCartItems", this.selected);
			this.$modal.push('payment-methods');
		}
	},
	data() {
		return {
			contacts: [],
			selected: false
		}
	},
	mounted() {
		let that = this;
		this.getContacts();

		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('fibre-max-upsell');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.next();
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/RicaContacts.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_RicaContactsvue_type_script_lang_js_ = (RicaContactsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/RicaContacts.vue?vue&type=style&index=0&id=464b90b8&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/RicaContacts.vue?vue&type=style&index=0&id=464b90b8&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/RicaContacts.vue



;


/* normalize component */

var RicaContacts_component = (0,componentNormalizer/* default */.Z)(
  fibre_RicaContactsvue_type_script_lang_js_,
  RicaContactsvue_type_template_id_464b90b8_render,
  RicaContactsvue_type_template_id_464b90b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RicaContacts = (RicaContacts_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/RicaCreateContact.vue?vue&type=template&id=1ea45190&
var RicaCreateContactvue_type_template_id_1ea45190_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"rica-contact-create"},[_c('div',{staticClass:"rica-column"},[_c('h4',[_vm._v("RICA contact")]),_c('signup-input',{attrs:{"label":"First Name"},model:{value:(_vm.form.first_name),callback:function ($$v) {_vm.$set(_vm.form, "first_name", $$v)},expression:"form.first_name"}}),_c('signup-input',{attrs:{"label":"Last Name"},model:{value:(_vm.form.last_name),callback:function ($$v) {_vm.$set(_vm.form, "last_name", $$v)},expression:"form.last_name"}}),_c('signup-input',{attrs:{"label":"Email Address"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('signup-input',{attrs:{"label":"Contact number"},model:{value:(_vm.form.contact_number),callback:function ($$v) {_vm.$set(_vm.form, "contact_number", $$v)},expression:"form.contact_number"}}),_c('signup-select',{attrs:{"label":"Identity type","options":_vm.idTypes},model:{value:(_vm.form.identity_type),callback:function ($$v) {_vm.$set(_vm.form, "identity_type", $$v)},expression:"form.identity_type"}}),(_vm.form.identity_type === 'passport')?_c('signup-select',{attrs:{"label":"Passport Country","options":_vm.countries},model:{value:(_vm.form.passport_country_code),callback:function ($$v) {_vm.$set(_vm.form, "passport_country_code", $$v)},expression:"form.passport_country_code"}}):_vm._e(),_c('signup-input',{attrs:{"label":`${_vm.form.identity_type === 'south_african_id' ? 'ID number' : 'Passport Number'}`},model:{value:(_vm.form.identity_number),callback:function ($$v) {_vm.$set(_vm.form, "identity_number", $$v)},expression:"form.identity_number"}})],1),_c('div',{staticClass:"rica-column"},[_c('h4',[_vm._v("RICA address")]),_c('signup-input',{attrs:{"label":"Address line 1"},model:{value:(_vm.form.address_line_1),callback:function ($$v) {_vm.$set(_vm.form, "address_line_1", $$v)},expression:"form.address_line_1"}}),_c('signup-input',{attrs:{"label":"Address line 2"},model:{value:(_vm.form.address_line_2),callback:function ($$v) {_vm.$set(_vm.form, "address_line_2", $$v)},expression:"form.address_line_2"}}),_c('signup-input',{attrs:{"label":"Suburb"},model:{value:(_vm.form.suburb),callback:function ($$v) {_vm.$set(_vm.form, "suburb", $$v)},expression:"form.suburb"}}),_c('signup-input',{attrs:{"label":"City"},model:{value:(_vm.form.city),callback:function ($$v) {_vm.$set(_vm.form, "city", $$v)},expression:"form.city"}}),_c('signup-input',{attrs:{"label":"Province"},model:{value:(_vm.form.region),callback:function ($$v) {_vm.$set(_vm.form, "region", $$v)},expression:"form.region"}}),_c('signup-input',{attrs:{"label":"Postal code"},model:{value:(_vm.form.postal_code),callback:function ($$v) {_vm.$set(_vm.form, "postal_code", $$v)},expression:"form.postal_code"}})],1)]),_c('error-bar',{attrs:{"error":_vm.error}})],1)
}
var RicaCreateContactvue_type_template_id_1ea45190_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/RicaCreateContact.vue?vue&type=script&lang=js&






/* harmony default export */ var RicaCreateContactvue_type_script_lang_js_ = ({
	components: {
		ErrorBar: ErrorBar,
		SignupSelect: SignupSelect,
		SignupInput: SignupInput

	},
	computed: {
		countries() {
			let countries = [...this.$signup.$store.getters['signupGeneral/countries']];
			return countries.map((c) => {
				return {
					"label": c.name,
					"value": c.code
				}
			})
		},
	},
	methods: {
		next() {
			this.form.country_code = 'ZAF'
			if(this.form.identity_type === 'south_african_id') {
				this.form.passport_country_code = 'ZAF'
			}

			this.$modal.toggleLoader(true)
			this.error = false
			this.$signup.$store.dispatch('signupUser/createRicaContact', {
				rica_contact: this.form
			})
				.then(r => {
					this.$signup.$store.dispatch("signupCart/addRicaContactIdToCartItems", r.rica_contact.id);
					this.$modal.push('payment-methods');
				}, e => {
					this.error = e
					this.$modal.toggleLoader(false)
				})
		}
	},
	data() {
		return {
			error: false,
			idTypes: [
				{
					label: 'SA ID',
					value: 'south_african_id'
				},
				{
					label: 'Passport',
					value: 'passport'
				}
			],
			form: {
				first_name: '',
				last_name: '',
				contact_number: '',
				email: '',
				address_line_1: '',
				address_line_2: '',
				suburb: '',
				city: '',
				region: '',
				country_code: '',
				postal_code: '',
				identity_type: 'south_african_id',
				identity_number: '',
				passport_country_code: 'ZAF',
				friendly_name: '',
			}
		}
	},
	mounted() {
		let that = this;

		this.$modal.toggleLoader(true)

		let user = {...this.$signup.$store.getters['signupUser/user']};
		this.form.first_name = user.first_name
		this.form.last_name = user.last_name
		this.form.contact_number = user.cell_number
		this.form.email = user.email
		this.form.identity_number = user.id_number

		this.$signup.$store.dispatch('signupGeneral/fetchCountries')
			.then(() => {
				this.$modal.toggleLoader(false)
			});

		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('fibre-max-upsell');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.next();
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/fibre/RicaCreateContact.vue?vue&type=script&lang=js&
 /* harmony default export */ var fibre_RicaCreateContactvue_type_script_lang_js_ = (RicaCreateContactvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/fibre/RicaCreateContact.vue?vue&type=style&index=0&id=1ea45190&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/fibre/RicaCreateContact.vue?vue&type=style&index=0&id=1ea45190&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/fibre/RicaCreateContact.vue



;


/* normalize component */

var RicaCreateContact_component = (0,componentNormalizer/* default */.Z)(
  fibre_RicaCreateContactvue_type_script_lang_js_,
  RicaCreateContactvue_type_template_id_1ea45190_render,
  RicaCreateContactvue_type_template_id_1ea45190_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RicaCreateContact = (RicaCreateContact_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/promos/ttConnectOptIn.vue?vue&type=template&id=9afd0fe2&scoped=true&
var ttConnectOptInvue_type_template_id_9afd0fe2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"promo-modal-tt-connect"},[_c('h2',[_vm._v("This package is on promotion. Opt in and get the first 3 months for FREE! ")]),_c('div',{staticClass:"package-card-comparison"},[_c('div',{staticClass:"promo-package-card"},[_c('span',{staticClass:"tag"},[_vm._v("Standard")]),_c('dl',[_c('dt',[_c('formatted-price',{attrs:{"price":_vm.selectedSolution.price}})],1),_c('dd')]),_c('div',{staticClass:"speed"},[_vm._v(_vm._s(_vm.selectedSolution.name))])]),_c('div',{staticClass:"arrow"},[_c('svg',{attrs:{"width":"42px","height":"42px","viewBox":"0 0 42 42"}},[_c('circle',{attrs:{"fill":"#E31C79","cx":"21","cy":"21","r":"21"}}),_c('path',{attrs:{"d":"M14.0267929,19.9509061 L25.4960693,19.9509061 L20.4853201,14.8056013 C20.0848708,14.3943987 20.0848708,13.7196046 20.4853201,13.308402 C20.8857693,12.8971993 21.5326488,12.8971993 21.933098,13.308402 L28.6996631,20.2566722 C29.1001123,20.6678748 29.1001123,21.3321252 28.6996631,21.7433278 L21.933098,28.691598 C21.5326488,29.1028007 20.8857693,29.1028007 20.4853201,28.691598 C20.0848708,28.2803954 20.0848708,27.616145 20.4853201,27.2049423 L25.4960693,22.0596376 L14.0267929,22.0596376 C13.4620568,22.0596376 13,21.585173 13,21.0052718 C13,20.4253707 13.4620568,19.9509061 14.0267929,19.9509061 Z","fill":"#FFFFFF"}})])]),_c('div',{staticClass:"promo-package-card --is-promo"},[_c('span',{staticClass:"tag"},[_vm._v("Promo")]),_c('dl',[_vm._m(0),_c('dd',[_vm._v("Thereafter "),_c('formatted-price',{attrs:{"price":_vm.selectedSolution.price}})],1)]),_c('div',{staticClass:"speed"},[_vm._v(_vm._s(_vm.selectedSolution.name))])])]),_vm._m(1)])])
}
var ttConnectOptInvue_type_template_id_9afd0fe2_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dt',[_vm._v("FREE "),_c('br'),_vm._v(" for the first 3 months")])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"terms-centered"},[_vm._v("* A clawback fee will apply if you cancel or downgrade your package within 12 months of opting in. Read the promotion's "),_c('a',{attrs:{"target":"_blank","href":"https://www.afrihost.com/terms-and-conditions/fibre"}},[_vm._v("Terms and Conditions")]),_vm._v(" for more.")])
}]


;// CONCATENATED MODULE: ./src/modals/promos/ttConnectOptIn.vue?vue&type=template&id=9afd0fe2&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/promos/ttConnectOptIn.vue?vue&type=script&lang=js&






/* harmony default export */ var ttConnectOptInvue_type_script_lang_js_ = ({
	components: {
		FormattedPrice: FormattedPrice,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {
		selectedSolution() {
			return this.$signup.$store.getters['signupSolutions/selectedSolution']
		}
	},
	data() {
		return {
			error: false
		}
	},
	methods: {
		async optIn() {
			// update the cart item requirements
			this.$signup.$store.commit('signupCart/addCartItemRequirement', {
				productTypeSlug: 'solution_fibre_line',
				cartItemRequirement: {
					name: 'fibre_promotion_slug',
					value: 'tt_connect_3_months_promo'
				}
			})

			this.$modal.push('auth-login');
		},
		async next() {
			this.$modal.push('auth-login');
		},
	},
	mounted() {

		this.$modal.toggleLoader(false)

		services_EventBus.$on('back', () => {
			this.next();
		})
		services_EventBus.$on('next', () => {
			this.optIn()
		})
	},
	destroyed() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/promos/ttConnectOptIn.vue?vue&type=script&lang=js&
 /* harmony default export */ var promos_ttConnectOptInvue_type_script_lang_js_ = (ttConnectOptInvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/promos/ttConnectOptIn.vue?vue&type=style&index=0&id=9afd0fe2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/promos/ttConnectOptIn.vue?vue&type=style&index=0&id=9afd0fe2&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/promos/ttConnectOptIn.vue



;


/* normalize component */

var ttConnectOptIn_component = (0,componentNormalizer/* default */.Z)(
  promos_ttConnectOptInvue_type_script_lang_js_,
  ttConnectOptInvue_type_template_id_9afd0fe2_scoped_true_render,
  ttConnectOptInvue_type_template_id_9afd0fe2_scoped_true_staticRenderFns,
  false,
  null,
  "9afd0fe2",
  null
  
)

/* harmony default export */ var ttConnectOptIn = (ttConnectOptIn_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryOption.vue?vue&type=template&id=3b6e8036&
var DeliveryOptionvue_type_template_id_3b6e8036_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"delivery-type-cards"},_vm._l((_vm.deliveryTypes),function(d){return _c('delivery-type-card',{key:d.label,attrs:{"label":d.label,"type":d.type,"disabled":d.disabled,"message":d.message,"price":d.price,"selected":d.type === _vm.selectedDeliveryOption},on:{"select":_vm.changeDeliveryType}})}),1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}}),_c('global-error',{attrs:{"error":_vm.globalError,"message":_vm.globalError.message,"goto":_vm.globalError.goto}})],1)
}
var DeliveryOptionvue_type_template_id_3b6e8036_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryOptionCard.vue?vue&type=template&id=3b5fa16e&
var DeliveryOptionCardvue_type_template_id_3b5fa16e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-type-card",class:[{'selected': _vm.selected}, {'disabled':_vm.disabled === true}],on:{"click":_vm.select}},[_c('div',{staticClass:"card-body"},[_c('icon',{attrs:{"name":_vm.type}}),_c('p',{staticClass:"head"},[_vm._v(_vm._s(_vm.label))]),(_vm.message)?_c('p',{staticClass:"warning"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)])
}
var DeliveryOptionCardvue_type_template_id_3b5fa16e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryOptionCard.vue?vue&type=script&lang=js&

	
	/* harmony default export */ var DeliveryOptionCardvue_type_script_lang_js_ = ({
		props: [
			'selected',
			'label',
			'price',
			'type',
            'disabled',
            'message'
		],
		components: {
			Icon: Icon
		},
		methods: {
			select() {
			    if (this.disabled !== true) {
				    this.$emit('select', this.type)
                }
			}
		}
	});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryOptionCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliveryOptionCardvue_type_script_lang_js_ = (DeliveryOptionCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryOptionCard.vue?vue&type=style&index=0&id=3b5fa16e&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryOptionCard.vue?vue&type=style&index=0&id=3b5fa16e&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryOptionCard.vue



;


/* normalize component */

var DeliveryOptionCard_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliveryOptionCardvue_type_script_lang_js_,
  DeliveryOptionCardvue_type_template_id_3b5fa16e_render,
  DeliveryOptionCardvue_type_template_id_3b5fa16e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DeliveryOptionCard = (DeliveryOptionCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GlobalError.vue?vue&type=template&id=688a0394&
var GlobalErrorvue_type_template_id_688a0394_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"signup-error-global"},[_c('icon',{attrs:{"name":"warning-circle"}}),_c('h1',[_vm._v("Something went wrong")]),_c('p',[_vm._v(_vm._s(_vm.errorMessage))]),_c('button',{staticClass:"signup-button primary",on:{"click":function($event){$event.preventDefault();return _vm.action.apply(null, arguments)}}},[_vm._v("Go back")])],1):_vm._e()
}
var GlobalErrorvue_type_template_id_688a0394_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GlobalError.vue?vue&type=script&lang=js&

    

    /* harmony default export */ var GlobalErrorvue_type_script_lang_js_ = ({
        props: ['error', 'message', 'goto'],
        components: {
            Icon: Icon
        },
        computed: {
            errorMessage() {
            	if(this.message) {
            		return this.message !== 'Something went wrong' ? this.message : 'Please try again' ;
				}

                return this.error.data && this.error.data.message && this.error.data.message !== 'Something went wrong' ? this.error.data.message : 'Please try again.';
            }
        },
		methods: {
        	action() {
        		if (!this.goto) {
        			this.$modal.push(this.$modal.state.previous.name);
				} else {
					this.$modal.push(this.goto);
				}
			}
		}
    });

;// CONCATENATED MODULE: ./src/components/GlobalError.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_GlobalErrorvue_type_script_lang_js_ = (GlobalErrorvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GlobalError.vue?vue&type=style&index=0&id=688a0394&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/GlobalError.vue?vue&type=style&index=0&id=688a0394&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/GlobalError.vue



;


/* normalize component */

var GlobalError_component = (0,componentNormalizer/* default */.Z)(
  components_GlobalErrorvue_type_script_lang_js_,
  GlobalErrorvue_type_template_id_688a0394_render,
  GlobalErrorvue_type_template_id_688a0394_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GlobalError = (GlobalError_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryOption.vue?vue&type=script&lang=js&

	
	
	
	
	

	/* harmony default export */ var DeliveryOptionvue_type_script_lang_js_ = ({
		components: {
			GlobalError: GlobalError,
			ErrorBar: ErrorBar,
			DeliveryTypeCard: DeliveryOptionCard,
			Icon: Icon

		},
		computed: {
			deliveryTypes() {
				let quotes = this.$signup.$store.getters['signupDelivery/deliveryQuotes'];
				let options = [];
				options.push({
					label: 'Deliver my order',
					type: 'deliver',
				})
				// debugger;
				if (quotes.length > 0 && quotes.find(q => { return q.name.indexOf('Collect') > -1 })) {
					options.push({
						label: 'Collect my order',
						type: 'collect',
						// disabled: true,
						// message: 'Collections from Afrihost HQ will be unavailable from 12 July 2021 until further notice.'
					});
				}
				return options;
			}
		},
		methods: {
			changeDeliveryType(value) {
				this.selectedDeliveryOption = value
				this.$signup.$store.commit('signupDelivery/updateSelectedDeliveryOption', this.selectedDeliveryOption);
			}
		},
		data() {
			return {
				error: false,
				globalError: false,
				// deliveryTypes: [],
				selectedDeliveryOption: ''
			}
		},
		async mounted() {
			this.$modal.toggleLoader(true);
			console.log('getDeliveryQuotes')
			let r = await this.$signup.$store.dispatch('signupDelivery/getDeliveryQuotes')
				.catch((err) => {
					//check if parts of cart went missing
					if (err.data.message.indexOf('value property missing') > 0) {
						this.globalError = {
							message: `Something went wrong with your order, please start again. If the problem persists, please contact support.`
						};
					} else {
						this.globalError = {
							message: `Cannot get delivery quotes - ${err.data.message}`
						};
					}
					if (err.data.error_slug === 'duplicate-fibre-order') {
						this.globalError.goto =  'coverage';
					}
				});

			console.log('r', r)

			this.$modal.toggleLoader(false);

			let that = this;
			// listen for back button event
			services_EventBus.$on('back', function () {
				that.$modal.push('payment-methods');
			});

			// listen for next button event
			services_EventBus.$on('next', function () {
				if (that.deliveryTypes.length < 1) { return; }
				that.error = false;
				if (!that.selectedDeliveryOption) {
					that.error = {message: 'Please select a delivery option.'}
				} else if (that.selectedDeliveryOption === 'deliver') {
					that.$modal.push('delivery-address');
				} else if (that.selectedDeliveryOption === 'collect') {
					that.$modal.push('collection');
				} else {
					that.error = {message: 'Unable to process delivery option.'}
				}
			});
		},
		beforeDestroy() {
			services_EventBus.$off('back')
			services_EventBus.$off('next')
		}
	});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryOption.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliveryOptionvue_type_script_lang_js_ = (DeliveryOptionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryOption.vue?vue&type=style&index=0&id=3b6e8036&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryOption.vue?vue&type=style&index=0&id=3b6e8036&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryOption.vue



;


/* normalize component */

var DeliveryOption_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliveryOptionvue_type_script_lang_js_,
  DeliveryOptionvue_type_template_id_3b6e8036_render,
  DeliveryOptionvue_type_template_id_3b6e8036_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DeliveryOption = (DeliveryOption_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/Solutions.vue?vue&type=template&id=2e3f2bdc&
var Solutionsvue_type_template_id_2e3f2bdc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"solution-cards"},_vm._l((_vm.solutions),function(s){return _c('solution-card',{key:s.id,attrs:{"selected":s.id === _vm.selectedSolutionId,"solution":s},on:{"select":_vm.selectSolution}})}),1),(_vm.unavailablePackages)?_c('p',{staticClass:"disclaimer"},[_vm._v("*Certain packages not available due to Openserve infrastructure restrictions.")]):_vm._e(),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error}})],1)
}
var Solutionsvue_type_template_id_2e3f2bdc_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/SolutionCard.vue?vue&type=template&id=4acf56f2&
var SolutionCardvue_type_template_id_4acf56f2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dsl-solution-card",class:{'selected': _vm.selected, 'disabled': _vm.disabled},on:{"click":function($event){return _vm.select()}}},[_c('div',{staticClass:"dsl-solution-card-body"},[_c('p',[_c('formatted-speed',{attrs:{"speed":_vm.solution.solution_composite_child_metas[0].child_solution.speed_kbps}})],1)]),_c('div',{staticClass:"dsl-solution-card-footer"},[_c('p',[(_vm.disabled)?_c('span',{staticClass:"violator"},[_vm._v("Unavailable *")]):_c('formatted-price',{attrs:{"price":_vm.solution.price}})],1)])])
}
var SolutionCardvue_type_template_id_4acf56f2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/SolutionCard.vue?vue&type=script&lang=js&

    
    

    /* harmony default export */ var dsl_SolutionCardvue_type_script_lang_js_ = ({
        props: ['solution', 'selected', 'disableOverride'],
        components: {
            FormattedSpeed: FormattedSpeed,
            FormattedPrice: FormattedPrice
        },
        computed: {
			disabled() {
				return this.solution.available === false && !this.disableOverride;
			},
            solutionPrice() {
                return `R000.00pm`
            },
            solutionSpeed() {
                return `4Mbps`
            }
        },
        methods: {
            select() {
            	if (!this.disabled) {
                	this.$emit('select', this.solution);
				}
            }
        }
    });

;// CONCATENATED MODULE: ./src/modals/dsl/SolutionCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_dsl_SolutionCardvue_type_script_lang_js_ = (dsl_SolutionCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/SolutionCard.vue?vue&type=style&index=0&id=4acf56f2&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/dsl/SolutionCard.vue?vue&type=style&index=0&id=4acf56f2&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/dsl/SolutionCard.vue



;


/* normalize component */

var dsl_SolutionCard_component = (0,componentNormalizer/* default */.Z)(
  modals_dsl_SolutionCardvue_type_script_lang_js_,
  SolutionCardvue_type_template_id_4acf56f2_render,
  SolutionCardvue_type_template_id_4acf56f2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dsl_SolutionCard = (dsl_SolutionCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/Solutions.vue?vue&type=script&lang=js&





/* harmony default export */ var dsl_Solutionsvue_type_script_lang_js_ = ({
	components: {
		ErrorBar: ErrorBar,
		SolutionCard: dsl_SolutionCard,
	},
	computed: {
		solutions() {
			let solutions = [...this.$signup.$store.getters['signupSolutions/solutions']];
			//set line availablility
			solutions.forEach(s => {
				s.available = (this.maxDownloadSpeed >= s.solution_composite_child_metas[0].child_solution.speed_kbps);
				// console.log(s)
				//set unavailable packages if there is an unavailable package
				if (!s.available && !this.unavailablePackages) this.unavailablePackages = true;
				return s
			})
			return solutions.sort((a, b) => {
				// if the prices are the same then sort by download speed
				if (a.price === b.price) {
					let lineChildSolutionA = a.solution_composite_child_metas.find(s => s.child_solution.display_category_slug === 'fibre_line');
					let lineChildSolutionB = b.solution_composite_child_metas.find(s => s.child_solution.display_category_slug === 'fibre_line');
					return lineChildSolutionB.line_download_speed - lineChildSolutionA.line_download_speed;
				}

				// else sort by price
				return a.price > b.price ? 1 : -1;
			});
		},
		selectedSolutionId() {
			let solutions = this.$signup.$store.getters['signupCart/cartItems'],
				solution = solutions.find(s => {
					return s.product_type_slug === 'solution_composite_dsl';
				});

			return solution ? solution.product_id : false;
		},
		place() {
			return this.$signup.$store.getters['signupCoverage/place'];
		}
	},
	methods: {
		selectSolution(solution) {

			if (solution === undefined) return

			let lineChildSolution = solution.solution_composite_child_metas.find(s => {
				return s.child_solution.display_category_slug === 'dsl_telkom_line';
			});

			let dataChildSolution = solution.solution_composite_child_metas.find(s => {
				return s.child_solution.display_category_slug === 'dsl_uncapped_pure';
			});

			let cartItems = [
				{
					product_type_slug: "solution_composite_dsl",
					product_id: solution.id,
					cart_item_requirements: []
				},
				{
					product_type_slug: "solution_dsl_line",
					product_id: lineChildSolution.child_solution.id,
					cart_item_requirements: []
				},
				{
					product_type_slug: "solution_connectivity_data",
					product_id: dataChildSolution.child_solution.id,
					cart_item_requirements: []
				}

			];

			this.$signup.$store.commit('signupCart/setCartItems', cartItems);
		},
		getSolutions() {
			// show loader
			this.$modal.toggleLoader(true);

			//check if client came from I'm sure modal
			let imSureFlag = this.$signup.$store.getters['signupGeneral/imSure'];

			let providers = [];
			let coverage = this.$signup.$store.getters['signupCoverage/coverage'];
			coverage.forEach(v => {
				if (v.solution_type_slug !== 'composite_dsl') return;
				if (v.max_download_speed < 4096) return;

				providers.push({
					name: v.vendor.name,
					slug: v.vendor.slug,
					max_download_speed: v.max_download_speed,
					pre_order: v.pre_order
				});
			});

			if (providers.length < 1 && !imSureFlag) {
				if(this.$signup.$store.getters['signupCoverage/availableUpsellSolutionTypes']) {
					// show upsell
					this.$modal.push('coverage-upsell');
					this.$modal.toggleLoader(false);
					return
				} else {
					this.$modal.push('no-coverage');
					this.$modal.toggleLoader(false);
					return;
				}
			}

			//circumvent max speed if coming from I'm sure modal
			this.maxDownloadSpeed = !imSureFlag ? providers[0].max_download_speed : 40960
			this.$signup.$store.commit('signupSolutions/updateCurrentProvider', providers[0]);

			// get solutions from the openAPI
			let sectionSlug = 'broadband';
			let categorySlug = 'dsl_pure_bundle';
			let provider = this.$signup.$store.getters['signupSolutions/currentProvider'];
			//set provider to openserve because provider will be zero if coming from I'm sure modal
			if (imSureFlag) { provider = { slug: 'openserve_dsl'}; }
			this.$signup.$store.dispatch('signupSolutions/getSolutions', {
				sectionSlug: sectionSlug,
				categorySlug: categorySlug,
				vendorSlug: provider.slug
			})
			.then(r => {
				this.$modal.toggleLoader(false);
				this.selectSolution(this.solutions[0]);
			}, e => {
				this.$modal.toggleLoader(false);
				this.error = true;
			});
		},
		next() {
			// clear error state
			this.error = false;

			// check for a selected solution id
			if (this.selectedSolutionId === false) {
				this.error = 'Please select a package before continuing.';
				return
			}

			let place = encodeURIComponent(JSON.stringify(this.place));
			let url = `https://clientzone.afrihost.com/order/#!/pure-dsl/inject/place=${place}&package_id=${this.selectedSolutionId}`
			window.location.href = url;

		}
	},
	data() {
		return {
			error: false,
			maxDownloadSpeed: 0,
			unavailablePackages: false,
			// selectedSolutionId: false,
			// solutions: []
		}
	},
	mounted() {
		let that = this;
		that.getSolutions();

		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		})

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.next();
		})
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/dsl/Solutions.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_dsl_Solutionsvue_type_script_lang_js_ = (dsl_Solutionsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/Solutions.vue?vue&type=style&index=0&id=2e3f2bdc&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/dsl/Solutions.vue?vue&type=style&index=0&id=2e3f2bdc&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/dsl/Solutions.vue



;


/* normalize component */

var dsl_Solutions_component = (0,componentNormalizer/* default */.Z)(
  modals_dsl_Solutionsvue_type_script_lang_js_,
  Solutionsvue_type_template_id_2e3f2bdc_render,
  Solutionsvue_type_template_id_2e3f2bdc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dsl_Solutions = (dsl_Solutions_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/Sidebar.vue?vue&type=template&id=3dd6ece8&
var Sidebarvue_type_template_id_3dd6ece8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-modal-sidebar"},[_c('div',{staticClass:"provider-logo"},[_c('icon',{attrs:{"name":"product-dsl"}})],1),_vm._m(0)])
}
var Sidebarvue_type_template_id_3dd6ece8_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-feature-table"},[_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("Installation")]),_c('dl',[_c('dt',{staticClass:"strike"},[_vm._v("R999.00")]),_c('dd',[_vm._v("FREE with Afrihost")])])]),_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("DSL Line")]),_c('dl',[_c('dt',[_vm._v("Included")])])]),_c('div',{staticClass:"signup-feature"},[_c('p',[_vm._v("Data")]),_c('dl',[_c('dt',[_vm._v("Uncapped")])])])])
}]


;// CONCATENATED MODULE: ./src/modals/dsl/Sidebar.vue?vue&type=template&id=3dd6ece8&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/Sidebar.vue?vue&type=script&lang=js&

    

    /* harmony default export */ var dsl_Sidebarvue_type_script_lang_js_ = ({
        components: {
            Icon: Icon
        }
    });

;// CONCATENATED MODULE: ./src/modals/dsl/Sidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_dsl_Sidebarvue_type_script_lang_js_ = (dsl_Sidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/dsl/Sidebar.vue





/* normalize component */
;
var dsl_Sidebar_component = (0,componentNormalizer/* default */.Z)(
  modals_dsl_Sidebarvue_type_script_lang_js_,
  Sidebarvue_type_template_id_3dd6ece8_render,
  Sidebarvue_type_template_id_3dd6ece8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dsl_Sidebar = (dsl_Sidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/ManualCheckConfirmation.vue?vue&type=template&id=7c720528&scoped=true&
var ManualCheckConfirmationvue_type_template_id_7c720528_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('h6',{staticClass:"thick"},[_vm._v(" After you place your order, we’ll have to first manually check with Openserve if your area does in fact have DSL coverage. ")]),_c('p',{staticClass:"highlight"},[_vm._v("This may delay your order at "+_vm._s(_vm.formattedAddress)+" by a few days.")]),_c('p',[_vm._v("If you don’t have coverage, your order will be cancelled. If you do have coverage, we’ll continue processing your order. You’ll only be charged once your order is complete and your services are active. ")])])
}
var ManualCheckConfirmationvue_type_template_id_7c720528_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/ManualCheckConfirmation.vue?vue&type=script&lang=js&



/* harmony default export */ var ManualCheckConfirmationvue_type_script_lang_js_ = ({
	computed: {
		formattedAddress() {
			return this.$signup.$store.getters['signupCoverage/formattedAddress']
		}
	},
	mounted() {
		let that = this;

		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('coverage');
		})

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.$modal.push('dsl-solutions')
		})
	},
});

;// CONCATENATED MODULE: ./src/modals/dsl/ManualCheckConfirmation.vue?vue&type=script&lang=js&
 /* harmony default export */ var dsl_ManualCheckConfirmationvue_type_script_lang_js_ = (ManualCheckConfirmationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/dsl/ManualCheckConfirmation.vue?vue&type=style&index=0&id=7c720528&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/dsl/ManualCheckConfirmation.vue?vue&type=style&index=0&id=7c720528&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/dsl/ManualCheckConfirmation.vue



;


/* normalize component */

var ManualCheckConfirmation_component = (0,componentNormalizer/* default */.Z)(
  dsl_ManualCheckConfirmationvue_type_script_lang_js_,
  ManualCheckConfirmationvue_type_template_id_7c720528_scoped_true_render,
  ManualCheckConfirmationvue_type_template_id_7c720528_scoped_true_staticRenderFns,
  false,
  null,
  "7c720528",
  null
  
)

/* harmony default export */ var ManualCheckConfirmation = (ManualCheckConfirmation_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Sidebar.vue?vue&type=template&id=151c2bea&
var Sidebarvue_type_template_id_151c2bea_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-modal-sidebar"},[_c('a',{staticClass:"oauth-button google",attrs:{"href":_vm.oAuthUrl('google')},on:{"click":function($event){return $event.preventDefault()}}},[_c('Icon',{attrs:{"name":"social-google"}}),_c('span',{staticClass:"btn-text"},[_vm._v("Login with Google")])],1),_c('a',{staticClass:"oauth-button facebook",attrs:{"href":_vm.oAuthUrl('facebook')},on:{"click":function($event){return $event.preventDefault()}}},[_c('Icon',{attrs:{"name":"social-facebook"}}),_c('span',{staticClass:"btn-text"},[_vm._v("Login with Facebook")])],1),_c('a',{staticClass:"oauth-button github",attrs:{"href":_vm.oAuthUrl('github')},on:{"click":function($event){return $event.preventDefault()}}},[_c('Icon',{attrs:{"name":"social-github"}}),_c('span',{staticClass:"btn-text"},[_vm._v("Login with GitHub")])],1)])
}
var Sidebarvue_type_template_id_151c2bea_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Sidebar.vue?vue&type=script&lang=js&



/* harmony default export */ var auth_Sidebarvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon
	},
	computed: {
		authType() {

		},
	},
	methods: {
		oAuthUrl(provider) {
			return `https://clientzone.afrihost.com/en/oauth/${provider}/external/redirect?oauth_source_application=${({"NODE_ENV":"production","VUE_APP_MIX_SIGNUP_PLUGIN_TEST":"true","VUE_APP_MIX_SIGNUP_PLUGIN_PAGE_REQUESTED_FROM":"fibre","VUE_APP_MIX_SIGNUP_PLUGIN_STORE_KEY":"ah-fibre","VUE_APP_MIX_SIGNUP_PLUGIN_X20_2_IN_STOCK":"false","VUE_APP_MIX_SIGNUP_PLUGIN_X20_3_IN_STOCK":"false","VUE_APP_MIX_SIGNUP_PLUGIN_FIBRE_FREEZE":"true","VUE_APP_MIX_SIGNUP_PLUGIN_GOOGLE_KEY":"AIzaSyAR0tRxfMAitJmiDk-JrRmxF8KW7vozAPo","BASE_URL":"/"}).VUE_OAUTH_LOGIN_APP_NAME}`
		},
	}
});

;// CONCATENATED MODULE: ./src/modals/auth/Sidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_auth_Sidebarvue_type_script_lang_js_ = (auth_Sidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Sidebar.vue?vue&type=style&index=0&id=151c2bea&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/auth/Sidebar.vue?vue&type=style&index=0&id=151c2bea&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/auth/Sidebar.vue



;


/* normalize component */

var auth_Sidebar_component = (0,componentNormalizer/* default */.Z)(
  modals_auth_Sidebarvue_type_script_lang_js_,
  Sidebarvue_type_template_id_151c2bea_render,
  Sidebarvue_type_template_id_151c2bea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var auth_Sidebar = (auth_Sidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Login.vue?vue&type=template&id=32926c44&
var Loginvue_type_template_id_32926c44_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"info-bar"},[_c('p',[_vm._v("Don't have an account? "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.gotoSignUp}},[_vm._v("Create a new account")]),_vm._v(" | Forgot your password? "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.gotoForgotPassword}},[_vm._v("Reset your password")])])]),_c('form',{staticClass:"signup-form password-orphan",on:{"keypress":_vm.enterHandler}},[_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"on","label":"Email address","type":"email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"current-password","label":"Password","type":"password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._m(0),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var Loginvue_type_template_id_32926c44_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("By logging in you accept our "),_c('a',{attrs:{"href":"https://www.afrihost.com/terms-and-conditions","target":"_blank"}},[_vm._v("Terms and Conditions")])])
}]


;// CONCATENATED MODULE: ./src/modals/auth/Login.vue?vue&type=template&id=32926c44&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Login.vue?vue&type=script&lang=js&






/* harmony default export */ var Loginvue_type_script_lang_js_ = ({
	components: {
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {},
	methods: {
		login() {
			if (this.form.email === '' || !this.form.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
				this.error = {message: "Please fill in a valid email address"};
				return;
			} else if (this.form.password === '') {
				this.error = {message: "Password cannot be empty"};
				return;
			}
			// clear error bar & show loader
			this.error = false;
			this.$modal.toggleLoader(true);

			// hit api
			this.$signup.$store.dispatch('signupUser/login', this.form)
				.then(r => {
					this.$signup.$store.dispatch('signupSignal/identify', {
						email: this.form.email
					})
					this.$modal.push('welcome-back');

					this.$signup.$store.dispatch('signupSignal/sendEvent', {
						type: 'account-login',
						value: null,
						meta: null,
					})
				})
				.catch((err) => {
					this.error = err;
					this.$modal.toggleLoader(false);
				});
		},
		gotoSignUp(e) {
			e.preventDefault();
			this.$modal.push('auth-signup');
		},
		gotoForgotPassword(e) {
			e.preventDefault();
			this.$modal.push('auth-forgot-password');
		},
		enterHandler(e) {
			if (e.key === 'Enter') {
				this.login();
			}
		}
	},
	data() {
		return {
			error: false,
			form: {
				email: '',
				password: ''
			}
		}
	},
	mounted() {
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.login();
		});

		this.$modal.toggleLoader(true);
		// is user token available
		if (this.$signup.$store.getters['signupUser/token'] !== false && this.$signup.$store.getters['signupUser/token'] !== "") {
			//refresh JWT token
			this.$signup.$store.dispatch('signupUser/refreshToken').then(() => {
				this.$modal.push('welcome-back');
			}).catch((err) => {
				console.error(err)
				this.$modal.toggleLoader(false);
			});
		} else {
			this.$modal.toggleLoader(false);
		}
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/auth/Login.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_Loginvue_type_script_lang_js_ = (Loginvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/auth/Login.vue





/* normalize component */
;
var Login_component = (0,componentNormalizer/* default */.Z)(
  auth_Loginvue_type_script_lang_js_,
  Loginvue_type_template_id_32926c44_render,
  Loginvue_type_template_id_32926c44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Login = (Login_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Register.vue?vue&type=template&id=579653de&
var Registervue_type_template_id_579653de_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"info-bar"},[_c('p',[_vm._v("Already have an account? "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.gotoLogin}},[_vm._v("Log in")])])]),_c('form',{staticClass:"signup-form password-orphan"},[_c('signup-input',{attrs:{"type":"email","label":"Email address","autocomplete":"email","disabled":false,"required":true,"error":false},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('signup-input',{attrs:{"type":"password","label":"Password","autocomplete":"password","disabled":false,"required":true,"error":false},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}}),_c('signup-input',{attrs:{"type":"password","label":"Confirm password","autocomplete":"off","disabled":false,"required":true,"error":false},model:{value:(_vm.form.confirmPassword),callback:function ($$v) {_vm.$set(_vm.form, "confirmPassword", $$v)},expression:"form.confirmPassword"}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var Registervue_type_template_id_579653de_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/Register.vue?vue&type=script&lang=js&






/* harmony default export */ var Registervue_type_script_lang_js_ = ({
	components: {
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {

	},
	methods: {
		createProfile() {

			// clear error bar & show loader
			this.error = false;
			this.$modal.toggleLoader(true);

			// save profile to store
			this.$signup.$store.commit('signupUser/updateUser', this.form);

			let data = {
				product: 'signup',
				type: 'account-create-start',
				value: 0,
				location: 'website',
				email: this.$signup.$store.getters['signupUser/user'].email,
			}
			this.$signup.$store.dispatch('signupCart/logAct', data);

			let conversionValue = this.$signup.$store.getters['signupSolutions/selectedSolution'].price
			let email = this.$signup.$store.getters['signupUser/user'].email
			data = {
				product: 'fibre', // @TODO - make dynamic when signing up other solution types in future
				type: 'coverage-check',
				value: conversionValue,
				location: 'website',
				email: email,
				ac_meta: [
					{
						field: 8,
						value: this.$signup.$store.getters['signupCoverage/formattedAddress'],
					},
					{
						field: 9,
						value:  this.$signup.$store.getters['signupSolutions/selectedSolution'].vendor.name
					},
					{
						field: 10,
						value: this.$signup.$store.getters['signupSolutions/selectedSolution'].name
					}
				]
			}
			this.$signup.$store.dispatch('signupCart/logAct', data);

			this.$modal.push('auth-create-account');
		},
		gotoLogin(e) {
			e.preventDefault();
			this.$modal.push('auth-login');
		}
	},
	data() {
		return {
			error: false,
			form: {
				email: '',
				password: '',
				confirmPassword: '',
			}
		}
	},
	mounted() {
		this.$modal.toggleLoader(false);

		if (this.$signup.$store.getters['signupUser/token'] !== false && this.$signup.$store.getters['signupUser/token'] !== "") {
			this.$modal.push('auth-login');
			return
		}


		this.form = {
			...this.form,
			...this.$signup.$store.getters['signupUser/user']
		};
		//populate countries for next page
		this.$signup.$store.dispatch('signupGeneral/fetchCountries');

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.form.email === '' || !that.form.email.match(/^[\w\d._%+-]+@([\w\d.-]+\.)+[\w-]{2,}$/)) {
				that.error = { message:"Please fill in a valid email address" };
			} else if (that.form.password === '') {
				that.error = { message:"Password cannot be empty" };
			} else if (that.form.password.length < 8) {
				that.error = { message:"Password must be longer than 7 characters" };
			} else if (that.form.password !== that.form.confirmPassword) {
				that.error = { message:"Passwords do not match" };
			} else {
				that.createProfile();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	},
});

;// CONCATENATED MODULE: ./src/modals/auth/Register.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_Registervue_type_script_lang_js_ = (Registervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/auth/Register.vue





/* normalize component */
;
var Register_component = (0,componentNormalizer/* default */.Z)(
  auth_Registervue_type_script_lang_js_,
  Registervue_type_template_id_579653de_render,
  Registervue_type_template_id_579653de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Register = (Register_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/CreateAccount.vue?vue&type=template&id=084a97ea&scoped=true&
var CreateAccountvue_type_template_id_084a97ea_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[(_vm.testSignup)?_c('p',{staticClass:"warn"},[_vm._v("Your account will be validated, but will not be saved because this is a development build.")]):_vm._e(),_c('form',{staticClass:"signup-form create-account"},[_c('div',{staticClass:"form-left"},[_c('h3',[_vm._v("Personal information")]),_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"first_name","label":"First name","type":"text"},model:{value:(_vm.form.first_name),callback:function ($$v) {_vm.$set(_vm.form, "first_name", $$v)},expression:"form.first_name"}}),_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"last_name","label":"Last name","type":"text"},model:{value:(_vm.form.last_name),callback:function ($$v) {_vm.$set(_vm.form, "last_name", $$v)},expression:"form.last_name"}}),_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"cell_number","label":"Contact number","type":"tel"},model:{value:(_vm.form.cell_number),callback:function ($$v) {_vm.$set(_vm.form, "cell_number", $$v)},expression:"form.cell_number"}})],1),_c('div',{staticClass:"form-right"},[_c('h3',[_vm._v("Identification")]),_c('signup-tabs',{attrs:{"options":_vm.identityOptions,"selected":_vm.form.identity_type},on:{"select":_vm.toggleID}}),(_vm.form.identity_type === 'id_number')?_c('div',{ref:"id_input"},[_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"id number","label":"South African ID number","type":"tel"},model:{value:(_vm.form.id_number),callback:function ($$v) {_vm.$set(_vm.form, "id_number", $$v)},expression:"form.id_number"}})],1):_vm._e(),(_vm.form.identity_type === 'passport')?_c('div',{ref:"passport_input"},[_c('signup-select',{attrs:{"disabled":false,"error":false,"options":_vm.countries,"required":true,"label":"Country"},model:{value:(_vm.form.passport_country_code),callback:function ($$v) {_vm.$set(_vm.form, "passport_country_code", $$v)},expression:"form.passport_country_code"}}),_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"passport","label":"Passport number","type":"text"},model:{value:(_vm.form.id_number),callback:function ($$v) {_vm.$set(_vm.form, "id_number", $$v)},expression:"form.id_number"}})],1):_vm._e()],1)]),_c('div',{staticClass:"terms"},[_c('signup-checkbox',{model:{value:(_vm.acceptTnc),callback:function ($$v) {_vm.acceptTnc=$$v},expression:"acceptTnc"}}),_vm._m(0)],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var CreateAccountvue_type_template_id_084a97ea_scoped_true_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("By creating an Afrihost account you accept all "),_c('a',{attrs:{"href":"https://www.afrihost.com/terms-and-conditions","target":"_blank"}},[_vm._v("Terms and Conditions")])])
}]


;// CONCATENATED MODULE: ./src/modals/auth/CreateAccount.vue?vue&type=template&id=084a97ea&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupCheckbox.vue?vue&type=template&id=2f1404a8&
var SignupCheckboxvue_type_template_id_2f1404a8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-checkbox",class:{'has-value': _vm.value, 'focused': _vm.focused}},[_c('input',{ref:"input",attrs:{"type":"checkbox","autocomplete":"off","disabled":_vm.disabled},domProps:{"value":!!_vm.value},on:{"input":function($event){return _vm.update()},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}}),_vm._m(0)])
}
var SignupCheckboxvue_type_template_id_2f1404a8_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"checkbox-control"},[_c('span')])
}]


;// CONCATENATED MODULE: ./src/components/forms/SignupCheckbox.vue?vue&type=template&id=2f1404a8&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupCheckbox.vue?vue&type=script&lang=js&



/* harmony default export */ var SignupCheckboxvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon,
	},
	props: [
		'disabled',
		'label',
		'required',
		'value',
	],
	methods: {
		update() {
			this.$emit('input', this.$refs.input.checked)
		}
	},
	data() {
		return {
			focused: false,
		}
	},
});

;// CONCATENATED MODULE: ./src/components/forms/SignupCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_SignupCheckboxvue_type_script_lang_js_ = (SignupCheckboxvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/SignupCheckbox.vue?vue&type=style&index=0&id=2f1404a8&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/forms/SignupCheckbox.vue?vue&type=style&index=0&id=2f1404a8&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/forms/SignupCheckbox.vue



;


/* normalize component */

var SignupCheckbox_component = (0,componentNormalizer/* default */.Z)(
  forms_SignupCheckboxvue_type_script_lang_js_,
  SignupCheckboxvue_type_template_id_2f1404a8_render,
  SignupCheckboxvue_type_template_id_2f1404a8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignupCheckbox = (SignupCheckbox_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/CreateAccount.vue?vue&type=script&lang=js&








/* harmony default export */ var CreateAccountvue_type_script_lang_js_ = ({
	components: {SignupTabs: SignupTabs, SignupSelect: SignupSelect, SignupInput: SignupInput, ErrorBar: ErrorBar, SignupCheckbox: SignupCheckbox},
	computed: {
		countries() {
			let countries = [...this.$signup.$store.getters['signupGeneral/countries']];
			return countries.map((c) => {
				return {
					"label": c.name,
					"value": c.code
				}
			})
		},
		testSignup() {
			return this.$signup.$store.getters['signupGeneral/testSignup'];
		}
	},
	data() {
		return {
			error: false,
			form: {
				first_name: '',
				last_name: '',
				cell_number: '',
				identity_type: 'id_number',
				id_number: '',
				passport_country: '',
			},
			acceptTnc: false,
			identityOptions: [
				{
					value: 'id_number',
					label: "South African ID",
				},
				{
					value: 'passport',
					label: "Passport",
				}
			],
		}
	},
	methods: {
		createProfile() {

			// clear error bar & show loader
			this.error = false;
			this.$modal.toggleLoader(true);

			// save profile to store
			this.$signup.$store.commit('signupUser/updateUser', this.form);

			this.$signup.$store.dispatch('signupUser/register').then((response) => {
				let data = {
					product: 'signup',
					type: 'account-create-complete',
					value: 0,
					location: 'website',
					email: this.$signup.$store.getters['signupUser/user'].email,
					first_name: this.$signup.$store.getters['signupUser/user'].first_name,
					last_name: this.$signup.$store.getters['signupUser/user'].last_name
				}
				this.$signup.$store.dispatch('signupCart/logAct', data);

				this.$signup.$store.dispatch('signupSignal/identify', {
					email: this.$signup.$store.getters['signupUser/user'].email
				})

				this.$signup.$store.dispatch('signupSignal/sendEvent', {
					type: 'account-register',
					value: null,
					meta: null,
				})

				this.$modal.push('account-created');
			}).catch((err) => {
				this.$modal.toggleLoader(false);
				this.error = err;
			});
		},
		toggleID(type) {
			switch (type) {
				case 'id_number':
					this.form.passport_country_code = '';
					this.form.identity_type = 'id_number';
					break;
				case 'passport':
					this.form.identity_type = 'passport';
			}
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);
		this.form = {
			...this.form,
			...JSON.parse(JSON.stringify(this.$signup.$store.getters['signupUser/user']))
		};

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.form.identity_type === 'id_number' && (that.form.id_number === '' || !that.form.id_number.match(/(\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8]))|([02468][048]|[13579][26])0229)(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/))) {
				that.error = {message: "Please fill in a valid South African ID Number"};
			} else if (that.form.identity_type === 'passport' && that.form.passport_country_code === '') {
				that.error = {message: "Please provide your country"};
			} else if (that.form.id_number === '') {
				that.error = {message: "Please fill in a valid Passport number"};
			} else if (that.form.first_name === '') {
				that.error = {message: "First name cannot be empty"};
			} else if (that.form.last_name === '') {
				that.error = {message: "Last name cannot be empty"};
			} else if (that.form.cell_number === '') {
				that.error = {message: "Contact number cannot be empty"};
			} else if (!that.acceptTnc) {
				that.error = {message: "Please accept the terms and conditions."};
			} else {
				that.createProfile();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	},
});

;// CONCATENATED MODULE: ./src/modals/auth/CreateAccount.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_CreateAccountvue_type_script_lang_js_ = (CreateAccountvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/CreateAccount.vue?vue&type=style&index=0&id=084a97ea&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/auth/CreateAccount.vue?vue&type=style&index=0&id=084a97ea&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/auth/CreateAccount.vue



;


/* normalize component */

var CreateAccount_component = (0,componentNormalizer/* default */.Z)(
  auth_CreateAccountvue_type_script_lang_js_,
  CreateAccountvue_type_template_id_084a97ea_scoped_true_render,
  CreateAccountvue_type_template_id_084a97ea_scoped_true_staticRenderFns,
  false,
  null,
  "084a97ea",
  null
  
)

/* harmony default export */ var CreateAccount = (CreateAccount_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/OTP.vue?vue&type=template&id=c4f10d6e&
var OTPvue_type_template_id_c4f10d6e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_vm._m(0),_c('form',{staticClass:"signup-form",attrs:{"autocomplete":"off"}},[_c('otp-input',{attrs:{"required":true,"error":false},on:{"submit":function($event){return _vm.verifyOTP()}},model:{value:(_vm.otp),callback:function ($$v) {_vm.otp=$$v},expression:"otp"}})],1),_c('error-bar',{attrs:{"error":_vm.error}})],1)
}
var OTPvue_type_template_id_c4f10d6e_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("We have sent you an One Time Pin (OTP) to your primary contact detail (SMS or email). "),_c('br'),_vm._v("Please enter the OTP below to continue.")])
}]


;// CONCATENATED MODULE: ./src/modals/auth/OTP.vue?vue&type=template&id=c4f10d6e&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/OtpInput.vue?vue&type=template&id=5d440442&
var OtpInputvue_type_template_id_5d440442_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-input otp-holder",class:{'has-value': _vm.value && _vm.value.length}},_vm._l((_vm.otpValue),function(otpChar,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otpValue[index]),expression:"otpValue[index]"}],ref:`otp`,refInFor:true,staticClass:"otp-input",attrs:{"autocomplete":"one-time-code","type":"tel"},domProps:{"value":(_vm.otpValue[index])},on:{"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.otpValue, index, $event.target.value)},function($event){return _vm.update($event, index)}],"focus":function($event){return _vm.focus($event, index)}}})}),0)
}
var OtpInputvue_type_template_id_5d440442_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/OtpInput.vue?vue&type=script&lang=js&

	

	/* harmony default export */ var OtpInputvue_type_script_lang_js_ = ({
		components: {
			Icon: Icon,
		},
		props: [
			'required',
			'value',
		],
		watch: {
			value(value) {
				if (value === false || value === "") {
					this.otpValue = ['','','','',];
					this.focus(null, 0);
				}
			}
		},
		methods: {
			update(event, index) {
				if (event.target.value.length > 1) {
					this.otpValue[index] = event.target.value[event.target.value.length-1]
				}
				this.$emit('input', this.otpValue.join(''))

				//if it's the last block, emit submit function
				if (index === this.otpValue.length - 1) {
					this.$emit('submit');
				}
				//if it's not the last block, go to next block
				else if (event.target.value.length > 0 && index !== this.otpValue.length-1) {
					this.$refs['otp'][index+1].focus()
				}
				//if we backspaced, go to prev block
				else if (event.target.value.length === 0 && index > 0) {
					this.otpValue[index] = '';
					let prevInput = this.$refs['otp'][index - 1]
					// prevInput.focus()
					prevInput.select()
					// prevInput.setSelectionRange(0, 1)
					event.preventDefault()
				}
			},
			focus(event, index) {
				this.$refs['otp'][index].select()
			},
			updateValue(value) {
				this.otpValue = value.toString().split();
			},
		},
		data() {
			return {
				otpValue: ['','','','',]
			}
		},
		mounted() {
			this.focus(null, 0);
		},
	});

;// CONCATENATED MODULE: ./src/components/forms/OtpInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_OtpInputvue_type_script_lang_js_ = (OtpInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/forms/OtpInput.vue?vue&type=style&index=0&id=5d440442&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/forms/OtpInput.vue?vue&type=style&index=0&id=5d440442&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/forms/OtpInput.vue



;


/* normalize component */

var OtpInput_component = (0,componentNormalizer/* default */.Z)(
  forms_OtpInputvue_type_script_lang_js_,
  OtpInputvue_type_template_id_5d440442_render,
  OtpInputvue_type_template_id_5d440442_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OtpInput = (OtpInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/OTP.vue?vue&type=script&lang=js&






/* harmony default export */ var OTPvue_type_script_lang_js_ = ({
	components: {
		OtpInput: OtpInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {

	},
	methods: {
		verifyOTP() {

			// clear error bar & show loader
			this.error = false;
			this.$modal.toggleLoader(true);

			// hit api
			this.$signup.$store.dispatch('signupUser/verifyOTP', this.otp).then(token => {
				this.$modal.toggleLoader(false);

				// store the updated token - already handled by store action

				// go to the previous screen
				this.$modal.push(this.$modal.state.previous.name);

			}, (err) => {
				this.error = err;
				if (err.slug === "otp_verification_failed") {
					this.error.message = "The OTP you filled in was incorrect.";
				}
				this.otp = '';
				this.$modal.toggleLoader(false);
			});
		}
	},
	data() {
		return {
			error: false,
			otp: '',
		}
	},
	mounted() {

		this.$modal.toggleLoader(false);

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.verifyOTP();
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/auth/OTP.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_OTPvue_type_script_lang_js_ = (OTPvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/auth/OTP.vue





/* normalize component */
;
var OTP_component = (0,componentNormalizer/* default */.Z)(
  auth_OTPvue_type_script_lang_js_,
  OTPvue_type_template_id_c4f10d6e_render,
  OTPvue_type_template_id_c4f10d6e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OTP = (OTP_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/WelcomeBack.vue?vue&type=template&id=76d8ff7c&scoped=true&
var WelcomeBackvue_type_template_id_76d8ff7c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":_vm.logoX1,"srcset":`${_vm.logoX1} 1x, ${_vm.logoX2}  2x`}})]),(_vm.user)?_c('h1',[_vm._v(" Welcome back, "+_vm._s(_vm.user.first_name)+"! ")]):_c('h1',[_vm._v(" Welcome back! ")]),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Continue with order ")]),_c('a',{staticClass:"logout-button",attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("That's not me")])])
}
var WelcomeBackvue_type_template_id_76d8ff7c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/assets/images/afrihost-logo.png
var afrihost_logo_namespaceObject = __webpack_require__.p + "img/afrihost-logo.6b2b4e0b.png";
;// CONCATENATED MODULE: ./src/assets/images/afrihost-logo@2x.png
var afrihost_logo_2x_namespaceObject = __webpack_require__.p + "img/afrihost-logo@2x.1c67f576.png";
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/WelcomeBack.vue?vue&type=script&lang=js&



/* harmony default export */ var WelcomeBackvue_type_script_lang_js_ = ({
	data() {
		return {
			logoX1: afrihost_logo_namespaceObject,
			logoX2: afrihost_logo_2x_namespaceObject,
		}
	},
	computed: {
		user() {
			return this.$signup.$store.getters['signupUser/user'];
		}
	},
	methods: {
		trackEvent(product) {
			let conversionValue = this.$signup.$store.getters['signupSolutions/selectedSolution'].price
			let email = this.$signup.$store.getters['signupUser/user'].email
			let data = {
				product: product,
				type: 'coverage-check',
				value: conversionValue,
				location: 'website',
				email: email,
				first_name: this.$signup.$store.getters['signupUser/user'].first_name,
				last_name: this.$signup.$store.getters['signupUser/user'].last_name,
				ac_meta: [
					{
						field: 8,
						value: this.$signup.$store.getters['signupCoverage/formattedAddress'],
					},
					{
						field: 9,
						value:  this.$signup.$store.getters['signupSolutions/selectedSolution'].vendor.name
					},
					{
						field: 10,
						value: this.$signup.$store.getters['signupSolutions/selectedSolution'].name
					}
				]
			}
			this.$signup.$store.dispatch('signupCart/logAct', data);
		},
		next() {
			//check which solution type we are on, and push to the correct modal
			switch (this.$signup.$store.getters['signupSolutions/solutions'][0].solution_type) {
				case 'composite_dsl':
					this.$modal.push('dsl-installation');
					break;
				case 'connectivity_mobile':
					this.$modal.push('404');
					this.trackEvent('lte')
					break;
				case 'composite_fibre':
					this.$modal.push('fibre-installation');
					this.trackEvent('fibre')
					break;
			}
		},
		logout() {
			this.$signup.$store.commit('signupUser/updateToken', '');
			this.$signup.$store.commit('signupUser/updateUser', false);
			this.user = false;
			this.$modal.push('auth-login');
		}
	},
	mounted() {
		if (this.user.first_name) {
			this.$modal.toggleLoader(false);
			this.next();
		} else {
			this.$signup.$store.dispatch('signupUser/getClientContact').then(() => {
				this.$modal.toggleLoader(false);
			});
		}
	}

});

;// CONCATENATED MODULE: ./src/modals/auth/WelcomeBack.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_WelcomeBackvue_type_script_lang_js_ = (WelcomeBackvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/WelcomeBack.vue?vue&type=style&index=0&id=76d8ff7c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/auth/WelcomeBack.vue?vue&type=style&index=0&id=76d8ff7c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/auth/WelcomeBack.vue



;


/* normalize component */

var WelcomeBack_component = (0,componentNormalizer/* default */.Z)(
  auth_WelcomeBackvue_type_script_lang_js_,
  WelcomeBackvue_type_template_id_76d8ff7c_scoped_true_render,
  WelcomeBackvue_type_template_id_76d8ff7c_scoped_true_staticRenderFns,
  false,
  null,
  "76d8ff7c",
  null
  
)

/* harmony default export */ var WelcomeBack = (WelcomeBack_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/AccountCreated.vue?vue&type=template&id=2693021d&scoped=true&
var AccountCreatedvue_type_template_id_2693021d_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":_vm.logoX1,"srcset":`${_vm.logoX1} 1x, ${_vm.logoX2}  2x`}})]),_c('h1',[_vm._v("Afrihost account created")]),(_vm.testSignup)?_c('p',{staticClass:"warn"},[_vm._v("Your account validation was successful but was not saved because this is a development build.")]):_vm._e(),_c('button',{staticClass:"signup-button",on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v(" Continue with order ")])])
}
var AccountCreatedvue_type_template_id_2693021d_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/AccountCreated.vue?vue&type=script&lang=js&



/* harmony default export */ var AccountCreatedvue_type_script_lang_js_ = ({
	computed: {
		user() {
			return this.$signup.$store.getters['signupUser/user'];
		},
		testSignup() {
			return this.$signup.$store.getters['signupGeneral/testSignup'];
		}
	},
	data() {
		return {
			logoX1: afrihost_logo_namespaceObject,
			logoX2: afrihost_logo_2x_namespaceObject,
		}
	},
	methods: {
		async next() {
			this.$modal.toggleLoader(true);
			await this.$signup.$store.dispatch('signupUser/login', {
				email: this.user.email,
				password: this.user.password
			})

			//check which solution type we are on, and push to the correct modal
			switch (this.$signup.$store.getters['signupSolutions/solutions'][0].solution_type) {
				case 'composite_dsl':
					this.$modal.push('dsl-installation');
					break;
				case 'connectivity_mobile':
					this.$modal.push('404');
					break;
				case 'composite_fibre':
					this.$modal.push('fibre-installation');
					break;
			}
			this.$modal.toggleLoader(false);
		},
		logout() {
			this.$signup.$store.commit('signupUser/updateToken', '');
			this.$modal.push('auth-login');
		}
	},
	mounted() {
		this.$modal.toggleLoader(false);
	}

});

;// CONCATENATED MODULE: ./src/modals/auth/AccountCreated.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_AccountCreatedvue_type_script_lang_js_ = (AccountCreatedvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/AccountCreated.vue?vue&type=style&index=0&id=2693021d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/auth/AccountCreated.vue?vue&type=style&index=0&id=2693021d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/auth/AccountCreated.vue



;


/* normalize component */

var AccountCreated_component = (0,componentNormalizer/* default */.Z)(
  auth_AccountCreatedvue_type_script_lang_js_,
  AccountCreatedvue_type_template_id_2693021d_scoped_true_render,
  AccountCreatedvue_type_template_id_2693021d_scoped_true_staticRenderFns,
  false,
  null,
  "2693021d",
  null
  
)

/* harmony default export */ var AccountCreated = (AccountCreated_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/ForgotPassword.vue?vue&type=template&id=47c17e69&
var ForgotPasswordvue_type_template_id_47c17e69_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_vm._m(0),_c('form',{staticClass:"signup-form"},[_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"email","label":"Email address","type":"email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('signup-input',{attrs:{"disabled":false,"error":false,"required":true,"autocomplete":"off","label":"Confirm email address","type":"email"},model:{value:(_vm.form.confirmEmail),callback:function ($$v) {_vm.$set(_vm.form, "confirmEmail", $$v)},expression:"form.confirmEmail"}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var ForgotPasswordvue_type_template_id_47c17e69_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-bar discrete"},[_c('p',[_vm._v("Enter your ClientZone email address below. We’ll send you reset instructions via email.")])])
}]


;// CONCATENATED MODULE: ./src/modals/auth/ForgotPassword.vue?vue&type=template&id=47c17e69&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/ForgotPassword.vue?vue&type=script&lang=js&






/* harmony default export */ var ForgotPasswordvue_type_script_lang_js_ = ({
	components: {
		SignupInput: SignupInput,
		ErrorBar: ErrorBar,
		Icon: Icon
	},
	computed: {},
	methods: {
		resetPassword() {
			this.$modal.toggleLoader(true)
			this.$signup.$store.commit('signupUser/updateUser', { email: this.form.email });

			this.$signup.$store.dispatch('signupUser/forgotPassword').then((response) => {
				// console.log(response);
				this.$modal.push('auth-password-reset-complete');
			}).catch((err) => {
				this.$modal.toggleLoader(false)
				this.error = err;

				if (this.error.slug === 'rate_limited') {
					this.error = { message: 'You have tried to reset your password too many times. Please contact support.' };
				}
			});

		},
	},
	data() {
		return {
			error: false,
			form: {
				email: '',
				confirmEmail: ''
			}
		}
	},
	mounted() {
		this.$modal.toggleLoader(false);
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.form.email === '' || !that.form.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
				that.error = {message: "Please fill in a valid email address"};
			} else if (that.form.email !== that.form.confirmEmail) {
				that.error = {message: "Email addresses do not match"};
			} else {
				that.resetPassword();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	},
});

;// CONCATENATED MODULE: ./src/modals/auth/ForgotPassword.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_ForgotPasswordvue_type_script_lang_js_ = (ForgotPasswordvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/auth/ForgotPassword.vue





/* normalize component */
;
var ForgotPassword_component = (0,componentNormalizer/* default */.Z)(
  auth_ForgotPasswordvue_type_script_lang_js_,
  ForgotPasswordvue_type_template_id_47c17e69_render,
  ForgotPasswordvue_type_template_id_47c17e69_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ForgotPassword = (ForgotPassword_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/PasswordResetConfirmation.vue?vue&type=template&id=5f57129d&scoped=true&
var PasswordResetConfirmationvue_type_template_id_5f57129d_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"tick-circle"}})],1),_c('h1',[_vm._v(" Password reset instructions sent ")]),_c('p',[_vm._v(" Instructions sent to "+_vm._s(_vm.email)+" ")]),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Log in ")])])
}
var PasswordResetConfirmationvue_type_template_id_5f57129d_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/PasswordResetConfirmation.vue?vue&type=script&lang=js&




/* harmony default export */ var PasswordResetConfirmationvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	data() {
		return {
			logoX1: afrihost_logo_namespaceObject,
			logoX2: afrihost_logo_2x_namespaceObject,
		}
	},
	computed: {
		email() {
			return this.$signup.$store.getters['signupUser/user'].email
		}
	},
	methods: {
		next() {
			this.$modal.push('auth-login');
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);
	}

});

;// CONCATENATED MODULE: ./src/modals/auth/PasswordResetConfirmation.vue?vue&type=script&lang=js&
 /* harmony default export */ var auth_PasswordResetConfirmationvue_type_script_lang_js_ = (PasswordResetConfirmationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/auth/PasswordResetConfirmation.vue?vue&type=style&index=0&id=5f57129d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/auth/PasswordResetConfirmation.vue?vue&type=style&index=0&id=5f57129d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/auth/PasswordResetConfirmation.vue



;


/* normalize component */

var PasswordResetConfirmation_component = (0,componentNormalizer/* default */.Z)(
  auth_PasswordResetConfirmationvue_type_script_lang_js_,
  PasswordResetConfirmationvue_type_template_id_5f57129d_scoped_true_render,
  PasswordResetConfirmationvue_type_template_id_5f57129d_scoped_true_staticRenderFns,
  false,
  null,
  "5f57129d",
  null
  
)

/* harmony default export */ var PasswordResetConfirmation = (PasswordResetConfirmation_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryAddress.vue?vue&type=template&id=3288d95d&
var DeliveryAddressvue_type_template_id_3288d95d_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('button',{staticClass:"signup-button add-button",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.newLocation.apply(null, arguments)}}},[_c('icon',{attrs:{"name":"plus-circle"}}),_c('span',[_vm._v("Add new address")])],1),_c('div',{staticClass:"card-container"},_vm._l((_vm.locations),function(location){return _c('address-card',{key:location.id,attrs:{"location":location},on:{"select":_vm.selectAddress}})}),1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var DeliveryAddressvue_type_template_id_3288d95d_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/AddressCard.vue?vue&type=template&id=fc9174fc&
var AddressCardvue_type_template_id_fc9174fc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-card",class:{selected: _vm.selected},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"info"},[(_vm.hasCustomName)?_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.location.name))]):_vm._e(),(_vm.location.building_number)?_c('p',[_vm._v(_vm._s(_vm.location.building_number)+", "+_vm._s(_vm.location.building_name))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.location.street_number)+", "+_vm._s(_vm.location.street_name))]),_c('p',[_vm._v(_vm._s(_vm.location.suburb)+", "+_vm._s(_vm.location.city_name))]),_c('p',[_vm._v(_vm._s(_vm.location.postal_code))])]),_c('icon',{attrs:{"name":"pin"}})],1)
}
var AddressCardvue_type_template_id_fc9174fc_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/AddressCard.vue?vue&type=script&lang=js&


/* harmony default export */ var AddressCardvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	props: ['location'],
	computed: {
		hasCustomName() {
			return this.location.name !== `${this.location.street_number}, ${this.location.street_name}, ${this.location.suburb}, ${this.location.city_name}, ${this.location.postal_code}`;
		},
		selected() {
			return this.$signup.$store.getters['signupDelivery/deliveryLocation'].id === this.location.id;
		}
	},
	methods: {
		click() {
			this.$emit('select', this.location);
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/AddressCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_AddressCardvue_type_script_lang_js_ = (AddressCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/AddressCard.vue?vue&type=style&index=0&id=fc9174fc&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/AddressCard.vue?vue&type=style&index=0&id=fc9174fc&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/delivery/AddressCard.vue



;


/* normalize component */

var AddressCard_component = (0,componentNormalizer/* default */.Z)(
  delivery_AddressCardvue_type_script_lang_js_,
  AddressCardvue_type_template_id_fc9174fc_render,
  AddressCardvue_type_template_id_fc9174fc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddressCard = (AddressCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryAddress.vue?vue&type=script&lang=js&






/* harmony default export */ var DeliveryAddressvue_type_script_lang_js_ = ({
	components: {ErrorBar: ErrorBar, Icon: Icon, AddressCard: AddressCard},
	computed: {
		locations() {
			return this.$signup.$store.getters['signupDelivery/locations'];
		},
		selectedLocation() {
			return this.$signup.$store.getters['signupDelivery/deliveryLocation'].id
		}
	},
	data() {
		return {
			error: false,
		}
	},
	methods: {
		newLocation() {
			this.$modal.push('new-delivery-address')
		},
		selectAddress(location) {
			this.$signup.$store.commit('signupDelivery/updateDeliveryLocation', location);
		},
		async next() {
			// if delivery location is different to installation location, update quote
			if (this.$signup.$store.getters['signupDelivery/deliveryLocation'].id !== this.$signup.$store.getters['signupCart/cartDetails'].delivery_location_id) {
				//update cart location
				let cart = {...this.$signup.$store.getters['signupCart/cartDetails']};
				cart.delivery_location_id = this.selectedLocation;
				this.$signup.$store.commit('signupCart/setCartDetails', cart);

				await this.$signup.$store.dispatch('signupDelivery/getDeliveryQuotes')
					.catch((err) => {
						this.error = err;
					});

			}

			this.$modal.push('delivery-recipient');
		}
	},
	mounted() {
		this.$modal.toggleLoader(true);
		this.$signup.$store.dispatch('signupDelivery/fetchLocations').then((res) => {
			this.$modal.toggleLoader(false);
		});

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-option');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (!that.selectedLocation) {
				that.error = { message: 'Please select a delivery location' };
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryAddress.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliveryAddressvue_type_script_lang_js_ = (DeliveryAddressvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryAddress.vue





/* normalize component */
;
var DeliveryAddress_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliveryAddressvue_type_script_lang_js_,
  DeliveryAddressvue_type_template_id_3288d95d_render,
  DeliveryAddressvue_type_template_id_3288d95d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DeliveryAddress = (DeliveryAddress_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/NewDeliveryAddress.vue?vue&type=template&id=607c3ee7&
var NewDeliveryAddressvue_type_template_id_607c3ee7_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"coverage-map-holder"},[_c('search-bar',{attrs:{"showGeoLocation":"true","should-check-coverage":false,"bind-place":_vm.currentPlace},on:{"selectPlace":_vm.selectPlace}}),_c('GmapMap',{attrs:{"center":_vm.mapCenter,"zoom":17,"options":_vm.mapOptions}},[(_vm.mapCenter && _vm.place)?_c('GmapMarker',{attrs:{"position":_vm.mapCenter,"draggable":true},on:{"dragend":_vm.markerDrop}}):_vm._e()],1)],1)])
}
var NewDeliveryAddressvue_type_template_id_607c3ee7_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/NewDeliveryAddress.vue?vue&type=script&lang=js&







/* harmony default export */ var NewDeliveryAddressvue_type_script_lang_js_ = ({
	components: {Icon: Icon, AddressCard: AddressCard},
	computed: {
		place() {
			return this.currentPlace;
		},
		coordinates() {
			return this.currentCoordinates;
		},
		mapCenter() {
			return this.place ? this.coordinates : {
				lat: -26.04606,
				lng: 28.05986
			};
		}
	},
	data() {
		return {
			currentPlace: '',
			currentCoordinates: false,
			mapOptions: {
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: false,
				styles: map_styles_namespaceObject
			}
		}
	},
	watch: {
		currentPlace() {
			if (this.currentPlace) {
				this.$modal.state.current.buttons[1].type = 'primary';
			} else {
				this.$modal.state.current.buttons[1].type = 'primary disabled';
			}
 		},
	},
	methods: {
		selectPlace(place) {
			this.currentPlace = place;
			this.currentCoordinates = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng(),
			};
		},
		markerDrop(event) {
			let that = this,
				google = (0,main.gmapApi)(),
				service = new google.maps.Geocoder(),
				latLng = {
					lat: event.latLng.lat(),
					lng: event.latLng.lng(),
				};

			that.currentCoordinates = latLng;

			service.geocode({
				'location': {
					lat: event.latLng.lat(),
					lng: event.latLng.lng(),
				}
			}, function(results, status) {
				if(status === 'OK' && results.length) {
					that.currentPlace = results[0];
				} else {
					throw new Error('Unable to GeoCode marker position');
				}
			});
		},
	},
	mounted() {

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-address');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.$modal.state.current.buttons[1].type.indexOf('disabled') > -1) return
			that.$signup.$store.commit('signupDelivery/updateDeliveryLocation', that.currentPlace);
			that.$modal.push('delivery-address-details');
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/NewDeliveryAddress.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_NewDeliveryAddressvue_type_script_lang_js_ = (NewDeliveryAddressvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/NewDeliveryAddress.vue





/* normalize component */
;
var NewDeliveryAddress_component = (0,componentNormalizer/* default */.Z)(
  delivery_NewDeliveryAddressvue_type_script_lang_js_,
  NewDeliveryAddressvue_type_template_id_607c3ee7_render,
  NewDeliveryAddressvue_type_template_id_607c3ee7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NewDeliveryAddress = (NewDeliveryAddress_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryAddressDetails.vue?vue&type=template&id=5b39941c&
var DeliveryAddressDetailsvue_type_template_id_5b39941c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body has-columns"},[_c('div',{staticClass:"modal-column"},[_c('signup-select',{attrs:{"label":"Location Type","disabled":false,"required":true,"error":false,"options":_vm.locationTypeOptions},model:{value:(_vm.form.location.type),callback:function ($$v) {_vm.$set(_vm.form.location, "type", $$v)},expression:"form.location.type"}}),(_vm.form.location.type !== 'house' && _vm.form.location.type !== 'school')?_c('signup-input',{attrs:{"type":"number","label":"Unit number","disabled":false,"required":false},model:{value:(_vm.form.location.buildingNumber),callback:function ($$v) {_vm.$set(_vm.form.location, "buildingNumber", $$v)},expression:"form.location.buildingNumber"}}):_vm._e(),_c('signup-input',{attrs:{"type":"string","label":"Street number","disabled":false,"required":true},model:{value:(_vm.form.location.streetNumber),callback:function ($$v) {_vm.$set(_vm.form.location, "streetNumber", $$v)},expression:"form.location.streetNumber"}}),_c('signup-input',{attrs:{"type":"text","label":"Suburb","disabled":false,"required":true},model:{value:(_vm.form.location.suburb),callback:function ($$v) {_vm.$set(_vm.form.location, "suburb", $$v)},expression:"form.location.suburb"}}),_c('signup-input',{attrs:{"type":"text","label":"Postal code","autocomplete":"postal-code","disabled":false,"required":true},model:{value:(_vm.form.location.postalCode),callback:function ($$v) {_vm.$set(_vm.form.location, "postalCode", $$v)},expression:"form.location.postalCode"}})],1),_c('div',{staticClass:"modal-column"},[(_vm.form.location.type !== 'house')?_c('signup-input',{attrs:{"type":"text","label":_vm.form.location.type === 'school' ? 'School Name': 'Building / complex',"disabled":false,"required":false},model:{value:(_vm.form.location.buildingName),callback:function ($$v) {_vm.$set(_vm.form.location, "buildingName", $$v)},expression:"form.location.buildingName"}}):_vm._e(),_c('signup-input',{attrs:{"type":"text","label":"Street name","disabled":false,"required":true},model:{value:(_vm.form.location.streetName),callback:function ($$v) {_vm.$set(_vm.form.location, "streetName", $$v)},expression:"form.location.streetName"}}),_c('signup-input',{attrs:{"type":"text","label":"City","disabled":false,"required":true},model:{value:(_vm.form.location.city),callback:function ($$v) {_vm.$set(_vm.form.location, "city", $$v)},expression:"form.location.city"}}),_c('signup-select',{attrs:{"label":"Province","disabled":false,"required":true,"error":false,"options":_vm.provinces},model:{value:(_vm.form.location.province),callback:function ($$v) {_vm.$set(_vm.form.location, "province", $$v)},expression:"form.location.province"}}),_c('signup-input',{attrs:{"type":"text","label":"Custom name (optional)","disabled":false,"required":false},model:{value:(_vm.form.location.customName),callback:function ($$v) {_vm.$set(_vm.form.location, "customName", $$v)},expression:"form.location.customName"}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var DeliveryAddressDetailsvue_type_template_id_5b39941c_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryAddressDetails.vue?vue&type=script&lang=js&





/* harmony default export */ var DeliveryAddressDetailsvue_type_script_lang_js_ = ({
	components: {ErrorBar: ErrorBar, SignupInput: SignupInput, SignupSelect: SignupSelect},
	data() {
		return {
			error: false,
			form: {
				location: {
					type: '',
					streetNumber: '',
					suburb: '',
					postalCode: '',
					buildingNumber: '',
					buildingName: '',
					streetName: '',
					province: '',
					customName: '',
				}
			},
			locationTypeOptions: [
				{
					label: 'Freestanding Home',
					value: 'house'
				},
				{
					label: 'Complex',
					value: 'complex'
				},
				{
					label: 'Business/Office Building',
					value: 'business'
				},
				{
					label: 'School Campus',
					value: 'school'
				},
				{
					label: 'Estate',
					value: 'estate'
				},
				{
					label: 'Apartment',
					value: 'apartment'
				}
			],
			provinces: [
				{
					label: "Eastern Cape",
					value: "Eastern Cape"
				},
				{
					label: "Free State",
					value: "Free State"
				},
				{
					label: "Gauteng",
					value: "Gauteng"
				},
				{
					label: "KwaZulu-Natal",
					value: "KwaZulu-Natal"
				},
				{
					label: "Limpopo",
					value: "Limpopo"
				},
				{
					label: "Mpumalanga",
					value: "Mpumalanga"
				},
				{
					label: "North West",
					value: "North West"
				},
				{
					label: "Northern Cape",
					value: "Northern Cape"
				},
				{
					label: "Western Cape",
					value: "Western Cape"
				}
			],
		}
	},
	methods: {
		async next() {
			let clientPlace = await this.$signup.$store.dispatch('signupGeneral/mapsToLocation', {
				place: this.$signup.$store.getters['signupDelivery/deliveryLocation']
			});

			this.form.location = {
				...this.form.location,
				...clientPlace
			}
			this.$signup.$store.dispatch('signupUser/addLocation', this.form.location)
			.then((res) => {
				this.$modal.push('delivery-address-added');
			}).catch((err) => {
				this.error = err;
			});
		}
	},
	async mounted() {
		let clientPlace = await this.$signup.$store.dispatch('signupGeneral/mapsToLocation', {
			place: this.$signup.$store.getters['signupDelivery/deliveryLocation']
		});

		this.form.location = {
			...this.form.location,
			...clientPlace
		}

		this.error = false;
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.form.location.type === '') {
				that.error = { message: 'Please select the type of location.' };
			} else if (that.form.location.streetName === '') {
				that.error = { message: 'Street name cannot be empty.' };
			} else if (that.form.location.streetNumber === '') {
				that.error = { message: 'Street number cannot be empty.' };
			} else if (that.form.location.suburb === '') {
				that.error = { message: 'Suburb cannot be empty.' };
			} else if (that.form.location.postalCode === '') {
				that.error = { message: 'Postal code cannot be empty.' };
			} else if (that.form.location.province === '') {
				that.error = { message: 'Please select a province.' };
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryAddressDetails.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliveryAddressDetailsvue_type_script_lang_js_ = (DeliveryAddressDetailsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryAddressDetails.vue





/* normalize component */
;
var DeliveryAddressDetails_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliveryAddressDetailsvue_type_script_lang_js_,
  DeliveryAddressDetailsvue_type_template_id_5b39941c_render,
  DeliveryAddressDetailsvue_type_template_id_5b39941c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DeliveryAddressDetails = (DeliveryAddressDetails_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/AddressAdded.vue?vue&type=template&id=65d66416&scoped=true&
var AddressAddedvue_type_template_id_65d66416_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"tick-circle"}})],1),_c('h1',[_vm._v(" New address added ")]),_c('p',[_vm._v(" "+_vm._s(_vm.address)+" ")]),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Continue ")])])
}
var AddressAddedvue_type_template_id_65d66416_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/AddressAdded.vue?vue&type=script&lang=js&


/* harmony default export */ var AddressAddedvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	computed: {
		address() {
			return this.$signup.$store.getters['signupDelivery/deliveryLocation'].formatted_address
		}
	},
	methods: {
		next() {
			this.$modal.push('delivery-address');
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);
	}

});

;// CONCATENATED MODULE: ./src/modals/delivery/AddressAdded.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_AddressAddedvue_type_script_lang_js_ = (AddressAddedvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/AddressAdded.vue?vue&type=style&index=0&id=65d66416&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/AddressAdded.vue?vue&type=style&index=0&id=65d66416&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/delivery/AddressAdded.vue



;


/* normalize component */

var AddressAdded_component = (0,componentNormalizer/* default */.Z)(
  delivery_AddressAddedvue_type_script_lang_js_,
  AddressAddedvue_type_template_id_65d66416_scoped_true_render,
  AddressAddedvue_type_template_id_65d66416_scoped_true_staticRenderFns,
  false,
  null,
  "65d66416",
  null
  
)

/* harmony default export */ var AddressAdded = (AddressAdded_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryType.vue?vue&type=template&id=6c2c4f80&
var DeliveryTypevue_type_template_id_6c2c4f80_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"delivery-type-cards"},_vm._l((_vm.deliveryTypes),function(d){return _c('delivery-type-card',{key:d.type,attrs:{"label":d.name,"type":d.type,"price":d.price,"terms":d.terms,"description":d.description,"selected":d === _vm.selectedDeliveryType},on:{"select":function($event){return _vm.changeDeliveryType(d)}}})}),1)])
}
var DeliveryTypevue_type_template_id_6c2c4f80_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryTypeCard.vue?vue&type=template&id=1f4190be&scoped=true&
var DeliveryTypeCardvue_type_template_id_1f4190be_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-type-card shipping-type",class:{'selected': _vm.selected},on:{"click":_vm.select}},[_c('div',{staticClass:"card-head"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.price))+" once-off")])]),_c('div',{staticClass:"card-body"},_vm._l((_vm.terms),function(term){return _c('div',{staticClass:"term"},[_c('p',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm._f("formatTermType")(term.type))+" ")]),_c('p',[_vm._v(" "+_vm._s(term.term)+" ")])])}),0),_c('div',{staticClass:"card-footer"},[_c('p',[_vm._v("Terms and conditions")]),_c('icon',{attrs:{"name":"error"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showTerms.apply(null, arguments)}}})],1),(_vm.termsVisible)?_c('div',{staticClass:"terms-overlay"},[_c('p',[_vm._v(_vm._s(_vm.description))]),_c('icon',{attrs:{"name":"cross"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.hideTerms.apply(null, arguments)}}})],1):_vm._e()])
}
var DeliveryTypeCardvue_type_template_id_1f4190be_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryTypeCard.vue?vue&type=script&lang=js&


/* harmony default export */ var DeliveryTypeCardvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	props: [
		'selected',
		'label',
		'price',
		'description',
		'terms',
		'type'
	],
	data() {
		return {
			termsVisible: false
		}
	},
	methods: {
		select() {
			this.$emit('select', this.type)
		},
		showTerms() {
			this.termsVisible = true;
		},
		hideTerms() {
			this.termsVisible = false;
		},
	},
});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryTypeCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliveryTypeCardvue_type_script_lang_js_ = (DeliveryTypeCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryTypeCard.vue?vue&type=style&index=0&id=1f4190be&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryTypeCard.vue?vue&type=style&index=0&id=1f4190be&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryTypeCard.vue



;


/* normalize component */

var DeliveryTypeCard_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliveryTypeCardvue_type_script_lang_js_,
  DeliveryTypeCardvue_type_template_id_1f4190be_scoped_true_render,
  DeliveryTypeCardvue_type_template_id_1f4190be_scoped_true_staticRenderFns,
  false,
  null,
  "1f4190be",
  null
  
)

/* harmony default export */ var DeliveryTypeCard = (DeliveryTypeCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryType.vue?vue&type=script&lang=js&





/* harmony default export */ var DeliveryTypevue_type_script_lang_js_ = ({
	components: {
		DeliveryTypeCard: DeliveryTypeCard,
		Icon: Icon
	},
	computed: {
		deliveryTypes() {
			return this.$signup.$store.getters['signupDelivery/deliveryQuotes'].filter(q => {
				return q.name.indexOf('Collect') < 0
				// return true
			});
		},
	},
	methods: {
		changeDeliveryType(value) {
			this.$signup.$store.commit('signupDelivery/updateSelectedDeliveryQuote', value);
			this.selectedDeliveryType = value;
		},
	},
	data() {
		return {
			selectedDeliveryType: false,
		}
	},
	mounted() {
		this.$modal.toggleLoader(false);

		if (this.deliveryTypes.length === 0) {
			this.$modal.push('no-delivery-available');
			return;
		} else if (this.deliveryTypes.length === 1) {
			this.changeDeliveryType(this.deliveryTypes[0]);
			this.$modal.push('delivery-single');
			return;
		}

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-recipient');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.selectedDeliveryType.name.indexOf('Express') > -1
				&& that.$signup.$store.getters['signupPayment/currentPaymentMethod'].payment_method !== 'CC') {
				that.$modal.push('only-credit-card');
			} else {
				that.$modal.push('summary');
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryType.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliveryTypevue_type_script_lang_js_ = (DeliveryTypevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliveryType.vue?vue&type=style&index=0&id=6c2c4f80&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryType.vue?vue&type=style&index=0&id=6c2c4f80&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/delivery/DeliveryType.vue



;


/* normalize component */

var DeliveryType_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliveryTypevue_type_script_lang_js_,
  DeliveryTypevue_type_template_id_6c2c4f80_render,
  DeliveryTypevue_type_template_id_6c2c4f80_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DeliveryType = (DeliveryType_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentMethods.vue?vue&type=template&id=574d78b2&
var PaymentMethodsvue_type_template_id_574d78b2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('button',{staticClass:"signup-button add-button",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.newPayment.apply(null, arguments)}}},[_c('icon',{attrs:{"name":"plus-circle"}}),_c('span',[_vm._v("Add payment method")])],1),_c('div',{staticClass:"card-container"},_vm._l((_vm.paymentMethods),function(paymentMethod){return _c('payment-method-card',{key:paymentMethod.id,attrs:{"payment-method":paymentMethod,"selected":paymentMethod.id === _vm.selectedPaymentMethod.id},on:{"select":_vm.selectPayment}})}),1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var PaymentMethodsvue_type_template_id_574d78b2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentMethodCard.vue?vue&type=template&id=51ecbecc&
var PaymentMethodCardvue_type_template_id_51ecbecc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-card",class:[{selected: _vm.selected}, _vm.paymentMethod.payment_method],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.click.apply(null, arguments)}}},[(_vm.paymentMethod.payment_method === 'CC' && _vm.focusElement !== 'cvv')?_c('div',{staticClass:"info"},[_c('div',{staticClass:"card-top"},[_c('span',{staticClass:"friendly-name"},[_vm._v(_vm._s(_vm.paymentMethod.friendly_name ? _vm.paymentMethod.friendly_name : ``))]),(_vm.paymentMethod.card_type)?_c('icon',{attrs:{"name":_vm.paymentMethod.card_type.toLowerCase()}}):_vm._e()],1),_c('p',{staticClass:"card-number",class:[_vm.focusElement === 'card-number' ? 'highlight' : ''],domProps:{"innerHTML":_vm._s(_vm.cardNumber)}}),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"details-left"},[_c('p',[_vm._v("Cardholder")]),_c('p',{staticClass:"cardholder-name",class:[_vm.focusElement === 'card-holder' ? 'highlight' : '']},[_vm._v(_vm._s(_vm.paymentMethod.card_holder ? _vm.paymentMethod.card_holder : 'Name Surname'))])]),_c('div',{staticClass:"details-right"},[_c('p',[_vm._v("Expiry")]),_c('p',{staticClass:"expiry-date"},[_c('span',{staticClass:"expiry-month",class:[_vm.focusElement === 'expiry-month' ? 'highlight' : '']},[_vm._v(_vm._s(_vm.expirationDate.month))]),_c('span',[_vm._v("/")]),_c('span',{staticClass:"expiry-year",class:[_vm.focusElement === 'expiry-year' ? 'highlight' : '']},[_vm._v(_vm._s(_vm.expirationDate.year))])])])])]):(_vm.paymentMethod.payment_method === 'CC' && _vm.focusElement === 'cvv' )?_c('div',{staticClass:"info back"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"dummy"},[_c('svg',{attrs:{"width":"140px","height":"27px","viewBox":"0 0 140 27","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("Combined Shape")]),_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","opacity":"0.5"}},[_c('path',{attrs:{"d":"M82.2345574,24 L82.2345574,27 L0,27 L0,24 L82.2345574,24 Z M108.308929,24 L108.308929,27 L86.2459992,27 L86.2459992,24 L108.308929,24 Z M139.397603,16 L139.397603,19 L20.0572091,19 L20.0572091,16 L139.397603,16 Z M16.0457673,16 L16.0457673,19 L1.24344979e-14,19 L1.24344979e-14,16 L16.0457673,16 Z M139.397603,8 L139.397603,11 L57.163046,11 L57.163046,8 L139.397603,8 Z M53.1516042,8 L53.1516042,11 L0,11 L0,8 L53.1516042,8 Z M82.2345574,0 L82.2345574,3 L0,3 L0,0 L82.2345574,0 Z M139.397603,0 L139.397603,3 L86.2459992,3 L86.2459992,0 L139.397603,0 Z","id":"Combined-Shape","fill":"#FFFFFF"}})])])]),_c('span',{staticClass:"cvv highlight"},[_vm._v(_vm._s(_vm.paymentMethod.cvv ? _vm.paymentMethod.cvv : 'CVV'))])]),_c('div',{staticClass:"card-footer"},[(_vm.paymentMethod.card_type)?_c('icon',{attrs:{"name":_vm.paymentMethod.card_type.toLowerCase()}}):_vm._e()],1)]):(_vm.paymentMethod.payment_method === 'DO')?_c('div',{staticClass:"info"},[_c('div',{staticClass:"card-top"},[_c('span',{staticClass:"friendly-name"},[_vm._v(_vm._s(_vm.paymentMethod.friendly_name ? _vm.paymentMethod.friendly_name : 'Custom name'))]),_c('icon',{attrs:{"name":"bank"}})],1),_c('p',{staticClass:"account-identifier"},[_vm._v(_vm._s(_vm.accountIdentifier ? _vm.accountIdentifier : 'Account number'))]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"details-left"},[_c('p',[_vm._v(_vm._s(_vm.paymentMethod.bank_name ? _vm.paymentMethod.bank_name : 'Bank'))]),_c('p',{staticClass:"cardholder-name"},[_vm._v(_vm._s(_vm.paymentMethod.account_holder ? _vm.paymentMethod.account_holder : 'Account holder'))])]),_c('div',{staticClass:"details-right"},[_vm._m(1),_c('p',[_vm._v(_vm._s(_vm.paymentMethod.account_type ? _vm.paymentMethod.account_type : 'Account type'))])])])]):_c('div',{staticClass:"info"},[_c('span',{staticClass:"friendly-name"},[_vm._v(_vm._s(_vm.paymentMethod.friendly_name))]),_c('p',{staticClass:"card-number"},[_vm._v(_vm._s(_vm.paymentMethod.masked_number))])])])
}
var PaymentMethodCardvue_type_template_id_51ecbecc_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-top"},[_c('div',{staticClass:"strip"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('br')])
}]


;// CONCATENATED MODULE: ./src/modals/payment/PaymentMethodCard.vue?vue&type=template&id=51ecbecc&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentMethodCard.vue?vue&type=script&lang=js&


/* harmony default export */ var PaymentMethodCardvue_type_script_lang_js_ = ({
	components: { Icon: Icon },
	props: ['paymentMethod', 'numberOnly', 'focusElement', 'selected'],
	computed: {
		hasCustomName() {
			return this.paymentMethod.name !== `${this.paymentMethod.street_number}, ${this.paymentMethod.street_name}, ${this.paymentMethod.suburb}, ${this.paymentMethod.city_name}, ${this.paymentMethod.postal_code}`;
		},
		expirationDate() {
			let expireMonth = this.paymentMethod.expiry_month || this.paymentMethod.expire_month ? this.paymentMethod.expiry_month || this.paymentMethod.expire_month : 'MM';
			let expireYear = this.paymentMethod.expiry_year || this.paymentMethod.expire_year ? this.paymentMethod.expiry_year || this.paymentMethod.expire_year : 'YYYY';
			return {
				month: ("00" + expireMonth).slice(-2),
				year: expireYear.toString().length > 2 ? expireYear.toString().slice(-2) : expireYear.toString()
		}
		},
		cardNumber() {
			if (this.numberOnly) { return this.paymentMethod.card_number ? this.paymentMethod.card_number : 'XXXX XXXX XXXX XXXX' }
			return this.paymentMethod.masked_number.replace(/X/g, '&#8226;');
		},
		accountIdentifier() {
			if (this.numberOnly) { return this.paymentMethod.account_number }
			let accNumber = this.paymentMethod.account_number.toString();
			return `${this.paymentMethod.account_type} ${accNumber.substr(accNumber.length - 4, accNumber.length)}`;
		}
	},
	methods: {
		click() {
			this.$emit('select', this.paymentMethod);
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/payment/PaymentMethodCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_PaymentMethodCardvue_type_script_lang_js_ = (PaymentMethodCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentMethodCard.vue?vue&type=style&index=0&id=51ecbecc&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/PaymentMethodCard.vue?vue&type=style&index=0&id=51ecbecc&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/payment/PaymentMethodCard.vue



;


/* normalize component */

var PaymentMethodCard_component = (0,componentNormalizer/* default */.Z)(
  payment_PaymentMethodCardvue_type_script_lang_js_,
  PaymentMethodCardvue_type_template_id_51ecbecc_render,
  PaymentMethodCardvue_type_template_id_51ecbecc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentMethodCard = (PaymentMethodCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentMethods.vue?vue&type=script&lang=js&







/* harmony default export */ var PaymentMethodsvue_type_script_lang_js_ = ({
	components: {PaymentMethodCard: PaymentMethodCard, ErrorBar: ErrorBar, Icon: Icon, AddressCard: AddressCard},
	computed: {
		paymentMethods() {
			return this.$signup.$store.getters['signupPayment/paymentMethods'];
		},
		selectedPaymentMethod() {
			return this.$signup.$store.getters['signupPayment/currentPaymentMethod'];
		},
	},
	data() {
		return {
			error: false,
		}
	},
	methods: {
		newPayment() {
			this.$modal.push('new-payment-method')
		},
		selectPayment(paymentMethod) {
			this.$signup.$store.commit('signupPayment/updateCurrentPaymentMethod', paymentMethod);
		},
		async next() {
			//check payment method id is valid
			if (!this.selectedPaymentMethod.id || this.selectedPaymentMethod.id === '') {
				this.error = { message: "Please select a valid payment method." }
				return;
			}

			//build cart - TODO: move to cart store
			//get all necessary data from store
			let user = this.$signup.$store.getters['signupUser/user'];
			let cartItems = JSON.parse(JSON.stringify(this.$signup.$store.getters['signupCart/cartItems'])); // deep copy because we don't want to mutate the vuex store
			let paymentId = this.selectedPaymentMethod.id;
			// let devices = this.$signup.$store.getters['signupSolutions/selectedDevices'];
			let location = this.$signup.$store.getters['signupSolutions/solutionLocation'];
			let devices = cartItems.filter(item => {
				return item.product_type_slug.includes('tangible');
			});

			try {
				this.$signup.$store.dispatch('signupSignal/sendEvent', {
					type: 'payment-detail-select',
					value: null,
					meta: null,
				})
			} catch (e) {
				console.log(e)
			}

			let cart = {
				payment_detail_id: paymentId,
			};

			cartItems.map(item => {
				if (item.product_type_slug === "solution_fibre_line") {
					const fibre_promo = item.cart_item_requirements.find(cir => cir.name === 'fibre_promotion_slug') ?? null
					item.cart_item_requirements = []
					if (fibre_promo)
						item.cart_item_requirements.push({ name: 'fibre_promotion_slug', value: fibre_promo.value })
					item.cart_item_requirements.push({ name: 'location_id', value: location.id })
					item.cart_item_requirements.push({ name: 'contact_number', value: location.contact_number })
					item.cart_item_requirements.push({ name: 'alternative_contact_number', value: location.alternative_contact_number })
					item.cart_item_requirements.push({ name: 'order_type', value: location.order_type })

					if (this.$signup.$store.getters['signupGeneral/imSure']) {
						item.cart_item_requirements.push({ name: 'is_im_sure_i_have_fibre_order', value: true });
					}
					if (location.migrate_email_address) {
						item.cart_item_requirements.push({ name: 'migrate_email_address', value: location.migrate_email_address });
					}
					if (location.migrate_fsan_number) {
						item.cart_item_requirements.push({ name: 'migrate_fsan_number', value: location.migrate_fsan_number });
					}
					if (location.migrate_object_number) {
						item.cart_item_requirements.push({ name: 'migrate_object_number', value: location.migrate_object_number });
					}
				}
			});
			this.$signup.$store.commit('signupCart/setCartItems', cartItems);
			this.$signup.$store.commit('signupCart/setCartDetails', cart);

			if (devices.length) {
				cart.delivery_location_id = location.id;
				devices.forEach(d => {
					if(d.product_type_slug === 'solution_tangible_fibre') {
						this.$signup.$store.commit('signupCart/replaceOrAddCartItem', {
							product_type_slug: "solution_tangible_fibre",
							product_id: d.product_id,
							cart_item_requirements: [
								// { name: "configure_wifi_network_name", value: d.ssid },
								// { name: "configure_wifi_network_password", value: d.password },
								{ name: 'recipient_first_name', value: user.first_name },
								{ name: 'recipient_last_name', value: user.last_name },
								{ name: 'contact_number', value: location.contact_number },
								{ name: 'email_address', value: user.email },
								{ name: 'id_number', value: user.id_number },
							]
						});
					}
				})
				this.$signup.$store.commit('signupCart/setCartDetails', cart);

				//check if redirected from payment change option
				if (!this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote']) {
					this.$modal.push('delivery-option');
				} else {
					//check if payment method has changed and makes sense
					if (this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote'].payment_detail_id !== this.selectedPaymentMethod.id) {
						// console.log('payment method changed - update quotes');
						await this.$signup.$store.dispatch('signupDelivery/getDeliveryQuotes');

						//select same delivery quote
						let selecedQuote = this.$signup.$store.getters['signupDelivery/deliveryQuotes'].find((d) => {
							return d.name === this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote'].name;
						});
						//if quote is empty - show error
						if (!selecedQuote) {
							this.$modal.push('no-delivery-available');
							return;
						} else {
							this.$signup.$store.commit('signupDelivery/updateSelectedDeliveryQuote', selecedQuote);
						}
					}
					//make sure CC is selected if express selected
					if (this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote'].name.indexOf('Express') > -1
						&& this.selectedPaymentMethod.payment_method !== 'CC') {
						this.$modal.push('only-credit-card');
					} else {
						this.$modal.push('summary');
					}
				}
			} else {
				this.$modal.push('summary');
			}
		}
	},
	mounted() {
		this.$modal.toggleLoader(true);
		let solutionId = this.$signup.$store.getters['signupSolutions/selectedSolution'].id;
		this.$signup.$store.dispatch('signupPayment/fetchPaymentMethods', {
			solutionId: solutionId
		})
		.then((res) => {
			this.$modal.toggleLoader(false);
			if (res.payment_details.length < 1) {
				this.$modal.push('new-payment-method');
			}
		});

		//is not coming from next screen or summary and payment method is selected
		// if (this.$modal.state.previous.name !== 'delivery-options' &&
		// 	this.$modal.state.previous.name !== 'summary'
		// 	&& this.selectedPaymentMethod) {
		// 	this.next();
		// }

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('fibre-installation');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (!that.selectedPaymentMethod) {
				that.error = { message: 'Please select a payment method' };
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/payment/PaymentMethods.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_PaymentMethodsvue_type_script_lang_js_ = (PaymentMethodsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/payment/PaymentMethods.vue





/* normalize component */
;
var PaymentMethods_component = (0,componentNormalizer/* default */.Z)(
  payment_PaymentMethodsvue_type_script_lang_js_,
  PaymentMethodsvue_type_template_id_574d78b2_render,
  PaymentMethodsvue_type_template_id_574d78b2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentMethods = (PaymentMethods_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewBankAccount.vue?vue&type=template&id=0e52227e&scoped=true&
var NewBankAccountvue_type_template_id_0e52227e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body has-columns"},[_c('div',{staticClass:"modal-column"},[_c('payment-method-card',{attrs:{"payment-method":_vm.account,"number-only":"true","selected":true}})],1),_c('div',{staticClass:"modal-column"},[_c('signup-input',{attrs:{"type":"text","label":"Account number","disabled":false,"required":true},on:{"input":_vm.accountNumberInput},model:{value:(_vm.account.account_number),callback:function ($$v) {_vm.$set(_vm.account, "account_number", $$v)},expression:"account.account_number"}}),_c('signup-input',{attrs:{"type":"text","label":"Account holder","disabled":false,"required":true},model:{value:(_vm.account.account_holder),callback:function ($$v) {_vm.$set(_vm.account, "account_holder", $$v)},expression:"account.account_holder"}}),_c('signup-select',{attrs:{"label":"Bank","disabled":false,"required":true,"error":false,"options":_vm.banks},on:{"input":_vm.bankSelect},model:{value:(_vm.account.bank_name),callback:function ($$v) {_vm.$set(_vm.account, "bank_name", $$v)},expression:"account.bank_name"}}),_c('div',{staticClass:"half-size"},[_c('signup-input',{attrs:{"type":"text","label":"Branch Code","disabled":false,"required":true},model:{value:(_vm.account.branch_code),callback:function ($$v) {_vm.$set(_vm.account, "branch_code", $$v)},expression:"account.branch_code"}}),_c('signup-select',{attrs:{"label":"Account type","disabled":false,"required":true,"error":false,"options":_vm.accountTypes},model:{value:(_vm.account.account_type),callback:function ($$v) {_vm.$set(_vm.account, "account_type", $$v)},expression:"account.account_type"}})],1),_c('signup-input',{attrs:{"type":"text","label":"Custom name","disabled":false,"required":false},model:{value:(_vm.account.friendly_name),callback:function ($$v) {_vm.$set(_vm.account, "friendly_name", $$v)},expression:"account.friendly_name"}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var NewBankAccountvue_type_template_id_0e52227e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewBankAccount.vue?vue&type=script&lang=js&







/* harmony default export */ var NewBankAccountvue_type_script_lang_js_ = ({
	components: {ErrorBar: ErrorBar, SignupSelect: SignupSelect, SignupInput: SignupInput, PaymentMethodCard: PaymentMethodCard},
	data() {
		return {
			error: '',
			account: {
				payment_method: 'DO',
				account_number: '',
				account_holder: '',
				bank_name: '',
				branch_code: '',
				account_type: '',
				friendly_name: '',
			},
			banks: [],
			accountTypes: [
				{
					label: 'Cheque',
					value: 'Cheque',
				},
				{
					label: 'Current',
					value: 'Current',
				},
				{
					label: 'Transmission',
					value: 'Transmission',
				},
			]
		}
	},
	methods: {
		bankSelect(value) {
			this.account.branch_code = this.banks.find(bank => {
				return bank.value === value;
			}).branch_code;
		},
		next() {
			this.$modal.toggleLoader(true);
			// this.$signup.$store.commit('signupPayment/updateCurrentPaymentMethod');
			this.$signup.$store.dispatch('signupPayment/addBankAccount', this.account)
			.then(res => {
				this.$signup.$store.commit('signupPayment/updateCurrentPaymentMethod', res.payment_detail);
				this.$modal.push('new-payment-added');
			})
			.catch((err) => {
				this.$modal.toggleLoader(false);
				this.error = {message: err.data.message}
			});
		},
		accountNumberInput(value) {
			let str = value.replace(/[^\dA-Z]/g, '');
			let parts = [];
			if (str.length > 3) {
				parts.push(str.substr(0, 3));
				parts.push(str.substr(3, str.length).replace(/(.{4})/g, '$1 ').trim())
			} else {
				parts.push(str);
			}
			// console.log(parts);
			this.account.account_number = parts.join(' ');
			// this.account.account_number = value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
		}
	},
	mounted() {
		this.$modal.toggleLoader(true);
		this.$signup.$store.dispatch('signupPayment/fetchBanks').then((result) => {
			this.$modal.toggleLoader(false);
			this.banks = [{label: 'Select a bank account', value:''},...result.banks.map(bank => {
				return {
					label: bank.bank_name,
					value: bank.bank_name,
					branch_code: bank.branch_code
				}
			})];
		});

		try {
			this.$signup.$store.dispatch('signupSignal/sendEvent', {
				type: 'payment-detail-create-debit',
				value: null,
				meta: null,
			})
		} catch (e) {

		}

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.error = false;
			if (that.account.account_number === '') {
				that.error = { message: 'Account number cannot be empty.' };
			} else if (that.account.account_holder === '') {
				that.error = { message: 'Account holder cannot be empty.' };
			} else if (that.account.bank_name === '') {
				that.error = { message: 'Please select a bank.' };
			} else if (that.account.account_type === '') {
				that.error = { message: 'Please select an account type.' };
			} else if (that.account.branch_code === '') {
				that.error = { message: 'Branch code cannot be empty.' };
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	},
});

;// CONCATENATED MODULE: ./src/modals/payment/NewBankAccount.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_NewBankAccountvue_type_script_lang_js_ = (NewBankAccountvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewBankAccount.vue?vue&type=style&index=0&id=0e52227e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/NewBankAccount.vue?vue&type=style&index=0&id=0e52227e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/payment/NewBankAccount.vue



;


/* normalize component */

var NewBankAccount_component = (0,componentNormalizer/* default */.Z)(
  payment_NewBankAccountvue_type_script_lang_js_,
  NewBankAccountvue_type_template_id_0e52227e_scoped_true_render,
  NewBankAccountvue_type_template_id_0e52227e_scoped_true_staticRenderFns,
  false,
  null,
  "0e52227e",
  null
  
)

/* harmony default export */ var NewBankAccount = (NewBankAccount_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentMethod.vue?vue&type=template&id=08531346&
var NewPaymentMethodvue_type_template_id_08531346_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"payment-method-cards"},_vm._l((_vm.paymentOptions),function(p){return _c('payment-option-card',{key:p.type,staticClass:"payment-option",attrs:{"label":p.label,"type":p.type,"selected":p.type === _vm.selectedPaymentType},on:{"select":_vm.changePaymentType}})}),1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var NewPaymentMethodvue_type_template_id_08531346_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentOptionCard.vue?vue&type=template&id=07eedcb6&
var PaymentOptionCardvue_type_template_id_07eedcb6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-type-card",class:{'selected': _vm.selected},on:{"click":_vm.select}},[_c('div',{staticClass:"card-body"},[_c('icon',{attrs:{"name":_vm.paymentType}}),_c('p',[_vm._v(_vm._s(_vm.label))])],1)])
}
var PaymentOptionCardvue_type_template_id_07eedcb6_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentOptionCard.vue?vue&type=script&lang=js&


/* harmony default export */ var PaymentOptionCardvue_type_script_lang_js_ = ({
	props: [
		'selected',
		'label',
		'price',
		'type'
	],
	components: {
		Icon: Icon
	},
	computed: {
		paymentType() {
			switch (this.type) {
				case "DO": return 'bank';
				case "CC": return 'card';
			}
		}
	},
	methods: {
		select() {
			this.$emit('select', this.type)
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/payment/PaymentOptionCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_PaymentOptionCardvue_type_script_lang_js_ = (PaymentOptionCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/PaymentOptionCard.vue?vue&type=style&index=0&id=07eedcb6&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/PaymentOptionCard.vue?vue&type=style&index=0&id=07eedcb6&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/payment/PaymentOptionCard.vue



;


/* normalize component */

var PaymentOptionCard_component = (0,componentNormalizer/* default */.Z)(
  payment_PaymentOptionCardvue_type_script_lang_js_,
  PaymentOptionCardvue_type_template_id_07eedcb6_render,
  PaymentOptionCardvue_type_template_id_07eedcb6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentOptionCard = (PaymentOptionCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentMethod.vue?vue&type=script&lang=js&






/* harmony default export */ var NewPaymentMethodvue_type_script_lang_js_ = ({
	components: {ErrorBar: ErrorBar, PaymentOptionCard: PaymentOptionCard, Icon: Icon},
	data() {
		return {
			error: false,
			selectedPaymentType: false,
			paymentOptions: [
				{
					type: "DO",
					label: "Bank Account"
				},
				{
					type: "CC",
					label: "Debit / Credit Card"
				},
			]
		}
	},
	methods: {
		changePaymentType(type) {
			this.selectedPaymentType = type
		}
	},
	mounted() {
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('payment-methods');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.selectedPaymentType === 'DO') {
				that.$modal.push('new-payment-bank');
			} else if (that.selectedPaymentType === 'CC') {
				that.$modal.push('new-payment-card');
			} else {
				that.error = { message: "Please select a valid payment option" }
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentMethod.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_NewPaymentMethodvue_type_script_lang_js_ = (NewPaymentMethodvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentMethod.vue?vue&type=style&index=0&id=08531346&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentMethod.vue?vue&type=style&index=0&id=08531346&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentMethod.vue



;


/* normalize component */

var NewPaymentMethod_component = (0,componentNormalizer/* default */.Z)(
  payment_NewPaymentMethodvue_type_script_lang_js_,
  NewPaymentMethodvue_type_template_id_08531346_render,
  NewPaymentMethodvue_type_template_id_08531346_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NewPaymentMethod = (NewPaymentMethod_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewCard.vue?vue&type=template&id=622ee780&scoped=true&
var NewCardvue_type_template_id_622ee780_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body has-columns"},[_c('div',{staticClass:"modal-column"},[_c('payment-method-card',{ref:"card",attrs:{"selected":true,"focus-element":_vm.focusElement,"payment-method":_vm.card,"number-only":true}})],1),_c('div',{staticClass:"modal-column"},[_c('signup-input',{attrs:{"type":"text","name":"card-holder","label":"Card holder","disabled":false,"required":true},on:{"focus":_vm.inputFocus},model:{value:(_vm.card.card_holder),callback:function ($$v) {_vm.$set(_vm.card, "card_holder", $$v)},expression:"card.card_holder"}}),_c('signup-input',{attrs:{"type":"text","name":"card-number","label":"Card number","maxlength":"19","disabled":false,"required":true},on:{"focus":_vm.inputFocus,"input":_vm.cardNumberInput},model:{value:(_vm.card.card_number),callback:function ($$v) {_vm.$set(_vm.card, "card_number", $$v)},expression:"card.card_number"}}),_c('div',{staticClass:"half-size"},[_c('signup-select',{attrs:{"label":"MM","name":"expiry-month","disabled":false,"required":true,"error":false,"options":_vm.months},on:{"focus":_vm.inputFocus},model:{value:(_vm.card.expiry_month),callback:function ($$v) {_vm.$set(_vm.card, "expiry_month", $$v)},expression:"card.expiry_month"}}),_c('signup-select',{attrs:{"label":"YY","name":"expiry-year","disabled":false,"required":true,"error":false,"options":_vm.years},on:{"focus":_vm.inputFocus},model:{value:(_vm.card.expiry_year),callback:function ($$v) {_vm.$set(_vm.card, "expiry_year", $$v)},expression:"card.expiry_year"}}),_c('signup-input',{attrs:{"type":"text","name":"cvv","label":"CVV","maxlength":"4","disabled":false,"required":true},on:{"focus":_vm.inputFocus},model:{value:(_vm.card.cvv),callback:function ($$v) {_vm.$set(_vm.card, "cvv", $$v)},expression:"card.cvv"}})],1),_c('signup-input',{attrs:{"type":"text","label":"Name your card","maxlength":"50","disabled":false,"required":false},on:{"focus":_vm.inputFocus},model:{value:(_vm.card.friendly_name),callback:function ($$v) {_vm.$set(_vm.card, "friendly_name", $$v)},expression:"card.friendly_name"}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var NewCardvue_type_template_id_622ee780_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewCard.vue?vue&type=script&lang=js&







/* harmony default export */ var NewCardvue_type_script_lang_js_ = ({
	components: {ErrorBar: ErrorBar, SignupSelect: SignupSelect, SignupInput: SignupInput, PaymentMethodCard: PaymentMethodCard},
	data() {
		return {
			error: '',
			card: {
				payment_method: 'CC',
				card_number: '',
				card_holder: '',
				expiry_month: '',
				expiry_year: '',
				cvv: '',
				friendly_name: '',
				card_type: 'blank',
			},
			banks: [],
			focusElement: false,
		}
	},
	computed: {
		months() {
			return new Array(12).fill(undefined).map((m, index) => {
				return {
					label: ("00" + (index+1)).slice(-2),
					value: ("00" + (index+1)).slice(-2)
				}
			});
		},
		years() {
			return new Array(11).fill(undefined).map((m, index) => {
				return {
					label: (index+new Date(Date.now()).getFullYear()).toString().slice(-2),
					value: (index+new Date(Date.now()).getFullYear()).toString().slice(-2)
				}
			})
		}
	},
	methods: {
		bankSelect(value) {
			this.card.branch_code = this.banks.find(bank => {
				return bank.value === value;
			}).branch_code;
		},
		next() {
			this.$modal.toggleLoader(true);
			// this.$signup.$store.commit('signupPayment/updateCurrentPaymentMethod');
			// console.log(this.card)
			this.$signup.$store.dispatch('signupPayment/createCreditCardToken', {
				card:this.card,
				url: window.location.origin + window.location.pathname // add this because we can't control which page the plugin is on
			})
				.then(res => {
					this.$modal.push('three-dee-secure');

					try {
						this.$signup.$store.dispatch('signupSignal/sendEvent', {
							type: 'payment-detail-create-card',
							value: null,
							meta: null,
						})
					}

					catch (e) {
						console.log(e)
					}

				})
				.catch((err) => {
					this.$modal.toggleLoader(false);
					this.error = {message: err.data.message}
				});
		},
		cardNumberInput(value) {
			let str = value.replace(/[^\dA-Z]/g, '');
			this.card.card_number = str.replace(/(.{4})/g, '$1 ').trim();

			if (str.match(/^4[0-9]{6,}$/)) {
				this.card.card_type = 'Visa';
			} else if (str.match(/^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$/)) {
				this.card.card_type = 'Mastercard';
			} else {
				this.card.card_type = 'blank';
			}
		},
		inputFocus(e) {
			this.focusElement = e.target.name;
		},

	},
	mounted() {
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push(that.$modal.state.previous.name);
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.error = false;
			if (that.card.card_number === '') {
				that.error = { message: 'Card number cannot be empty.' };
			} else if (that.card.card_holder === '') {
				that.error = { message: 'Card holder cannot be empty.' };
			} else if (that.card.expiry_month === '') {
				that.error = { message: 'Please specify your card expiry date.' };
			} else if (that.card.expiry_year === '') {
				that.error = { message: 'Please specify your card expiry date.' };
			} else if (that.card.cvv === '') {
				that.error = { message: 'CVV code cannot be empty.' };
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	},
});

;// CONCATENATED MODULE: ./src/modals/payment/NewCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_NewCardvue_type_script_lang_js_ = (NewCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewCard.vue?vue&type=style&index=0&id=622ee780&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/NewCard.vue?vue&type=style&index=0&id=622ee780&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/payment/NewCard.vue



;


/* normalize component */

var NewCard_component = (0,componentNormalizer/* default */.Z)(
  payment_NewCardvue_type_script_lang_js_,
  NewCardvue_type_template_id_622ee780_scoped_true_render,
  NewCardvue_type_template_id_622ee780_scoped_true_staticRenderFns,
  false,
  null,
  "622ee780",
  null
  
)

/* harmony default export */ var NewCard = (NewCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentConfirmation.vue?vue&type=template&id=6c1db781&scoped=true&
var NewPaymentConfirmationvue_type_template_id_6c1db781_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"tick-circle"}})],1),_c('h1',[_vm._v(" New payment method added ")]),_c('p',[_vm._v(" "+_vm._s(_vm.payment)+" ")]),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Continue ")])])
}
var NewPaymentConfirmationvue_type_template_id_6c1db781_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentConfirmation.vue?vue&type=script&lang=js&


/* harmony default export */ var NewPaymentConfirmationvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	computed: {
		payment() {
			let method = this.$signup.$store.getters['signupPayment/currentPaymentMethod'].payment_method;
			let number = method === 'DO' ?
				this.$signup.$store.getters['signupPayment/currentPaymentMethod'].account_number :
				method === 'CC' ?
				this.$signup.$store.getters['signupPayment/currentPaymentMethod'].masked_number :
				'';
			return `${method === 'DO' ? 'Bank account' : 'Credit card'} ending with ${number.toString().substr(number.length - 4, number.length)}`
		}
	},
	methods: {
		next() {
			this.$modal.push('payment-methods');
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);

		if (!this.$signup.$store.getters['signupPayment/currentPaymentMethod']) {
			this.$modal.close();
			return;
		}

		//clear payment data for security purposes
		this.$signup.$store.commit('signupPayment/updateCurrentPaymentMethod', {
			...this.$signup.$store.getters['signupPayment/currentPaymentMethod'],
			cvv: '',
			card_number: '',
		});

		try {
			this.$signup.$store.dispatch('signupSignal/sendEvent', {
				type: 'payment-detail-created',
				value: null,
				meta: null,
			})
		} catch (e) {

		}
	}

});

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentConfirmation.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_NewPaymentConfirmationvue_type_script_lang_js_ = (NewPaymentConfirmationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentConfirmation.vue?vue&type=style&index=0&id=6c1db781&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentConfirmation.vue?vue&type=style&index=0&id=6c1db781&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentConfirmation.vue



;


/* normalize component */

var NewPaymentConfirmation_component = (0,componentNormalizer/* default */.Z)(
  payment_NewPaymentConfirmationvue_type_script_lang_js_,
  NewPaymentConfirmationvue_type_template_id_6c1db781_scoped_true_render,
  NewPaymentConfirmationvue_type_template_id_6c1db781_scoped_true_staticRenderFns,
  false,
  null,
  "6c1db781",
  null
  
)

/* harmony default export */ var NewPaymentConfirmation = (NewPaymentConfirmation_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/3DSecure.vue?vue&type=template&id=52af7692&scoped=true&
var _3DSecurevue_type_template_id_52af7692_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.threeDee)?_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":_vm.logoX1,"srcset":`${_vm.logoX1} 1x, ${_vm.logoX2}  2x`}})]),_c('form',{ref:"VCSForm",attrs:{"method":"POST","action":"https://www.vcs.co.za/vvonline/vcspay.aspx","name":"ccf","id":"ccf"}},[_c('input',{attrs:{"type":"hidden","name":"p1"},domProps:{"value":_vm.threeDee.parameters.vcs_terminal_id}}),_c('input',{attrs:{"type":"hidden","name":"p2"},domProps:{"value":_vm.threeDee.verification.reference}}),_c('input',{attrs:{"type":"hidden","name":"p3","value":"Afrihost - Card Verification"}}),_c('input',{attrs:{"type":"hidden","name":"p4","value":"1"}}),_c('input',{attrs:{"type":"hidden","name":"p6","value":"1"}}),_c('input',{attrs:{"type":"hidden","name":"p7","value":"O"}}),_c('input',{attrs:{"type":"hidden","name":"p12","value":"Y"}}),_c('input',{attrs:{"type":"hidden","name":"Hash"},domProps:{"value":_vm.threeDee.verification.hash}}),_c('input',{attrs:{"type":"hidden","name":"UrlsProvided","value":"Y"}}),_c('input',{attrs:{"type":"hidden","name":"ApprovedUrl"},domProps:{"value":_vm.threeDee.url.ApprovedUrl}}),_c('input',{attrs:{"type":"hidden","name":"DeclinedUrl"},domProps:{"value":_vm.threeDee.url.DeclinedUrl}}),_c('input',{attrs:{"type":"hidden","name":"PaymentMethod","value":"cc"}}),_c('input',{attrs:{"type":"hidden","name":"CardholderName"},domProps:{"value":_vm.card.card_holder}}),_c('input',{attrs:{"type":"hidden","name":"CardNumber"},domProps:{"value":_vm.card.card_number}}),_c('input',{attrs:{"type":"hidden","name":"ExpiryDate"},domProps:{"value":_vm.card.expiry_year + '' + _vm.card.expiry_month}}),_c('input',{attrs:{"type":"hidden","name":"CVV"},domProps:{"value":_vm.card.cvv}}),_c('input',{attrs:{"type":"hidden","name":"m_1","value":""}}),_c('input',{attrs:{"type":"hidden","name":"m_2"},domProps:{"value":_vm.threeDee.parameters.m_2}}),_c('input',{attrs:{"type":"hidden","name":"m_3"},domProps:{"value":_vm.threeDee.parameters.m_3}}),_c('div',{staticClass:"body-section"},[_c('h1',[_vm._v("Verify Your Card")]),_c('p',[_vm._v(" You'll need to verify your card with 3D Secure. By continuing, you will be directed to your bank to approve a R1 transaction which will be refunded. ")]),_c('p',[_vm._v(" Once completed, you will be brought back here to complete your signup. ")]),_c('button',{staticClass:"signup-button",attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.verifyCard.apply(null, arguments)}}},[_c('span',{staticClass:"label"},[_vm._v("Verify Card")])])])])]):_vm._e()
}
var _3DSecurevue_type_template_id_52af7692_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/3DSecure.vue?vue&type=script&lang=js&



/* harmony default export */ var _3DSecurevue_type_script_lang_js_ = ({
	data() {
		return {
			threeDee: false,
			card: false,
			logoX1: afrihost_logo_namespaceObject,
			logoX2: afrihost_logo_2x_namespaceObject,
		}
	},
	mounted() {
		this.threeDee = this.$signup.$store.getters['signupPayment/cardToken'];
		this.card = this.$signup.$store.getters['signupPayment/currentPaymentMethod'];
		this.$modal.toggleLoader(false);
	},
	methods: {
		verifyCard(e) {
			// console.log("VERIFY!", e);
			// console.log(this.$refs['VCSForm']);
			// let windowFeatures = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,innerWidth=400"
			// let newWindow = window.open('', 'VCSWindow', windowFeatures);
			// newWindow.addEventListener('locationchange', function(e){
			// 	console.log('location changed!', e);
			// })
			this.$refs['VCSForm'].submit();
		}
	}
});

;// CONCATENATED MODULE: ./src/modals/payment/3DSecure.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_3DSecurevue_type_script_lang_js_ = (_3DSecurevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/3DSecure.vue?vue&type=style&index=0&id=52af7692&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/3DSecure.vue?vue&type=style&index=0&id=52af7692&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/payment/3DSecure.vue



;


/* normalize component */

var _3DSecure_component = (0,componentNormalizer/* default */.Z)(
  payment_3DSecurevue_type_script_lang_js_,
  _3DSecurevue_type_template_id_52af7692_scoped_true_render,
  _3DSecurevue_type_template_id_52af7692_scoped_true_staticRenderFns,
  false,
  null,
  "52af7692",
  null
  
)

/* harmony default export */ var _3DSecure = (_3DSecure_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentFailed.vue?vue&type=template&id=046b0e0d&scoped=true&
var NewPaymentFailedvue_type_template_id_046b0e0d_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"warning-circle"}})],1),_c('h1',[_vm._v(" New payment method was not added ")]),_c('p',[_vm._v(" Adding the payment method failed ")]),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Edit payment details ")])])
}
var NewPaymentFailedvue_type_template_id_046b0e0d_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentFailed.vue?vue&type=script&lang=js&


/* harmony default export */ var NewPaymentFailedvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	methods: {
		next() {
			this.$modal.push('new-payment-card');
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);

		if (!this.$signup.$store.getters['signupPayment/currentPaymentMethod']) {
			this.$modal.close();
			return;
		}
	}

});

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentFailed.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_NewPaymentFailedvue_type_script_lang_js_ = (NewPaymentFailedvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/payment/NewPaymentFailed.vue?vue&type=style&index=0&id=046b0e0d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentFailed.vue?vue&type=style&index=0&id=046b0e0d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/payment/NewPaymentFailed.vue



;


/* normalize component */

var NewPaymentFailed_component = (0,componentNormalizer/* default */.Z)(
  payment_NewPaymentFailedvue_type_script_lang_js_,
  NewPaymentFailedvue_type_template_id_046b0e0d_scoped_true_render,
  NewPaymentFailedvue_type_template_id_046b0e0d_scoped_true_staticRenderFns,
  false,
  null,
  "046b0e0d",
  null
  
)

/* harmony default export */ var NewPaymentFailed = (NewPaymentFailed_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/Summary.vue?vue&type=template&id=7bc8b5c8&
var Summaryvue_type_template_id_7bc8b5c8_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.solution.solution_type === 'composite_fibre')?_c('div',{ref:"modal-body",staticClass:"modal-body has-columns summary"},[(_vm.testSignup)?_c('p',{staticClass:"warn"},[_vm._v("Your order will be validated but it will "),_c('strong',[_vm._v("not")]),_vm._v(" be processed because this is a development build.")]):_vm._e(),_c('coupon-bar',{attrs:{"solution":_vm.solution},on:{"apply":_vm.applyCoupon}}),_c('div',{staticClass:"modal-column no-padding"},[(_vm.solution.solution_type === 'composite_fibre')?_c('summary-card-fibre',{attrs:{"solution":_vm.solution,"is-pre-order":_vm.provider.pre_order}}):_vm._e(),(_vm.maxProduct)?_c('summary-card-max',{attrs:{"product":_vm.maxProduct}}):_vm._e(),_c('summary-card-devices')],1),_c('div',{staticClass:"modal-column"},[(_vm.solutionLocation.order_type !== 'transfer')?_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head"},[_c('p',{},[_vm._v("Setup costs")]),_c('icon',{attrs:{"name":"cog"}})],1),_vm._l((_vm.provider.eventPrices.filter(e => e.event_type === 'install')),function(prices){return _c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(prices.pricing_type.name))]),_c('div',{staticClass:"price-compare"},[_c('p',{staticClass:"item-value price"},[_vm._v(_vm._s(_vm._f("formatPrice")(prices.retail_price))+" with Afrihost")]),(prices.base_price > 0)?_c('p',{staticClass:"strike"},[_vm._v(_vm._s(_vm._f("formatPrice")(prices.base_price)))]):_vm._e()])])})],2):_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head"},[_c('p',{},[_vm._v("Setup costs")]),_c('icon',{attrs:{"name":"cog"}})],1),_vm._l((_vm.provider.eventPrices.filter(e => e.event_type === 'migrate_in')),function(prices){return _c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(prices.pricing_type.name))]),_c('div',{staticClass:"price-compare"},[_c('p',{staticClass:"item-value price"},[_vm._v(_vm._s(_vm._f("formatPrice")(prices.retail_price))+" with Afrihost")]),(prices.base_price > 0)?_c('p',{staticClass:"strike"},[_vm._v(_vm._s(_vm._f("formatPrice")(prices.base_price)))]):_vm._e()])])})],2),_c('summary-card-delivery'),_c('summary-payment-card')],1),_c('global-error',{attrs:{"error":_vm.globalError,"message":_vm.globalError.message,"goto":_vm.globalError.goto}}),_c('portal',{attrs:{"to":"terms-portal"}},[_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}}),_c('div',{ref:"terms",staticClass:"terms-section"},[_c('div',{staticClass:"terms"},[_c('signup-checkbox',{on:{"input":_vm.checkTncs},model:{value:(_vm.acceptTnc),callback:function ($$v) {_vm.acceptTnc=$$v},expression:"acceptTnc"}}),_c('p',[_vm._v(" By placing this order you accept all "),_c('a',{attrs:{"href":"https://www.afrihost.com/terms-and-conditions","target":"_blank"}},[_vm._v("Terms and Conditions")])])],1),(_vm.payment.payment_method === 'DO')?_c('div',{staticClass:"terms"},[_c('signup-checkbox',{on:{"input":_vm.checkTncs},model:{value:(_vm.acceptPayment),callback:function ($$v) {_vm.acceptPayment=$$v},expression:"acceptPayment"}}),_c('p',[_vm._v(" I authorise Afrihost to draw the monthly amount against the account specified. This authorisation is to remain in force until terminated by Afrihost or myself. I accept that Afrihost may debit my account on a date other than specified. If there are insufficient funds in the nominated account to meet the monthly payment due, Afrihost is entitled to track my account and present the instruction for payment as soon as sufficient funds are available. ")])],1):_vm._e()])],1),(!_vm.mobileWindow)?_c('portal-target',{attrs:{"name":"terms-portal"}}):_vm._e()],1):_vm._e()
}
var Summaryvue_type_template_id_7bc8b5c8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardDevices.vue?vue&type=template&id=70896d09&
var SummaryCardDevicesvue_type_template_id_70896d09_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.devices && _vm.devices.length)?_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head"},[_c('p',{},[_vm._v("Hardware")]),_c('icon',{attrs:{"name":"blocks"}})],1),_vm._l((_vm.devices),function(device,i){return _c('summary-item-device',{key:i,attrs:{"device":device}})}),(_vm.hasFreeRouter)?_c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_c('icon',{directives:[{name:"signup-show-tooltip",rawName:"v-signup-show-tooltip"}],staticClass:"pointer",attrs:{"name":"error"}}),_vm._v(" Fibre promotion ")],1),_c('p',{staticClass:"item-value price positive"},[_vm._v("-"+_vm._s(_vm._f("formatPrice")(999)))]),_c('div',{staticClass:"tooltip"},[_c('icon',{directives:[{name:"signup-hide-tooltip",rawName:"v-signup-hide-tooltip"}],attrs:{"name":"cross"}}),_vm._m(0)],1)]):_vm._e()],2):_vm._e()
}
var SummaryCardDevicesvue_type_template_id_70896d09_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" Your Fibre Router is included in the "),_c('strong',[_vm._v("Save up to R5000 promotion")]),_vm._v(". Sign up now and get your WiFi Router for FREE. Yours to keep, forever. ")])
}]


;// CONCATENATED MODULE: ./src/components/summary/SummaryCardDevices.vue?vue&type=template&id=70896d09&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryItemDevice.vue?vue&type=template&id=2084ebdf&
var SummaryItemDevicevue_type_template_id_2084ebdf_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meta)?_c('div',{staticClass:"section",attrs:{"id":""}},[_c('div',{staticClass:"summary-line"},[_c('div',{staticClass:"info"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.meta.name)+" "),(_vm.device.qty > 1)?_c('span',[_vm._v(" (x"+_vm._s(_vm.device.qty)+")")]):_vm._e()]),_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.meta.category))]),(_vm.isMax)?_c('p',{staticClass:"price"},[_vm._v("Included with Max Uptime "+_vm._s(_vm.device.qty > 1 || _vm.device.product_id === 827991 ? 'VIP' : ""))]):_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.meta.price)))])]),_c('div',{staticClass:"image"},[(_vm.deviceHero)?_c('img',{attrs:{"src":_vm.deviceHero.oneX,"srcset":`${_vm.deviceHero.twoX} 2x`}}):_vm._e()])])]):_vm._e()
}
var SummaryItemDevicevue_type_template_id_2084ebdf_staticRenderFns = []


;// CONCATENATED MODULE: ./src/assets/images/router.png
var router_namespaceObject = __webpack_require__.p + "img/router.141124f6.png";
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryItemDevice.vue?vue&type=script&lang=js&











/* harmony default export */ var SummaryItemDevicevue_type_script_lang_js_ = ({
	props: ['device'],
	computed: {
		isMax() {
			return !!this.device.cart_item_requirements.find(c => c.name === 'max_uptime_included')
		},
		meta() {
			switch (this.device.product_id) {
				case 890991: // tp-link ex511
					return {
						name: 'TP-Link EX511',
						category: 'Fibre Router',
						price: 0
					}
				case 826991: // x50 3 pack
					return {
						name: 'Deco X50 3 Pack',
						category: 'Mesh WiFi',
						price: 5999
					}
				case 827991: // x50 2 pack
					return {
						name: 'Deco X50 2 Pack',
						category: 'Mesh WiFi',
						price: 3999
					}
				case 798991: // gizzu ups
					return {
						name: 'Gizzu-GUP36W',
						category: 'UPS',
						price: 999
					}
				default:
					return false
			}
		},
		deviceHero() {
			if (this.device.product_type_slug === 'solution_tangible_fibre') {
				return {
					oneX: router_namespaceObject,
					twoX: router_namespaceObject,
				}
			}
			switch (this.device.product_id) {
				case 827991 :
					return {
						oneX: _2201_TPLink_DecoX50_hero_namespaceObject,
						twoX: _2201_TPLink_DecoX50_hero_2x_namespaceObject,
					}
				case 826991 :
					return {
						oneX: _2201_TPLink_Deco_X50_3_pack_hero_namespaceObject,
						twoX: _2201_TPLink_Deco_X50_3_pack_hero_2x_namespaceObject,
					}
				case 798991 :
					return {
						oneX: Gizzu_GUP36W_OrderForms_namespaceObject,
						twoX: Gizzu_GUP36W_OrderForms_2x_namespaceObject,
					}
				case 819991 :
					return {
						oneX: _21_10_DC100_Plus_Hero_namespaceObject,
						twoX: _21_10_DC100_Plus_Hero_2x_namespaceObject,
					}
				default:
					return false
			}
		}
	},
	mounted() {
		console.log(this.device)
	}
});

;// CONCATENATED MODULE: ./src/components/summary/SummaryItemDevice.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummaryItemDevicevue_type_script_lang_js_ = (SummaryItemDevicevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SummaryItemDevice.vue





/* normalize component */
;
var SummaryItemDevice_component = (0,componentNormalizer/* default */.Z)(
  summary_SummaryItemDevicevue_type_script_lang_js_,
  SummaryItemDevicevue_type_template_id_2084ebdf_render,
  SummaryItemDevicevue_type_template_id_2084ebdf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummaryItemDevice = (SummaryItemDevice_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardDevices.vue?vue&type=script&lang=js&

	
	

	/* harmony default export */ var SummaryCardDevicesvue_type_script_lang_js_ = ({
		components: {
			Icon: Icon,
			SummaryItemDevice: SummaryItemDevice
		},
		computed: {
			devices() {
				let devices = [];
				this.$signup.$store.getters['signupCart/cartItems'].forEach(i => {
					if([
						'solution_tangible_fibre',
						'solution_tangible_mesh',
						'solution_tangible_ups',
					].indexOf(i.product_type_slug) >= 0) {
						devices.push(i);
					}
				})

				let uniqueDevices = []
				devices.forEach(d => {
					let device = uniqueDevices.find(ud => ud.product_id === d.product_id);
					if(!device) {
						d.qty = 1
						uniqueDevices.push(d)
					} else {
						device.qty = device.qty+1
					}
				})


				return uniqueDevices
				return this.$signup.$store.getters['signupSolutions/selectedDevices'];
			},
			hasFreeRouter() {
				return !!this.devices.find(d => d.product_type_slug === 'solution_tangible_fibre')
			}
		},
		directives: {
			SignupShowTooltip(el) {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					e.target.closest('.summary-card').querySelector('.tooltip').classList.add('show');
				})
			},
			SignupHideTooltip(el) {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					e.target.closest('.tooltip').classList.remove('show');
				})
			},
		},
	});

;// CONCATENATED MODULE: ./src/components/summary/SummaryCardDevices.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummaryCardDevicesvue_type_script_lang_js_ = (SummaryCardDevicesvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SummaryCardDevices.vue





/* normalize component */
;
var SummaryCardDevices_component = (0,componentNormalizer/* default */.Z)(
  summary_SummaryCardDevicesvue_type_script_lang_js_,
  SummaryCardDevicesvue_type_template_id_70896d09_render,
  SummaryCardDevicesvue_type_template_id_70896d09_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummaryCardDevices = (SummaryCardDevices_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardFibre.vue?vue&type=template&id=a9471d54&
var SummaryCardFibrevue_type_template_id_a9471d54_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head",class:{'pre-order': _vm.isPreOrder}},[_c('div',[(_vm.isPreOrder)?_c('span',{staticClass:"tag pre-order"},[_vm._v("Pre-order")]):_vm._e(),_c('p',{staticClass:"product"},[_vm._v(_vm._s(_vm.solution.display_name))]),(_vm.solution.price_promo)?_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.solution.price_promo))+"pm")]):_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.solution.price))+"pm ("),(_vm.solution.id === 2258820)?_c('span',[_vm._v("From June 2025*")]):_vm._e(),_vm._v(")")])]),_c('icon',{attrs:{"name":"bolt"}})],1),_c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_vm._v("Download speed")]),_c('p',{staticClass:"item-value"},[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolutionFibre.line_download_speed}})],1)]),_c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_vm._v("Upload speed")]),_c('p',{staticClass:"item-value"},[_c('formatted-speed',{attrs:{"speed":_vm.lineChildSolutionFibre.line_upload_speed}})],1)]),_vm._m(0),(_vm.coupon)?_c('coupon-line-item',{attrs:{"coupon":_vm.coupon}}):_vm._e()],1)
}
var SummaryCardFibrevue_type_template_id_a9471d54_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_vm._v("Data included")]),_c('p',{staticClass:"item-value"},[_vm._v("Uncapped")])])
}]


;// CONCATENATED MODULE: ./src/components/summary/SummaryCardFibre.vue?vue&type=template&id=a9471d54&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/CouponLineItem.vue?vue&type=template&id=7df07fc9&
var CouponLineItemvue_type_template_id_7df07fc9_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-line-item"},[_c('div',{staticClass:"left-side"},[_c('svg',{staticClass:"icon",attrs:{"width":"18px","height":"18px","viewBox":"0 0 18 18"}},[_c('path',{attrs:{"d":"M11.7459397,0.0245677889 C11.9060325,0.0682438581 12.0208817,0.170154686 12.0904872,0.330300273 L13.4060325,2.68880801 L15.974478,3.23475887 C16.1276102,3.26387625 16.2563805,3.34758872 16.3607889,3.48589627 C16.4521462,3.60691538 16.4928763,3.74186761 16.4829793,3.89075296 L16.1832947,6.57597816 L17.8329466,8.56323931 C17.9443155,8.67970883 18,8.82529572 18,9 C18,9.17470428 17.9443155,9.32029117 17.8329466,9.43676069 L16.1832947,11.4458599 L16.4756381,14.066424 C16.5034803,14.2411283 16.4651972,14.3976342 16.3607889,14.5359418 C16.2563805,14.6742493 16.1276102,14.7579618 15.974478,14.7870792 L13.4060325,15.33303 L12.0904872,17.6696997 C12.0208817,17.8298453 11.9060325,17.9317561 11.7459397,17.9754322 C11.5858469,18.0191083 11.4292343,18.0045496 11.2761021,17.9317561 L9,16.8180164 L6.72389791,17.9317561 C6.57076566,18.0045496 6.41763341,18.0118289 6.26450116,17.9535942 C6.11136891,17.8953594 5.99303944,17.7934486 5.90951276,17.6478617 L4.61484919,15.33303 L2.02552204,14.7870792 C1.87238979,14.7579618 1.74361949,14.6742493 1.63921114,14.5359418 C1.54785383,14.4149227 1.50712369,14.2799704 1.51702074,14.1310851 L1.81670534,11.4458599 L0.167053364,9.43676069 C0.0556844548,9.32029117 0,9.17470428 0,9 C0,8.82529572 0.0556844548,8.67970883 0.167053364,8.56323931 L1.81670534,6.57597816 L1.52436195,3.95541401 C1.49651972,3.78070974 1.53480278,3.62420382 1.63921114,3.48589627 C1.74361949,3.34758872 1.87238979,3.26387625 2.02552204,3.23475887 L4.61484919,2.68880801 L5.90951276,0.352138308 C5.99303944,0.20655141 6.11136891,0.104640582 6.26450116,0.0464058235 C6.41763341,-0.0118289354 6.57076566,-0.00454959054 6.72389791,0.0682438581 L9,1.18198362 L11.2761021,0.0682438581 C11.4292343,-0.00454959054 11.5858469,-0.0191082803 11.7459397,0.0245677889 Z M11.6670688,8.81785714 C11.3561951,8.81785714 11.073755,8.87142857 10.8197484,8.97857143 C10.5657419,9.08571429 10.3496467,9.23035714 10.171463,9.4125 C9.99327934,9.59464286 9.85490264,9.80714286 9.75633293,10.05 C9.67184461,10.2581633 9.62356557,10.4794461 9.61149581,10.7138484 L9.60847837,10.8535714 C9.60847837,11.125 9.65776323,11.3821429 9.75633293,11.625 C9.85490264,11.8678571 9.99327934,12.0803571 10.171463,12.2625 C10.3496467,12.4446429 10.5657419,12.5892857 10.8197484,12.6964286 C11.073755,12.8035714 11.3524039,12.8571429 11.6556953,12.8571429 C11.966569,12.8571429 12.2471136,12.8035714 12.497329,12.6964286 C12.7475444,12.5892857 12.9636395,12.4446429 13.1456143,12.2625 C13.3275892,12.0803571 13.4678615,11.8660714 13.5664312,11.6196429 C13.6509195,11.4084184 13.6991985,11.1880102 13.7112683,10.9584184 L13.7142857,10.8214286 C13.7142857,10.5428571 13.6650009,10.2821429 13.5664312,10.0392857 C13.4678615,9.79642857 13.3294847,9.58392857 13.1513011,9.40178571 C12.9731174,9.21964286 12.7589178,9.07678571 12.5087024,8.97321429 C12.258487,8.86964286 11.9779424,8.81785714 11.6670688,8.81785714 Z M12.8385318,5.25 L11.3031191,5.25 L8.51662933,8.71071429 L5.16146821,12.75 L6.69688092,12.75 L9.44925039,9.33214286 L12.8385318,5.25 Z M11.6556953,9.98571429 C11.8528347,9.98571429 12.0139583,10.0660714 12.139066,10.2267857 C12.2485352,10.3674107 12.3101117,10.539481 12.3237953,10.7429967 L12.3267276,10.8535714 C12.3267276,11.0892857 12.2660693,11.2857143 12.1447527,11.4428571 C12.0234362,11.6 11.8642082,11.6785714 11.6670688,11.6785714 C11.4775116,11.6785714 11.3182836,11.5982143 11.1893848,11.4375 C11.0765983,11.296875 11.0131559,11.1275391 10.9990576,10.9294922 L10.9960365,10.8214286 C10.9960365,10.5785714 11.0547992,10.3785714 11.1723247,10.2214286 C11.2898501,10.0642857 11.4509736,9.98571429 11.6556953,9.98571429 Z M6.34430467,5.14285714 C6.03343098,5.14285714 5.75099087,5.19642857 5.49698432,5.30357143 C5.24297777,5.41071429 5.02688265,5.55535714 4.84869895,5.7375 C4.67051525,5.91964286 4.53213855,6.13214286 4.43356884,6.375 C4.34908052,6.58316327 4.30080149,6.80444606 4.28873173,7.0388484 L4.28571429,7.17857143 C4.28571429,7.45 4.33499914,7.70714286 4.43356884,7.95 C4.53213855,8.19285714 4.67241082,8.40535714 4.85438566,8.5875 C5.0363605,8.76964286 5.25245563,8.9125 5.50267103,9.01607143 C5.75288644,9.11964286 6.02963984,9.17142857 6.33293124,9.17142857 C6.64380493,9.17142857 6.92434947,9.11785714 7.17456488,9.01071429 C7.42478029,8.90357143 7.64087541,8.75892857 7.82285025,8.57678571 C8.00482509,8.39464286 8.14509736,8.18214286 8.24366707,7.93928571 C8.32815539,7.73112245 8.37643443,7.51246356 8.38850419,7.28330904 L8.39152163,7.14642857 C8.39152163,6.86785714 8.34223677,6.60714286 8.24366707,6.36428571 C8.14509736,6.12142857 8.00672066,5.90892857 7.82853696,5.72678571 C7.65035327,5.54464286 7.43615371,5.40178571 7.18593831,5.29821429 C6.9357229,5.19464286 6.65517836,5.14285714 6.34430467,5.14285714 Z M6.33293124,6.31071429 C6.53007065,6.31071429 6.69119421,6.39107143 6.81630191,6.55178571 C6.92577115,6.69241071 6.9873476,6.86448103 7.00103126,7.06799665 L7.00396347,7.17857143 C7.00396347,7.41428571 6.94330519,7.61071429 6.82198863,7.76785714 C6.70067207,7.925 6.54144408,8.00357143 6.34430467,8.00357143 C6.15474754,8.00357143 5.99551956,7.92321429 5.86662071,7.7625 C5.75383422,7.621875 5.69039182,7.45253906 5.67629351,7.25449219 L5.67327245,7.14642857 C5.67327245,6.90357143 5.73393073,6.70357143 5.85524729,6.54642857 C5.97656385,6.38928571 6.13579183,6.31071429 6.33293124,6.31071429 Z","fill":"#6ECA1E","fill-rule":"nonzero"}})]),_c('dl',{staticClass:"label"},[_c('dt',[_vm._v("Coupon")]),_c('dd',[_vm._v(_vm._s(_vm.coupon.coupon_code))])])]),_c('div',{staticClass:"right-side"},[_c('dl',{staticClass:"value"},[_c('dt',[_vm._v(_vm._s(_vm._f("couponValue")(_vm.coupon)))]),_c('dd',[_vm._v(_vm._s(_vm._f("couponRecurrence")(_vm.coupon)))])])])])
}
var CouponLineItemvue_type_template_id_7df07fc9_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/CouponLineItem.vue?vue&type=script&lang=js&

	/* harmony default export */ var CouponLineItemvue_type_script_lang_js_ = ({
		props: ['coupon']
	});

;// CONCATENATED MODULE: ./src/components/summary/CouponLineItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_CouponLineItemvue_type_script_lang_js_ = (CouponLineItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/CouponLineItem.vue?vue&type=style&index=0&id=7df07fc9&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/summary/CouponLineItem.vue?vue&type=style&index=0&id=7df07fc9&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/summary/CouponLineItem.vue



;


/* normalize component */

var CouponLineItem_component = (0,componentNormalizer/* default */.Z)(
  summary_CouponLineItemvue_type_script_lang_js_,
  CouponLineItemvue_type_template_id_7df07fc9_render,
  CouponLineItemvue_type_template_id_7df07fc9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CouponLineItem = (CouponLineItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardFibre.vue?vue&type=script&lang=js&

	
	
	

	/* harmony default export */ var SummaryCardFibrevue_type_script_lang_js_ = ({
		props: ['solution', 'isPreOrder'],
		components: {
			CouponLineItem: CouponLineItem,
			Icon: Icon,
			FormattedSpeed: FormattedSpeed
		},
		computed: {
			coupon() {
				let coupon = this.$signup.$store.getters['signupCart/coupon'];
				// if(!coupon) return false
				return coupon && coupon.available_for_solutions.includes(this.solution.id) ? coupon.coupon : false
			},
			lineChildSolutionFibre() {
				let lineChildSolution = this.solution.solution_composite_child_metas.find(s => {
					return s.child_solution.display_category_slug === 'fibre_line';
				});

				return lineChildSolution ? lineChildSolution.child_solution : false;
			},
		}
	});

;// CONCATENATED MODULE: ./src/components/summary/SummaryCardFibre.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummaryCardFibrevue_type_script_lang_js_ = (SummaryCardFibrevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SummaryCardFibre.vue





/* normalize component */
;
var SummaryCardFibre_component = (0,componentNormalizer/* default */.Z)(
  summary_SummaryCardFibrevue_type_script_lang_js_,
  SummaryCardFibrevue_type_template_id_a9471d54_render,
  SummaryCardFibrevue_type_template_id_a9471d54_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummaryCardFibre = (SummaryCardFibre_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardDelivery.vue?vue&type=template&id=4f1615db&
var SummaryCardDeliveryvue_type_template_id_4f1615db_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.delivery)?_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head"},[_c('p',{},[_vm._v(_vm._s(_vm.delivery.name))]),_c('icon',{attrs:{"name":_vm.delivery.name.indexOf('Collect') > -1 ? 'collect' : 'deliver'}})],1),_c('div',{staticClass:"summary-line"},[(_vm.delivery.name.indexOf('Collect') > -1)?_c('div',{staticClass:"info"},[_c('p',[_vm._v("Afrihost HQ,")]),_c('p',[_vm._v("376 Rivonia Boulevard")]),_c('p',[_vm._v("Edenburg, Johannesburg")]),_c('p',[_vm._v("2124")])]):_c('div',{staticClass:"info"},[_c('p',{},[_vm._v(_vm._s(`${_vm.deliveryLocation.building_number} ${_vm.deliveryLocation.building_name}`))]),_c('p',{},[_vm._v(_vm._s(`${_vm.deliveryLocation.street_number} ${_vm.deliveryLocation.street_name},`))]),_c('p',{},[_vm._v(_vm._s(`${_vm.deliveryLocation.suburb}, ${_vm.deliveryLocation.city_name}`))]),_c('p',{},[_vm._v(_vm._s(`${_vm.deliveryLocation.postal_code}`))])]),_c('p',{staticClass:"item-value price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.delivery.price)))])]),(_vm.eta)?_c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_c('icon',{directives:[{name:"signup-show-tooltip",rawName:"v-signup-show-tooltip"}],staticClass:"pointer",attrs:{"name":"error"}}),_vm._v(" When will I get it? ")],1),_c('div',{staticClass:"tooltip"},[_c('icon',{directives:[{name:"signup-hide-tooltip",rawName:"v-signup-hide-tooltip"}],attrs:{"name":"cross"}}),_c('p',[_vm._v(_vm._s(_vm.eta.term))])],1)]):_vm._e()]):_vm._e()
}
var SummaryCardDeliveryvue_type_template_id_4f1615db_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardDelivery.vue?vue&type=script&lang=js&

	
	/* harmony default export */ var SummaryCardDeliveryvue_type_script_lang_js_ = ({
		components: {
			Icon: Icon
		},
		computed: {
			delivery() {
				return this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote']
			},
			deliveryLocation() {
				return this.$signup.$store.getters['signupDelivery/deliveryLocation']
			},
			eta() {
				return this.delivery.terms.find((t) => { return t.type === 'eta' })
			}
		},
		directives: {
			SignupShowTooltip(el) {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					e.target.closest('.summary-card').querySelector('.tooltip').classList.add('show');
				})
			},
			SignupHideTooltip(el) {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					e.target.closest('.tooltip').classList.remove('show');
				})
			},
		},
	});

;// CONCATENATED MODULE: ./src/components/summary/SummaryCardDelivery.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummaryCardDeliveryvue_type_script_lang_js_ = (SummaryCardDeliveryvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SummaryCardDelivery.vue





/* normalize component */
;
var SummaryCardDelivery_component = (0,componentNormalizer/* default */.Z)(
  summary_SummaryCardDeliveryvue_type_script_lang_js_,
  SummaryCardDeliveryvue_type_template_id_4f1615db_render,
  SummaryCardDeliveryvue_type_template_id_4f1615db_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummaryCardDelivery = (SummaryCardDelivery_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryPaymentCard.vue?vue&type=template&id=fce11ee4&
var SummaryPaymentCardvue_type_template_id_fce11ee4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head"},[_c('p',{},[_vm._v("Paying via "+_vm._s(_vm.payment.payment_method === 'DO' ? 'Debit Order' : 'Credit Card'))]),_c('icon',{attrs:{"name":_vm.payment.payment_method === 'DO' ? 'bank' : 'card'}})],1),_c('div',{staticClass:"summary-line"},[(_vm.payment.payment_method === 'DO')?_c('div',{staticClass:"info"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm._f("titleCase")(_vm.payment.bank_name)))]),_c('p',{},[_vm._v(_vm._s(_vm.payment.account_number))])]):_vm._e(),(_vm.payment.payment_method === 'CC')?_c('div',{staticClass:"info"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.payment.card_holder))]),_c('p',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.payment.masked_number)+" | Expires "+_vm._s(_vm.payment.expire_month)+"/"+_vm._s(_vm.payment.expire_year))])]):_vm._e(),_c('icon',{staticClass:"pointer",attrs:{"name":"pencil"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.changePayment.apply(null, arguments)}}})],1)])
}
var SummaryPaymentCardvue_type_template_id_fce11ee4_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryPaymentCard.vue?vue&type=script&lang=js&

	
	/* harmony default export */ var SummaryPaymentCardvue_type_script_lang_js_ = ({
		components: {Icon: Icon},
		computed: {
			payment() {
				return this.$signup.$store.getters['signupPayment/currentPaymentMethod'];
			},
		},
		filters: {
			titleCase(str) {
				return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
			}
		},
		methods: {
			changePayment() {
				this.$modal.push('payment-methods');
			},
		}
	});

;// CONCATENATED MODULE: ./src/components/summary/SummaryPaymentCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummaryPaymentCardvue_type_script_lang_js_ = (SummaryPaymentCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SummaryPaymentCard.vue





/* normalize component */
;
var SummaryPaymentCard_component = (0,componentNormalizer/* default */.Z)(
  summary_SummaryPaymentCardvue_type_script_lang_js_,
  SummaryPaymentCardvue_type_template_id_fce11ee4_render,
  SummaryPaymentCardvue_type_template_id_fce11ee4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummaryPaymentCard = (SummaryPaymentCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/CouponBar.vue?vue&type=template&id=5f1765df&
var CouponBarvue_type_template_id_5f1765df_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-bar-holder"},[(!_vm.coupon || _vm.loading)?_c('div',{staticClass:"coupon-bar"},[_c('div',{staticClass:"coupon-bar-icon"},[_c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.6612529,0.0327570519 C15.87471,0.0909918107 16.0278422,0.226872915 16.1206497,0.440400364 L17.87471,3.58507734 L21.2993039,4.31301183 C21.5034803,4.351835 21.675174,4.46345162 21.8143852,4.64786169 C21.9361949,4.8092205 21.9905017,4.98915681 21.9773057,5.18767061 L21.5777262,8.76797088 L23.7772622,11.4176524 C23.9257541,11.5729451 24,11.767061 24,12 C24,12.232939 23.9257541,12.4270549 23.7772622,12.5823476 L21.5777262,15.2611465 L21.9675174,18.755232 C22.0046404,18.9881711 21.9535963,19.1968456 21.8143852,19.3812557 C21.675174,19.5656658 21.5034803,19.6772824 21.2993039,19.7161056 L17.87471,20.44404 L16.1206497,23.5595996 C16.0278422,23.7731271 15.87471,23.9090082 15.6612529,23.9672429 C15.4477958,24.0254777 15.2389791,24.0060661 15.0348028,23.9090082 L12,22.4240218 L8.96519722,23.9090082 C8.76102088,24.0060661 8.55684455,24.0157719 8.35266821,23.9381256 C8.14849188,23.8604792 7.99071926,23.7245981 7.87935035,23.5304823 L6.15313225,20.44404 L2.70069606,19.7161056 C2.49651972,19.6772824 2.32482599,19.5656658 2.18561485,19.3812557 C2.0638051,19.2198969 2.00949826,19.0399606 2.02269432,18.8414468 L2.42227378,15.2611465 L0.222737819,12.5823476 C0.0742459397,12.4270549 0,12.232939 0,12 C0,11.767061 0.0742459397,11.5729451 0.222737819,11.4176524 L2.42227378,8.76797088 L2.0324826,5.27388535 C1.99535963,5.04094631 2.04640371,4.83227176 2.18561485,4.64786169 C2.32482599,4.46345162 2.49651972,4.351835 2.70069606,4.31301183 L6.15313225,3.58507734 L7.87935035,0.469517743 C7.99071926,0.27540188 8.14849188,0.139520776 8.35266821,0.0618744313 C8.55684455,-0.0157719139 8.76102088,-0.00606612072 8.96519722,0.0909918107 L12,1.57597816 L15.0348028,0.0909918107 C15.2389791,-0.00606612072 15.4477958,-0.025477707 15.6612529,0.0327570519 Z M15.5560917,11.7571429 C15.1415934,11.7571429 14.7650066,11.8285714 14.4263312,11.9714286 C14.0876558,12.1142857 13.799529,12.3071429 13.5619507,12.55 C13.3243725,12.7928571 13.1398702,13.0761905 13.0084439,13.4 C12.8957928,13.677551 12.8314208,13.9725948 12.8153278,14.2851312 L12.8113045,14.4714286 C12.8113045,14.8333333 12.8770176,15.1761905 13.0084439,15.5 C13.1398702,15.8238095 13.3243725,16.1071429 13.5619507,16.35 C13.799529,16.5928571 14.0876558,16.7857143 14.4263312,16.9285714 C14.7650066,17.0714286 15.1365386,17.1428571 15.5409271,17.1428571 C15.9554254,17.1428571 16.3294847,17.0714286 16.6631053,16.9285714 C16.9967258,16.7857143 17.2848527,16.5928571 17.5274858,16.35 C17.7701189,16.1071429 17.9571486,15.8214286 18.0885749,15.4928571 C18.201226,15.2112245 18.265598,14.9173469 18.281691,14.6112245 L18.2857143,14.4285714 C18.2857143,14.0571429 18.2200011,13.7095238 18.0885749,13.3857143 C17.9571486,13.0619048 17.7726463,12.7785714 17.5350681,12.5357143 C17.2974898,12.2928571 17.0118904,12.102381 16.6782699,11.9642857 C16.3446493,11.8261905 15.9705899,11.7571429 15.5560917,11.7571429 Z M17.1180424,7 L15.0708254,7 L11.3555058,11.6142857 L6.88195761,17 L8.92917456,17 L12.5990005,12.4428571 L17.1180424,7 Z M15.5409271,13.3142857 C15.8037797,13.3142857 16.0186111,13.4214286 16.1854213,13.6357143 C16.3313803,13.8232143 16.4134823,14.0526414 16.4317271,14.3239955 L16.4356367,14.4714286 C16.4356367,14.7857143 16.354759,15.047619 16.1930036,15.2571429 C16.0312482,15.4666667 15.8189442,15.5714286 15.5560917,15.5714286 C15.3033488,15.5714286 15.0910449,15.4642857 14.9191797,15.25 C14.7687977,15.0625 14.6842079,14.8367188 14.6654101,14.5726562 L14.661382,14.4285714 C14.661382,14.1047619 14.7397323,13.8380952 14.8964329,13.6285714 C15.0531334,13.4190476 15.2679648,13.3142857 15.5409271,13.3142857 Z M8.45907289,6.85714286 C8.04457465,6.85714286 7.66798782,6.92857143 7.32931242,7.07142857 C6.99063703,7.21428571 6.7025102,7.40714286 6.46493193,7.65 C6.22735367,7.89285714 6.0428514,8.17619048 5.91142512,8.5 C5.79877403,8.77755102 5.73440198,9.07259475 5.71830897,9.3851312 L5.71428571,9.57142857 C5.71428571,9.93333333 5.77999885,10.2761905 5.91142512,10.6 C6.0428514,10.9238095 6.2298811,11.2071429 6.47251422,11.45 C6.71514734,11.6928571 7.00327417,11.8833333 7.33689471,12.0214286 C7.67051525,12.1595238 8.03951979,12.2285714 8.44390832,12.2285714 C8.85840657,12.2285714 9.23246597,12.1571429 9.56608651,12.0142857 C9.89970705,11.8714286 10.1878339,11.6785714 10.430467,11.4357143 C10.6731001,11.1928571 10.8601298,10.9095238 10.9915561,10.5857143 C11.1042072,10.3081633 11.1685792,10.0166181 11.1846722,9.71107872 L11.1886955,9.52857143 C11.1886955,9.15714286 11.1229824,8.80952381 10.9915561,8.48571429 C10.8601298,8.16190476 10.6756275,7.87857143 10.4380493,7.63571429 C10.200471,7.39285714 9.91487162,7.20238095 9.58125108,7.06428571 C9.24763054,6.92619048 8.87357114,6.85714286 8.45907289,6.85714286 Z M8.44390832,8.41428571 C8.70676087,8.41428571 8.92159228,8.52142857 9.08840255,8.73571429 C9.23436154,8.92321429 9.31646347,9.15264137 9.33470834,9.42399554 L9.33861796,9.57142857 C9.33861796,9.88571429 9.25774025,10.147619 9.09598484,10.3571429 C8.93422942,10.5666667 8.72192544,10.6714286 8.45907289,10.6714286 C8.20633006,10.6714286 7.99402608,10.5642857 7.82216095,10.35 C7.67177896,10.1625 7.5871891,9.93671875 7.56839135,9.67265625 L7.56436326,9.52857143 C7.56436326,9.2047619 7.64524097,8.93809524 7.80699638,8.72857143 C7.9687518,8.51904762 8.18105578,8.41428571 8.44390832,8.41428571 Z","fill":"#2062AC","fill-rule":"nonzero"}})])]),_c('signup-input',{attrs:{"label":"Enter referral code","type":"text"},model:{value:(_vm.couponCode),callback:function ($$v) {_vm.couponCode=$$v},expression:"couponCode"}}),(!_vm.loading)?_c('button',{staticClass:"signup-button primary",class:{'disabled': !_vm.couponCode},on:{"click":_vm.applyCoupon}},[_c('span',[_vm._v("Apply Referral Code")])]):_c('button',{staticClass:"signup-button primary loading"},[_c('span')])],1):_c('div',{staticClass:"coupon-bar"},[_c('div',{staticClass:"coupon-bar-icon"},[_c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.6612529,0.0327570519 C15.87471,0.0909918107 16.0278422,0.226872915 16.1206497,0.440400364 L17.87471,3.58507734 L21.2993039,4.31301183 C21.5034803,4.351835 21.675174,4.46345162 21.8143852,4.64786169 C21.9361949,4.8092205 21.9905017,4.98915681 21.9773057,5.18767061 L21.5777262,8.76797088 L23.7772622,11.4176524 C23.9257541,11.5729451 24,11.767061 24,12 C24,12.232939 23.9257541,12.4270549 23.7772622,12.5823476 L21.5777262,15.2611465 L21.9675174,18.755232 C22.0046404,18.9881711 21.9535963,19.1968456 21.8143852,19.3812557 C21.675174,19.5656658 21.5034803,19.6772824 21.2993039,19.7161056 L17.87471,20.44404 L16.1206497,23.5595996 C16.0278422,23.7731271 15.87471,23.9090082 15.6612529,23.9672429 C15.4477958,24.0254777 15.2389791,24.0060661 15.0348028,23.9090082 L12,22.4240218 L8.96519722,23.9090082 C8.76102088,24.0060661 8.55684455,24.0157719 8.35266821,23.9381256 C8.14849188,23.8604792 7.99071926,23.7245981 7.87935035,23.5304823 L6.15313225,20.44404 L2.70069606,19.7161056 C2.49651972,19.6772824 2.32482599,19.5656658 2.18561485,19.3812557 C2.0638051,19.2198969 2.00949826,19.0399606 2.02269432,18.8414468 L2.42227378,15.2611465 L0.222737819,12.5823476 C0.0742459397,12.4270549 0,12.232939 0,12 C0,11.767061 0.0742459397,11.5729451 0.222737819,11.4176524 L2.42227378,8.76797088 L2.0324826,5.27388535 C1.99535963,5.04094631 2.04640371,4.83227176 2.18561485,4.64786169 C2.32482599,4.46345162 2.49651972,4.351835 2.70069606,4.31301183 L6.15313225,3.58507734 L7.87935035,0.469517743 C7.99071926,0.27540188 8.14849188,0.139520776 8.35266821,0.0618744313 C8.55684455,-0.0157719139 8.76102088,-0.00606612072 8.96519722,0.0909918107 L12,1.57597816 L15.0348028,0.0909918107 C15.2389791,-0.00606612072 15.4477958,-0.025477707 15.6612529,0.0327570519 Z M15.5560917,11.7571429 C15.1415934,11.7571429 14.7650066,11.8285714 14.4263312,11.9714286 C14.0876558,12.1142857 13.799529,12.3071429 13.5619507,12.55 C13.3243725,12.7928571 13.1398702,13.0761905 13.0084439,13.4 C12.8957928,13.677551 12.8314208,13.9725948 12.8153278,14.2851312 L12.8113045,14.4714286 C12.8113045,14.8333333 12.8770176,15.1761905 13.0084439,15.5 C13.1398702,15.8238095 13.3243725,16.1071429 13.5619507,16.35 C13.799529,16.5928571 14.0876558,16.7857143 14.4263312,16.9285714 C14.7650066,17.0714286 15.1365386,17.1428571 15.5409271,17.1428571 C15.9554254,17.1428571 16.3294847,17.0714286 16.6631053,16.9285714 C16.9967258,16.7857143 17.2848527,16.5928571 17.5274858,16.35 C17.7701189,16.1071429 17.9571486,15.8214286 18.0885749,15.4928571 C18.201226,15.2112245 18.265598,14.9173469 18.281691,14.6112245 L18.2857143,14.4285714 C18.2857143,14.0571429 18.2200011,13.7095238 18.0885749,13.3857143 C17.9571486,13.0619048 17.7726463,12.7785714 17.5350681,12.5357143 C17.2974898,12.2928571 17.0118904,12.102381 16.6782699,11.9642857 C16.3446493,11.8261905 15.9705899,11.7571429 15.5560917,11.7571429 Z M17.1180424,7 L15.0708254,7 L11.3555058,11.6142857 L6.88195761,17 L8.92917456,17 L12.5990005,12.4428571 L17.1180424,7 Z M15.5409271,13.3142857 C15.8037797,13.3142857 16.0186111,13.4214286 16.1854213,13.6357143 C16.3313803,13.8232143 16.4134823,14.0526414 16.4317271,14.3239955 L16.4356367,14.4714286 C16.4356367,14.7857143 16.354759,15.047619 16.1930036,15.2571429 C16.0312482,15.4666667 15.8189442,15.5714286 15.5560917,15.5714286 C15.3033488,15.5714286 15.0910449,15.4642857 14.9191797,15.25 C14.7687977,15.0625 14.6842079,14.8367188 14.6654101,14.5726562 L14.661382,14.4285714 C14.661382,14.1047619 14.7397323,13.8380952 14.8964329,13.6285714 C15.0531334,13.4190476 15.2679648,13.3142857 15.5409271,13.3142857 Z M8.45907289,6.85714286 C8.04457465,6.85714286 7.66798782,6.92857143 7.32931242,7.07142857 C6.99063703,7.21428571 6.7025102,7.40714286 6.46493193,7.65 C6.22735367,7.89285714 6.0428514,8.17619048 5.91142512,8.5 C5.79877403,8.77755102 5.73440198,9.07259475 5.71830897,9.3851312 L5.71428571,9.57142857 C5.71428571,9.93333333 5.77999885,10.2761905 5.91142512,10.6 C6.0428514,10.9238095 6.2298811,11.2071429 6.47251422,11.45 C6.71514734,11.6928571 7.00327417,11.8833333 7.33689471,12.0214286 C7.67051525,12.1595238 8.03951979,12.2285714 8.44390832,12.2285714 C8.85840657,12.2285714 9.23246597,12.1571429 9.56608651,12.0142857 C9.89970705,11.8714286 10.1878339,11.6785714 10.430467,11.4357143 C10.6731001,11.1928571 10.8601298,10.9095238 10.9915561,10.5857143 C11.1042072,10.3081633 11.1685792,10.0166181 11.1846722,9.71107872 L11.1886955,9.52857143 C11.1886955,9.15714286 11.1229824,8.80952381 10.9915561,8.48571429 C10.8601298,8.16190476 10.6756275,7.87857143 10.4380493,7.63571429 C10.200471,7.39285714 9.91487162,7.20238095 9.58125108,7.06428571 C9.24763054,6.92619048 8.87357114,6.85714286 8.45907289,6.85714286 Z M8.44390832,8.41428571 C8.70676087,8.41428571 8.92159228,8.52142857 9.08840255,8.73571429 C9.23436154,8.92321429 9.31646347,9.15264137 9.33470834,9.42399554 L9.33861796,9.57142857 C9.33861796,9.88571429 9.25774025,10.147619 9.09598484,10.3571429 C8.93422942,10.5666667 8.72192544,10.6714286 8.45907289,10.6714286 C8.20633006,10.6714286 7.99402608,10.5642857 7.82216095,10.35 C7.67177896,10.1625 7.5871891,9.93671875 7.56839135,9.67265625 L7.56436326,9.52857143 C7.56436326,9.2047619 7.64524097,8.93809524 7.80699638,8.72857143 C7.9687518,8.51904762 8.18105578,8.41428571 8.44390832,8.41428571 Z","fill":"#2062AC","fill-rule":"nonzero"}})])]),_c('signup-input',{attrs:{"label":"Enter referral code","disabled":true,"type":"text","value":_vm.coupon.coupon.coupon_code}}),_vm._m(0),_c('icon',{attrs:{"name":"cross"},nativeOn:{"click":function($event){return _vm.clearCoupon()}}})],1),_c('error-bar',{attrs:{"error":_vm.error,"message":"Invalid coupon code"}})],1)
}
var CouponBarvue_type_template_id_5f1765df_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"signup-button green",attrs:{"disabled":""}},[_c('span',[_vm._v("Referral Code Applied")])])
}]


;// CONCATENATED MODULE: ./src/components/summary/CouponBar.vue?vue&type=template&id=5f1765df&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/CouponBar.vue?vue&type=script&lang=js&





/* harmony default export */ var CouponBarvue_type_script_lang_js_ = ({
	props: ['solution'],
	components: {
		ErrorBar: ErrorBar,
		Icon: Icon,
		SignupInput: SignupInput
	},
	computed: {
		coupon() {
			return this.$signup.$store.getters['signupCart/coupon']
		},
	},
	methods: {
		clearCoupon() {
			this.$signup.$store.commit('signupCart/addCoupon', false)
			this.couponCode = '';
		},
		applyCoupon() {
			this.error = false
			this.loading = true
			this.$signup.$store.dispatch('signupCart/checkCoupon', {
				coupon: this.couponCode,
				solution_id: this.solution.id
			}).then(r => {
				this.loading = false
				if(r.availability.available) {
					this.$signup.$store.commit('signupCart/addCoupon', r.availability)
					this.couponCode = '';

				} else {
					this.error = true
				}

			}, e => {
				// @TODO -  show the error
				this.loading = false
				this.error = true
			})
		}
	},
	data() {
		return {
			couponCode: '',
			error: false,
			loading: false
		}
	},
	mounted() {
		if(this.coupon) {
			this.$signup.$store.commit('signupCart/addCoupon', false)
		}

		let preCoupon = this.$signup.$store.getters['signupCart/preLoadedCoupon']
		if(preCoupon) {
			this.couponCode = preCoupon
			this.applyCoupon()
		}
	}
});

;// CONCATENATED MODULE: ./src/components/summary/CouponBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_CouponBarvue_type_script_lang_js_ = (CouponBarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/CouponBar.vue?vue&type=style&index=0&id=5f1765df&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/summary/CouponBar.vue?vue&type=style&index=0&id=5f1765df&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/summary/CouponBar.vue



;


/* normalize component */

var CouponBar_component = (0,componentNormalizer/* default */.Z)(
  summary_CouponBarvue_type_script_lang_js_,
  CouponBarvue_type_template_id_5f1765df_render,
  CouponBarvue_type_template_id_5f1765df_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CouponBar = (CouponBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardMax.vue?vue&type=template&id=ebb163d2&
var SummaryCardMaxvue_type_template_id_ebb163d2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"card-head"},[_c('div',[_c('p',{staticClass:"product"},[_vm._v(_vm._s(_vm.product.name))]),_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.product.price))+"pm")])]),_c('icon',{attrs:{"name":"bolt"}})],1),_vm._l((_vm.product.features),function(f){return _c('div',{staticClass:"summary-line"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(f.label))]),_c('p',{staticClass:"item-value"},[_vm._v(_vm._s(f.value))])])})],2)
}
var SummaryCardMaxvue_type_template_id_ebb163d2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SummaryCardMax.vue?vue&type=script&lang=js&

	
	

	/* harmony default export */ var SummaryCardMaxvue_type_script_lang_js_ = ({
		props: ['product'],
		components: {
			Icon: Icon,
			FormattedSpeed: FormattedSpeed
		},
		computed: {

		}
	});

;// CONCATENATED MODULE: ./src/components/summary/SummaryCardMax.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummaryCardMaxvue_type_script_lang_js_ = (SummaryCardMaxvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SummaryCardMax.vue





/* normalize component */
;
var SummaryCardMax_component = (0,componentNormalizer/* default */.Z)(
  summary_SummaryCardMaxvue_type_script_lang_js_,
  SummaryCardMaxvue_type_template_id_ebb163d2_render,
  SummaryCardMaxvue_type_template_id_ebb163d2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummaryCardMax = (SummaryCardMax_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/Summary.vue?vue&type=script&lang=js&
















/* harmony default export */ var Summaryvue_type_script_lang_js_ = ({
	components: {
		SummaryCardMax: SummaryCardMax,
		CouponBar: CouponBar,
		SignupInput: SignupInput,
		SummaryPaymentCard: SummaryPaymentCard,
		SummaryCardDelivery: SummaryCardDelivery,
		Icon: Icon,
		ErrorBar: ErrorBar,
		GlobalError: GlobalError,
		SignupCheckbox: SignupCheckbox,
		SummaryCardFibre: SummaryCardFibre,
		SummaryCardDevices: SummaryCardDevices
	},
	computed: {
		testSignup() {
			return this.$signup.$store.getters['signupGeneral/testSignup'];
		},
		payment() {
			return this.$signup.$store.getters['signupPayment/currentPaymentMethod'];
		},
		solution() {
			return this.$signup.$store.getters['signupSolutions/selectedSolution']
			// return sol;
		},
		maxProduct() {
			let solution = this.$signup.$store.getters['signupCart/cartItems'].find(s => s.product_type_slug === 'solution_max_uptime');
			if(!solution) return false

			let features = [
				{ label: 'Max Support', value: 'Included' },
				{ label: 'Uncapped LTE failover', value: 'Included' },
				{ label: 'TP-Link MR600 Router', value: 'Included' },
				{ label: 'Backup power', value: 'Included' }
			]

			if(solution.product_id === 2760) {
				features.push({label: 'WiFi mesh', value: 'Included' })
			}

			return {
				name: 'Max Uptime' + (solution.product_id === 2760 ? ' VIP' : ''),
				price: solution.product_id === 1760 ? 499 : 999,
				features: features
			}

		},
		solutionLocation() {
			return this.$signup.$store.getters['signupSolutions/solutionLocation'];
		},
		provider() {
			return this.$signup.$store.getters['signupSolutions/currentProvider']
		},
		// cart() {
		// 	return {
		// 		...this.$signup.$store.getters['signupCart/cartDetails'],
		// 		cart_items: [
		// 			this.$signup.$store.getters['signupCart/cartItems'],
		// 			[this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote'].cart_item]
		// 		]
		// 	};
		// },
		installationFees() {
			let fees = 0;
			this.$signup.$store.getters['signupSolutions/currentProvider'].eventPrices.forEach((e) => {
				fees += e.price;
			});
			return fees;
		},
		deliveryFees() {
			if (!this.device) return 0
			let fees = 0;
			fees += this.device.product.price - 999;
			fees += this.delivery.price;
			return fees;
		},
		mobileWindow() {
			return window.innerWidth <= 600;
		}
	},
	methods: {
		applyCoupon(coupon) {
			console.log('coupon', coupon)
		},
		trackCartEvent() {
			let conversionValue = this.solution.price
			let email = this.$signup.$store.getters['signupUser/user'].email
			let data = {
				product: 'fibre',
				type: 'add-to-cart',
				value: conversionValue,
				location: 'website',
				email: email,
				first_name: this.$signup.$store.getters['signupUser/user'].first_name,
				last_name: this.$signup.$store.getters['signupUser/user'].last_name,
				ac_meta: [
					{
						field: 8,
						value: this.$signup.$store.getters['signupCoverage/formattedAddress'],
					},
					{
						field: 9,
						value: this.$signup.$store.getters['signupSolutions/selectedSolution'].vendor.name
					},
					{
						field: 10,
						value: this.$signup.$store.getters['signupSolutions/selectedSolution'].name
					}
				]
			}
			this.$signup.$store.dispatch('signupCart/logAct', data);

			this.$signup.$store.dispatch('signupSignal/sendEvent', {
				type: 'add-to-cart',
				value: conversionValue,
				meta: {
					solution: this.$signup.$store.getters['signupSolutions/selectedSolution'].name,
					vendor: this.$signup.$store.getters['signupSolutions/selectedSolution'].vendor.name
				},
			})
		},
		next() {
			//get data for GTM tracking
			let line = this.solution.solution_composite_child_metas.find(s => {
				return s.child_solution.display_category_slug === 'fibre_line';
			}).child_solution;
			// console.log(line);
			let cartInfo = {
				name: this.solution.display_name,
				provider: this.provider.name,
				speed: `${line.line_download_speed / 1024}/${line.line_upload_speed / 1024}`,
				price: this.solution.price,
			}
			if (this.$signup.$store.getters['signupGeneral/testSignup']) {
				cartInfo = {
					...cartInfo,
					test: true
				};
			}

			let signalPayload = {
				type: 'sale',
				value: this.solution.price,
				meta: {
					solution: this.$signup.$store.getters['signupSolutions/selectedSolution'].name,
					vendor: this.$signup.$store.getters['signupSolutions/selectedSolution'].vendor.name
				},
			}

			//do checkout
			this.$signup.$store.dispatch('signupCart/doCheckout').then((res) => {
				if (res.cart.id) { //redundant check
					//send event to GTM
					this.$tracking.gtm.push({
						event: 'Fibre.Conversion',
						...cartInfo,
					});
					//send fb pixel event
					this.$tracking.fbq('trackCustom', 'Fibre Conversion', {currency: "ZAR", ...cartInfo});
					this.$modal.push('order-successful');

					try {
						this.$signup.$store.dispatch('signupSignal/sendEvent', signalPayload)
					} catch (e) {
						console.log(e)
					}
				}
				// console.log(res)
			}).catch((err) => {
				if (err.data.error_slug === 'delivery_quotation_expired' || err.data.error_slug === 'terminal_sign_up_exception') {
					this.globalError = {
						message: "The delivery method has become unavailable since you selected it. Please update the delivery.",
						goto: 'delivery-option'
					};
					return;
				} else if (err.data.error_slug === 'duplicate-fibre-order') {
					this.globalError = {
						message: err.data.message,
						goto: 'coverage',
					};
					return;
				} else if (err.data.error_slug === 'client_business_logic' && err.data.message.indexOf('cart.cart_items[][]') > -1) {
					// the something is wrong with one of the cart items
					this.error = {
						message: 'A cart error has occurred, please refresh and try again. If the issue persists, please contact support@afrihost.com or reach out to our WhatsApp support team'
					};
					return;
				} else if (err.data.error_slug === 'client_business_logic' && err.data.message.indexOf('not yet supported on this API') > -1) {
					// the server has received an unexpected product_type_slug
					this.error = {
						message: 'A product error has occurred, please contact support@afrihost.com or reach out to our WhatsApp support team'
					};
					return;
				}
				this.error = {
					message: 'Something went wrong, please refresh and try again. If the issue persists, please contact support@afrihost.com or reach out to our WhatsApp support team'
				};
			});
		},
		checkTncs() {
			this.error = false;
			if (this.acceptTnc) {
				if (this.$signup.$store.getters['signupPayment/currentPaymentMethod'].payment_method !== 'DO') {
					this.$modal.state.current.buttons[1].type = 'primary';
				} else if (this.acceptPayment) {
					this.$modal.state.current.buttons[1].type = 'primary';
				} else {
					this.$modal.state.current.buttons[1].type = 'primary disabled';
				}
			} else {
				this.$modal.state.current.buttons[1].type = 'primary disabled';
			}
		}
	},
	data() {
		return {
			globalError: false,
			error: false,
			acceptTnc: false,
			acceptPayment: false,
		}
	},
	async mounted() {
		// this.$modal.toggleLoader(true);
		//check for fibre and upsell deco device
		// if (
		// 	this.solution.solution_type === "composite_fibre" && //is fibre
		// 	this.devices.length > 0 && //has device fibre
		// 	!this.$signup.$store.getters['signupGeneral/upsellShown'].find(u => u.name = 'fibreMeshDevice').value //deco device upsell not shown
		// ) {
		// 	this.$modal.push('fibre-device-upsell');
		// 	return;
		// }

		this.$modal.toggleLoader(true);
		this.$modal.state.current.buttons[1].type = 'primary';

		// check cart summary
		// let summary = await this.$signup.$store.dispatch('signupCart/getCheckoutSummary')
		// console.log(summary)

		this.$modal.toggleLoader(false);
		this.trackCartEvent();
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('fibre-installation');
			if (that.solution.solution_type === 'composite_fibre') {
				// debugger;
				/*if (that.$modal.state.previous.name === 'fibre-device-upsell') {
					that.$modal.push(that.$modal.state.previous.name);
				} else*/
				// if (that.device) {
				// 	that.$modal.push('delivery-option');
				// } else {
				// 	that.$modal.push('fibre-device');
				// }
			}

		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.error = false;

			if (that.acceptTnc) {
				if (that.payment.payment_method !== 'DO') {
					that.next();
				} else if (that.acceptPayment) {
					that.next();
				} else {
					that.refs['modal-body'].scrollTo('.terms');
					that.error = {message: 'Please accept debit order authorisation.'}

				}
			} else {
				// that.$refs['modal-body'].scrollTo(document.querySelector('.terms').getBoundingClientRect());
				that.error = {message: 'Please read and accept the Terms and Conditions below.'}

				that.$nextTick(() => {
					const el = document.querySelector('.vue-portal-target');
					if (el) {
						// Use el.scrollIntoView() to instantly scroll to the element
						el.scrollIntoView({behavior: 'smooth', block: "start"});
					}
				})
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	},
});

;// CONCATENATED MODULE: ./src/modals/summary/Summary.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_Summaryvue_type_script_lang_js_ = (Summaryvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/Summary.vue?vue&type=style&index=0&id=7bc8b5c8&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/summary/Summary.vue?vue&type=style&index=0&id=7bc8b5c8&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/summary/Summary.vue



;


/* normalize component */

var Summary_component = (0,componentNormalizer/* default */.Z)(
  summary_Summaryvue_type_script_lang_js_,
  Summaryvue_type_template_id_7bc8b5c8_render,
  Summaryvue_type_template_id_7bc8b5c8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Summary = (Summary_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/SummarySideBar.vue?vue&type=template&id=4c39c2d8&
var SummarySideBarvue_type_template_id_4c39c2d8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-modal-sidebar summary"},[(!_vm.provider.pre_order)?_c('div',[(_vm.solution.solution_type === 'composite_fibre' && _vm.solutionLocation.order_type !== 'transfer' && !_vm.provider.pre_order)?_c('sidebar-section',{attrs:{"large-title":true,"title":"What you pay today","lines":_vm.payTodayLineItems,"tooltip":"Once your Fibre line has been installed and activated, you’ll be charged pro-rata for the remainder of the month. You’ll start paying the full amount for your Fibre package the following month."}}):_vm._e(),(_vm.solution.solution_type === 'composite_fibre' && _vm.solutionLocation.order_type === 'transfer')?_c('sidebar-section',{attrs:{"large-title":true,"title":"Payable once activation is completed","lines":_vm.provider.eventPrices.filter(e => e.event_type === 'migrate_in').map(e => ({name: e.pricing_type.name, price: e.retail_price})),"tooltip":"You’ll be billed for these items once your Fibre line has successfully been activated."}}):_vm._e()],1):_c('div',[(_vm.solution.solution_type === 'composite_fibre')?_c('sidebar-section',{attrs:{"large-title":true,"title":"What you pay today","lines":[{name: _vm.solution.display_name, price: 0.00}],"tooltip":"Once your Fibre line has been installed and activated, you’ll be charged pro-rata for the remainder of the month. You’ll start paying the full amount for your Fibre package the following month."}}):_vm._e(),(_vm.solution.solution_type === 'composite_fibre' && _vm.provider.pre_order)?_c('sidebar-section',{attrs:{"title":"Payable once area is live","lines":_vm.provider.eventPrices.map(e => ({name: e.pricing_type.name, price: e.price})),"tooltip":"You’ll be billed for these items once your Fibre goes live in your area."}}):_vm._e()],1),(_vm.solution.solution_type === 'composite_fibre' && _vm.delivery)?_c('div',{staticClass:"order-group"},[_c('sidebar-section',{attrs:{"title":"Payable on order confirmation","tooltip":`You’ll be billed for these items once ${_vm.provider.name} has accepted your Fibre order. Once payment has been received, your Fibre WiFi Router will be configured and scheduled for delivery.`,"lines":_vm.fibreDeviceLines}})],1):_vm._e(),(_vm.mobileWindow)?_c('portal-target',{attrs:{"name":"terms-portal"}}):_vm._e()],1)
}
var SummarySideBarvue_type_template_id_4c39c2d8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SidebarSection.vue?vue&type=template&id=28b03356&
var SidebarSectionvue_type_template_id_28b03356_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lines.length > 0)?_c('div',{staticClass:"order-group"},[(_vm.largeTitle)?_c('h3',[_vm._v(_vm._s(_vm.title)+" "),_c('icon',{directives:[{name:"signup-show-tooltip",rawName:"v-signup-show-tooltip"}],attrs:{"name":"error"}})],1):_c('p',{staticClass:"group-header"},[_vm._v(_vm._s(_vm.title)+" "),_c('icon',{directives:[{name:"signup-show-tooltip",rawName:"v-signup-show-tooltip"}],attrs:{"name":"error"}})],1),_vm._l((_vm.lines),function(prices){return _c('div',{staticClass:"order-line"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(prices.name))]),_c('p',{staticClass:"item-price"},[_vm._v(_vm._s(_vm._f("formatPriceNotFree")(prices.price)))])])}),_c('p',{staticClass:"price",class:{main: _vm.largeTitle}},[_vm._v(_vm._s(_vm._f("formatPriceNotFree")(_vm.total)))]),_c('span',{staticClass:"tooltip"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")]),_c('icon',{directives:[{name:"signup-hide-tooltip",rawName:"v-signup-hide-tooltip"}],attrs:{"name":"cross"}})],1)],2):_vm._e()
}
var SidebarSectionvue_type_template_id_28b03356_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/summary/SidebarSection.vue?vue&type=script&lang=js&



/* harmony default export */ var SidebarSectionvue_type_script_lang_js_ = ({
	name: "SidebarSection",
	components: {Icon: Icon},
	props: ["largeTitle", "title", "lines", "tooltip"],
	computed: {
		total() {
			return this.lines.reduce((curr, prev) => {
				return curr + prev.price;
			}, 0);
		}
	},
	directives: {
		SignupShowTooltip(el) {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				e.target.closest('.order-group').querySelector('.tooltip').classList.add('show');
			})
		},
		SignupHideTooltip(el) {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				e.target.closest('.tooltip').classList.remove('show');
			})
		},
	},
});

;// CONCATENATED MODULE: ./src/components/summary/SidebarSection.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SidebarSectionvue_type_script_lang_js_ = (SidebarSectionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/summary/SidebarSection.vue





/* normalize component */
;
var SidebarSection_component = (0,componentNormalizer/* default */.Z)(
  summary_SidebarSectionvue_type_script_lang_js_,
  SidebarSectionvue_type_template_id_28b03356_render,
  SidebarSectionvue_type_template_id_28b03356_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SidebarSection = (SidebarSection_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/SummarySideBar.vue?vue&type=script&lang=js&




/* harmony default export */ var SummarySideBarvue_type_script_lang_js_ = ({
	components: {
		SidebarSection: SidebarSection,
		Icon: Icon
	},
	data() {
		return {}
	},
	directives: {
		SignupShowTooltip(el) {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				e.target.closest('.order-group').querySelector('.tooltip').classList.add('show');
			})
		},
		SignupHideTooltip(el) {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				e.target.closest('.tooltip').classList.remove('show');
			})
		},
	},
	computed: {
		solution() {
			// console.log(this.$signup.$store.getters['signupSolutions/selectedSolution']);
			return this.$signup.$store.getters['signupSolutions/selectedSolution'];
		},
		solutionLocation() {
			return this.$signup.$store.getters['signupSolutions/solutionLocation'];
		},
		provider() {
			return this.$signup.$store.getters['signupSolutions/currentProvider']
		},
		delivery() {
			return this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote']
		},
		devices() {
			return this.$signup.$store.getters['signupSolutions/selectedDevices'];
		},
		maxSidebarLineItem() {
			let solution = this.$signup.$store.getters['signupCart/cartItems'].find(s => s.product_type_slug === 'solution_max_uptime')
			if(!solution) return false

			let price = solution.product_id === 1760 ? 499 : 999
			let now = new Date()
			let daysInMonth = new Date(now.getFullYear(), now.getMonth()+1, 0).getDate()
			let remainingDays = (daysInMonth - (now.getDate()))+1
			let prorata = Math.ceil((price/daysInMonth)*remainingDays)

			return {
				name: 'Max Uptime Prorata',
				price: prorata
			}
		},
		payTodayLineItems() {
			let items = [
				{
					name: this.solution.display_name,
					price: 0.00
				},
				this.provider.eventPrices.filter(e => e.event_type === 'install').map(e => ({name: e.pricing_type.name, price: e.retail_price}))
			].flat()

			if(this.maxSidebarLineItem) {
				items.push(this.maxSidebarLineItem)
			}

			return items
		},
		installationFees() {
			let fees = 0;
			this.$signup.$store.getters['signupSolutions/currentProvider'].eventPrices.forEach((e) => {
				if (this.solutionLocation.order_type !== 'transfer' && e.slug !== 'installation') {
					fees += e.price;
				}
			});
			return fees;
		},
		deliveryFees() {
			let fees = 0;
			this.devices.forEach(d => {
				if (d.product_type_slug === 'solution_tangible_fibre') {
					fees += d.product.price - 999;
				} else {
					fees += d.product.price;
				}
			})
			// fees += this.devices[0].product.price - 999;
			// this.devices.slice(1).forEach(d => { fees += d.product.price });
			fees += this.delivery.price;
			return fees;
		},
		mobileWindow() {
			return window.innerWidth <= 600;
		},
		fibreDeviceLines() {
			return [
				this.devices.map(d => ({
					name: d.product.display_category,
					price: d.product_type_slug === 'solution_tangible_fibre' ? d.product.price - 999 : d.product.price
				})),
				{
					...this.delivery
				}
			].flat()
		}
	},
	mounted() {
	}
});

;// CONCATENATED MODULE: ./src/modals/summary/SummarySideBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_SummarySideBarvue_type_script_lang_js_ = (SummarySideBarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/SummarySideBar.vue?vue&type=style&index=0&id=4c39c2d8&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/summary/SummarySideBar.vue?vue&type=style&index=0&id=4c39c2d8&prod&lang=scss&

;// CONCATENATED MODULE: ./src/modals/summary/SummarySideBar.vue



;


/* normalize component */

var SummarySideBar_component = (0,componentNormalizer/* default */.Z)(
  summary_SummarySideBarvue_type_script_lang_js_,
  SummarySideBarvue_type_template_id_4c39c2d8_render,
  SummarySideBarvue_type_template_id_4c39c2d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SummarySideBar = (SummarySideBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/NoDeliveryAvailable.vue?vue&type=template&id=bcda3a9a&
var NoDeliveryAvailablevue_type_template_id_bcda3a9a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('h3',[_vm._v("We do not have any delivery options available at "+_vm._s(_vm.selectedDeliveryLocation))]),_c('p',[_vm._v("Please check that you selected the correct delivery address or choose another address.")])])
}
var NoDeliveryAvailablevue_type_template_id_bcda3a9a_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/NoDeliveryAvailable.vue?vue&type=script&lang=js&




/* harmony default export */ var NoDeliveryAvailablevue_type_script_lang_js_ = ({
	components: {ErrorBar: ErrorBar},
	computed: {
		selectedDeliveryLocation() {
			let location = this.$signup.$store.getters['signupDelivery/deliveryLocation'];
			return `${location.building_number} ${location.building_name} ${location.street_number} ${location.street_name}, ${location.suburb}, ${location.city_name}, ${location.postal_code}`;
		}
	},
	data() {
		return {
			error: false,
		}
	},
	mounted() {
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-address');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.$modal.push('delivery-address');
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/NoDeliveryAvailable.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_NoDeliveryAvailablevue_type_script_lang_js_ = (NoDeliveryAvailablevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/NoDeliveryAvailable.vue





/* normalize component */
;
var NoDeliveryAvailable_component = (0,componentNormalizer/* default */.Z)(
  delivery_NoDeliveryAvailablevue_type_script_lang_js_,
  NoDeliveryAvailablevue_type_template_id_bcda3a9a_render,
  NoDeliveryAvailablevue_type_template_id_bcda3a9a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NoDeliveryAvailable = (NoDeliveryAvailable_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/RecipientDetails.vue?vue&type=template&id=53f64af2&
var RecipientDetailsvue_type_template_id_53f64af2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body has-columns"},[_c('div',{staticClass:"modal-column"},[_c('h3',[_vm._v("Recipient details")]),_c('address-preview',{attrs:{"delivery":true},on:{"changeAddress":function($event){return _vm.changeAddress()}}}),_c('signup-tabs',{attrs:{"options":_vm.recipientTabs,"selected":_vm.isRecipient},on:{"select":_vm.updateRecipient}}),_c('signup-input',{attrs:{"type":"name","label":"Full name and surname of the recipient","disabled":false,"required":true},model:{value:(_vm.form.full_name),callback:function ($$v) {_vm.$set(_vm.form, "full_name", $$v)},expression:"form.full_name"}}),_c('signup-input',{attrs:{"type":"tel","label":"Mobile contact number of recipient","disabled":false,"required":true},model:{value:(_vm.form.cell_number),callback:function ($$v) {_vm.$set(_vm.form, "cell_number", $$v)},expression:"form.cell_number"}}),_c('signup-input',{attrs:{"type":"tel","label":"Email address of recipient","disabled":false,"required":true},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_c('div',{staticClass:"modal-column"},[_c('h3',[_vm._v("Identification Details")]),_c('signup-tabs',{attrs:{"options":_vm.identityOptions,"selected":_vm.form.identity_type},on:{"select":_vm.updateIdentityType}}),(_vm.form.identity_type === 'id_number')?_c('div',{staticClass:"signup-tab"},[_c('signup-input',{attrs:{"type":"tel","label":"ID number of recipient","disabled":false,"required":true},model:{value:(_vm.form.id_number),callback:function ($$v) {_vm.$set(_vm.form, "id_number", $$v)},expression:"form.id_number"}})],1):_vm._e(),(_vm.form.identity_type === 'passport')?_c('div',{staticClass:"signup-tab"},[_c('signup-select',{ref:"passport_select",attrs:{"disabled":false,"error":false,"options":_vm.countries,"required":true,"label":"Country of issue"},model:{value:(_vm.form.passport_country_code),callback:function ($$v) {_vm.$set(_vm.form, "passport_country_code", $$v)},expression:"form.passport_country_code"}}),_c('signup-input',{attrs:{"type":"tel","label":"Passport number of recipient","disabled":false,"required":true},model:{value:(_vm.form.id_number),callback:function ($$v) {_vm.$set(_vm.form, "id_number", $$v)},expression:"form.id_number"}})],1):_vm._e()],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var RecipientDetailsvue_type_template_id_53f64af2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/RecipientDetails.vue?vue&type=script&lang=js&








/* harmony default export */ var RecipientDetailsvue_type_script_lang_js_ = ({
	components: {SignupTabs: SignupTabs, SignupInput: SignupInput, SignupSelect: SignupSelect, AddressPreview: AddressPreview, ErrorBar: ErrorBar},
	computed: {
		countries() {
			let countries = [...this.$signup.$store.getters['signupGeneral/countries']];
			if (!countries) { return [] }
			return countries.map((c) => {
				return {
					"label": c.name,
					"value": c.code
				}
			})
		}
	},
	methods: {
		async next() {
			// if delivery recipient is different to current user, update quote
			let user = this.$signup.$store.getters['signupUser/user'];
			if (
				!(this.form.id_number === user.id_number &&
				this.form.full_name === user.first_name + ' ' + user.last_name &&
				this.form.cell_number === user.cell_number &&
				this.form.email === user.email &&
				this.form.passport_country_code === user.passport_country_code)
			) {
				//update recipient on devices
				await this.$signup.$store.dispatch('signupCart/updateDeviceRecipient', {form: this.form});

				await this.$signup.$store.dispatch('signupDelivery/getDeliveryQuotes')
					.catch((err) => {
						this.error = {message: err.data.message};
					});

				//if api came back with error, bail
				if (this.error) {
					return;
				}
			}
			this.$modal.push('delivery-type');
		},
		updateRecipient(isRecipient) {
			this.isRecipient = isRecipient;
			if (isRecipient) {
				let user = this.$signup.$store.getters['signupUser/user'];
				this.form.full_name = user.first_name + ' ' + user.last_name;
				this.form.cell_number = user.cell_number;
				this.form.email = user.email;
				this.form.identity_type = 'id_number';
				if (user.passport_country) {
					this.form.identity_type = user.passport_country.passport_code === 'ZAF' ? 'id_number' : 'passport';
				}
				this.form.id_number = user.id_number;
				this.form.passport_country_code = user.passport_country_code;
			} else {
				this.form.full_name = '';
				this.form.cell_number = '';
				this.form.email = '';
				this.form.identity_type = 'id_number';
				this.form.id_number = '';
				this.form.passport_country_code = '';
			}
		},
		updateIdentityType(idType) {
			this.form.identity_type = idType;
		},
		changeAddress() {
			this.$modal.push('delivery-address')
		},
	},
	data() {
		return {
			error: false,
			recipientTabs: [
				{
					value: true,
					label: "I'm the recipient",
				},
				{
					value: false,
					label: "I'm not the recipient",
				}
			],
			identityOptions: [
				{
					value: 'id_number',
					label: "South African ID",
				},
				{
					value: 'passport',
					label: "Passport",
				}
			],
			isRecipient: true,
			form: {
				full_name: '',
				cell_number: '',
				email: '',
				identity_type: 'id_number',
				id_number: '',
				passport_country_code: '',
			}
		}
	},
	async mounted() {
		if (!this.$signup.$store.getters['signupGeneral/countries']) {
			await this.$signup.$store.dispatch('signupGeneral/fetchCountries');
		}
		this.updateRecipient(this.isRecipient)
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-address');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.error = false;
			if (that.form.full_name === '') {
				that.error = {message: "Full name cannot be empty"};
			} else if (that.form.cell_number === '') {
				that.error = {message: "Contact number cannot be empty"};
			} else if (that.form.email === '') {
				that.error = {message: "Email address cannot be empty"};
			} else if (that.form.identity_type === 'id_number' && (that.form.id_number === '' || !that.form.id_number.match(/(\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8]))|([02468][048]|[13579][26])0229)(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/))) {
				that.error = {message: "Please fill in a valid South African ID Number"};
			} else if (that.form.identity_type === 'passport' && !that.form.passport_country_code) {
				that.error = {message: "Please provide your country"};
			} else if (that.form.id_number === '') {
				that.error = {message: "Please fill in a valid Passport number"};
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/RecipientDetails.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_RecipientDetailsvue_type_script_lang_js_ = (RecipientDetailsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/RecipientDetails.vue





/* normalize component */
;
var RecipientDetails_component = (0,componentNormalizer/* default */.Z)(
  delivery_RecipientDetailsvue_type_script_lang_js_,
  RecipientDetailsvue_type_template_id_53f64af2_render,
  RecipientDetailsvue_type_template_id_53f64af2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecipientDetails = (RecipientDetails_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/OnlyCreditCard.vue?vue&type=template&id=49e76a35&
var OnlyCreditCardvue_type_template_id_49e76a35_render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var OnlyCreditCardvue_type_template_id_49e76a35_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('h3',[_vm._v("Please note that Express deliveries can only be paid by Credit Card to avoid clearance delays.")]),_c('p',[_vm._v("If you want to pay via Debit Order, please go back and select Standard Delivery.")])])
}]


;// CONCATENATED MODULE: ./src/modals/delivery/OnlyCreditCard.vue?vue&type=template&id=49e76a35&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/OnlyCreditCard.vue?vue&type=script&lang=js&



/* harmony default export */ var OnlyCreditCardvue_type_script_lang_js_ = ({
	mounted() {
		this.$modal.toggleLoader(false);
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-type');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.$modal.push('payment-methods');
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/OnlyCreditCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_OnlyCreditCardvue_type_script_lang_js_ = (OnlyCreditCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/OnlyCreditCard.vue





/* normalize component */
;
var OnlyCreditCard_component = (0,componentNormalizer/* default */.Z)(
  delivery_OnlyCreditCardvue_type_script_lang_js_,
  OnlyCreditCardvue_type_template_id_49e76a35_render,
  OnlyCreditCardvue_type_template_id_49e76a35_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OnlyCreditCard = (OnlyCreditCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/CollectionDetails.vue?vue&type=template&id=0d81bcc8&
var CollectionDetailsvue_type_template_id_0d81bcc8_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body has-columns"},[_c('div',{staticClass:"modal-column"},[_c('h3',[_vm._v("Who’ll be collecting")]),_c('address-preview',{attrs:{"hq":true}}),_c('signup-tabs',{attrs:{"options":_vm.recipientTabs,"selected":_vm.isRecipient},on:{"select":_vm.updateRecipient}}),_c('signup-input',{attrs:{"type":"name","label":"Full name and surname of the recipient","disabled":false,"required":true},model:{value:(_vm.form.full_name),callback:function ($$v) {_vm.$set(_vm.form, "full_name", $$v)},expression:"form.full_name"}}),_c('signup-input',{attrs:{"type":"tel","label":"Mobile contact number of recipient","disabled":false,"required":true},model:{value:(_vm.form.cell_number),callback:function ($$v) {_vm.$set(_vm.form, "cell_number", $$v)},expression:"form.cell_number"}}),_c('signup-input',{attrs:{"type":"tel","label":"Email address of recipient *","disabled":false,"required":true},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_c('div',{staticClass:"modal-column"},[_c('h3',[_vm._v("Identification Details")]),_c('signup-tabs',{attrs:{"options":_vm.identityOptions,"selected":_vm.form.identity_type},on:{"select":_vm.updateIdentityType}}),(_vm.form.identity_type === 'id_number')?_c('div',{staticClass:"signup-tab"},[_c('signup-input',{attrs:{"type":"tel","label":"ID number of recipient","disabled":false,"required":true},model:{value:(_vm.form.id_number),callback:function ($$v) {_vm.$set(_vm.form, "id_number", $$v)},expression:"form.id_number"}})],1):_vm._e(),(_vm.form.identity_type === 'passport')?_c('div',{staticClass:"signup-tab"},[_c('signup-select',{ref:"passport_select",attrs:{"disabled":false,"error":false,"options":_vm.countries,"required":true,"label":"Country"},model:{value:(_vm.form.passport_country_code),callback:function ($$v) {_vm.$set(_vm.form, "passport_country_code", $$v)},expression:"form.passport_country_code"}}),_c('signup-input',{attrs:{"type":"tel","label":"Passport number of recipient","disabled":false,"required":true},model:{value:(_vm.form.id_number),callback:function ($$v) {_vm.$set(_vm.form, "id_number", $$v)},expression:"form.id_number"}})],1):_vm._e()],1),_c('error-bar',{attrs:{"error":_vm.error,"message":_vm.error.message}})],1)
}
var CollectionDetailsvue_type_template_id_0d81bcc8_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/CollectionDetails.vue?vue&type=script&lang=js&








/* harmony default export */ var CollectionDetailsvue_type_script_lang_js_ = ({
	components: {SignupTabs: SignupTabs, SignupInput: SignupInput, SignupSelect: SignupSelect, AddressPreview: AddressPreview, ErrorBar: ErrorBar},
	computed: {
		countries() {
			let countries = [...this.$signup.$store.getters['signupGeneral/countries']];
			if (!countries) { return [] }
			return countries.map((c) => {
				return {
					"label": c.name,
					"value": c.code
				}
			})
		}
	},
	methods: {
		async next() {
			this.$signup.$store.commit('signupDelivery/updateDeliveryLocation', {
				id: 1
			});
			this.$signup.$store.commit('signupCart/setCartDetails', {
				delivery_location_id: 1,
				payment_detail_id: this.$signup.$store.getters['signupPayment/currentPaymentMethod'].id
			});

			// if delivery recipient is different to current user, update quote
			let user = this.$signup.$store.getters['signupUser/user'];
			if (
				!(this.form.id_number === user.id_number &&
				this.form.full_name === user.first_name + ' ' + user.last_name &&
				this.form.cell_number === user.cell_number &&
				this.form.email === user.email &&
				this.form.passport_country_code === user.passport_country_code)
			) {
				//update recipient on devices
				await this.$signup.$store.dispatch('signupCart/updateDeviceRecipient', {form: this.form});

				await this.$signup.$store.dispatch('signupDelivery/getDeliveryQuotes')
					.catch((err) => {
						this.error = {message: err.data.message};
					});

				//if api came back with error, bail
				if (this.error) {
					return;
				}
			}

			this.$signup.$store.commit('signupDelivery/updateSelectedDeliveryQuote',
				this.$signup.$store.getters['signupDelivery/deliveryQuotes'].find(q => {
					return q.name.indexOf('Collect') > -1
				})
			);
			this.$modal.push('summary');
		},
		updateRecipient(isRecipient) {
			if (isRecipient) {
				let user = this.$signup.$store.getters['signupUser/user'];
				// console.log(user);
				this.form.full_name = user.first_name + ' ' + user.last_name;
				this.form.cell_number = user.cell_number;
				this.form.email = user.email;
				this.form.identity_type = "id_number";
				if (user.passport_country) {
					this.form.identity_type = user.passport_country.passport_code === 'ZAF' ? 'id_number' : 'passport';
				}
				this.form.id_number = user.id_number;
				this.form.passport_country_code = user.passport_country_code;
			} else {
				this.form.full_name = '';
				this.form.cell_number = '';
				this.form.email = '';
				this.form.identity_type = 'id_number';
				this.form.id_number = '';
				this.form.passport_country_code = '';
			}
			this.isRecipient = isRecipient;
		},
		updateIdentityType(idType) {
			this.form.identity_type = idType;
		},
	},
	data() {
		return {
			error: false,
			recipientTabs: [
				{
					value: true,
					label: "I'm collecting",
				},
				{
					value: false,
					label: "Someone else",
				}
			],
			identityOptions: [
				{
					value: 'id_number',
					label: "South African ID",
				},
				{
					value: 'passport',
					label: "Passport",
				}
			],
			isRecipient: true,
			form: {
				full_name: '',
				cell_number: '',
				email: '',
				identity_type: 'id_number',
				id_number: '',
				passport_country_code: '',
			},
		}
	},
	async mounted() {
		//update current delivery selection
		this.$signup.$store.commit('signupDelivery/updateSelectedDeliveryQuote', this.$signup.$store.getters['signupDelivery/deliveryQuotes'].find(q => { return q.name.indexOf('Collect') > -1 }));
		if (!this.$signup.$store.getters['signupGeneral/countries'].length) {
			await this.$signup.$store.dispatch('signupGeneral/fetchCountries');
		}
		this.updateRecipient(this.isRecipient)
		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-option');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			that.error = false;
			if (that.form.full_name === '') {
				that.error = {message: "Full name cannot be empty"};
			} else if (that.form.cell_number === '') {
				that.error = {message: "Contact number cannot be empty"};
			} else if (that.form.email === '') {
				that.error = {message: "Email address cannot be empty"};
			} else if (that.form.identity_type === 'id_number' && (that.form.id_number === '' || !that.form.id_number.match(/(\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8]))|([02468][048]|[13579][26])0229)(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/))) {
				that.error = {message: "Please fill in a valid South African ID Number"};
			} else if (that.form.identity_type === 'passport' && !that.form.passport_country_code) {
				that.error = {message: "Please provide your country"};
			} else if (that.form.id_number === '') {
				that.error = {message: "Please fill in a valid Passport number"};
			} else {
				that.next();
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/CollectionDetails.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_CollectionDetailsvue_type_script_lang_js_ = (CollectionDetailsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modals/delivery/CollectionDetails.vue





/* normalize component */
;
var CollectionDetails_component = (0,componentNormalizer/* default */.Z)(
  delivery_CollectionDetailsvue_type_script_lang_js_,
  CollectionDetailsvue_type_template_id_0d81bcc8_render,
  CollectionDetailsvue_type_template_id_0d81bcc8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CollectionDetails = (CollectionDetails_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/CollectionSidebar.vue?vue&type=template&id=62a97738&scoped=true&
var CollectionSidebarvue_type_template_id_62a97738_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.collection)?_c('div',{staticClass:"signup-modal-sidebar"},[_c('h3',[_vm._v(_vm._s(_vm.collection.name))]),_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.collection.price))+" with Afrihost")]),_c('hr'),_vm._l((_vm.collection.terms),function(term){return _c('div',{staticClass:"term"},[_c('p',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm._f("formatTermType")(term.type))+" ")]),_c('p',[_vm._v(" "+_vm._s(term.term)+" ")])])})],2):_vm._e()
}
var CollectionSidebarvue_type_template_id_62a97738_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/CollectionSidebar.vue?vue&type=script&lang=js&



/* harmony default export */ var CollectionSidebarvue_type_script_lang_js_ = ({
	components: {
		Icon: Icon
	},
	data() {
		return {
			// collection: false,
		}
	},

	computed: {
		collection() {
			return this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote'];
		}
	},
});

;// CONCATENATED MODULE: ./src/modals/delivery/CollectionSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_CollectionSidebarvue_type_script_lang_js_ = (CollectionSidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/CollectionSidebar.vue?vue&type=style&index=0&id=62a97738&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/CollectionSidebar.vue?vue&type=style&index=0&id=62a97738&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/delivery/CollectionSidebar.vue



;


/* normalize component */

var CollectionSidebar_component = (0,componentNormalizer/* default */.Z)(
  delivery_CollectionSidebarvue_type_script_lang_js_,
  CollectionSidebarvue_type_template_id_62a97738_scoped_true_render,
  CollectionSidebarvue_type_template_id_62a97738_scoped_true_staticRenderFns,
  false,
  null,
  "62a97738",
  null
  
)

/* harmony default export */ var CollectionSidebar = (CollectionSidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliverySingleType.vue?vue&type=template&id=1c7ade4c&scoped=true&
var DeliverySingleTypevue_type_template_id_1c7ade4c_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"delivery-type-cards"},[_c('div',{staticClass:"delivery-type-card"},[_c('h3',[_vm._v(_vm._s(_vm.delivery.name))]),_c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.delivery.price))+" with Afrihost")]),_c('hr'),_c('p',{staticClass:"head"},[_vm._v("Terms and conditions")]),_c('p',[_vm._v(_vm._s(_vm.delivery.description))])]),_c('div',{staticClass:"delivery-type-card"},_vm._l((_vm.delivery.terms),function(term){return _c('div',{staticClass:"term"},[_c('p',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm._f("formatTermType")(term.type))+" ")]),_c('p',[_vm._v(" "+_vm._s(term.term)+" ")])])}),0)])])
}
var DeliverySingleTypevue_type_template_id_1c7ade4c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliverySingleType.vue?vue&type=script&lang=js&





/* harmony default export */ var DeliverySingleTypevue_type_script_lang_js_ = ({
	components: {
		Icon: Icon,
		DeliveryTypeCard: DeliveryTypeCard
	},
	computed: {
		delivery() {
			return this.$signup.$store.getters['signupDelivery/selectedDeliveryQuote'];
		},
	},
	data() {
		return {
			selectedDeliveryType: false,
		}
	},
	mounted() {
		this.$modal.toggleLoader(false);

		let that = this;
		// listen for back button event
		services_EventBus.$on('back', function () {
			that.$modal.push('delivery-recipient');
		});

		// listen for next button event
		services_EventBus.$on('next', function () {
			if (that.delivery.name.indexOf('Express') > -1
				&& that.$signup.$store.getters['signupPayment/currentPaymentMethod'].payment_method !== 'CC') {
				that.$modal.push('only-credit-card');
			} else {
				that.$modal.push('summary');
			}
		});
	},
	beforeDestroy() {
		services_EventBus.$off('back')
		services_EventBus.$off('next')
	}
});

;// CONCATENATED MODULE: ./src/modals/delivery/DeliverySingleType.vue?vue&type=script&lang=js&
 /* harmony default export */ var delivery_DeliverySingleTypevue_type_script_lang_js_ = (DeliverySingleTypevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/delivery/DeliverySingleType.vue?vue&type=style&index=0&id=1c7ade4c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/delivery/DeliverySingleType.vue?vue&type=style&index=0&id=1c7ade4c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/delivery/DeliverySingleType.vue



;


/* normalize component */

var DeliverySingleType_component = (0,componentNormalizer/* default */.Z)(
  delivery_DeliverySingleTypevue_type_script_lang_js_,
  DeliverySingleTypevue_type_template_id_1c7ade4c_scoped_true_render,
  DeliverySingleTypevue_type_template_id_1c7ade4c_scoped_true_staticRenderFns,
  false,
  null,
  "1c7ade4c",
  null
  
)

/* harmony default export */ var DeliverySingleType = (DeliverySingleType_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/OrderSuccessful.vue?vue&type=template&id=4834964f&scoped=true&
var OrderSuccessfulvue_type_template_id_4834964f_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"tick-circle"}})],1),_c('h1',[_vm._v(" Your order was successful ")]),(_vm.testSignup)?_c('p',{staticClass:"warn"},[_vm._v("Your order will not be processed because this is a development build.")]):_vm._e(),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Done ")])])
}
var OrderSuccessfulvue_type_template_id_4834964f_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/OrderSuccessful.vue?vue&type=script&lang=js&


/* harmony default export */ var OrderSuccessfulvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	computed: {
		testSignup() {
			return this.$signup.$store.getters['signupGeneral/testSignup']
		}
	},
	methods: {
		next() {
			this.$modal.close();
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);
	}

});

;// CONCATENATED MODULE: ./src/modals/summary/OrderSuccessful.vue?vue&type=script&lang=js&
 /* harmony default export */ var summary_OrderSuccessfulvue_type_script_lang_js_ = (OrderSuccessfulvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/summary/OrderSuccessful.vue?vue&type=style&index=0&id=4834964f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/summary/OrderSuccessful.vue?vue&type=style&index=0&id=4834964f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/summary/OrderSuccessful.vue



;


/* normalize component */

var OrderSuccessful_component = (0,componentNormalizer/* default */.Z)(
  summary_OrderSuccessfulvue_type_script_lang_js_,
  OrderSuccessfulvue_type_template_id_4834964f_scoped_true_render,
  OrderSuccessfulvue_type_template_id_4834964f_scoped_true_staticRenderFns,
  false,
  null,
  "4834964f",
  null
  
)

/* harmony default export */ var OrderSuccessful = (OrderSuccessful_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/InterestRecorded.vue?vue&type=template&id=b8a3b536&scoped=true&
var InterestRecordedvue_type_template_id_b8a3b536_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"logo-container"},[_c('icon',{attrs:{"name":"tick-circle"}})],1),_c('h1',[_vm._v(" Thank you for showing your interest. ")]),_c('p',[_vm._v("We'll notify you when "+_vm._s(_vm.product)+" is available in your area.")]),_c('button',{staticClass:"signup-button",on:{"click":_vm.next}},[_vm._v(" Close ")])])
}
var InterestRecordedvue_type_template_id_b8a3b536_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/InterestRecorded.vue?vue&type=script&lang=js&


/* harmony default export */ var InterestRecordedvue_type_script_lang_js_ = ({
	components: {Icon: Icon},
	computed: {
		product() {
			let solutionType = this.$signup.$store.getters['signupCoverage/solutionTypes'];
			if(solutionType.length > 1) {
				return 'coverage';
			}

			switch (solutionType[0]) {
				case 'connectivity_mobile':
					return 'LTE coverage';
				case 'composite_fibre':
					return 'Fibre coverage';
				case 'composite_dsl':
					return 'DSL coverage';
				default:
					return 'coverage';
			}
		}
	},
	methods: {
		next() {
			this.$modal.close();
		},
	},
	mounted() {
		this.$modal.toggleLoader(false);
	}

});

;// CONCATENATED MODULE: ./src/modals/coverage/InterestRecorded.vue?vue&type=script&lang=js&
 /* harmony default export */ var coverage_InterestRecordedvue_type_script_lang_js_ = (InterestRecordedvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modals/coverage/InterestRecorded.vue?vue&type=style&index=0&id=b8a3b536&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modals/coverage/InterestRecorded.vue?vue&type=style&index=0&id=b8a3b536&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modals/coverage/InterestRecorded.vue



;


/* normalize component */

var InterestRecorded_component = (0,componentNormalizer/* default */.Z)(
  coverage_InterestRecordedvue_type_script_lang_js_,
  InterestRecordedvue_type_template_id_b8a3b536_scoped_true_render,
  InterestRecordedvue_type_template_id_b8a3b536_scoped_true_staticRenderFns,
  false,
  null,
  "b8a3b536",
  null
  
)

/* harmony default export */ var InterestRecorded = (InterestRecorded_component.exports);
;// CONCATENATED MODULE: ./src/plugin/Modal.js






































































// import ShowInterest from './modals/coverage/ShowInterest'

class Modal_Modal {

	constructor(Vue) {

		// new instance to store the data
		this.storeVM = new Vue({
			data() {
				return {
					routes: [
						{
							name: 'coverage',
							component: CoverageMap,
							title: "Coverage check",
							sidebar: false,
							buttons: [
								{
									label: 'Close',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Check coverage',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'no-coverage',
							component: NoCoverage,
							title: "No Coverage",
							sidebar: false,
							buttons: [
								{
									label: 'Edit Address',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Notify Me',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'interest-recorded',
							component: InterestRecorded,
							title: "Thank you",
							sidebar: false,
							fullPage: true,
						},
						{
							name: 'coverage-upsell',
							component: NoCoverageUpsell,
							title: 'No coverage',
							sidebar: false,
							buttons: [
								{
									label: 'Edit Address',
									type: 'ghost',
									action: 'back'
								}
							]
						},
						{
							name: 'no-coverage-promo',
							component: NoCoveragePromo,
							title: 'Fibre coverage',
							sidebar: false,
							buttons: [
								{
									label: 'Edit Address',
									type: 'ghost',
									action: 'back'
								}
							]
						},

						{
							name: 'dsl-providers',
							component: dsl_Solutions,
							title: "Choose a package",
							sidebar: dsl_Sidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'dsl-solutions',
							component: dsl_Solutions,
							title: "Choose a package",
							sidebar: dsl_Sidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'dsl-im-sure',
							component: ManualCheckConfirmation,
							title: "Are you sure?",
							sidebar: false,
							buttons: [
								{
									label: 'Edit address',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'I\'m sure, continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'lte-providers',
							component: Providers,
							title: "Choose a provider",
							sidebar: false,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'lte-solutions',
							component: Solutions,
							title: "Choose a package",
							sidebar: Sidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},

						{
							name: 'fibre-experience',
							component: Experience,
							title: "Choose an experience",
							sidebar: false,
							buttons: [
								{
									label: 'Edit address',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'fibre-providers',
							component: fibre_Providers,
							title: "Choose a provider",
							sidebar: false,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'fibre-solutions',
							component: fibre_Solutions,
							title: "Choose a package",
							sidebar: fibre_Sidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'promo-tt-connect',
							component: ttConnectOptIn,
							title: "Choose a package",
							sidebar: false,
							buttons: [
								{
									label: 'No thanks',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Opt in',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'fibre-device',
							component: Device,
							title: "Fibre WiFi Router",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'fibre-device-upsell',
							component: MeshUpsell,
							title: "Home mesh WiFi 6 system",

							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							],
						},
						{
							name: 'fibre-ups-upsell',
							component: UpsUpsell,
							title: "UPS Devices",

							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							],
						},
						{
							name: 'fibre-installation',
							component: Installation,
							title: "Fibre installation",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},

						{
							name: 'fibre-max-upsell',
							component: MaxUpsell,
							title: "Afrihost Max add-on",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'fibre-addons',
							component: Addons,
							title: "Helpful add-ons",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'rica-contacts',
							component: RicaContacts,
							title: "RICA contacts",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'rica-create-contact',
							component: RicaCreateContact,
							title: "New RICA contact",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},

						{
							name: 'bundle-promo-available',
							component: PromoAvailable,
							title: "Unleash your limits",
							sidebar: false,
							buttons: [
								{
									label: 'Edit address',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'bundle-promo-unavailable',
							component: PromoUnavailable,
							title: "Promo Available",
							sidebar: false,
							buttons: [
								{
									label: 'Edit address',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Sign up for Fibre',
									type: 'primary',
									action: 'next'
								}
							]
						},

						{
							name: 'payment-methods',
							component: PaymentMethods,
							title: "Payment method",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'new-payment-method',
							component: NewPaymentMethod,
							title: "Add Payment method",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'new-payment-card',
							component: NewCard,
							title: "Add card details",
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Add card',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'three-dee-secure',
							component: _3DSecure,
							title: "Add card details",
							fullPage: true,
							buttons: []
						},
						{
							name: 'new-payment-bank',
							component: NewBankAccount,
							title: "Add bank details",
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Add Payment',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'new-payment-added',
							component: NewPaymentConfirmation,
							title: "New Payment method added",
							fullPage: true,
							buttons: []
						},
						{
							name: 'new-payment-failed',
							component: NewPaymentFailed,
							title: "New Payment method failed to add",
							fullPage: true,
							buttons: []
						},

						{
							name: 'delivery-option',
							component: DeliveryOption,
							title: "Delivery options",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'delivery-address',
							component: DeliveryAddress,
							title: "Choose address",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'new-delivery-address',
							component: NewDeliveryAddress,
							title: "New delivery address",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Use this address',
									type: 'primary disabled',
									action: 'next'
								}
							]
						},
						{
							name: 'delivery-address-details',
							component: DeliveryAddressDetails,
							title: "Delivery address details",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Add address',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'delivery-address-added',
							component: AddressAdded,
							title: "Delivery address details",
							fullPage: true,
							buttons: []
						},
						{
							name: 'delivery-type',
							component: DeliveryType,
							title: "Delivery type",
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'delivery-single',
							component: DeliverySingleType,
							title: "Delivery type",
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'no-delivery-available',
							component: NoDeliveryAvailable,
							title: "No delivery options available",
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Change delivery address',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'delivery-recipient',
							component: RecipientDetails,
							title: "Delivery details",
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'collection',
							component: CollectionDetails,
							title: "Collection details",
							sidebar: CollectionSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'only-credit-card',
							component: OnlyCreditCard,
							title: "You can only pay via Credit Card",
							buttons: [
								{
									label: 'Go back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Change payment method',
									type: 'primary',
									action: 'next'
								}
							]
						},

						{
							name: 'auth-signup',
							component: Register,
							title: "Create new account",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'auth-create-account',
							component: CreateAccount,
							title: "Create new account",
							sidebar: false,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Create Account',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'auth-login',
							component: Login,
							title: "Account Login",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'welcome-back',
							component: WelcomeBack,
							fullPage: true,
							title: "Welcome Back",
							buttons: []
						},
						{
							name: 'account-created',
							component: AccountCreated,
							fullPage: true,
							title: "Account Created",
							buttons: []
						},
						{
							name: 'auth-otp',
							component: OTP,
							title: "OTP Authentication",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Continue',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'auth-forgot-password',
							component: ForgotPassword,
							title: "Reset Password",
							// sidebar: AuthSidebar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Reset password',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'auth-password-reset-complete',
							component: PasswordResetConfirmation,
							title: "Password reset instructions sent",
							fullPage: true,
							buttons: []
						},


						{
							name: 'summary',
							component: Summary,
							title: "Confirm your order",
							sidebar: SummarySideBar,
							buttons: [
								{
									label: 'Back',
									type: 'ghost',
									action: 'back'
								},
								{
									label: 'Complete Order',
									type: 'primary',
									action: 'next'
								}
							]
						},
						{
							name: 'order-successful',
							component: OrderSuccessful,
							title: "Order Successful!",
							fullPage: true,
							buttons: []
						},
					],
					previous: null,
					current: null,
					loading: false,
					open: false,
					closing: false,
					opening: false,
					props: false,
				};
			},
		});

		this.updateHeader = (text, icon = 'signup-map-pin') =>  {
			this.state.header = {
				icon: icon,
				text: text
			}
		}

		this.updateTitle = (text) =>  {
			this.state.current.title = text
		}

		this.push = (name) => {
			let route = this.state.routes.find(r => r.name === name);
			if(!route) throw new Error(`Route "${name}" not found`);
			this.state.previous = this.state.current;
			this.state.current = route;
			//add body class to prevent scrolling
			document.body.classList.add('signup-modal-open');
		};

		this.open = (route) => {
			this.push(route);
			this.state.open = true;
			this.state.opening = true;
			this.state.closing = false;

			setTimeout(() => {
				this.state.opening = false;
			}, 300);
		};

		this.close = () => {
			this.state.previous = this.state.current;
			this.state.closing = true;
			setTimeout(() => {
				this.state.open = false;
				this.state.current = false;
				this.state.false = false;
				this.state.loading = false;
				this.state.closing = false;
			}, 300);
			//remove body class to prevent scrolling
			document.body.classList.remove('signup-modal-open');

		};

		this.toggle = (modalState) => {
			this.state.open = !!modalState;
			if(!this.state.open) {
				this.state.current = route;
			}
		};

		this.updateProps = (props) => {
			this.state.props = props;
		};

		this.toggleLoader = (value) => {
			this.state.loading = value;
		};
	}

	/**
	 * Gets the state of the data
	 * @return {Object}
	 */
	get state() {
		return this.storeVM.$data;
	}
}


;// CONCATENATED MODULE: ./package.json
var package_namespaceObject = {"i8":"1.0.70"};
// EXTERNAL MODULE: ./node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(9996);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);
;// CONCATENATED MODULE: ./node_modules/vuex-persist/dist/esm/index.js


/**
 * Created by championswimmer on 22/07/17.
 */
let MockStorage;
// @ts-ignore
{
    MockStorage = class {
        get length() {
            return Object.keys(this).length;
        }
        key(index) {
            return Object.keys(this)[index];
        }
        setItem(key, data) {
            this[key] = data.toString();
        }
        getItem(key) {
            return this[key];
        }
        removeItem(key) {
            delete this[key];
        }
        clear() {
            for (let key of Object.keys(this)) {
                delete this[key];
            }
        }
    };
}

// tslint:disable: variable-name
class SimplePromiseQueue {
    constructor() {
        this._queue = [];
        this._flushing = false;
    }
    enqueue(promise) {
        this._queue.push(promise);
        if (!this._flushing) {
            return this.flushQueue();
        }
        return Promise.resolve();
    }
    flushQueue() {
        this._flushing = true;
        const chain = () => {
            const nextTask = this._queue.shift();
            if (nextTask) {
                return nextTask.then(chain);
            }
            else {
                this._flushing = false;
            }
        };
        return Promise.resolve(chain());
    }
}

const options = {
    replaceArrays: {
        arrayMerge: (destinationArray, sourceArray, options) => sourceArray
    },
    concatArrays: {
        arrayMerge: (target, source, options) => target.concat(...source)
    }
};
function merge(into, from, mergeOption) {
    return cjs_default()(into, from, options[mergeOption]);
}

let FlattedJSON = JSON;
/**
 * A class that implements the vuex persistence.
 * @type S type of the 'state' inside the store (default: any)
 */
class VuexPersistence {
    /**
     * Create a {@link VuexPersistence} object.
     * Use the <code>plugin</code> function of this class as a
     * Vuex plugin.
     * @param {PersistOptions} options
     */
    constructor(options) {
        // tslint:disable-next-line:variable-name
        this._mutex = new SimplePromiseQueue();
        /**
         * Creates a subscriber on the store. automatically is used
         * when this is used a vuex plugin. Not for manual usage.
         * @param store
         */
        this.subscriber = (store) => (handler) => store.subscribe(handler);
        if (typeof options === 'undefined')
            options = {};
        this.key = ((options.key != null) ? options.key : 'vuex');
        this.subscribed = false;
        this.supportCircular = options.supportCircular || false;
        if (this.supportCircular) {
            FlattedJSON = __webpack_require__(939);
        }
        this.mergeOption = options.mergeOption || 'replaceArrays';
        let localStorageLitmus = true;
        try {
            window.localStorage.getItem('');
        }
        catch (err) {
            localStorageLitmus = false;
        }
        /**
         * 1. First, prefer storage sent in optinos
         * 2. Otherwise, use window.localStorage if available
         * 3. Finally, try to use MockStorage
         * 4. None of above? Well we gotta fail.
         */
        if (options.storage) {
            this.storage = options.storage;
        }
        else if (localStorageLitmus) {
            this.storage = window.localStorage;
        }
        else if (MockStorage) {
            this.storage = new MockStorage();
        }
        else {
            throw new Error("Neither 'window' is defined, nor 'MockStorage' is available");
        }
        /**
         * How this works is -
         *  1. If there is options.reducer function, we use that, if not;
         *  2. We check options.modules;
         *    1. If there is no options.modules array, we use entire state in reducer
         *    2. Otherwise, we create a reducer that merges all those state modules that are
         *        defined in the options.modules[] array
         * @type {((state: S) => {}) | ((state: S) => S) | ((state: any) => {})}
         */
        this.reducer = ((options.reducer != null)
            ? options.reducer
            : ((options.modules == null)
                ? ((state) => state)
                : ((state) => options.modules.reduce((a, i) => merge(a, { [i]: state[i] }, this.mergeOption), { /* start empty accumulator*/}))));
        this.filter = options.filter || ((mutation) => true);
        this.strictMode = options.strictMode || false;
        this.RESTORE_MUTATION = function RESTORE_MUTATION(state, savedState) {
            const mergedState = merge(state, savedState || {}, this.mergeOption);
            for (const propertyName of Object.keys(mergedState)) {
                this._vm.$set(state, propertyName, mergedState[propertyName]);
            }
        };
        this.asyncStorage = options.asyncStorage || false;
        if (this.asyncStorage) {
            /**
             * Async {@link #VuexPersistence.restoreState} implementation
             * @type {((key: string, storage?: Storage) =>
             *      (Promise<S> | S)) | ((key: string, storage: AsyncStorage) => Promise<any>)}
             */
            this.restoreState = ((options.restoreState != null)
                ? options.restoreState
                : ((key, storage) => (storage).getItem(key)
                    .then((value) => typeof value === 'string' // If string, parse, or else, just return
                    ? (this.supportCircular
                        ? FlattedJSON.parse(value || '{}')
                        : JSON.parse(value || '{}'))
                    : (value || {}))));
            /**
             * Async {@link #VuexPersistence.saveState} implementation
             * @type {((key: string, state: {}, storage?: Storage) =>
             *    (Promise<void> | void)) | ((key: string, state: {}, storage?: Storage) => Promise<void>)}
             */
            this.saveState = ((options.saveState != null)
                ? options.saveState
                : ((key, state, storage) => (storage).setItem(key, // Second argument is state _object_ if asyc storage, stringified otherwise
                // do not stringify the state if the storage type is async
                (this.asyncStorage
                    ? merge({}, state || {}, this.mergeOption)
                    : (this.supportCircular
                        ? FlattedJSON.stringify(state)
                        : JSON.stringify(state))))));
            /**
             * Async version of plugin
             * @param {Store<S>} store
             */
            this.plugin = (store) => {
                /**
                 * For async stores, we're capturing the Promise returned
                 * by the `restoreState()` function in a `restored` property
                 * on the store itself. This would allow app developers to
                 * determine when and if the store's state has indeed been
                 * refreshed. This approach was suggested by GitHub user @hotdogee.
                 * See https://github.com/championswimmer/vuex-persist/pull/118#issuecomment-500914963
                 * @since 2.1.0
                 */
                store.restored = (this.restoreState(this.key, this.storage)).then((savedState) => {
                    /**
                     * If in strict mode, do only via mutation
                     */
                    if (this.strictMode) {
                        store.commit('RESTORE_MUTATION', savedState);
                    }
                    else {
                        store.replaceState(merge(store.state, savedState || {}, this.mergeOption));
                    }
                    this.subscriber(store)((mutation, state) => {
                        if (this.filter(mutation)) {
                            this._mutex.enqueue(this.saveState(this.key, this.reducer(state), this.storage));
                        }
                    });
                    this.subscribed = true;
                });
            };
        }
        else {
            /**
             * Sync {@link #VuexPersistence.restoreState} implementation
             * @type {((key: string, storage?: Storage) =>
             *    (Promise<S> | S)) | ((key: string, storage: Storage) => (any | string | {}))}
             */
            this.restoreState = ((options.restoreState != null)
                ? options.restoreState
                : ((key, storage) => {
                    const value = (storage).getItem(key);
                    if (typeof value === 'string') { // If string, parse, or else, just return
                        return (this.supportCircular
                            ? FlattedJSON.parse(value || '{}')
                            : JSON.parse(value || '{}'));
                    }
                    else {
                        return (value || {});
                    }
                }));
            /**
             * Sync {@link #VuexPersistence.saveState} implementation
             * @type {((key: string, state: {}, storage?: Storage) =>
             *     (Promise<void> | void)) | ((key: string, state: {}, storage?: Storage) => Promise<void>)}
             */
            this.saveState = ((options.saveState != null)
                ? options.saveState
                : ((key, state, storage) => (storage).setItem(key, // Second argument is state _object_ if localforage, stringified otherwise
                (this.supportCircular
                    ? FlattedJSON.stringify(state)
                    : JSON.stringify(state)))));
            /**
             * Sync version of plugin
             * @param {Store<S>} store
             */
            this.plugin = (store) => {
                const savedState = this.restoreState(this.key, this.storage);
                if (this.strictMode) {
                    store.commit('RESTORE_MUTATION', savedState);
                }
                else {
                    store.replaceState(merge(store.state, savedState || {}, this.mergeOption));
                }
                this.subscriber(store)((mutation, state) => {
                    if (this.filter(mutation)) {
                        this.saveState(this.key, this.reducer(state), this.storage);
                    }
                });
                this.subscribed = true;
            };
        }
    }
}

/* harmony default export */ var esm = (VuexPersistence);

//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(6808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./src/services/Encoder.js
/* harmony default export */ var Encoder = ({
	encode: (value) => {
		return btoa(JSON.stringify(value))
	},
	decode: (value) => {
		return JSON.parse(atob(value))
	}
});
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/services/API.js



// import Vue from 'vue'

/* harmony default export */ var API = ({

    postRoot(url, request, noAuth = false) {
    	let token = js_cookie_default().get('ah-signup-1036') ? Encoder.decode(js_cookie_default().get('ah-signup-1036')).signupUser.token : undefined;
    	// let token = JSON.parse(localStorage['ah-signup']).signupUser.token;
    	let authHeaders = {
			Authorization: 'Bearer ' + token
		};
        return axios_default().post(url, request, {
			headers: noAuth ? null : authHeaders
		})
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },

	getRoot(url, params, noAuth = false) {
		let token = js_cookie_default().get('ah-signup-1036') ? Encoder.decode(js_cookie_default().get('ah-signup-1036')).signupUser.token : undefined;
		// let token = JSON.parse(localStorage['ah-signup']).signupUser.token;
		let authHeaders = {
			Authorization: 'Bearer ' + token
		}

		return axios_default().get(url, {
			params: params,
			headers: noAuth ? null : authHeaders
		})
			.then((response) => Promise.resolve(response.data))
			.catch((error) => Promise.reject(error));
	},

    post(url, request, noAuth = false) {
    	return this.postRoot('https://clientzone.afrihost.com/en/api/' + url, request, noAuth);
    },

    get(url, params, noAuth = false) {
    	return this.getRoot('https://clientzone.afrihost.com/en/api/' + url, params, noAuth);
    }
});
;// CONCATENATED MODULE: ./src/store/modules/signupUser.js


/* harmony default export */ var signupUser = ({
	namespaced: true,
	state: {
		user: false,
		token: false,
		ricaContacts: false,
		selectedRicaContact: false,
	},
	getters: {
		user: state => {
			return state.user;
		},
		token: state => {
			return state.token;
		},
		ricaContacts: state => {
			return state.ricaContacts;
		},
		selectedRicaContact: state => {
			return state.selectedRicaContact;
		},

	},
	mutations: {
		updateUser(state, value) {
			if (!value) {
				state.user = false;
				return;
			}
			state.user = {
				...state.user,
				...value
			};
		},
		updateToken(state, value) {
			state.token = value;
		},
		updateRicaContacts(state, value) {
			state.ricaContacts = value;
		},
		selectRicaContact(state, value) {
			state.selectedRicaContact = value;
		},
	},
	actions: {
		register({rootState, commit, state, dispatch}) {
			let userObj = {
				first_name: state.user.first_name,
				last_name: state.user.last_name,
				email: state.user.email,
				cell_number: state.user.cell_number,
				password: state.user.password,
				identity_type: state.user.identity_type,
				id_number: state.user.id_number,
			};

			if (rootState.signupGeneral.testSignup) {
				userObj = {
					...userObj,
					tomato: "soup" //add for dev purposes
				}
			}

			// add the passport number
			if(state.user.identity_type === 'passport') {
				userObj.passport_country_code = state.user.passport_country_code;
			} else {
				userObj.passport_country_code = 'ZAF'
			}

			return new Promise((resolve, reject) => {
				return API.post('public/v1/client-contact', userObj, true).then(async response => {
					commit('updateUser', response.client_contact);
					resolve(response);
				}, error => {
					reject(error);
				});
			});
		},
		login({commit}, credentials) {
			return new Promise((resolve, reject) => {
				return API.post('v1/auth/jwt/login', {
						_username: credentials.email,
						_password: credentials.password,
					})
					.then(response => {
						commit('updateToken', response.token)
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		forgotPassword({state}) {
			if (state.user.email === undefined) {
				return Promise.reject({ message: 'No email address has been defined.' });
			}
			return new Promise((resolve, reject) => {
				return API.post('public/v1/auth/forgot-password',{
					email_address: state.user.email
				}, false)
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		refreshToken({commit}, _payload = { resetState: true }) {
			return new Promise((resolve, reject) => {
				return API.get('v1/auth/jwt/refresh')
					.then(response => {
						commit('updateToken', response.token);
						if (_payload.resetState === true) {
							//reset store to not contain previous values
							commit('signupPayment/resetState', null, { root: true });
							commit('signupDelivery/resetState', null, { root: true });
						}
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		verifyOTP({commit}, otp) {
			return new Promise((resolve, reject) => {
				return API.post('v1/auth/jwt/otp/verify', {
						otp: otp,
					})
					.then(response => {
						commit('updateToken', response.token)
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getClientContact({commit}) {
			return new Promise((resolve, reject) => {
				return API.get('v1/client-contact', false)
					.then(response => {
						if (!response.client_contact.email) {
							reject('no token supplied')
						}
						commit('updateUser', response.client_contact);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		addLocation({state}, _payload) {
			return new Promise((resolve, reject) => {
				return API.post('v1/location', {
				// return apiService.post('public/v1/location/validate', {
					"location_type_name": _payload.type,
					"name": _payload.customName,
					"province": _payload.province,
					"suburb": _payload.suburb,
					"city": _payload.city,
					"postal_code": _payload.postalCode,
					"street_name": _payload.streetName,
					"street_number": _payload.streetNumber,
					"building_name": _payload.buildingName,
					"building_number": _payload.buildingNumber,
					"longitude": _payload.longitude,
					"latitude": _payload.latitude
				})
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getRicaContacts({commit}) {
			return new Promise((resolve, reject) => {
				return API.get('v1/rica-contact/search', false)
					.then(response => {
						commit('updateRicaContacts', response.rica_contacts);
						resolve(response.rica_contacts);
					}, error => {
						reject(error);
					});
			});
		},
		createRicaContact({commit}, _payload) {
			return new Promise((resolve, reject) => {
				return API.post('v1/rica-contact', _payload)
					.then(response => {
						commit('selectRicaContact', response.rica_contact.id);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		}
	},
});

;// CONCATENATED MODULE: ./src/store/modules/signupCoverage.js




/* harmony default export */ var signupCoverage = ({
	namespaced: true,
	state: {
		solutionTypes: [],
		availableSolutionTypes: [],
		upsellSolutionTypes: [],
		availableUpsellSolutionTypes: [],
		place: false,
		coordinates: false,
		formattedAddress: false,
		coverage: false,
		autoSearch: false,
		vendorScope: false,
	},
	getters: {
		solutionTypes: state => {
			return state.solutionTypes;
		},
		availableSolutionTypes: state => {
			return state.availableSolutionTypes;
		},
		upsellSolutionTypes: state => {
			return state.upsellSolutionTypes;
		},
		availableUpsellSolutionTypes: state => {
			return state.availableUpsellSolutionTypes;
		},
		place: state => {
			return state.place;
		},
		coordinates: state => {
			return state.coordinates;
		},
		formattedAddress: state => {
			return state.formattedAddress;
		},
		coverage: state => {
			return state.coverage;
		},
		coverageByType: (state) => (solutionType) => {
			return state.coverage.filter(provider => provider.solution_type_slug === solutionType);
		},
		autoSearch: state => {
			return state.autoSearch;
		},
		vendorScope: state => {
			return state.vendorScope;
		},
	},
	mutations: {
		resetState(state) {
			state.availableSolutionTypes = [];
			state.availableUpsellSolutionTypes = [];
			state.place = false;
			state.formattedAddress = false;
			state.coverage = false;
		},
		updateVendorScope(state, value) {
			state.vendorScope = value;
		},
		updateSolutionTypes(state, value) {
			state.solutionTypes = value;
		},
		updateAvailableSolutionTypes(state, value) {
			state.availableSolutionTypes = value;
		},
		addAvailableSolutionTypes(state, value) {
			state.availableSolutionTypes.push(value);
		},
		updateUpsellSolutionTypes(state, value) {
			state.upsellSolutionTypes = value;
		},
		updateAvailableUpsellSolutionTypes(state, value) {
			state.availableUpsellSolutionTypes = value;
		},
		addAvailableUpsellSolutionTypes(state, value) {
			state.availableUpsellSolutionTypes.push(value);
		},
		updatePlace(state, value) {
			state.place = value;
		},
		updateCoordinates(state, value) {
			state.coordinates = value;
		},
		updateFormattedAddress(state, value) {
			state.formattedAddress = value;
		},
		updateCoverage(state, value) {
			state.coverage = value;
		},
		updateAutoSearch(state, value) {
			state.autoSearch = value;
		},
	},
	actions: {
		setCoverage({state, commit}, data) {
			// reset coverage data
			commit('signupGeneral/updateImSure', false, {root: true});
			commit('updateCoverage', data);
			commit('updateAvailableSolutionTypes', []);
			commit('updateAvailableUpsellSolutionTypes', []);

			let solutionTypes = state.solutionTypes;
			let upsellSolutionTypes = state.upsellSolutionTypes;

			// create a flat array of solution types at the coverage location
			let solutionTypesAtPlace = data.map(a => a.solution_type_slug);

			// fill availableSolutionTypes with available solution types
			solutionTypes.forEach(t => {
				if (solutionTypesAtPlace.indexOf(t) >= 0) {
					commit('addAvailableSolutionTypes', t);
				}
			});

			// fill availableUpsellSolutionTypes with available solution types
			upsellSolutionTypes.forEach(t => {
				if (solutionTypesAtPlace.indexOf(t) >= 0) {
					commit('addAvailableUpsellSolutionTypes', t);
				}
			});
		},
		checkCoverage({state, dispatch}) {
			let solutionTypes = state.solutionTypes;
			let upsellSolutionTypes = state.upsellSolutionTypes;
			let coordinates = state.coordinates;

			return new Promise((resolve, reject) => {
				return API.get('public/v1/coverage/vendors', {
					latitude: coordinates.lat.toFixed(6),
					longitude: coordinates.lng.toFixed(6),
					solution_types: solutionTypes,
					with: ['max_download_speed']
				}, true)
					.then(response => {
						//check if vendor_coverage_data is empty, then check upsell solutions for coverage
						if (response.vendor_coverage_data.length < 1 && upsellSolutionTypes.length > 0) {
							resolve(dispatch('checkUpsellCoverage'))
						} else {

							// check if the vendor is scoped
							if(state.vendorScope) {
								let vendors = response.vendor_coverage_data.filter(i => i.vendor.slug === state.vendorScope)
								dispatch('setCoverage', vendors);
							} else {
								dispatch('setCoverage', response.vendor_coverage_data);
							}
							resolve(response);
						}
					}, error => {
						reject(error);
					});
			});
		},
		//split upsell coverage-check out because MTN's api goes down and it hinders fibre signups
		checkUpsellCoverage({state, dispatch}) {
			let upsellSolutionTypes = state.upsellSolutionTypes;
			let coordinates = state.coordinates;

			return new Promise((resolve, reject) => {
				return API.get('public/v1/coverage/vendors', {
					latitude: coordinates.lat.toFixed(6),
					longitude: coordinates.lng.toFixed(6),
					solution_types: upsellSolutionTypes,
					with: ['max_download_speed']
				}, true)
					.then(response => {
						dispatch('setCoverage', response.vendor_coverage_data);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		async checkBundleCoverage({state, commit}) {
			let suburb = state.place.address_components.filter(c => {
				if (c.types.includes('sublocality')) {
					return c;
				}
			});
			if (suburb.length < 1) {
				return Promise.reject('No suburb here');
			}

			//get providers
			let bundleProviders = [];
			let coverage = state.coverage;
			coverage.forEach(v => {
				if (v.solution_type_slug !== 'composite_fibre') return;

				bundleProviders.push({
					slug: v.vendor.slug,
				});
			});

			//check each of the providers
			bundleProviders = await Promise.all(bundleProviders.map(async (p) => {
				p.bundle_allowed = await axios_default().post("https://www.afrihost.com/fibre/api/can-bundle", {
					suburb: suburb[0].long_name,
					provider_slug: p.slug
				}).then(response => {
					return response.data.bundle_allowed;
				});
				return p;
			}));

			await commit('signupSolutions/updateBundleProviders', bundleProviders, { root: true });
			return bundleProviders;
		},
		showInterest({ rootGetters }, _payload) {
			return new Promise((resolve, reject) => {
				return API.post('public/v1/coverage/interest', {
					"first_name": _payload.first_name,
					"last_name": _payload.last_name,
					"email": _payload.email,
					"solution_type": _payload.solutionType,
					"location": {
						//TODO:make editable
						"location_type_name": {
							"name": "house",
							"display_name": "Freestanding Home"
						},
						"province": _payload.location.province,
						"city": _payload.location.city,
						"suburb": _payload.location.suburb,
						"postal_code": _payload.location.postalCode,
						"street_name": _payload.location.streetName,
						"street_number": _payload.location.streetNumber,
						// "building_name": "Fictitious Place",
						// "building_number": "1A",
						"longitude": _payload.location.longitude,
						"latitude": _payload.location.latitude,
					},
				}, true).then(response => {
					resolve(response);
				}, error => {
					reject(error);
				});
			});
		},
	},
});
;// CONCATENATED MODULE: ./src/store/modules/signupSolutions.js




/* harmony default export */ var signupSolutions = ({
	namespaced: true,
	state: {
		currentProvider: false,
		providers: [],
		solutions: [],
		selectedSolution: false,
		activeProviders: [],
		devices: false,
		selectedDevices: [],
		bundleProviders: [],
		solutionLocation: false,
	},
	getters: {
		currentProvider: state => {
			return state.currentProvider;
		},
		providers: state => {
			return state.providers;
		},
		solutions: state => {
			return state.solutions;
			// if(state.currentProvider.slug === 'telkom_lte') {
			// 	let s = [...state.solutions];
			// 	let newProd = JSON.parse('{"id":1299220,"name":"Uncapped Telkom LTE","display_name":"Uncapped Telkom","group_name":"Mobile Monthly Uncapped","display_order":6,"price":997,"bill_recurrence":1,"bill_recurrence_unit":"month","created_at":1632292565,"updated_at":1632996087,"display_category":"Fixed Wireless","display_section":"Mobile","display_section_slug":"mobile","display_category_slug":"fixed_wireless_telkom_lte","vendor":{"slug":"telkom_lte","name":"Telkom LTE"},"attributes":[],"speed_limit_kbps":null,"bandwidth_limit_bytes":"5000000000000","bandwidth_valid":"-99","top_up_solution":false,"is_capped_solution":false,"solution_type":"connectivity_mobile"}')
			// 	s.push(newProd)
			// 	return s
			// } else {
			//
			// }
		},
		selectedSolution: state => {
			return state.selectedSolution;
		},
		activeProviders: state => {
			return state.activeProviders;
		},
		devices: state => {
			return state.devices;
		},
		selectedDevices: state => {
			return state.selectedDevices;
		},
		bundleProviders: state => {
			return state.bundleProviders;
		},
		solutionLocation: state => {
			return state.solutionLocation;
		},
	},
	mutations: {
		resetState(state) {
			state.currentProvider = false;
			state.providers = [];
			state.solutions = [];
			state.selectedSolution = false;
			state.devices = [];
			state.selectedDevices = [];
			state.bundleProviders = [];
			state.solutionLocation = false;
		},
		updateCurrentProvider(state, value) {
			state.currentProvider = value;
		},
		updateProviders(state, value) {
			state.providers = value;
		},
		updateSolutions(state, value) {
			state.solutions = value;
		},
		updateSelectedSolution(state, value) {
			state.selectedSolution = value;
		},
		updateActiveProviders(state, value) {
			state.activeProviders = value;
		},
		updateSolutionPrice(state, data) {
			let solution = state.solutions.find(s => s.id === data.id);
			if(!solution) return
			solution.price_promo = data.price
			let index = state.solutions.indexOf(solution)
			vue_runtime_esm["default"].set(state.solutions, index, solution);
		},
		updateDevices(state, value) {
			// let devices = [
			// 	...state.devices,
			// 	{
			// 		category: value.category,
			// 		solutions: value.solutions
			// 	}
			// ];
			// Vue.set(state, 'devices', devices);
			if (!state.devices) state.devices = {};
			state.devices[value.category] = value.solutions;
		},
		updateSelectedDevices(state, value) {
			state.selectedDevices = value;
		},
		addSelectedDevices(state, value) {
			state.selectedDevices.push(value);
		},
		updateBundleProviders(state, value) {
			state.bundleProviders = value;
		},
		updateSolutionLocation(state, value) {
			state.solutionLocation = value;
		},
		updateSolutionEventPrices(state, value) {
			state.currentProvider = {
				...state.currentProvider,
				eventPrices: value
			};
		},
		updateProviderSolutions(state, value) {
			state.providers = state.providers.map((v) => {
				v.solutions = [];
				value.forEach((s) => {
					if (v.slug === s.vendor.slug) {
						v.solutions.push(s);
					}
				})
				return v;
			})
			// Vue.set(state, 'providers', providers);
		},
	},
	actions: {
		getSolutions({commit}, data) {
			if (!data.vendorSlug || data.vendorSlug.length < 1) return Promise.reject('vendor slug not provided')

			return new Promise((resolve, reject) => {
				return API.get('public/v1/solutions', {
					section_slug: [data.sectionSlug],
					category_slug: [data.categorySlug],
					with: ['vendor', 'solution_attributes', 'detail_type', 'detail_category', 'child_solutions'],
					vendor_slug: Array.isArray(data.vendorSlug) ? data.vendorSlug : [data.vendorSlug],
				}, true)
					.then(response => {
						commit('updateProviderSolutions', response.solutions);
						commit('updateSolutions', response.solutions);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getAllSolutions({commit}, data) {
			return new Promise((resolve, reject) => {
				return API.get('public/v1/solutions', {
					section_slug: [data.sectionSlug],
					category_slug: [data.categorySlug],
					with: ['vendor', 'solution_attributes', 'detail_type', 'detail_category', 'child_solutions'],
				}, true)
					.then(response => {
						commit('updateProviderSolutions', response.solutions);
						commit('updateSolutions', response.solutions);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getCurrentlyActiveFibreProviders({rootGetters, commit}, data) {
			return new Promise((resolve, reject) => {
				let url = 'https://www.afrihost.com/fibre/api/providers';

				if (rootGetters['signupGeneral/testSignup']) {
					url = 'https://fibre.cms.afrihost.com/api/providers'
				}

				if(false) {}

				return API.getRoot(url, null, true)
					.then(response => {
						commit('updateActiveProviders', response)
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getSolutionEventPrices({commit, state}, data) {
			if (!data.solutionId) return Promise.reject('solution id not provided');
			return new Promise((resolve, reject) => {
				return API.get(`public/v1/solution/${data.solutionId}/vendor-event-pricings`, {
					"latitude": state.solutionLocation.latitude,
					"longitude": state.solutionLocation.longitude,
				}, true)
					.then(response => {
						commit('updateSolutionEventPrices', response.vendor_event_pricings);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		async getProviderPromos({commit, state, dispatch}, provider) {
			let promoSlug = false;

			if(provider.location_promos) {
				switch (provider.location_promos[0]) {
					case 'frogfoot_century_oudtshoort':
					case 'frogfoot_century_tzaneen':
					case 'frogfoot_century_idasvallei':
						promoSlug = 'frogfoot_century_one'
						break;
					case 'frogfoot_century_swellendam':
					case 'frogfoot_century_caledon':
					case 'frogfoot_century_despatch':
						promoSlug = 'frogfoot_century_two'
						break;
				}
			}

			if(promoSlug) {
				let solutions = state.currentProvider.solutions;
				for (let index = 0; index < solutions.length; index++) {
					const s = solutions[index]
					const promosForSolution = await dispatch('getSolutionPromo',  s.id)
					let promo = promosForSolution.solution_promotions.find(p => p.slug === promoSlug);
					if(promo) {
						let priceTerm = promo.terms.find(t => t.type === 'billing')
						if(priceTerm) {
							await commit('updateSolutionPrice', {
								id: s.id,
								price: parseFloat(priceTerm.term)
							})
						}
					}
				}
			}
		},
		getSolutionPromo({commit, state}, solutionId) {
			return new Promise((resolve, reject) => {
				return API.get(`public/v1/solution/${solutionId}/promotion`, null, true)
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getDevices({state, commit}, _payload) {
			if (!state.currentProvider) {
				return Promise.reject('No provider has been selected');
			}
			let categorySlug = '';
			if (_payload && _payload.categorySlug) {
				categorySlug = _payload.categorySlug;
			} else if (state.currentProvider.solutions.length > 0 && state.currentProvider.solutions[0].solution_type === 'composite_fibre') {
				categorySlug = 'fibre_router';
			} else {
				return Promise.reject('Unhandled solution type');
			}
			return new Promise((resolve, reject) => {
				return API.get('public/v1/solutions', {
					section_slug: ['tangible'],
					category_slug: [categorySlug],
					with: ['vendor', 'solution_attributes', 'detail_type', 'detail_category', 'child_solutions'],
				}, true)
					.then(response => {
						commit('updateDevices', {
							category: categorySlug,
							solutions: response.solutions
						});
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		addLocation(_payload) {
			return new Promise((resolve, reject) => {
				return API.post('v1/location', {
					// return apiService.post('public/v1/location/validate', {
					"location_type_name": _payload.type,
					"name": _payload.customName,
					"province": _payload.province,
					"suburb": _payload.suburb,
					"city": _payload.city,
					"postal_code": _payload.postalCode,
					"street_name": _payload.streetName,
					"street_number": _payload.streetNumber,
					"building_name": _payload.buildingName,
					"building_number": _payload.buildingNumber,
					"longitude": _payload.geometry.location.lng(),
					"latitude": _payload.geometry.location.lat()
				})
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		getAddonSolutions({state, commit}) {
			return new Promise((resolve, reject) => {
				return API.get('public/v1/solutions', {
					section_slug: ['tangible'],
					category_slug: [],
					with: ['vendor', 'solution_attributes', 'detail_type', 'detail_category', 'child_solutions'],
				}, true)
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		checkStockAvailability({state, commit}, _solutionIds) {
			return new Promise((resolve, reject) => {
				return API.get('public/v1/solution/stock-availability', {
					solution_tangible_ids: _solutionIds
				}, true)
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		}
	},
});

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/utils/WatchPrimitiveProperties.js
var WatchPrimitiveProperties = __webpack_require__(7382);
;// CONCATENATED MODULE: ./src/store/modules/signupCart.js




/* harmony default export */ var signupCart = ({
	namespaced: true,
	state: {
		cartDetails: false,
		cartItems: false,
		coupon: false,
		preLoadedCoupon: false
	},
	getters: {
		cartDetails: state => {
			return state.cartDetails;
		},
		cartItems: state => {
			return state.cartItems;
		},
		coupon: state => {
			return state.coupon;
		},
		preLoadedCoupon: state => {
			return state.preLoadedCoupon;
		},
	},
	mutations: {
		resetState(state) {
			state.cartDetails = false;
			state.cartItems = false;
		},
		setCartDetails(state, value) {
			state.cartDetails = value;
		},
		setCartItems(state, value) {
			state.cartItems = value;
		},
		addCoupon(state, value) {
			state.coupon = value
		},
		addPreLoadedCoupon(state, value) {
			state.preLoadedCoupon = value
		},
		addCartItem(state, item) {
			state.cartItems.push(item);
		},
		replaceOrAddCartItem(state, item) {
			let replaced = false;

			state.cartItems = state.cartItems.map((c) => {
				// if (c.product_type_slug === item.product_type_slug) {
				if (c.product_id === item.product_id) {
					replaced = true;
					return item;
				}
				return c;
			});
			if (!replaced) {
				state.cartItems.push(item);
			}
		},
		removeCartItem(state, productTypeSlug) {
			state.cartItems = state.cartItems.filter(c => {
				return c.product_type_slug !== productTypeSlug
			});
		},
		removeCartItemByProductId(state, productId) {
			state.cartItems = state.cartItems.filter(c => {
				return c.product_id !== productId
			});
		},
		addCartItemRequirement(state, data) {
			state.cartItems.forEach(item => {
				if(item.product_type_slug === data.productTypeSlug) {
					item.cart_item_requirements.push(data.cartItemRequirement)
				}
			})
		}
	},
	actions: {
		checkCoupon({}, _payload) {
			return new Promise((resolve, reject) => {
				API.get("v1/coupon/" + _payload.coupon + '/availability',
					{
						solution_ids: [_payload.solution_id]
					})
					.then((res) => {
						resolve(res)
					}, (err) => {
						reject(err)
					})
			})
		},
		updateDeviceRecipient({rootGetters, commit}, _payload) {
			if (!_payload.form && (!_payload.form.full_name || !_payload.form.cell_number || !_payload.form.email || !_payload.form.id_number)) {
				return Promise.reject('Incorrect form details supplied')
			}
			let devices = rootGetters['signupSolutions/selectedDevices'];

			for (const device of devices) {
				let cartItem = {
					"product_id": device.product.id,
					"cart_item_requirements": [
						{name: 'recipient_first_name', value: _payload.form.full_name.split(' ')[0]},
						{name: 'recipient_last_name', value: _payload.form.full_name.split(' ').slice(1).join(' ')},
						{name: 'contact_number', value: _payload.form.cell_number},
						{name: 'email_address', value: _payload.form.email},
						{name: 'id_number', value: _payload.form.id_number},
					]
				}
				//if fibre router, add slug and configuration details
				if (device.product_type_slug === "solution_tangible_fibre") {
					cartItem.product_type_slug = "solution_tangible_fibre";
					cartItem.cart_item_requirements.concat([
						{name: "configure_wifi_network_name", value: device.ssid},
						{name: "configure_wifi_network_password", value: device.password},
					])
				} else if (device.product_type_slug === "mesh_network") {
					//else if mesh, add mesh as slug
					cartItem.product_type_slug = "solution_tangible_mesh";
				} else if (device.product_type_slug === "ups_tangible") {
					//else if ups, add ups slug
					cartItem.product_type_slug = "solution_tangible_ups";
				}
				commit('replaceOrAddCartItem', cartItem);
			}
			return Promise.resolve();
		},
		addRicaContactIdToCartItems({state, rootState}, rcId) {
			console.log('addRicaContactIdToCartItems')
			let cartItems = JSON.parse(JSON.stringify(state.cartItems));
			cartItems.forEach(cartItem => {
				// check if rica needs to be added
				console.log(cartItem.product_type_slug, cartItem.product_id)
				cartItem.cart_item_requirements.forEach(cir => {
					console.log(cir)
					if(cir.name === 'rica_contact_id') {
						cir.value = rcId
					}
				})
			})

			state.cartItems = cartItems
		},
		createDeliveryCart({state, rootState}, includeCoupon = false) {
			if (!state.cartDetails) { return Promise.reject('Cart has not been set up correctly')}

			//remove any cart item that does not have a product_type_slug
			state.cartItems = state.cartItems.filter(c => {
				return c.product_type_slug !== undefined && c.product_type_slug.trim().length !== 0
			})

			let cartItems = JSON.parse(JSON.stringify(state.cartItems));

			if (rootState.signupGeneral.testSignup) {
				cartItems.forEach((cartItem) => {
					cartItem.cart_item_requirements.push({name: 'test_sign_up', value: "on_page_signup_test"})
				})
			}

			let coupon = rootState.signupCart.coupon
			if(includeCoupon && coupon) {
				cartItems.forEach(cartItem => {
					if(coupon.available_for_solutions.includes(cartItem.product_id)) {
						cartItem.cart_item_requirements.push({
							name: "coupon_code",
							value: coupon.coupon.coupon_code
						})
					}
				})
			}

			let cart = {
				...state.cartDetails,
				cart_items: [cartItems]
			};

			return Promise.resolve(cart);
		},
		buildCart({state, rootState}, data) {

			let coupon = data.coupon
			let deliveryQuote = data.deliveryQuote
			let getDeliveryQuoteForCoupon = data.getDeliveryQuoteForCoupon

			console.log('buildCart')
			console.log('coupon', coupon)
			console.log('deliveryQuote', deliveryQuote)
			console.log('getDeliveryQuoteForCoupon', getDeliveryQuoteForCoupon)

			// build the cart
			let cart = {
				...state.cartDetails,
				cart_items: [
					state.cartItems,
				]
			};

			cart = JSON.parse(JSON.stringify(cart));

			//check for development and add test requirement
			if (rootState.signupGeneral.testSignup) {
				cart.cart_items.forEach(c => {
					c.forEach(r => {
						r.cart_item_requirements.push({name: 'test_sign_up', value: "on_page_signup_test"})
					})
				})
			}

			// signup source
			// needs to be added to the delivery quote before
			// cart.cart_items.forEach(c => {
			// 	c.forEach(r => {
			// 		if(r.product_type_slug === "solution_composite_fibre") {
			// 			r.cart_item_requirements.push({name: 'cart_creation_source', value: "afrihost_fibre_page"})
			// 		}
			// 	})
			// })

			//add delivery cart item
			if (deliveryQuote) {
				// console.log('adding delivery quote cart item', deliveryQuote.cart_item)
				cart.cart_items[0].push(JSON.parse(JSON.stringify(deliveryQuote.cart_item))) // remove the observer for better console viewing
			}

			// add coupon
			if(coupon) {
				// console.log('applying coupon to matching solutions')
				cart.cart_items[0].forEach(i => {
					if(coupon.available_for_solutions.includes(i.product_id)) {
						i.cart_item_requirements.push({
							name: "coupon_code",
							value: coupon.coupon.coupon_code
						})
					}
				})
			}

			console.log('built cart', cart)
			return cart
		},
		async getCheckoutSummary({state, rootState, dispatch}) {

			let coupon = rootState.signupCart.coupon
			let deliveryQuote = rootState.signupDelivery.selectedDeliveryQuote

			let cart = await dispatch('buildCart', coupon, deliveryQuote, false);
			// let cart = this.buildCart(state, coupon, deliveryQuote, false)

			console.log(cart)

			return new Promise((resolve, reject) => {
				return API.post('v1/cart/checkout-summary', {
					cart: cart
				}).then((res) => {
					resolve(res);
				}, (err) => {
					reject(err);
				})
			});
		},
		async doCheckout({state, commit, rootState, dispatch}, getDeliveryQuoteForCoupon = true) {
			let coupon = rootState.signupCart.coupon
			let deliveryQuote = rootState.signupDelivery.selectedDeliveryQuote
			console.log('deliveryQuote', deliveryQuote)

			let cart = await dispatch('buildCart', {
				coupon: coupon,
				deliveryQuote: deliveryQuote,
				getDeliveryQuoteForCoupon: getDeliveryQuoteForCoupon
			});
			console.log('cart', cart)

			if(coupon && deliveryQuote && getDeliveryQuoteForCoupon) {

				// console.log('fetching delivery quotes as user has a coupon & delivery items')
				// console.log('cart pre new delivery quote', JSON.parse(JSON.stringify(cart)));

				// get fresh delivery quote so the coupon does not mess things up
				return dispatch('signupDelivery/getDeliveryQuotes', true, {root: true})
					.then(r => {
						let q = r.delivery_quotations.find(dq => dq.location_id === deliveryQuote.location_id && dq.price === deliveryQuote.price);
						if(!q) {
							return Promise.reject('Failed to match new delivery quote on coupon addition')
						}

						commit('signupDelivery/updateSelectedDeliveryQuote', q, {root: true});

						// console.log('delivery quote updated, re-running checkout')
						// rerun the checkout action
						return dispatch('doCheckout', false)

					}, () => {
						return Promise.reject('Failed to fetch new delivery quotes')
					})
			}

			// console.log('final cart', JSON.parse(JSON.stringify(cart)));
			// return

			return new Promise((resolve, reject) => {
				return API.post('v1/cart', {cart: cart}).then((res) => {

					// tracking events
					let conversionValue = rootState.signupSolutions.selectedSolution.price
					let email = rootState.signupUser.user.email
					let data = {
						product: 'fibre',
						type: 'sale',
						value: conversionValue,
						location: 'website',
						email: email
					}

					dispatch('recordSignup', res.cart.id);
					dispatch('logAct', data);

					//clear store for safety
					commit('resetState');
					commit('signupPayment/resetState', null, { root: true });
					commit('signupDelivery/resetState', null, { root: true });
					commit('signupSolutions/resetState', null, { root: true });
					commit('signupCoverage/resetState', null, { root: true });
					resolve(res);
				}, (err) => {
					/*
					* There are a number of error_slug values in 400 responses to /v1/cart:
						delivery_charge_required,
						delivery_quotation_expired,
						delivery_quotation_missing,
						delivery_quotation_invalid,
						delivery_quotation_used
					* */
					reject(err);
				})
			});
		},
		recordSignup({rootState}, cartId) {
			return new Promise((resolve, reject) => {
				axios_default().post("https://www.afrihost.com/fibre/api/signup", {
					"cart_id": rootState.signupGeneral.testSignup ? 'test-cart-' + cartId : cartId
				}, true).then((res) => {
					resolve(res)
				}, (err) => {
					reject(err)
				})
			})
		},
		logAct({rootState}, data) {
			return new Promise((resolve, reject) => {
				if (rootState.signupGeneral.testSignup) {
					console.log('LOG ACT: ', data)
					return resolve()
				}
				return axios_default().post('https://act.afrihost.com/api/event', data)
					.then(r => {
						resolve(r.data)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
	},
});

;// CONCATENATED MODULE: ./src/store/modules/signupGeneral.js


/* harmony default export */ var signupGeneral = ({
	namespaced: true,
	state: {
		googleMapsKey: false,
		pageRequestedFrom: "",
		showBundleOnPages: ['fibre/bundle'],
		imSure: false,
		countries: false,
		hideFooter: false,
		testSignup: false,

		fibreFreeze: false,

		decoInStock: {
			twoPack: false,
			threePack: false,
		},

		upsellShown: [
			{
				name:'fibreMeshDevice',
				value:false,
			},
		],

		//checks for providers that don't have devices
		noDeviceProviders: [
			'vuma_reach',
			'openserve_web_connect',
			'frogfoot_air',
			'vuma_reach_prepaid',
			'openserve_prepaid'
		],
		noDeviceProvider: false,

		// promos
		currentLTEPromotions: [],

		// the user selected fibre type
		fibreExperience: false,

		// the default fibre type (based on what page the user is on)
		fibreTypeScope: false,

		skipProvidersView: true,
	},
	getters: {
		googleMapsKey: state => {
			return state.solutionType;
		},
		skipProvidersView: state => {
			return state.skipProvidersView;
		},
		pageRequestedFrom: state => {
			return state.pageRequestedFrom;
		},
		showBundleOnPages: state => {
			return state.showBundleOnPages;
		},
		imSure: state => {
			return state.imSure;
		},
		countries: state => {
			return state.countries;
		},
		hideFooter: state => {
			return state.hideFooter;
		},
		testSignup: state => {
			return state.testSignup;
		},
		fibreFreeze: state => {
			return state.fibreFreeze;
		},
		fibreTypeScope: state => {
			return state.fibreTypeScope;
		},
		upsellShown: state => {
			return state.upsellShown;
		},
		noDeviceProviders: state => {
			return state.noDeviceProviders;
		},
		noDeviceProvider: state => {
			return state.noDeviceProvider;
		},
		currentLTEPromotions: state => {
			return state.currentLTEPromotions;
		},
		decoInStock: state => {
			return state.decoInStock
		},
		fibreExperience: state => {
			return state.fibreExperience
		}
	},
	mutations: {
		updateGoogleMapsKey(state, value) {
			state.solutionType = value;
		},
		setSkipProvidersView(state, value) {
			state.skipProvidersView = value;
		},
		updatePageRequestedFrom(state, value) {
			state.pageRequestedFrom = value;
		},
		updateImSure(state, value) {
			state.imSure = value;
		},
		updateCountries(state, value) {
			state.countries = value;
		},
		hideFooter(state, value) {
			state.hideFooter = value;
		},
		updateTestSignup(state, value) {
			state.testSignup = value;
		},
		updateFibreFreeze(state, value) {
			state.fibreFreeze = value;
		},
		upsellShown(state, value) {
			state.upsellShown = value;
		},
		setUpsellShown(state, value) {
			let shown = state.upsellShown;
			state.upsellShown = shown.map(s => {
				if (s.name === value.name) {
					s.value = value.value;
				}
				return s;
			});
		},
		updateNoDeviceProvider(state, value) {
			state.noDeviceProvider = value;
		},
		updateCurrentLTEPromotions(state, value) {
			state.currentLTEPromotions = value;
		},
		setFibreExperience(state, value) {
			state.fibreExperience = value;
		},
		setFibreTypeScope(state, value) {
			state.fibreTypeScope = value;
		},
		updateDecoInStock(state,value) {
			state.decoInStock = {
				twoPack: value.twoPack,
				threePack: value.threePack,
			}
		},
	},
	actions: {
		fetchCountries({commit, state}) {
			if (state.countries) { return Promise.resolve(state.countries) }

			return new Promise((resolve, reject) => {
				return API.get(`public/v1/countries`, null, true)
					.then(response => {
						commit('updateCountries', response.countries);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		mapsToLocation(ctx, _payload) {
			if (!_payload.place) {return Promise.reject('No place provided')}
			let returnPlace = {
				streetNumber: "",
				streetName: "",
				suburb: "",
				postalCode: "",
				city: "",
				province: "",
			};
			let checkPlace = _payload.place.address_components.find((a)=>{return a.types.includes('street_number')});
			if (checkPlace) {
				returnPlace.streetNumber = checkPlace.long_name;
			}
			checkPlace = _payload.place.address_components.find((a)=>{return a.types.includes('route')});
			if (checkPlace) {
				returnPlace.streetName = checkPlace.long_name;
			}
			checkPlace = _payload.place.address_components.find((a)=>{return a.types.includes('sublocality')});
			if (checkPlace) {
				returnPlace.suburb =	checkPlace.long_name;
			}
			checkPlace = _payload.place.address_components.find((a)=>{return a.types.includes('postal_code')});
			if (checkPlace) {
				returnPlace.postalCode = checkPlace.long_name;
			}
			checkPlace = _payload.place.address_components.find((a)=>{return a.types.includes('locality')});
			if (checkPlace) {
				returnPlace.city = checkPlace.long_name;
			}
			checkPlace = _payload.place.address_components.find((a)=>{return a.types.includes('administrative_area_level_1')});
			if (checkPlace) {
				returnPlace.province = checkPlace.long_name;
			}

			if (_payload.coordinates) {
				returnPlace.longitude = _payload.coordinates.lng;
				returnPlace.latitude = _payload.coordinates.lat;
			} else {
				returnPlace.longitude = _payload.place.geometry.location.lng();
				returnPlace.latitude = _payload.place.geometry.location.lat();

			}

			return Promise.resolve(returnPlace);
		},

		fetchLTEPromotions({commit}) {
			return new Promise((resolve, reject) => {
				let url = 'https://www.afrihost.com/lte/api/providers';
				if (window.location.href.indexOf('www') !== -1) {
					url = 'https://www.afrihost.com/lte/api/providers';
				}
				API.getRoot(url)
				// apiService.getRoot('http://localhost:3001/api/providers')
					.then(res => {
						let promotions = res.map(p => {
							if (p.promotions.length > 0) {
								let promos = p.promotions.map( promo => {
									return {
										...promo,
										provider_slug: p.vendor_slug
									}
								})
								return promos;
							}
							return undefined;
						})
						promotions = promotions.flat();
						promotions = promotions.filter(p => p);

						commit('updateCurrentLTEPromotions', promotions)
						resolve(promotions);
					})
					.catch(err => reject);
			})
		}
	},
});

;// CONCATENATED MODULE: ./src/store/modules/signupDelivery.js


/* harmony default export */ var signupDelivery = ({
	namespaced: true,
	state: {
		locations: [],
		deliveryLocation: false,
		coordinates: false,
		deliveryQuotes: false,
		selectedDeliveryQuote: false,
		selectedDeliveryOption: false 	// deliver | collect
	},
	getters: {
		locations: state => {
			return state.locations;
		},
		deliveryLocation: state => {
			return state.deliveryLocation;
		},
		coordinates: state => {
			return state.coordinates;
		},
		deliveryQuotes: state => {
			return state.deliveryQuotes;
		},
		selectedDeliveryQuote: state => {
			return state.selectedDeliveryQuote;
		},
		selectedDeliveryOption: state => {
			return state.selectedDeliveryOption;
		},
	},
	mutations: {
		resetState: (state) => {
			state.locations = [];
			state.deliveryLocation = false;
			state.deliveryQuotes = false;
			state.selectedDeliveryQuote = false;
			state.selectedDeliveryOption = false;
		},
		addLocation(state, value) {
			state.locations.push(value);
		},
		updateLocations(state, value) {
			state.locations = value;
		},
		updateDeliveryLocation(state, value) {
			state.deliveryLocation = value;
		},
		updateCoordinates(state, value) {
			state.coordinates = value;
		},
		updateDeliveryQuotes: (state, value) => {
			state.deliveryQuotes = value;
		},
		updateSelectedDeliveryQuote: (state, value) => {
			state.selectedDeliveryQuote = value;
		},
		updateSelectedDeliveryOption: (state, value) => {
			state.selectedDeliveryOption = value;
		},
	},
	actions: {
		fetchLocations({commit}) {
			return new Promise((resolve, reject) => {
				return API.get('v1/locations')
					.then(response => {
						commit('updateLocations', response.locations)
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		async getDeliveryQuotes({commit, dispatch}, includeCoupon) {
			let quoteCart = await dispatch('signupCart/createDeliveryCart', includeCoupon, {root:true})
			console.log('quoteCart', quoteCart)

			return new Promise((resolve, reject) => {
				return API.post('v1/cart/delivery-quotations', {cart: quoteCart}).then(response => {
					commit('updateDeliveryQuotes', response.delivery_quotations)
					resolve(response);
				}, error => {
					reject(error);
				});
			});
		},
	},
});

;// CONCATENATED MODULE: ./src/store/modules/signupPayment.js


/* harmony default export */ var signupPayment = ({
	namespaced: true,
	state: {
		paymentMethods: [],
		currentPaymentMethod: false,
		banks: [],
		cardToken: false,
	},
	getters: {
		paymentMethods: state => {
			return state.paymentMethods;
		},
		currentPaymentMethod: state => {
			return state.currentPaymentMethod;
		},
		banks: state => {
			return state.banks;
		},
		cardToken: state => {
			return state.cardToken;
		},
	},
	mutations: {
		resetState: (state) => {
			state.paymentMethods = [];
			state.currentPaymentMethod = false;
			state.banks = [];
			state.cardToken = false;
		},
		updatePaymentMethods: (state, value) => {
			state.paymentMethods = value;
		},
		updateCurrentPaymentMethod: (state, value) => {
			state.currentPaymentMethod = value;
		},
		updateBanks: (state, value) => {
			state.banks = value;
		},
		updateCardToken(state, value) {
			state.cardToken = value;
		}
 	},
	actions: {
		fetchPaymentMethods({commit}, _payload) {
			let parameters = null;
			if (_payload && _payload.solutionId) {
				parameters = {
					solution_id: _payload.solutionId
				};
			}
			return new Promise((resolve, reject) => {
				return API.get('v1/payment-details', parameters)
					.then(response => {
						commit('updatePaymentMethods', response.payment_details);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		fetchBanks({commit}) {
			return new Promise((resolve, reject) => {
				return API.get('v1/payment-detail/banks')
					.then(response => {
						commit('updateBanks', response.banks);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		addBankAccount({dispatch}, _payload) {
			if (_payload.account_number === '') { return Promise.reject('No account number passed')}
			_payload.account_number = _payload.account_number.replace(/ /g,'');
			return new Promise((resolve, reject) => {
				return API.post('v1/payment-detail', _payload)
					.then(response => {
						dispatch('fetchPaymentMethods')
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		addBankCard({dispatch, commit}, _payload) {
			if (_payload.card_number === '') { return Promise.reject('No account number passed')}
			_payload.card_number = _payload.card_number.replace(/ /g,'');
			return new Promise((resolve, reject) => {
				return API.post('v1/payment-detail/card-token', _payload)
					.then(response => {
						commit('updateCardToken', response)
						dispatch('fetchPaymentMethods')
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
		createCreditCardToken({commit}, _payload) {
			if (_payload.card_number === '') { return Promise.reject('No account number passed')}
			_payload.card.card_number = _payload.card.card_number.replace(/ /g,'');
			let cardObj = {
				card_holder: _payload.card.card_holder,
				card_number: _payload.card.card_number,
				expiry_month: _payload.card.expiry_month,
				expiry_year: _payload.card.expiry_year,
				cvv: _payload.card.cvv,
				success_redirect: `${_payload.url}?signupCallback=new-payment-added`,
				decline_redirect: `${_payload.url}?signupCallback=new-payment-failed`,
			};

			return new Promise((resolve, reject) => {
				return API.post('v1/payment-detail/card-token', cardObj)
					.then(response => {
						commit('updateCardToken', response);
						//ommit card number and cvv from payment method
						// _payload.card.cvv = '';
						// _payload.card.card_number = '';
						_payload.card.masked_number = `${_payload.card.card_number.substr(0,4)} XXXX XXXX ${_payload.card.card_number.substr(12,4)}`;
						commit('updateCurrentPaymentMethod', _payload.card);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},
	},
});

;// CONCATENATED MODULE: ./src/store/modules/signupSignal.js


const signalInstance = axios_default().create({
	baseURL: 'https://signal.afrihost.com/api/',
	withCredentials: true,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
	}
})

/* harmony default export */ var signupSignal = ({
	namespaced: true,
	state: {
		uuid: false,
	},
	getters: {

	},
	mutations: {
		setUuid(state, value) {
			state.uuid = value;
		},
	},
	actions: {
		sendEvent({state, commit}, data) {

			const searchParams = new URLSearchParams(window.location.search);
			let l = window.location
			let path = l.pathname
			let source = searchParams.get('utm_source')
			let medium = searchParams.get('utm_medium')
			let campaign = searchParams.get('utm_campaign')

			let event = {
				type: data.type,
				value: data.value,
				path: path,
				meta: data.meta,
				campaign: campaign,
				medium: medium,
				source: source
			}

			if(!state.uuid) {
				console.log('no uuid set, bailing', event)
				return
			}

			signalInstance.post(`/public/project/${state.uuid}/event`, event)
		},
		identify({state, commit}, data) {
			if(!state.uuid) return

			signalInstance.post(`/public/project/${state.uuid}/id`, data)
		},
	},
});
;// CONCATENATED MODULE: ./src/store/index.js

// import Vuex from 'vuex'













// Vue.use(Vuex);

let key = 'ah-signup-1036'; // NB!!! this needs to be changed in the api service as well

const vuexCookie = new esm({
	key: key,
	restoreState: (key, storage) => {
		let state = js_cookie_default().get(key);
		// console.log(JSON.parse(atob(state)))

		return state ? Encoder.decode(state) : undefined
	},
	saveState: async (key, state, storage) => {

		let encState = Encoder.encode(state);

		return js_cookie_default().set(key, encState, {
			// 1 day / 1440 minutes * 15 minutes
			expires: ((1/1440) * 15)
		})
	},
	//only save user token
	reducer: (state) => ({
		signupUser: { token: state.signupUser.token },
	}),
})
const vuexLocal = new esm({
	storage: window.localStorage,
	key: key,
	reducer: (state) => ({
		signupCart: state.signupCart,
		signupPayment: state.signupPayment,
		signupSolutions: state.signupSolutions,
	}),
});

// export default new Vuex.Store({
// 	modules: {
// 		user,
// 		coverage,
// 		solutions,
// 		cart,
// 		general,
// 		delivery,
// 		payment,
// 	},
// 	strict: true,
// 	plugins: [vuexLocal.plugin, vuexCookie.plugin]
// })

/* harmony default export */ var store = ({
	register(store) {
		store.registerModule('signupUser', signupUser);
		store.registerModule('signupCoverage', signupCoverage);
		store.registerModule('signupSolutions', signupSolutions);
		store.registerModule('signupCart', signupCart);
		store.registerModule('signupGeneral', signupGeneral);
		store.registerModule('signupDelivery', signupDelivery);
		store.registerModule('signupPayment', signupPayment);
		store.registerModule('signupSignal', signupSignal);

		vuexLocal.plugin(store);
		vuexCookie.plugin(store);
	}
});
;// CONCATENATED MODULE: ./src/services/Tracking.js
class GtmInterface {
	constructor(Vue) {
		this.dataLayer = Vue.state.gtm;
		this.debug = Vue.testSignup;

		this.push = (attrs) => {
			if (this.dataLayer) {
				if (this.debug) console.log('GTM event pushed.', attrs)
				this.dataLayer.push(attrs);
			} else {
				if (this.debug) console.warn('GTM event pushed into void.', attrs)
			}
		}
		return this;
	}
}

class SentryInterface {
	constructor() {
		return this;
	}
	shoot(attrs) {
		console.warn('Sentry event pushed into void.', attrs)
	}
}

class FbPixelInterface {
	constructor(Vue) {
		this.fbq = Vue.state.fbq;
		this.debug = Vue.testSignup;

		this.push = (...attrs) => {
			if (this.fbq) {
				if (this.debug) console.log('Facebook Pixel event pushed.', attrs)
				this.fbq(attrs[0], attrs[1], attrs[2]);
			} else {
				if (this.debug) console.warn('Facebook Pixel event pushed into void.', attrs)
			}
		}
		return this;
	}
}
class Tracking {
	constructor(Vue, testSignup) {
		this.debug = Vue.testSignup;
		// let gtm = new GtmInterface(this);
		// let sentry = new SentryInterface(this);
		this.storeVM = new Vue({
			data() {
				return {
					//interfaces with abstracted calls
					gtmInterface: false,
					sentryInterface: false,
					fbqInterface: false,
					//actual instances
					gtm: false,
					sentry: false,
					fbq: false
				}
			}
		})

		if (this.checkGTM()) {
			this.state.gtm = this.getGTM();
		} else {
			// retry 5 times
			let GTMCheckedTimes = 0;
			let GTMChecker = setInterval(() => {
				if (this.getGTM() || GTMCheckedTimes >= 5) {
					this.state.gtm = this.getGTM();
					this.state.gtmInterface = new GtmInterface(this);
					clearInterval(GTMChecker)
				} else {
					GTMCheckedTimes++;
				}
			}, 1000);
		}
		this.state.gtmInterface = new GtmInterface(this);

		if (this.checkSentry()) {
			this.state.sentry = {}
		} else {
			//retry 5 times
		}
		this.state.sentryInterface = new SentryInterface(this);

		//check if fbq is available - do it 5 times because of network delays
		let FBCheckedTimes = 0;
		let FBChecker = setInterval(() => {
			if (this.checkFbq() || FBCheckedTimes >= 5) {
				this.state.fbq = this.getFbq();
				this.state.fbqInterface = new FbPixelInterface(this);
				clearInterval(FBChecker)
			} else {
				FBCheckedTimes++;
			}
		}, 1000);
		this.state.fbqInterface = new FbPixelInterface(this);
	}

	getGTM() {
		return window.dataLayer;
	}
	getFbq() {
		return window.fbq;
	}
	checkGTM() {
		if (this.debug) console.log('tracking: GTM', window.google_tag_manager !== undefined);
		if (this.debug) console.log('tracking: dataLayer', window.dataLayer !== undefined);
		return window.dataLayer !== undefined;
	}
	checkFbq() {
		if (this.debug) console.log('tracking: FB Pixel', window.fbq !== undefined);
		return window.fbq !== undefined;
	}
	checkSentry() {
		return false;
	}

	get gtm() {
		return this.storeVM.$data.gtmInterface;
	}
	get sentry() {
		return this.storeVM.$data.sentryInterface;
	}
	get fbq() {
		return this.storeVM.$data.fbqInterface.push;
	}
	get state() {
		return this.storeVM.$data;
	}
}

/* harmony default export */ var services_Tracking = (Tracking);
// EXTERNAL MODULE: ./node_modules/portal-vue/dist/portal-vue.common.js
var portal_vue_common = __webpack_require__(2433);
;// CONCATENATED MODULE: ./src/index.js











window._v = package_namespaceObject.i8;

/* harmony default export */ var src_0 = ({
	install(Vue, options) {

		if(!options || typeof(options.solutionTypes) == 'undefined' || options.solutionTypes.length === 0) {
			throw new Error('Please initialise plugin with the allowed solution types');
		}

		if(!options || typeof(options.upsellSolutionTypes) == 'undefined') {
			throw new Error('Please initialise plugin with the allowed upsell solution types');
		}

		if(!options || typeof(options.googleMapsKey) == 'undefined') {
			throw new Error('Please initialise plugin with a google maps API key');
		}

		if(options && options.fibreTypeScope !== undefined && ['fibre_uncapped_pure', 'fibre_prepaid'].indexOf(options.fibreTypeScope) < 0) {
			throw new Error('Invalid fibre type scope');
		}

		if (!options || typeof(options.store) == 'undefined') {
			throw new Error('Please provide a store!!');
		}

		/** Signup **/

		//register modules
		store.register(options.store);
		// hello

		Vue.prototype.$signup = new plugin_Signup(
			Vue,
			options.store,
			options.solutionTypes,
			options.upsellSolutionTypes,
			options.googleMapsKey,
			options.pageRequestedFrom,
			options.testSignup,
			options.decoInStock,
			options.fibreFreeze,
			options.vendorScope,
			options.fibreTypeScope,
			options.signalUuid,
		);
		Vue.prototype.$store = store;

		// add axios interceptor to catch 511 responses
		// and redirect the user to the OTP screen
		axios_default().interceptors.response.use((response) => {
			return response;
		}, (err) => {
			if(err.response.status === 511 && err.response.data.error_slug === 'otp_required') { //needs otp verification
				Vue.prototype.$modal.push('auth-otp');
			} else if (err.response.status === 401) { //not authorised/token expired
				Vue.prototype.$signup.$store.commit('signupUser/updateToken', false);
				Vue.prototype.$modal.push('auth-login');
			}
			return Promise.reject(err.response);
		});
		/** end Signup **/

		/** Searchbar **/
		if(!options || typeof(options.googleMapsKey) == 'undefined') {
			throw new Error('Please initialise plugin with a google Maps key');
		}

		// components
		Vue.component('SearchBar', plugin_SearchBar)

		Vue.use(main, {
			load: {
				key: options.googleMapsKey,
				libraries: 'places',
			}
		});

		Vue.use(portal_vue_common/* default */.ZP)
		/** end Searchbar **/

		/** Signup Modal **/
		Vue.prototype.$modal = new Modal_Modal(
			Vue,
		);

		// components
		Vue.component('SignupModal', Modal)
		/** end Signup Modal **/

		/** Global Filters **/
		Vue.filter('formatTermType', (value) => {
			switch (value) {
				case 'eta':
					return 'When will I get it?'
				case 'general':
					return 'Delivery days'
				case 'billing':
					return 'Billing T&C'
				case 'rica':
					return 'You need to get RICA\'d'
				default:
					return value.replace('_', ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
			}
		});

		Vue.filter('couponValue', (coupon) => {
			switch (coupon.value_type.unit.name) {
				case 'rand':
					return '-R' + parseFloat(coupon.value) + '.00'
				default:
					return coupon.value;
			}
		});

		Vue.filter('couponRecurrence', (coupon) => {
			switch (coupon.recurrence_unit.name) {
				case 'Month':
					return coupon.recurrence === 1 ? 'For 1 month' : `For ${coupon.recurrence} months`
				default:
					return `${coupon.recurrence} ${coupon.recurrence.plural_name}`;
			}
		});

		Vue.filter('formatPrice', (p) => {
			if (p === undefined) {
				return p
			}
			return p !== 0 ? `R${p.toFixed(2).toLocaleString('en-ZA')}` : 'FREE';
		});

		Vue.filter('formatPriceNotFree', (p) => {
			if (p === undefined) {
				return p
			}
			return p !== 0 ? `R${p.toFixed(2).toLocaleString('en-ZA')}` : 'R0.00';
		});
		/** end Global Filters **/


		/** Global Directives **/
		// Vue.directive('show-tooltip', (el, bind, vnode) => {
		// 	el.addEventListener('click', (e) => {
		// 		e.preventDefault();
		// 		console.log(e.target)
		// 	})
		// })
		/** end Global Directives **/


		/** Global Tracking **/

		Vue.prototype.$tracking = new services_Tracking(Vue, options.testSignup);

		/** end Global Tracking **/
	}
});

// opera mobile shim
if (!Object.entries) {
	Object.entries = function( obj ){
		var ownProps = Object.keys( obj ),
			i = ownProps.length,
			resArray = new Array(i); // preallocate the Array
		while (i--)
			resArray[i] = [ownProps[i], obj[ownProps[i]]];

		return resArray;
	};
}

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (src_0);


}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=afrihost-signup.common.js.map